export default {
  11:
  {
    name: '北京市',
    parseid: '',
    longitude: '116.41338369712',
    latitude: '39.9109245473'
  },
  12:
  {
    name: '天津市',
    parseid: '',
    longitude: '117.20952321467',
    latitude: '39.093667843404'
  },
  13:
  {
    name: '河北省',
    parseid: '',
    longitude: '114.53659630532',
    latitude: '38.0432016452'
  },
  14:
  {
    name: '山西省',
    parseid: '',
    longitude: '112.56937550968',
    latitude: '37.879829423856'
  },
  15:
  {
    name: '内蒙古自治区',
    parseid: '',
    longitude: '111.67741976203',
    latitude: '40.824033761161'
  },
  21:
  {
    name: '辽宁省',
    parseid: '',
    longitude: '123.43559785683',
    latitude: '41.841465251202'
  },
  22:
  {
    name: '吉林省',
    parseid: '',
    longitude: '125.33107197952',
    latitude: '43.892575780569'
  },
  23:
  {
    name: '黑龙江省',
    parseid: '',
    longitude: '126.66965282042',
    latitude: '45.747929837435'
  },
  31:
  {
    name: '上海市',
    parseid: '',
    longitude: '121.48053886018',
    latitude: '31.235929042252'
  },
  32:
  {
    name: '江苏省',
    parseid: '',
    longitude: '118.76955164467',
    latitude: '32.066776944293'
  },
  33:
  {
    name: '浙江省',
    parseid: '',
    longitude: '120.15953308739',
    latitude: '30.271548393337'
  },
  34:
  {
    name: '安徽省',
    parseid: '',
    longitude: '117.33054041772',
    latitude: '31.734294156317'
  },
  35:
  {
    name: '福建省',
    parseid: '',
    longitude: '119.30244747704',
    latitude: '26.106339415901'
  },
  36:
  {
    name: '江西省',
    parseid: '',
    longitude: '115.91542320365',
    latitude: '28.681690516761'
  },
  37:
  {
    name: '山东省',
    parseid: '',
    longitude: '117.02744162848',
    latitude: '36.674856650405'
  },
  41:
  {
    name: '河南省',
    parseid: '',
    longitude: '113.75938408486',
    latitude: '34.771712921931'
  },
  42:
  {
    name: '湖北省',
    parseid: '',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  43:
  {
    name: '湖南省',
    parseid: '',
    longitude: '112.98960254335',
    latitude: '28.118269998009'
  },
  44:
  {
    name: '广东省',
    parseid: '',
    longitude: '113.27242891273',
    latitude: '23.137948556539'
  },
  45:
  {
    name: '广西壮族自治区',
    parseid: '',
    longitude: '108.33452122944',
    latitude: '22.821268997909'
  },
  46:
  {
    name: '海南省',
    parseid: '',
    longitude: '110.3552939684',
    latitude: '20.024489976328'
  },
  50:
  {
    name: '重庆市',
    parseid: '',
    longitude: '106.55843415538',
    latitude: '29.568996245339'
  },
  51:
  {
    name: '四川省',
    parseid: '',
    longitude: '104.07346654728',
    latitude: '30.577543147015'
  },
  52:
  {
    name: '贵州省',
    parseid: '',
    longitude: '106.71447593089',
    latitude: '26.604029544995'
  },
  53:
  {
    name: '云南省',
    parseid: '',
    longitude: '102.71641607523',
    latitude: '25.051562267345'
  },
  54:
  {
    name: '西藏自治区',
    parseid: '',
    longitude: '91.12399286781',
    latitude: '29.654594348363'
  },
  61:
  {
    name: '陕西省',
    parseid: '',
    longitude: '108.96039314875',
    latitude: '34.275808006024'
  },
  62:
  {
    name: '甘肃省',
    parseid: '',
    longitude: '103.83318221998',
    latitude: '36.066455006427'
  },
  63:
  {
    name: '青海省',
    parseid: '',
    longitude: '101.78537335908',
    latitude: '36.629351658335'
  },
  64:
  {
    name: '宁夏回族自治区',
    parseid: '',
    longitude: '106.26560480701',
    latitude: '38.476877967911'
  },
  65:
  {
    name: '新疆维吾尔自治区',
    parseid: '',
    longitude: '87.633473205738',
    latitude: '43.79923810129'
  },
  71:
  {
    name: '台湾省',
    parseid: '',
    longitude: '121.97387097872',
    latitude: '24.086956718805'
  },
  81:
  {
    name: '香港特别行政区',
    parseid: '',
    longitude: '114.18612410257',
    latitude: '22.29358599328'
  },
  82:
  {
    name: '澳门特别行政区',
    parseid: '',
    longitude: '113.55751910182',
    latitude: '22.204117988443'
  },
  1101:
  {
    name: '市辖区',
    parseid: '11',
    longitude: '116.41338369712',
    latitude: '39.9109245473'
  },
  1201:
  {
    name: '市辖区',
    parseid: '12',
    longitude: '117.20952321467',
    latitude: '39.093667843404'
  },
  1301:
  {
    name: '石家庄市',
    parseid: '13',
    longitude: '114.46902163265',
    latitude: '38.052097109847'
  },
  1302:
  {
    name: '唐山市',
    parseid: '13',
    longitude: '118.18645947204',
    latitude: '39.636583724147'
  },
  1303:
  {
    name: '秦皇岛市',
    parseid: '13',
    longitude: '119.60853063334',
    latitude: '39.941748102378'
  },
  1304:
  {
    name: '邯郸市',
    parseid: '13',
    longitude: '114.54562822824',
    latitude: '36.631262731204'
  },
  1305:
  {
    name: '邢台市',
    parseid: '13',
    longitude: '115.03166244306',
    latitude: '37.077166850059'
  },
  1306:
  {
    name: '保定市',
    parseid: '13',
    longitude: '115.47146383769',
    latitude: '38.879987768455'
  },
  1307:
  {
    name: '张家口市',
    parseid: '13',
    longitude: '114.89257223145',
    latitude: '40.773237202691'
  },
  1308:
  {
    name: '承德市',
    parseid: '13',
    longitude: '117.96939750997',
    latitude: '40.957856012338'
  },
  1309:
  {
    name: '沧州市',
    parseid: '13',
    longitude: '116.84558075595',
    latitude: '38.310215141107'
  },
  1310:
  {
    name: '廊坊市',
    parseid: '13',
    longitude: '116.69058173343',
    latitude: '39.543366662759'
  },
  1311:
  {
    name: '衡水市',
    parseid: '13',
    longitude: '115.67540613762',
    latitude: '37.745191408077'
  },
  1401:
  {
    name: '太原市',
    parseid: '14',
    longitude: '112.55639149167',
    latitude: '37.876989028848'
  },
  1402:
  {
    name: '大同市',
    parseid: '14',
    longitude: '113.30643625859',
    latitude: '40.082468716161'
  },
  1403:
  {
    name: '阳泉市',
    parseid: '14',
    longitude: '113.58761666288',
    latitude: '37.862360847859'
  },
  1404:
  {
    name: '长治市',
    parseid: '14',
    longitude: '113.12255886985',
    latitude: '36.201268372155'
  },
  1405:
  {
    name: '晋城市',
    parseid: '14',
    longitude: '112.85857823133',
    latitude: '35.496284586473'
  },
  1406:
  {
    name: '朔州市',
    parseid: '14',
    longitude: '112.43937093967',
    latitude: '39.337108370542'
  },
  1407:
  {
    name: '晋中市',
    parseid: '14',
    longitude: '112.75959475566',
    latitude: '37.69283940976'
  },
  1408:
  {
    name: '运城市',
    parseid: '14',
    longitude: '111.01338945448',
    latitude: '35.032706912909'
  },
  1409:
  {
    name: '忻州市',
    parseid: '14',
    longitude: '112.74062416024',
    latitude: '38.422383385178'
  },
  1410:
  {
    name: '临汾市',
    parseid: '14',
    longitude: '111.52553022403',
    latitude: '36.09374189542'
  },
  1411:
  {
    name: '吕梁市',
    parseid: '14',
    longitude: '111.15044967529',
    latitude: '37.524497749577'
  },
  1501:
  {
    name: '呼和浩特市',
    parseid: '15',
    longitude: '111.75550856171',
    latitude: '40.848422997113'
  },
  1502:
  {
    name: '包头市',
    parseid: '15',
    longitude: '109.84654350721',
    latitude: '40.662928788261'
  },
  1503:
  {
    name: '乌海市',
    parseid: '15',
    longitude: '106.80039105',
    latitude: '39.662006364891'
  },
  1504:
  {
    name: '赤峰市',
    parseid: '15',
    longitude: '118.89552039752',
    latitude: '42.261686103412'
  },
  1505:
  {
    name: '通辽市',
    parseid: '15',
    longitude: '122.25052178738',
    latitude: '43.657980083917'
  },
  1506:
  {
    name: '鄂尔多斯市',
    parseid: '15',
    longitude: '109.78744317924',
    latitude: '39.614482313949'
  },
  1507:
  {
    name: '呼伦贝尔市',
    parseid: '15',
    longitude: '119.77237049947',
    latitude: '49.218446475565'
  },
  1508:
  {
    name: '巴彦淖尔市',
    parseid: '15',
    longitude: '107.39439808372',
    latitude: '40.749359489573'
  },
  1509:
  {
    name: '乌兰察布市',
    parseid: '15',
    longitude: '113.13946767446',
    latitude: '41.000748327674'
  },
  1522:
  {
    name: '兴安盟',
    parseid: '15',
    longitude: '122.04436452583',
    latitude: '46.088463713219'
  },
  1525:
  {
    name: '锡林郭勒盟',
    parseid: '15',
    longitude: '116.05439144075',
    latitude: '43.939422665339'
  },
  1529:
  {
    name: '阿拉善盟',
    parseid: '15',
    longitude: '105.73537746449',
    latitude: '38.858275883057'
  },
  2101:
  {
    name: '沈阳市',
    parseid: '21',
    longitude: '123.47109664482',
    latitude: '41.683830069191'
  },
  2102:
  {
    name: '大连市',
    parseid: '21',
    longitude: '121.62163148459',
    latitude: '38.918953666786'
  },
  2103:
  {
    name: '鞍山市',
    parseid: '21',
    longitude: '123.00137251399',
    latitude: '41.115053596949'
  },
  2104:
  {
    name: '抚顺市',
    parseid: '21',
    longitude: '123.96437461561',
    latitude: '41.885969593057'
  },
  2105:
  {
    name: '本溪市',
    parseid: '21',
    longitude: '123.69250712421',
    latitude: '41.492916460553'
  },
  2106:
  {
    name: '丹东市',
    parseid: '21',
    longitude: '124.36154728159',
    latitude: '40.006408705594'
  },
  2107:
  {
    name: '锦州市',
    parseid: '21',
    longitude: '121.13259630056',
    latitude: '41.100931499462'
  },
  2108:
  {
    name: '营口市',
    parseid: '21',
    longitude: '122.2415746645',
    latitude: '40.673136838267'
  },
  2109:
  {
    name: '阜新市',
    parseid: '21',
    longitude: '121.67640799866',
    latitude: '42.028021901318'
  },
  2110:
  {
    name: '辽阳市',
    parseid: '21',
    longitude: '123.24336640651',
    latitude: '41.274161290454'
  },
  2111:
  {
    name: '盘锦市',
    parseid: '21',
    longitude: '122.07749009021',
    latitude: '41.125875288737'
  },
  2112:
  {
    name: '铁岭市',
    parseid: '21',
    longitude: '123.73236520918',
    latitude: '42.229947997184'
  },
  2113:
  {
    name: '朝阳市',
    parseid: '21',
    longitude: '120.45749949793',
    latitude: '41.579820864756'
  },
  2114:
  {
    name: '葫芦岛市',
    parseid: '21',
    longitude: '120.84339833993',
    latitude: '40.717364436362'
  },
  2201:
  {
    name: '长春市',
    parseid: '22',
    longitude: '125.33060207591',
    latitude: '43.821953501043'
  },
  2202:
  {
    name: '吉林市',
    parseid: '22',
    longitude: '126.55563450495',
    latitude: '43.843567834579'
  },
  2203:
  {
    name: '四平市',
    parseid: '22',
    longitude: '124.35648155716',
    latitude: '43.171993571561'
  },
  2204:
  {
    name: '辽源市',
    parseid: '22',
    longitude: '125.15042516689',
    latitude: '42.894055005746'
  },
  2205:
  {
    name: '通化市',
    parseid: '22',
    longitude: '125.94660627598',
    latitude: '41.733815801613'
  },
  2206:
  {
    name: '白山市',
    parseid: '22',
    longitude: '126.42963008938',
    latitude: '41.939627205329'
  },
  2207:
  {
    name: '松原市',
    parseid: '22',
    longitude: '124.83148187569',
    latitude: '45.147404193414'
  },
  2208:
  {
    name: '白城市',
    parseid: '22',
    longitude: '122.8455906085',
    latitude: '45.625504359996'
  },
  2224:
  {
    name: '延边朝鲜族自治州',
    parseid: '22',
    longitude: '129.47737632023',
    latitude: '42.915743033722'
  },
  2301:
  {
    name: '哈尔滨市',
    parseid: '23',
    longitude: '126.54161509032',
    latitude: '45.808825827952'
  },
  2302:
  {
    name: '齐齐哈尔市',
    parseid: '23',
    longitude: '123.92457086842',
    latitude: '47.359977186015'
  },
  2303:
  {
    name: '鸡西市',
    parseid: '23',
    longitude: '130.97561865877',
    latitude: '45.300872317824'
  },
  2304:
  {
    name: '鹤岗市',
    parseid: '23',
    longitude: '130.30443289867',
    latitude: '47.356056157685'
  },
  2305:
  {
    name: '双鸭山市',
    parseid: '23',
    longitude: '131.16534168078',
    latitude: '46.653185895886'
  },
  2306:
  {
    name: '大庆市',
    parseid: '23',
    longitude: '125.10865763402',
    latitude: '46.593633176722'
  },
  2307:
  {
    name: '伊春市',
    parseid: '23',
    longitude: '128.8475463802',
    latitude: '47.733318457231'
  },
  2308:
  {
    name: '佳木斯市',
    parseid: '23',
    longitude: '130.32735909257',
    latitude: '46.805689990858'
  },
  2309:
  {
    name: '七台河市',
    parseid: '23',
    longitude: '131.01154459103',
    latitude: '45.776300321548'
  },
  2310:
  {
    name: '牡丹江市',
    parseid: '23',
    longitude: '129.63953977835',
    latitude: '44.556245708986'
  },
  2311:
  {
    name: '黑河市',
    parseid: '23',
    longitude: '127.53548988622',
    latitude: '50.25127231175'
  },
  2312:
  {
    name: '绥化市',
    parseid: '23',
    longitude: '126.9753568753',
    latitude: '46.660032179824'
  },
  2327:
  {
    name: '大兴安岭地区',
    parseid: '23',
    longitude: '124.15292785448',
    latitude: '50.420025955028'
  },
  3101:
  {
    name: '市辖区',
    parseid: '31',
    longitude: '121.48053886018',
    latitude: '31.235929042252'
  },
  3201:
  {
    name: '南京市',
    parseid: '32',
    longitude: '118.80242172125',
    latitude: '32.064652885618'
  },
  3202:
  {
    name: '无锡市',
    parseid: '32',
    longitude: '120.31858328811',
    latitude: '31.498809732686'
  },
  3203:
  {
    name: '徐州市',
    parseid: '32',
    longitude: '117.29057543439',
    latitude: '34.212666550113'
  },
  3204:
  {
    name: '常州市',
    parseid: '32',
    longitude: '119.98148471328',
    latitude: '31.815795653328'
  },
  3205:
  {
    name: '苏州市',
    parseid: '32',
    longitude: '120.59241222959',
    latitude: '31.303564074442'
  },
  3206:
  {
    name: '南通市',
    parseid: '32',
    longitude: '120.90159173866',
    latitude: '31.986549431201'
  },
  3207:
  {
    name: '连云港市',
    parseid: '32',
    longitude: '119.22862133317',
    latitude: '34.602249525267'
  },
  3208:
  {
    name: '淮安市',
    parseid: '32',
    longitude: '119.02148367071',
    latitude: '33.616295301033'
  },
  3209:
  {
    name: '盐城市',
    parseid: '32',
    longitude: '120.16754426576',
    latitude: '33.355100917626'
  },
  3210:
  {
    name: '扬州市',
    parseid: '32',
    longitude: '119.41941890823',
    latitude: '32.40067693609'
  },
  3211:
  {
    name: '镇江市',
    parseid: '32',
    longitude: '119.43048944567',
    latitude: '32.194715920524'
  },
  3212:
  {
    name: '泰州市',
    parseid: '32',
    longitude: '119.92956633785',
    latitude: '32.460675049308'
  },
  3213:
  {
    name: '宿迁市',
    parseid: '32',
    longitude: '118.28157403571',
    latitude: '33.96774971569'
  },
  3301:
  {
    name: '杭州市',
    parseid: '33',
    longitude: '120.21551180372',
    latitude: '30.253082981693'
  },
  3302:
  {
    name: '宁波市',
    parseid: '33',
    longitude: '121.62857249434',
    latitude: '29.866033045866'
  },
  3303:
  {
    name: '温州市',
    parseid: '33',
    longitude: '120.70647689036',
    latitude: '28.001085404472'
  },
  3304:
  {
    name: '嘉兴市',
    parseid: '33',
    longitude: '120.76355182586',
    latitude: '30.75097483092'
  },
  3305:
  {
    name: '湖州市',
    parseid: '33',
    longitude: '120.09451660916',
    latitude: '30.898963937294'
  },
  3306:
  {
    name: '绍兴市',
    parseid: '33',
    longitude: '120.58547847885',
    latitude: '30.036369311307'
  },
  3307:
  {
    name: '金华市',
    parseid: '33',
    longitude: '119.65343619053',
    latitude: '29.084639385514'
  },
  3308:
  {
    name: '衢州市',
    parseid: '33',
    longitude: '118.86659674036',
    latitude: '28.975545802265'
  },
  3309:
  {
    name: '舟山市',
    parseid: '33',
    longitude: '122.21355631852',
    latitude: '29.99091168016'
  },
  3310:
  {
    name: '台州市',
    parseid: '33',
    longitude: '121.42743470428',
    latitude: '28.662194055996'
  },
  3311:
  {
    name: '丽水市',
    parseid: '33',
    longitude: '119.92957305844',
    latitude: '28.473278180563'
  },
  3401:
  {
    name: '合肥市',
    parseid: '34',
    longitude: '117.23344266498',
    latitude: '31.826577833687'
  },
  3402:
  {
    name: '芜湖市',
    parseid: '34',
    longitude: '118.43943137654',
    latitude: '31.358536655799'
  },
  3403:
  {
    name: '蚌埠市',
    parseid: '34',
    longitude: '117.39551332814',
    latitude: '32.921523704351'
  },
  3404:
  {
    name: '淮南市',
    parseid: '34',
    longitude: '117.00638885072',
    latitude: '32.631847399053'
  },
  3405:
  {
    name: '马鞍山市',
    parseid: '34',
    longitude: '118.51357957943',
    latitude: '31.676265597609'
  },
  3406:
  {
    name: '淮北市',
    parseid: '34',
    longitude: '116.80453726703',
    latitude: '33.961656300276'
  },
  3407:
  {
    name: '铜陵市',
    parseid: '34',
    longitude: '117.81847679446',
    latitude: '30.951233239913'
  },
  3408:
  {
    name: '安庆市',
    parseid: '34',
    longitude: '117.06360390492',
    latitude: '30.530956568043'
  },
  3410:
  {
    name: '黄山市',
    parseid: '34',
    longitude: '118.34543725315',
    latitude: '29.721889786592'
  },
  3411:
  {
    name: '滁州市',
    parseid: '34',
    longitude: '118.33940613597',
    latitude: '32.261270872041'
  },
  3412:
  {
    name: '阜阳市',
    parseid: '34',
    longitude: '115.82043612491',
    latitude: '32.896060994852'
  },
  3413:
  {
    name: '宿州市',
    parseid: '34',
    longitude: '116.97054394561',
    latitude: '33.652095326452'
  },
  3415:
  {
    name: '六安市',
    parseid: '34',
    longitude: '116.52640966419',
    latitude: '31.741450815323'
  },
  3416:
  {
    name: '亳州市',
    parseid: '34',
    longitude: '115.78446321127',
    latitude: '33.850642695789'
  },
  3417:
  {
    name: '池州市',
    parseid: '34',
    longitude: '117.4984209616',
    latitude: '30.670883790765'
  },
  3418:
  {
    name: '宣城市',
    parseid: '34',
    longitude: '118.76553424277',
    latitude: '30.946601545293'
  },
  3501:
  {
    name: '福州市',
    parseid: '35',
    longitude: '119.30346983854',
    latitude: '26.080429420698'
  },
  3502:
  {
    name: '厦门市',
    parseid: '35',
    longitude: '118.09643549977',
    latitude: '24.485406605176'
  },
  3503:
  {
    name: '莆田市',
    parseid: '35',
    longitude: '119.01452097813',
    latitude: '25.459865455923'
  },
  3504:
  {
    name: '三明市',
    parseid: '35',
    longitude: '117.64552116782',
    latitude: '26.269736515992'
  },
  3505:
  {
    name: '泉州市',
    parseid: '35',
    longitude: '118.6824462668',
    latitude: '24.879952330498'
  },
  3506:
  {
    name: '漳州市',
    parseid: '35',
    longitude: '117.65357645299',
    latitude: '24.518929791171'
  },
  3507:
  {
    name: '南平市',
    parseid: '35',
    longitude: '118.18436954814',
    latitude: '26.647772874203'
  },
  3508:
  {
    name: '龙岩市',
    parseid: '35',
    longitude: '117.02344756678',
    latitude: '25.081219844872'
  },
  3509:
  {
    name: '宁德市',
    parseid: '35',
    longitude: '119.55451074543',
    latitude: '26.672241711409'
  },
  3601:
  {
    name: '南昌市',
    parseid: '36',
    longitude: '115.86458944232',
    latitude: '28.689455295061'
  },
  3602:
  {
    name: '景德镇市',
    parseid: '36',
    longitude: '117.18457644639',
    latitude: '29.274247711041'
  },
  3603:
  {
    name: '萍乡市',
    parseid: '36',
    longitude: '113.86149643375',
    latitude: '27.628392709397'
  },
  3604:
  {
    name: '九江市',
    parseid: '36',
    longitude: '116.00753491163',
    latitude: '29.711340559079'
  },
  3605:
  {
    name: '新余市',
    parseid: '36',
    longitude: '114.9235346514',
    latitude: '27.823578697789'
  },
  3606:
  {
    name: '鹰潭市',
    parseid: '36',
    longitude: '117.07557542703',
    latitude: '28.265787063191'
  },
  3607:
  {
    name: '赣州市',
    parseid: '36',
    longitude: '114.94050337298',
    latitude: '25.835176103498'
  },
  3608:
  {
    name: '吉安市',
    parseid: '36',
    longitude: '115.00051072001',
    latitude: '27.11972682607'
  },
  3609:
  {
    name: '宜春市',
    parseid: '36',
    longitude: '114.42356367591',
    latitude: '27.820856421848'
  },
  3610:
  {
    name: '抚州市',
    parseid: '36',
    longitude: '116.36453876864',
    latitude: '27.95489225342'
  },
  3611:
  {
    name: '上饶市',
    parseid: '36',
    longitude: '117.94945960312',
    latitude: '28.460625921852'
  },
  3701:
  {
    name: '济南市',
    parseid: '37',
    longitude: '117.12639941261',
    latitude: '36.656554201787'
  },
  3702:
  {
    name: '青岛市',
    parseid: '37',
    longitude: '120.38945519115',
    latitude: '36.072227496663'
  },
  3703:
  {
    name: '淄博市',
    parseid: '37',
    longitude: '118.0614525349',
    latitude: '36.819085683322'
  },
  3704:
  {
    name: '枣庄市',
    parseid: '37',
    longitude: '117.33054194484',
    latitude: '34.815994048435'
  },
  3705:
  {
    name: '东营市',
    parseid: '37',
    longitude: '118.68138493514',
    latitude: '37.439641826323'
  },
  3706:
  {
    name: '烟台市',
    parseid: '37',
    longitude: '121.4544154173',
    latitude: '37.470038383731'
  },
  3707:
  {
    name: '潍坊市',
    parseid: '37',
    longitude: '119.16837791143',
    latitude: '36.712651551268'
  },
  3708:
  {
    name: '济宁市',
    parseid: '37',
    longitude: '116.59361234854',
    latitude: '35.42017739453'
  },
  3709:
  {
    name: '泰安市',
    parseid: '37',
    longitude: '117.0944948348',
    latitude: '36.205858044885'
  },
  3710:
  {
    name: '威海市',
    parseid: '37',
    longitude: '122.12754097831',
    latitude: '37.516430548015'
  },
  3711:
  {
    name: '日照市',
    parseid: '37',
    longitude: '119.53341540457',
    latitude: '35.422838998438'
  },
  3713:
  {
    name: '临沂市',
    parseid: '37',
    longitude: '118.36353300501',
    latitude: '35.110671242365'
  },
  3714:
  {
    name: '德州市',
    parseid: '37',
    longitude: '116.36555674397',
    latitude: '37.441308454576'
  },
  3715:
  {
    name: '聊城市',
    parseid: '37',
    longitude: '115.9915878483',
    latitude: '36.462758187694'
  },
  3716:
  {
    name: '滨州市',
    parseid: '37',
    longitude: '117.97740401715',
    latitude: '37.388196196077'
  },
  3717:
  {
    name: '菏泽市',
    parseid: '37',
    longitude: '115.48754503343',
    latitude: '35.239407424766'
  },
  4101:
  {
    name: '郑州市',
    parseid: '41',
    longitude: '113.63141920734',
    latitude: '34.753438850454'
  },
  4102:
  {
    name: '开封市',
    parseid: '41',
    longitude: '114.31459258497',
    latitude: '34.802885811212'
  },
  4103:
  {
    name: '洛阳市',
    parseid: '41',
    longitude: '112.45942129831',
    latitude: '34.624262779219'
  },
  4104:
  {
    name: '平顶山市',
    parseid: '41',
    longitude: '113.19952856052',
    latitude: '33.772050748691'
  },
  4105:
  {
    name: '安阳市',
    parseid: '41',
    longitude: '114.39950042177',
    latitude: '36.105940984015'
  },
  4106:
  {
    name: '鹤壁市',
    parseid: '41',
    longitude: '114.30359364248',
    latitude: '35.7523574114'
  },
  4107:
  {
    name: '新乡市',
    parseid: '41',
    longitude: '113.93360046733',
    latitude: '35.309639930337'
  },
  4108:
  {
    name: '焦作市',
    parseid: '41',
    longitude: '113.24854783457',
    latitude: '35.220963254039'
  },
  4109:
  {
    name: '濮阳市',
    parseid: '41',
    longitude: '115.03559747034',
    latitude: '35.767593028906'
  },
  4110:
  {
    name: '许昌市',
    parseid: '41',
    longitude: '113.85847553686',
    latitude: '34.041431611619'
  },
  4111:
  {
    name: '漯河市',
    parseid: '41',
    longitude: '114.02342077765',
    latitude: '33.587710707102'
  },
  4112:
  {
    name: '三门峡市',
    parseid: '41',
    longitude: '111.20653322387',
    latitude: '34.77832724946'
  },
  4113:
  {
    name: '南阳市',
    parseid: '41',
    longitude: '112.53450131351',
    latitude: '32.996562204651'
  },
  4114:
  {
    name: '商丘市',
    parseid: '41',
    longitude: '115.66244933826',
    latitude: '34.420201665859'
  },
  4115:
  {
    name: '信阳市',
    parseid: '41',
    longitude: '114.09748283305',
    latitude: '32.153014547531'
  },
  4116:
  {
    name: '周口市',
    parseid: '41',
    longitude: '114.70348251482',
    latitude: '33.631828875702'
  },
  4117:
  {
    name: '驻马店市',
    parseid: '41',
    longitude: '114.02847078173',
    latitude: '33.017842416744'
  },
  4190:
  {
    name: '省直辖县级行政区划',
    parseid: '41',
    longitude: '113.75938408486',
    latitude: '34.771712921931'
  },
  4201:
  {
    name: '武汉市',
    parseid: '42',
    longitude: '114.31158155473',
    latitude: '30.598466736401'
  },
  4202:
  {
    name: '黄石市',
    parseid: '42',
    longitude: '115.04553290894',
    latitude: '30.205207848942'
  },
  4203:
  {
    name: '十堰市',
    parseid: '42',
    longitude: '110.8045295607',
    latitude: '32.635061858401'
  },
  4205:
  {
    name: '宜昌市',
    parseid: '42',
    longitude: '111.29254921035',
    latitude: '30.697446484492'
  },
  4206:
  {
    name: '襄阳市',
    parseid: '42',
    longitude: '112.128537201',
    latitude: '32.014796804669'
  },
  4207:
  {
    name: '鄂州市',
    parseid: '42',
    longitude: '114.90160738827',
    latitude: '30.396572173317'
  },
  4208:
  {
    name: '荆门市',
    parseid: '42',
    longitude: '112.20639298023',
    latitude: '31.04173257557'
  },
  4209:
  {
    name: '孝感市',
    parseid: '42',
    longitude: '113.92251007734',
    latitude: '30.930689227018'
  },
  4210:
  {
    name: '荆州市',
    parseid: '42',
    longitude: '112.24552262926',
    latitude: '30.340842107743'
  },
  4211:
  {
    name: '黄冈市',
    parseid: '42',
    longitude: '114.87849048411',
    latitude: '30.459358857618'
  },
  4212:
  {
    name: '咸宁市',
    parseid: '42',
    longitude: '114.32851909027',
    latitude: '29.847055947646'
  },
  4213:
  {
    name: '随州市',
    parseid: '42',
    longitude: '113.38945001822',
    latitude: '31.696516772328'
  },
  4228:
  {
    name: '恩施土家族苗族自治州',
    parseid: '42',
    longitude: '109.49459261858',
    latitude: '30.277939575301'
  },
  4290:
  {
    name: '省直辖县级行政区划',
    parseid: '42',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  4301:
  {
    name: '长沙市',
    parseid: '43',
    longitude: '112.94547319535',
    latitude: '28.234889399944'
  },
  4302:
  {
    name: '株洲市',
    parseid: '43',
    longitude: '113.14047079776',
    latitude: '27.833567639016'
  },
  4303:
  {
    name: '湘潭市',
    parseid: '43',
    longitude: '112.95046418076',
    latitude: '27.835702227136'
  },
  4304:
  {
    name: '衡阳市',
    parseid: '43',
    longitude: '112.57844721326',
    latitude: '26.899576139189'
  },
  4305:
  {
    name: '邵阳市',
    parseid: '43',
    longitude: '111.47443288593',
    latitude: '27.245270272809'
  },
  4306:
  {
    name: '岳阳市',
    parseid: '43',
    longitude: '113.13548942422',
    latitude: '29.363178293926'
  },
  4307:
  {
    name: '常德市',
    parseid: '43',
    longitude: '111.70545217996',
    latitude: '29.037749999407'
  },
  4308:
  {
    name: '张家界市',
    parseid: '43',
    longitude: '110.48553254695',
    latitude: '29.122815562552'
  },
  4309:
  {
    name: '益阳市',
    parseid: '43',
    longitude: '112.36151595471',
    latitude: '28.55971117849'
  },
  4310:
  {
    name: '郴州市',
    parseid: '43',
    longitude: '113.02146049909',
    latitude: '25.776683273602'
  },
  4311:
  {
    name: '永州市',
    parseid: '43',
    longitude: '111.61945505792',
    latitude: '26.4258641179'
  },
  4312:
  {
    name: '怀化市',
    parseid: '43',
    longitude: '110.00851426537',
    latitude: '27.575160902979'
  },
  4313:
  {
    name: '娄底市',
    parseid: '43',
    longitude: '112.00150349288',
    latitude: '27.703208596992'
  },
  4331:
  {
    name: '湘西土家族苗族自治州',
    parseid: '43',
    longitude: '109.74557664947',
    latitude: '28.317369104701'
  },
  4401:
  {
    name: '广州市',
    parseid: '44',
    longitude: '113.27143134446',
    latitude: '23.135336306695'
  },
  4402:
  {
    name: '韶关市',
    parseid: '44',
    longitude: '113.60352734562',
    latitude: '24.815881278583'
  },
  4403:
  {
    name: '深圳市',
    parseid: '44',
    longitude: '114.06455183659',
    latitude: '22.548456637984'
  },
  4404:
  {
    name: '珠海市',
    parseid: '44',
    longitude: '113.58255478655',
    latitude: '22.276564654249'
  },
  4405:
  {
    name: '汕头市',
    parseid: '44',
    longitude: '116.68852864055',
    latitude: '23.359091717725'
  },
  4406:
  {
    name: '佛山市',
    parseid: '44',
    longitude: '113.1285121955',
    latitude: '23.027758750789'
  },
  4407:
  {
    name: '江门市',
    parseid: '44',
    longitude: '113.08855619524',
    latitude: '22.584603880965'
  },
  4408:
  {
    name: '湛江市',
    parseid: '44',
    longitude: '110.36555441393',
    latitude: '21.276723439012'
  },
  4409:
  {
    name: '茂名市',
    parseid: '44',
    longitude: '110.93154257997',
    latitude: '21.669064031332'
  },
  4412:
  {
    name: '肇庆市',
    parseid: '44',
    longitude: '112.47148894063',
    latitude: '23.052888771126'
  },
  4413:
  {
    name: '惠州市',
    parseid: '44',
    longitude: '114.42355801658',
    latitude: '23.116358854726'
  },
  4414:
  {
    name: '梅州市',
    parseid: '44',
    longitude: '116.12953737612',
    latitude: '24.294177532206'
  },
  4415:
  {
    name: '汕尾市',
    parseid: '44',
    longitude: '115.38155260365',
    latitude: '22.791263036547'
  },
  4416:
  {
    name: '河源市',
    parseid: '44',
    longitude: '114.70744627291',
    latitude: '23.74968437096'
  },
  4417:
  {
    name: '阳江市',
    parseid: '44',
    longitude: '111.98848929181',
    latitude: '21.864339726139'
  },
  4418:
  {
    name: '清远市',
    parseid: '44',
    longitude: '113.06246832527',
    latitude: '23.688230292088'
  },
  4419:
  {
    name: '东莞市',
    parseid: '44',
    longitude: '113.75842045788',
    latitude: '23.027308411643'
  },
  4420:
  {
    name: '中山市',
    parseid: '44',
    longitude: '113.39942236263',
    latitude: '22.522314670791'
  },
  4451:
  {
    name: '潮州市',
    parseid: '44',
    longitude: '116.62947017363',
    latitude: '23.662623192616'
  },
  4452:
  {
    name: '揭阳市',
    parseid: '44',
    longitude: '116.37851218034',
    latitude: '23.555740488276'
  },
  4453:
  {
    name: '云浮市',
    parseid: '44',
    longitude: '112.05151269959',
    latitude: '22.920911970343'
  },
  4501:
  {
    name: '南宁市',
    parseid: '45',
    longitude: '108.37345082582',
    latitude: '22.822606601187'
  },
  4502:
  {
    name: '柳州市',
    parseid: '45',
    longitude: '109.43442194635',
    latitude: '24.331961386852'
  },
  4503:
  {
    name: '桂林市',
    parseid: '45',
    longitude: '110.20354537458',
    latitude: '25.242885724873'
  },
  4504:
  {
    name: '梧州市',
    parseid: '45',
    longitude: '111.28551681182',
    latitude: '23.482745281135'
  },
  4505:
  {
    name: '北海市',
    parseid: '45',
    longitude: '109.12653321257',
    latitude: '21.486836495769'
  },
  4506:
  {
    name: '防城港市',
    parseid: '45',
    longitude: '108.3604188383',
    latitude: '21.693005289969'
  },
  4507:
  {
    name: '钦州市',
    parseid: '45',
    longitude: '108.66058016842',
    latitude: '21.986593539484'
  },
  4508:
  {
    name: '贵港市',
    parseid: '45',
    longitude: '109.60552031033',
    latitude: '23.117448382038'
  },
  4509:
  {
    name: '玉林市',
    parseid: '45',
    longitude: '110.18845312337',
    latitude: '22.659830509953'
  },
  4510:
  {
    name: '百色市',
    parseid: '45',
    longitude: '106.62458932565',
    latitude: '23.908185934296'
  },
  4511:
  {
    name: '贺州市',
    parseid: '45',
    longitude: '111.57352631416',
    latitude: '24.409450902865'
  },
  4512:
  {
    name: '河池市',
    parseid: '45',
    longitude: '108.09149994499',
    latitude: '24.698911731273'
  },
  4513:
  {
    name: '来宾市',
    parseid: '45',
    longitude: '109.2274581959',
    latitude: '23.756546762607'
  },
  4514:
  {
    name: '崇左市',
    parseid: '45',
    longitude: '107.3715202061',
    latitude: '22.383117234663'
  },
  4601:
  {
    name: '海口市',
    parseid: '46',
    longitude: '110.32552547126',
    latitude: '20.044049439257'
  },
  4602:
  {
    name: '三亚市',
    parseid: '46',
    longitude: '109.5185567014',
    latitude: '18.258736291748'
  },
  4603:
  {
    name: '三沙市',
    parseid: '46',
    longitude: '112.26157741483',
    latitude: '30.316571904872'
  },
  4604:
  {
    name: '儋州市',
    parseid: '46',
    longitude: '109.17398808756',
    latitude: '19.642787582321'
  },
  4690:
  {
    name: '省直辖县级行政区划',
    parseid: '46',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  5001:
  {
    name: '市辖区',
    parseid: '50',
    longitude: '106.55843415538',
    latitude: '29.568996245339'
  },
  5002:
  {
    name: '县',
    parseid: '50',
    longitude: '106.55843415538',
    latitude: '29.568996245339'
  },
  5101:
  {
    name: '成都市',
    parseid: '51',
    longitude: '104.08153351042',
    latitude: '30.655821878416'
  },
  5103:
  {
    name: '自贡市',
    parseid: '51',
    longitude: '104.78444884672',
    latitude: '29.345584921328'
  },
  5104:
  {
    name: '攀枝花市',
    parseid: '51',
    longitude: '101.72554117091',
    latitude: '26.588033173333'
  },
  5105:
  {
    name: '泸州市',
    parseid: '51',
    longitude: '105.44852406933',
    latitude: '28.877668303607'
  },
  5106:
  {
    name: '德阳市',
    parseid: '51',
    longitude: '104.40441936496',
    latitude: '31.133115003657'
  },
  5107:
  {
    name: '绵阳市',
    parseid: '51',
    longitude: '104.68556186076',
    latitude: '31.473663048746'
  },
  5108:
  {
    name: '广元市',
    parseid: '51',
    longitude: '105.85042318166',
    latitude: '32.441616305315'
  },
  5109:
  {
    name: '遂宁市',
    parseid: '51',
    longitude: '105.59942153064',
    latitude: '30.539097671109'
  },
  5110:
  {
    name: '内江市',
    parseid: '51',
    longitude: '105.064588025',
    latitude: '29.58588653832'
  },
  5111:
  {
    name: '乐山市',
    parseid: '51',
    longitude: '103.77253760363',
    latitude: '29.557940717458'
  },
  5113:
  {
    name: '南充市',
    parseid: '51',
    longitude: '106.11750261487',
    latitude: '30.843782508337'
  },
  5114:
  {
    name: '眉山市',
    parseid: '51',
    longitude: '103.85656331579',
    latitude: '30.082526119421'
  },
  5115:
  {
    name: '宜宾市',
    parseid: '51',
    longitude: '104.64940370487',
    latitude: '28.758007028552'
  },
  5116:
  {
    name: '广安市',
    parseid: '51',
    longitude: '106.63955268233',
    latitude: '30.461746110679'
  },
  5117:
  {
    name: '达州市',
    parseid: '51',
    longitude: '107.47459385898',
    latitude: '31.214307723927'
  },
  5118:
  {
    name: '雅安市',
    parseid: '51',
    longitude: '103.0495426236',
    latitude: '30.016792545706'
  },
  5119:
  {
    name: '巴中市',
    parseid: '51',
    longitude: '106.75158530316',
    latitude: '31.872888585957'
  },
  5120:
  {
    name: '资阳市',
    parseid: '51',
    longitude: '104.63443534164',
    latitude: '30.134956559253'
  },
  5132:
  {
    name: '阿坝藏族羌族自治州',
    parseid: '51',
    longitude: '101.71360970816',
    latitude: '32.908220918625'
  },
  5133:
  {
    name: '甘孜藏族自治州',
    parseid: '51',
    longitude: '101.96854674579',
    latitude: '30.055278843518'
  },
  5134:
  {
    name: '凉山彝族自治州',
    parseid: '51',
    longitude: '102.27350268097',
    latitude: '27.88775230037'
  },
  5201:
  {
    name: '贵阳市',
    parseid: '52',
    longitude: '106.63657676353',
    latitude: '26.65332482231'
  },
  5202:
  {
    name: '六盘水市',
    parseid: '52',
    longitude: '104.83755460235',
    latitude: '26.598833108257'
  },
  5203:
  {
    name: '遵义市',
    parseid: '52',
    longitude: '106.93342774802',
    latitude: '27.731700878917'
  },
  5204:
  {
    name: '安顺市',
    parseid: '52',
    longitude: '105.95441712389',
    latitude: '26.259252378715'
  },
  5205:
  {
    name: '毕节市',
    parseid: '52',
    longitude: '105.29858879501',
    latitude: '27.290215083426'
  },
  5206:
  {
    name: '铜仁市',
    parseid: '52',
    longitude: '109.19643889818',
    latitude: '27.737786456405'
  },
  5223:
  {
    name: '黔西南布依族苗族自治州',
    parseid: '52',
    longitude: '106.03857397726',
    latitude: '27.014344747084'
  },
  5226:
  {
    name: '黔东南苗族侗族自治州',
    parseid: '52',
    longitude: '107.98944624078',
    latitude: '26.589702969826'
  },
  5227:
  {
    name: '黔南布依族苗族自治州',
    parseid: '52',
    longitude: '107.52840270574',
    latitude: '26.260616196074'
  },
  5301:
  {
    name: '昆明市',
    parseid: '53',
    longitude: '102.852448365',
    latitude: '24.873998150044'
  },
  5303:
  {
    name: '曲靖市',
    parseid: '53',
    longitude: '103.80243482795',
    latitude: '25.496406931544'
  },
  5304:
  {
    name: '玉溪市',
    parseid: '53',
    longitude: '102.55356029311',
    latitude: '24.357710942446'
  },
  5305:
  {
    name: '保山市',
    parseid: '53',
    longitude: '99.177273285818',
    latitude: '25.139038793266'
  },
  5306:
  {
    name: '昭通市',
    parseid: '53',
    longitude: '103.72351177197',
    latitude: '27.344083860247'
  },
  5307:
  {
    name: '丽江市',
    parseid: '53',
    longitude: '100.23246452903',
    latitude: '26.860657438065'
  },
  5308:
  {
    name: '普洱市',
    parseid: '53',
    longitude: '100.97256981473',
    latitude: '22.83097918601'
  },
  5309:
  {
    name: '临沧市',
    parseid: '53',
    longitude: '100.09544042015',
    latitude: '23.890468556279'
  },
  5323:
  {
    name: '楚雄彝族自治州',
    parseid: '53',
    longitude: '101.5344124805',
    latitude: '25.05177356534'
  },
  5325:
  {
    name: '红河哈尼族彝族自治州',
    parseid: '53',
    longitude: '102.42755057757',
    latitude: '23.374488738365'
  },
  5326:
  {
    name: '文山壮族苗族自治州',
    parseid: '53',
    longitude: '104.22256899109',
    latitude: '23.405994293612'
  },
  5328:
  {
    name: '西双版纳傣族自治州',
    parseid: '53',
    longitude: '100.80344682456',
    latitude: '22.013601254764'
  },
  5329:
  {
    name: '大理白族自治州',
    parseid: '53',
    longitude: '100.23651930044',
    latitude: '25.597604905452'
  },
  5331:
  {
    name: '德宏傣族景颇族自治州',
    parseid: '53',
    longitude: '98.591359356114',
    latitude: '24.438010702758'
  },
  5333:
  {
    name: '怒江傈僳族自治州',
    parseid: '53',
    longitude: '98.863288381358',
    latitude: '25.823707417658'
  },
  5334:
  {
    name: '迪庆藏族自治州',
    parseid: '53',
    longitude: '99.70952999014',
    latitude: '27.825184683643'
  },
  5401:
  {
    name: '拉萨市',
    parseid: '54',
    longitude: '91.120823915464',
    latitude: '29.650040274768'
  },
  5402:
  {
    name: '日喀则市',
    parseid: '54',
    longitude: '88.893703034826',
    latitude: '29.275657822512'
  },
  5403:
  {
    name: '昌都市',
    parseid: '54',
    longitude: '97.179583594086',
    latitude: '31.147346549327'
  },
  5404:
  {
    name: '林芝市',
    parseid: '54',
    longitude: '94.368058287133',
    latitude: '29.654042176952'
  },
  5405:
  {
    name: '山南市',
    parseid: '54',
    longitude: '91.778675138519',
    latitude: '29.243026939249'
  },
  5406:
  {
    name: '那曲市',
    parseid: '54',
    longitude: '92.057338498175',
    latitude: '31.482438388455'
  },
  5425:
  {
    name: '阿里地区',
    parseid: '54',
    longitude: '80.112776921926',
    latitude: '32.506866017633'
  },
  6101:
  {
    name: '西安市',
    parseid: '61',
    longitude: '108.94646555063',
    latitude: '34.347268816624'
  },
  6102:
  {
    name: '铜川市',
    parseid: '61',
    longitude: '108.95240424836',
    latitude: '34.902637080503'
  },
  6103:
  {
    name: '宝鸡市',
    parseid: '61',
    longitude: '107.24457536704',
    latitude: '34.36891564287'
  },
  6104:
  {
    name: '咸阳市',
    parseid: '61',
    longitude: '108.71542245143',
    latitude: '34.335476293369'
  },
  6105:
  {
    name: '渭南市',
    parseid: '61',
    longitude: '109.51658960526',
    latitude: '34.505715516753'
  },
  6106:
  {
    name: '延安市',
    parseid: '61',
    longitude: '109.49658191613',
    latitude: '36.591111035218'
  },
  6107:
  {
    name: '汉中市',
    parseid: '61',
    longitude: '107.02943020926',
    latitude: '33.073799907834'
  },
  6108:
  {
    name: '榆林市',
    parseid: '61',
    longitude: '109.74161603381',
    latitude: '38.290883835484'
  },
  6109:
  {
    name: '安康市',
    parseid: '61',
    longitude: '109.03560108266',
    latitude: '32.690512770574'
  },
  6110:
  {
    name: '商洛市',
    parseid: '61',
    longitude: '109.92441788136',
    latitude: '33.878633852208'
  },
  6201:
  {
    name: '兰州市',
    parseid: '62',
    longitude: '103.84052119634',
    latitude: '36.067234693546'
  },
  6202:
  {
    name: '嘉峪关市',
    parseid: '62',
    longitude: '98.296203843001',
    latitude: '39.777960147391'
  },
  6203:
  {
    name: '金昌市',
    parseid: '62',
    longitude: '102.1946056867',
    latitude: '38.525820092093'
  },
  6204:
  {
    name: '白银市',
    parseid: '62',
    longitude: '104.14445082834',
    latitude: '36.550825330415'
  },
  6205:
  {
    name: '天水市',
    parseid: '62',
    longitude: '105.73141674567',
    latitude: '34.587411881651'
  },
  6206:
  {
    name: '武威市',
    parseid: '62',
    longitude: '102.64455434037',
    latitude: '37.934377808158'
  },
  6207:
  {
    name: '张掖市',
    parseid: '62',
    longitude: '100.45641147406',
    latitude: '38.932066007005'
  },
  6208:
  {
    name: '平凉市',
    parseid: '62',
    longitude: '106.67144234828',
    latitude: '35.549232050464'
  },
  6209:
  {
    name: '酒泉市',
    parseid: '62',
    longitude: '98.500685216068',
    latitude: '39.738469080716'
  },
  6210:
  {
    name: '庆阳市',
    parseid: '62',
    longitude: '107.64938569595',
    latitude: '35.715215983562'
  },
  6211:
  {
    name: '定西市',
    parseid: '62',
    longitude: '104.63242008306',
    latitude: '35.586832926562'
  },
  6212:
  {
    name: '陇南市',
    parseid: '62',
    longitude: '104.92857497071',
    latitude: '33.406620229951'
  },
  6229:
  {
    name: '临夏回族自治州',
    parseid: '62',
    longitude: '103.2495491776',
    latitude: '35.609898772689'
  },
  6230:
  {
    name: '甘南藏族自治州',
    parseid: '62',
    longitude: '102.91758468826',
    latitude: '34.989139909968'
  },
  6301:
  {
    name: '西宁市',
    parseid: '63',
    longitude: '101.78445017051',
    latitude: '36.623384696517'
  },
  6302:
  {
    name: '海东市',
    parseid: '63',
    longitude: '102.11044407228',
    latitude: '36.508511080941'
  },
  6322:
  {
    name: '海北藏族自治州',
    parseid: '63',
    longitude: '100.90743432146',
    latitude: '36.96066282413'
  },
  6323:
  {
    name: '黄南藏族自治州',
    parseid: '63',
    longitude: '102.02242827808',
    latitude: '35.525804586516'
  },
  6325:
  {
    name: '海南藏族自治州',
    parseid: '63',
    longitude: '100.62662114446',
    latitude: '36.292102479899'
  },
  6326:
  {
    name: '果洛藏族自治州',
    parseid: '63',
    longitude: '100.2515919788',
    latitude: '34.477193866471'
  },
  6327:
  {
    name: '玉树藏族自治州',
    parseid: '63',
    longitude: '97.013180762773',
    latitude: '33.010979585143'
  },
  6328:
  {
    name: '海西蒙古族藏族自治州',
    parseid: '63',
    longitude: '97.376299116019',
    latitude: '37.382750462527'
  },
  6401:
  {
    name: '银川市',
    parseid: '64',
    longitude: '106.2384935874',
    latitude: '38.49246005551'
  },
  6402:
  {
    name: '石嘴山市',
    parseid: '64',
    longitude: '106.3906004255',
    latitude: '38.989682839915'
  },
  6403:
  {
    name: '吴忠市',
    parseid: '64',
    longitude: '106.20537126664',
    latitude: '38.003712913453'
  },
  6404:
  {
    name: '固原市',
    parseid: '64',
    longitude: '106.24857742607',
    latitude: '36.021617258011'
  },
  6405:
  {
    name: '中卫市',
    parseid: '64',
    longitude: '105.20357090089',
    latitude: '37.505701418703'
  },
  6501:
  {
    name: '乌鲁木齐市',
    parseid: '65',
    longitude: '87.62443993536',
    latitude: '43.83076320429'
  },
  6502:
  {
    name: '克拉玛依市',
    parseid: '65',
    longitude: '84.895900538875',
    latitude: '45.585675237814'
  },
  6504:
  {
    name: '吐鲁番市',
    parseid: '65',
    longitude: '89.197297246008',
    latitude: '42.956984848771'
  },
  6505:
  {
    name: '哈密市',
    parseid: '65',
    longitude: '93.521215540285',
    latitude: '42.825824368113'
  },
  6523:
  {
    name: '昌吉回族自治州',
    parseid: '65',
    longitude: '87.315001624474',
    latitude: '44.01685415992'
  },
  6527:
  {
    name: '博尔塔拉蒙古自治州',
    parseid: '65',
    longitude: '82.072914758274',
    latitude: '44.912196413465'
  },
  6528:
  {
    name: '巴音郭楞蒙古自治州',
    parseid: '65',
    longitude: '86.151713865333',
    latitude: '41.77028733045'
  },
  6529:
  {
    name: '阿克苏地区',
    parseid: '65',
    longitude: '80.266943484735',
    latitude: '41.175029860077'
  },
  6530:
  {
    name: '克孜勒苏柯尔克孜自治州',
    parseid: '65',
    longitude: '76.174308676212',
    latitude: '39.720471204871'
  },
  6531:
  {
    name: '喀什地区',
    parseid: '65',
    longitude: '75.996390556397',
    latitude: '39.476096748645'
  },
  6532:
  {
    name: '和田地区',
    parseid: '65',
    longitude: '79.928507063512',
    latitude: '37.120446463042'
  },
  6540:
  {
    name: '伊犁哈萨克自治州',
    parseid: '65',
    longitude: '81.330537747532',
    latitude: '43.922723137492'
  },
  6542:
  {
    name: '塔城地区',
    parseid: '65',
    longitude: '82.987235518406',
    latitude: '46.750948254373'
  },
  6543:
  {
    name: '阿勒泰地区',
    parseid: '65',
    longitude: '88.147926203735',
    latitude: '47.850727870102'
  },
  6590:
  {
    name: '自治区',
    parseid: '65',
    longitude: '87.633473205738',
    latitude: '43.79923810129'
  },
  110101:
  {
    name: '东城区',
    parseid: '1101',
    longitude: '116.42240097766',
    latitude: '39.934827272396'
  },
  110102:
  {
    name: '西城区',
    parseid: '1101',
    longitude: '116.37251358117',
    latitude: '39.918123605841'
  },
  110105:
  {
    name: '朝阳区',
    parseid: '1101',
    longitude: '116.4495587295',
    latitude: '39.92637452308'
  },
  110106:
  {
    name: '丰台区',
    parseid: '1101',
    longitude: '116.29240188731',
    latitude: '39.864937197557'
  },
  110107:
  {
    name: '石景山区',
    parseid: '1101',
    longitude: '116.22961266776',
    latitude: '39.911353808778'
  },
  110108:
  {
    name: '海淀区',
    parseid: '1101',
    longitude: '116.3054340545',
    latitude: '39.965489841101'
  },
  110109:
  {
    name: '门头沟区',
    parseid: '1101',
    longitude: '116.10760355577',
    latitude: '39.946146720034'
  },
  110111:
  {
    name: '房山区',
    parseid: '1101',
    longitude: '116.14944375184',
    latitude: '39.754325839773'
  },
  110112:
  {
    name: '通州区',
    parseid: '1101',
    longitude: '116.66341535785',
    latitude: '39.916017122432'
  },
  110113:
  {
    name: '顺义区',
    parseid: '1101',
    longitude: '116.66142426369',
    latitude: '40.136350762231'
  },
  110114:
  {
    name: '昌平区',
    parseid: '1101',
    longitude: '116.23761791731',
    latitude: '40.226413371594'
  },
  110115:
  {
    name: '大兴区',
    parseid: '1101',
    longitude: '116.34862521223',
    latitude: '39.732555236554'
  },
  110116:
  {
    name: '怀柔区',
    parseid: '1101',
    longitude: '116.63838587143',
    latitude: '40.322618404266'
  },
  110117:
  {
    name: '平谷区',
    parseid: '1101',
    longitude: '117.1273791046',
    latitude: '40.146950735799'
  },
  110118:
  {
    name: '密云区',
    parseid: '1101',
    longitude: '116.92043197274',
    latitude: '40.523288036704'
  },
  110119:
  {
    name: '延庆区',
    parseid: '1101',
    longitude: '115.9913320109',
    latitude: '40.438670025319'
  },
  120101:
  {
    name: '和平区',
    parseid: '1201',
    longitude: '117.2214669949',
    latitude: '39.12339025328'
  },
  120102:
  {
    name: '河东区',
    parseid: '1201',
    longitude: '117.25841295307',
    latitude: '39.134487325955'
  },
  120103:
  {
    name: '河西区',
    parseid: '1201',
    longitude: '117.22941628002',
    latitude: '39.115718082216'
  },
  120104:
  {
    name: '南开区',
    parseid: '1201',
    longitude: '117.15651537432',
    latitude: '39.144105279768'
  },
  120105:
  {
    name: '河北区',
    parseid: '1201',
    longitude: '117.20359278136',
    latitude: '39.153485144705'
  },
  120106:
  {
    name: '红桥区',
    parseid: '1201',
    longitude: '117.15751788327',
    latitude: '39.173285646564'
  },
  120110:
  {
    name: '东丽区',
    parseid: '1201',
    longitude: '117.32056850791',
    latitude: '39.092332342815'
  },
  120111:
  {
    name: '西青区',
    parseid: '1201',
    longitude: '117.01441017994',
    latitude: '39.148726608967'
  },
  120112:
  {
    name: '津南区',
    parseid: '1201',
    longitude: '117.36338677903',
    latitude: '38.944148568115'
  },
  120113:
  {
    name: '北辰区',
    parseid: '1201',
    longitude: '117.14140273158',
    latitude: '39.230343909918'
  },
  120114:
  {
    name: '武清区',
    parseid: '1201',
    longitude: '117.05059715978',
    latitude: '39.389871228788'
  },
  120115:
  {
    name: '宝坻区',
    parseid: '1201',
    longitude: '117.31660069248',
    latitude: '39.723194482933'
  },
  120116:
  {
    name: '滨海新区',
    parseid: '1201',
    longitude: '117.71739882966',
    latitude: '39.009415773647'
  },
  120117:
  {
    name: '宁河区',
    parseid: '1201',
    longitude: '117.83239334342',
    latitude: '39.336956431227'
  },
  120118:
  {
    name: '静海区',
    parseid: '1201',
    longitude: '116.98046860455',
    latitude: '38.953370689172'
  },
  120119:
  {
    name: '蓟州区',
    parseid: '1201',
    longitude: '117.4134140417',
    latitude: '40.047634052521'
  },
  130102:
  {
    name: '长安区',
    parseid: '1301',
    longitude: '114.54561160958',
    latitude: '38.043256136498'
  },
  130104:
  {
    name: '桥西区',
    parseid: '1301',
    longitude: '114.46741977426',
    latitude: '38.010381080199'
  },
  130105:
  {
    name: '新华区',
    parseid: '1301',
    longitude: '114.46943844641',
    latitude: '38.057119539196'
  },
  130107:
  {
    name: '井陉矿区',
    parseid: '1301',
    longitude: '114.06863186515',
    latitude: '38.070565834517'
  },
  130108:
  {
    name: '裕华区',
    parseid: '1301',
    longitude: '114.53758291426',
    latitude: '38.012087686284'
  },
  130109:
  {
    name: '藁城区',
    parseid: '1301',
    longitude: '114.85337790442',
    latitude: '38.027816555321'
  },
  130110:
  {
    name: '鹿泉区',
    parseid: '1301',
    longitude: '114.32059757764',
    latitude: '38.09174945759'
  },
  130111:
  {
    name: '栾城区',
    parseid: '1301',
    longitude: '114.65457561879',
    latitude: '37.905816364165'
  },
  130121:
  {
    name: '井陉县',
    parseid: '1301',
    longitude: '114.15146299928',
    latitude: '38.038386214927'
  },
  130123:
  {
    name: '正定县',
    parseid: '1301',
    longitude: '114.57748106365',
    latitude: '38.151713727954'
  },
  130125:
  {
    name: '行唐县',
    parseid: '1301',
    longitude: '114.55960676028',
    latitude: '38.444238747676'
  },
  130126:
  {
    name: '灵寿县',
    parseid: '1301',
    longitude: '114.38947775771',
    latitude: '38.314629370046'
  },
  130127:
  {
    name: '高邑县',
    parseid: '1301',
    longitude: '114.61841307286',
    latitude: '37.621879561553'
  },
  130128:
  {
    name: '深泽县',
    parseid: '1301',
    longitude: '115.20740369913',
    latitude: '38.190451203069'
  },
  130129:
  {
    name: '赞皇县',
    parseid: '1301',
    longitude: '114.39246354556',
    latitude: '37.671667061291'
  },
  130130:
  {
    name: '无极县',
    parseid: '1301',
    longitude: '114.98243934348',
    latitude: '38.18543617028'
  },
  130131:
  {
    name: '平山县',
    parseid: '1301',
    longitude: '113.98543503085',
    latitude: '38.271951013311'
  },
  130132:
  {
    name: '元氏县',
    parseid: '1301',
    longitude: '114.53256551866',
    latitude: '37.772338553855'
  },
  130133:
  {
    name: '赵县',
    parseid: '1301',
    longitude: '114.78259655058',
    latitude: '37.761858522888'
  },
  130171:
  {
    name: '石家庄高新技术产业开发区',
    parseid: '1301',
    longitude: '114.65476830532',
    latitude: '38.048141786489'
  },
  130172:
  {
    name: '石家庄循环化工园区',
    parseid: '1301',
    longitude: '114.69991489449',
    latitude: '38.002797993721'
  },
  130181:
  {
    name: '辛集市',
    parseid: '1301',
    longitude: '115.22445084279',
    latitude: '37.949309043173'
  },
  130183:
  {
    name: '晋州市',
    parseid: '1301',
    longitude: '115.0505290147',
    latitude: '38.039491309736'
  },
  130184:
  {
    name: '新乐市',
    parseid: '1301',
    longitude: '114.69053218327',
    latitude: '38.349292647959'
  },
  130202:
  {
    name: '路南区',
    parseid: '1302',
    longitude: '118.16060668862',
    latitude: '39.631042853572'
  },
  130203:
  {
    name: '路北区',
    parseid: '1302',
    longitude: '118.20639924928',
    latitude: '39.630660799099'
  },
  130204:
  {
    name: '古冶区',
    parseid: '1302',
    longitude: '118.45340092552',
    latitude: '39.739735914766'
  },
  130205:
  {
    name: '开平区',
    parseid: '1302',
    longitude: '118.26860762449',
    latitude: '39.677143635862'
  },
  130207:
  {
    name: '丰南区',
    parseid: '1302',
    longitude: '118.0903655757',
    latitude: '39.581540485109'
  },
  130208:
  {
    name: '丰润区',
    parseid: '1302',
    longitude: '118.16854133135',
    latitude: '39.838353430851'
  },
  130209:
  {
    name: '曹妃甸区',
    parseid: '1302',
    longitude: '118.46645986221',
    latitude: '39.279283996335'
  },
  130224:
  {
    name: '滦南县',
    parseid: '1302',
    longitude: '118.68040524315',
    latitude: '39.510044702469'
  },
  130225:
  {
    name: '乐亭县',
    parseid: '1302',
    longitude: '118.91938406305',
    latitude: '39.431931320096'
  },
  130227:
  {
    name: '迁西县',
    parseid: '1302',
    longitude: '118.32038397781',
    latitude: '40.147837151362'
  },
  130229:
  {
    name: '玉田县',
    parseid: '1302',
    longitude: '117.74543440564',
    latitude: '39.906592348189'
  },
  130271:
  {
    name: '河北唐山芦台经济开发区',
    parseid: '1302',
    longitude: '118.18645947204',
    latitude: '39.636583724147'
  },
  130272:
  {
    name: '唐山市汉沽管理区',
    parseid: '1302',
    longitude: '118.18645947204',
    latitude: '39.636583724147'
  },
  130273:
  {
    name: '唐山高新技术产业开发区',
    parseid: '1302',
    longitude: '118.19474346579',
    latitude: '39.697258450239'
  },
  130274:
  {
    name: '河北唐山海港经济开发区',
    parseid: '1302',
    longitude: '119.61747524097',
    latitude: '39.940412688357'
  },
  130281:
  {
    name: '遵化市',
    parseid: '1302',
    longitude: '117.97237521307',
    latitude: '40.195533204033'
  },
  130283:
  {
    name: '迁安市',
    parseid: '1302',
    longitude: '118.70645736056',
    latitude: '40.004183924931'
  },
  130284:
  {
    name: '滦州市',
    parseid: '1302',
    longitude: '118.71048006247',
    latitude: '39.747115765489'
  },
  130302:
  {
    name: '海港区',
    parseid: '1303',
    longitude: '119.61747524097',
    latitude: '39.940412688357'
  },
  130303:
  {
    name: '山海关区',
    parseid: '1303',
    longitude: '119.78243521397',
    latitude: '39.984445641831'
  },
  130304:
  {
    name: '北戴河区',
    parseid: '1303',
    longitude: '119.49152607118',
    latitude: '39.841005667936'
  },
  130306:
  {
    name: '抚宁区',
    parseid: '1303',
    longitude: '119.25154914402',
    latitude: '39.88141356935'
  },
  130321:
  {
    name: '青龙满族自治县',
    parseid: '1303',
    longitude: '118.95648129587',
    latitude: '40.412793702313'
  },
  130322:
  {
    name: '昌黎县',
    parseid: '1303',
    longitude: '119.16937521021',
    latitude: '39.71905083388'
  },
  130324:
  {
    name: '卢龙县',
    parseid: '1303',
    longitude: '118.89948911126',
    latitude: '39.897958466103'
  },
  130371:
  {
    name: '秦皇岛市经济技术开发区',
    parseid: '1303',
    longitude: '119.60853063334',
    latitude: '39.941748102378'
  },
  130372:
  {
    name: '北戴河新区',
    parseid: '1303',
    longitude: '119.42056002572',
    latitude: '39.804514118982'
  },
  130402:
  {
    name: '邯山区',
    parseid: '1304',
    longitude: '114.49638868967',
    latitude: '36.586692191979'
  },
  130403:
  {
    name: '丛台区',
    parseid: '1304',
    longitude: '114.49943259789',
    latitude: '36.642672565982'
  },
  130404:
  {
    name: '复兴区',
    parseid: '1304',
    longitude: '114.47941224265',
    latitude: '36.623325246127'
  },
  130406:
  {
    name: '峰峰矿区',
    parseid: '1304',
    longitude: '114.21948332131',
    latitude: '36.425653614399'
  },
  130407:
  {
    name: '肥乡区',
    parseid: '1304',
    longitude: '114.80654708226',
    latitude: '36.55382525367'
  },
  130408:
  {
    name: '永年区',
    parseid: '1304',
    longitude: '114.55062514246',
    latitude: '36.747569389575'
  },
  130423:
  {
    name: '临漳县',
    parseid: '1304',
    longitude: '114.62642694614',
    latitude: '36.340765980595'
  },
  130424:
  {
    name: '成安县',
    parseid: '1304',
    longitude: '114.67657655802',
    latitude: '36.449796208953'
  },
  130425:
  {
    name: '大名县',
    parseid: '1304',
    longitude: '115.15461253007',
    latitude: '36.291288466231'
  },
  130426:
  {
    name: '涉县',
    parseid: '1304',
    longitude: '113.69758434883',
    latitude: '36.590691663211'
  },
  130427:
  {
    name: '磁县',
    parseid: '1304',
    longitude: '114.38043173139',
    latitude: '36.380358940947'
  },
  130430:
  {
    name: '邱县',
    parseid: '1304',
    longitude: '115.19339516368',
    latitude: '36.817362417143'
  },
  130431:
  {
    name: '鸡泽县',
    parseid: '1304',
    longitude: '114.89658577064',
    latitude: '36.916398206414'
  },
  130432:
  {
    name: '广平县',
    parseid: '1304',
    longitude: '114.95441490649',
    latitude: '36.489779995612'
  },
  130433:
  {
    name: '馆陶县',
    parseid: '1304',
    longitude: '115.28853676635',
    latitude: '36.553956728653'
  },
  130434:
  {
    name: '魏县',
    parseid: '1304',
    longitude: '114.94545044631',
    latitude: '36.366156454371'
  },
  130435:
  {
    name: '曲周县',
    parseid: '1304',
    longitude: '114.96340442939',
    latitude: '36.771544831336'
  },
  130471:
  {
    name: '邯郸经济技术开发区',
    parseid: '1304',
    longitude: '114.57254209013',
    latitude: '36.68115967064'
  },
  130473:
  {
    name: '邯郸冀南新区',
    parseid: '1304',
    longitude: '114.47435945382',
    latitude: '36.469114464703'
  },
  130481:
  {
    name: '武安市',
    parseid: '1304',
    longitude: '114.21051607638',
    latitude: '36.70248828628'
  },
  130502:
  {
    name: '桥东区',
    parseid: '1305',
    longitude: '114.51347113674',
    latitude: '37.073749959651'
  },
  130503:
  {
    name: '桥西区',
    parseid: '1305',
    longitude: '114.4743934996',
    latitude: '37.066172415704'
  },
  130521:
  {
    name: '邢台县',
    parseid: '1305',
    longitude: '114.14341085818',
    latitude: '37.17710928752'
  },
  130522:
  {
    name: '临城县',
    parseid: '1305',
    longitude: '114.50544333972',
    latitude: '37.450788548442'
  },
  130523:
  {
    name: '内丘县',
    parseid: '1305',
    longitude: '114.51849293403',
    latitude: '37.292857912047'
  },
  130524:
  {
    name: '柏乡县',
    parseid: '1305',
    longitude: '114.69949736209',
    latitude: '37.488758727152'
  },
  130525:
  {
    name: '隆尧县',
    parseid: '1305',
    longitude: '114.77661608165',
    latitude: '37.355908006295'
  },
  130526:
  {
    name: '任县',
    parseid: '1305',
    longitude: '114.67860600983',
    latitude: '37.126726783523'
  },
  130527:
  {
    name: '南和县',
    parseid: '1305',
    longitude: '114.69054772395',
    latitude: '37.01099797056'
  },
  130528:
  {
    name: '宁晋县',
    parseid: '1305',
    longitude: '114.92556169283',
    latitude: '37.625612279932'
  },
  130529:
  {
    name: '巨鹿县',
    parseid: '1305',
    longitude: '115.04358735887',
    latitude: '37.227088328938'
  },
  130530:
  {
    name: '新河县',
    parseid: '1305',
    longitude: '115.24854716945',
    latitude: '37.534590601536'
  },
  130531:
  {
    name: '广宗县',
    parseid: '1305',
    longitude: '115.14960474634',
    latitude: '37.080457122162'
  },
  130532:
  {
    name: '平乡县',
    parseid: '1305',
    longitude: '115.03658174369',
    latitude: '37.069096393044'
  },
  130533:
  {
    name: '威县',
    parseid: '1305',
    longitude: '115.27361761861',
    latitude: '36.981581608663'
  },
  130534:
  {
    name: '清河县',
    parseid: '1305',
    longitude: '115.67439356765',
    latitude: '37.046375401617'
  },
  130535:
  {
    name: '临西县',
    parseid: '1305',
    longitude: '115.50762943786',
    latitude: '36.87675996654'
  },
  130571:
  {
    name: '河北邢台经济开发区',
    parseid: '1305',
    longitude: '114.57224196626',
    latitude: '37.067608970469'
  },
  130581:
  {
    name: '南宫市',
    parseid: '1305',
    longitude: '115.4145290548',
    latitude: '37.364069402723'
  },
  130582:
  {
    name: '沙河市',
    parseid: '1305',
    longitude: '114.50947385688',
    latitude: '36.861127341145'
  },
  130602:
  {
    name: '竞秀区',
    parseid: '1306',
    longitude: '115.46543414161',
    latitude: '38.883787961691'
  },
  130606:
  {
    name: '莲池区',
    parseid: '1306',
    longitude: '115.53548768833',
    latitude: '38.860675807041'
  },
  130607:
  {
    name: '满城区',
    parseid: '1306',
    longitude: '115.3283750886',
    latitude: '38.955441208686'
  },
  130608:
  {
    name: '清苑区',
    parseid: '1306',
    longitude: '115.49660588179',
    latitude: '38.771001774749'
  },
  130609:
  {
    name: '徐水区',
    parseid: '1306',
    longitude: '115.66247952133',
    latitude: '39.024712583834'
  },
  130623:
  {
    name: '涞水县',
    parseid: '1306',
    longitude: '115.72054302508',
    latitude: '39.400334198489'
  },
  130624:
  {
    name: '阜平县',
    parseid: '1306',
    longitude: '114.20156347384',
    latitude: '38.855351444796'
  },
  130626:
  {
    name: '定兴县',
    parseid: '1306',
    longitude: '115.81441011189',
    latitude: '39.269423528527'
  },
  130627:
  {
    name: '唐县',
    parseid: '1306',
    longitude: '114.9894471146',
    latitude: '38.754019925125'
  },
  130628:
  {
    name: '高阳县',
    parseid: '1306',
    longitude: '115.78544721513',
    latitude: '38.706257734087'
  },
  130629:
  {
    name: '容城县',
    parseid: '1306',
    longitude: '115.86863129349',
    latitude: '39.048559435416'
  },
  130630:
  {
    name: '涞源县',
    parseid: '1306',
    longitude: '114.70047561679',
    latitude: '39.366271691524'
  },
  130631:
  {
    name: '望都县',
    parseid: '1306',
    longitude: '115.16158760286',
    latitude: '38.700157645549'
  },
  130632:
  {
    name: '安新县',
    parseid: '1306',
    longitude: '115.94242628266',
    latitude: '38.941734298593'
  },
  130633:
  {
    name: '易县',
    parseid: '1306',
    longitude: '115.50360664612',
    latitude: '39.355054469981'
  },
  130634:
  {
    name: '曲阳县',
    parseid: '1306',
    longitude: '114.7514548138',
    latitude: '38.628384104122'
  },
  130635:
  {
    name: '蠡县',
    parseid: '1306',
    longitude: '115.59044548045',
    latitude: '38.494200963238'
  },
  130636:
  {
    name: '顺平县',
    parseid: '1306',
    longitude: '115.14159743069',
    latitude: '38.843261370364'
  },
  130637:
  {
    name: '博野县',
    parseid: '1306',
    longitude: '115.47046698806',
    latitude: '38.463408004952'
  },
  130638:
  {
    name: '雄县',
    parseid: '1306',
    longitude: '116.11460144552',
    latitude: '39.000180119499'
  },
  130671:
  {
    name: '保定高新技术产业开发区',
    parseid: '1306',
    longitude: '116.05126578672',
    latitude: '39.491694925719'
  },
  130672:
  {
    name: '保定白沟新城',
    parseid: '1306',
    longitude: '116.05160902926',
    latitude: '39.134510134299'
  },
  130681:
  {
    name: '涿州市',
    parseid: '1306',
    longitude: '115.98161971138',
    latitude: '39.491065832'
  },
  130682:
  {
    name: '定州市',
    parseid: '1306',
    longitude: '114.99649620776',
    latitude: '38.522198840134'
  },
  130683:
  {
    name: '安国市',
    parseid: '1306',
    longitude: '115.33340802488',
    latitude: '38.424828318687'
  },
  130684:
  {
    name: '高碑店市',
    parseid: '1306',
    longitude: '115.88056905507',
    latitude: '39.332335447462'
  },
  130702:
  {
    name: '桥东区',
    parseid: '1307',
    longitude: '114.90060577763',
    latitude: '40.794268437423'
  },
  130703:
  {
    name: '桥西区',
    parseid: '1307',
    longitude: '114.87651609843',
    latitude: '40.825605695041'
  },
  130705:
  {
    name: '宣化区',
    parseid: '1307',
    longitude: '115.1054444068',
    latitude: '40.614591888266'
  },
  130706:
  {
    name: '下花园区',
    parseid: '1307',
    longitude: '115.29351688226',
    latitude: '40.508145182672'
  },
  130708:
  {
    name: '万全区',
    parseid: '1307',
    longitude: '114.74742582376',
    latitude: '40.773149648997'
  },
  130709:
  {
    name: '崇礼区',
    parseid: '1307',
    longitude: '115.28954933632',
    latitude: '40.98047788587'
  },
  130722:
  {
    name: '张北县',
    parseid: '1307',
    longitude: '114.7263751121',
    latitude: '41.164943620015'
  },
  130723:
  {
    name: '康保县',
    parseid: '1307',
    longitude: '114.60635583664',
    latitude: '41.858636884497'
  },
  130724:
  {
    name: '沽源县',
    parseid: '1307',
    longitude: '115.69540744878',
    latitude: '41.676015876097'
  },
  130725:
  {
    name: '尚义县',
    parseid: '1307',
    longitude: '113.97580941782',
    latitude: '41.082215639825'
  },
  130726:
  {
    name: '蔚县',
    parseid: '1307',
    longitude: '114.5954005518',
    latitude: '39.847088636366'
  },
  130727:
  {
    name: '阳原县',
    parseid: '1307',
    longitude: '114.15752413604',
    latitude: '40.109588388731'
  },
  130728:
  {
    name: '怀安县',
    parseid: '1307',
    longitude: '114.39246911506',
    latitude: '40.680369343116'
  },
  130730:
  {
    name: '怀来县',
    parseid: '1307',
    longitude: '115.52455288485',
    latitude: '40.420289890382'
  },
  130731:
  {
    name: '涿鹿县',
    parseid: '1307',
    longitude: '115.21138346203',
    latitude: '40.385834075003'
  },
  130732:
  {
    name: '赤城县',
    parseid: '1307',
    longitude: '115.83850589957',
    latitude: '40.918761216841'
  },
  130771:
  {
    name: '张家口经济开发区',
    parseid: '1307',
    longitude: '114.89121650878',
    latitude: '40.780123257535'
  },
  130772:
  {
    name: '张家口市察北管理区',
    parseid: '1307',
    longitude: '114.95192606124',
    latitude: '41.408114773236'
  },
  130773:
  {
    name: '张家口市塞北管理区',
    parseid: '1307',
    longitude: '115.82875802716',
    latitude: '41.878693914378'
  },
  130802:
  {
    name: '双桥区',
    parseid: '1308',
    longitude: '117.94942790899',
    latitude: '40.980824477401'
  },
  130803:
  {
    name: '双滦区',
    parseid: '1308',
    longitude: '117.80657828883',
    latitude: '40.964729148178'
  },
  130804:
  {
    name: '鹰手营子矿区',
    parseid: '1308',
    longitude: '117.66560909159',
    latitude: '40.552043233623'
  },
  130821:
  {
    name: '承德县',
    parseid: '1308',
    longitude: '118.18045573699',
    latitude: '40.774367194936'
  },
  130822:
  {
    name: '兴隆县',
    parseid: '1308',
    longitude: '117.50742737264',
    latitude: '40.423454029635'
  },
  130824:
  {
    name: '滦平县',
    parseid: '1308',
    longitude: '117.33949787111',
    latitude: '40.94756096291'
  },
  130825:
  {
    name: '隆化县',
    parseid: '1308',
    longitude: '117.7454510243',
    latitude: '41.319898805021'
  },
  130826:
  {
    name: '丰宁满族自治县',
    parseid: '1308',
    longitude: '116.65239270009',
    latitude: '41.215336380004'
  },
  130827:
  {
    name: '宽城满族自治县',
    parseid: '1308',
    longitude: '118.49159436055',
    latitude: '40.617151507814'
  },
  130828:
  {
    name: '围场满族蒙古族自治县',
    parseid: '1308',
    longitude: '117.76656434785',
    latitude: '41.944323773611'
  },
  130871:
  {
    name: '承德高新技术产业开发区',
    parseid: '1308',
    longitude: '118.29106481308',
    latitude: '40.9919571837'
  },
  130881:
  {
    name: '平泉市',
    parseid: '1308',
    longitude: '118.70742672204',
    latitude: '41.023755625929'
  },
  130902:
  {
    name: '新华区',
    parseid: '1309',
    longitude: '116.87243317375',
    latitude: '38.320366719478'
  },
  130903:
  {
    name: '运河区',
    parseid: '1309',
    longitude: '116.8386119713',
    latitude: '38.316522737476'
  },
  130921:
  {
    name: '沧县',
    parseid: '1309',
    longitude: '116.88439779466',
    latitude: '38.299452743407'
  },
  130922:
  {
    name: '青县',
    parseid: '1309',
    longitude: '116.81057477836',
    latitude: '38.58846475864'
  },
  130923:
  {
    name: '东光县',
    parseid: '1309',
    longitude: '116.54340955698',
    latitude: '37.894513906653'
  },
  130924:
  {
    name: '海兴县',
    parseid: '1309',
    longitude: '117.50441804918',
    latitude: '38.149402516518'
  },
  130925:
  {
    name: '盐山县',
    parseid: '1309',
    longitude: '117.23741362448',
    latitude: '38.064318399559'
  },
  130926:
  {
    name: '肃宁县',
    parseid: '1309',
    longitude: '115.83651767998',
    latitude: '38.428905919718'
  },
  130927:
  {
    name: '南皮县',
    parseid: '1309',
    longitude: '116.71560115883',
    latitude: '38.045187886965'
  },
  130928:
  {
    name: '吴桥县',
    parseid: '1309',
    longitude: '116.39739206243',
    latitude: '37.633908755554'
  },
  130929:
  {
    name: '献县',
    parseid: '1309',
    longitude: '116.12956002887',
    latitude: '38.195981438007'
  },
  130930:
  {
    name: '孟村回族自治县',
    parseid: '1309',
    longitude: '117.11043607455',
    latitude: '38.059839127888'
  },
  130971:
  {
    name: '河北沧州经济开发区',
    parseid: '1309',
    longitude: '117.20359278136',
    latitude: '39.153485144705'
  },
  130972:
  {
    name: '沧州高新技术产业开发区',
    parseid: '1309',
    longitude: '116.81737899345',
    latitude: '38.343914044524'
  },
  130973:
  {
    name: '沧州渤海新区',
    parseid: '1309',
    longitude: '117.76206895759',
    latitude: '38.282373316931'
  },
  130981:
  {
    name: '泊头市',
    parseid: '1309',
    longitude: '116.58462803581',
    latitude: '38.089256915446'
  },
  130982:
  {
    name: '任丘市',
    parseid: '1309',
    longitude: '116.1056050955',
    latitude: '38.717348630775'
  },
  130983:
  {
    name: '黄骅市',
    parseid: '1309',
    longitude: '117.33648109172',
    latitude: '38.377493900735'
  },
  130984:
  {
    name: '河间市',
    parseid: '1309',
    longitude: '116.10562809212',
    latitude: '38.451356515106'
  },
  131002:
  {
    name: '安次区',
    parseid: '1310',
    longitude: '116.70963326617',
    latitude: '39.526159764041'
  },
  131003:
  {
    name: '广阳区',
    parseid: '1310',
    longitude: '116.71761426148',
    latitude: '39.528611447334'
  },
  131022:
  {
    name: '固安县',
    parseid: '1310',
    longitude: '116.30542004093',
    latitude: '39.444484855304'
  },
  131023:
  {
    name: '永清县',
    parseid: '1310',
    longitude: '116.50542928985',
    latitude: '39.327852998574'
  },
  131024:
  {
    name: '香河县',
    parseid: '1310',
    longitude: '117.0124021078',
    latitude: '39.767939188546'
  },
  131025:
  {
    name: '大城县',
    parseid: '1310',
    longitude: '116.66040917846',
    latitude: '38.710858640026'
  },
  131026:
  {
    name: '文安县',
    parseid: '1310',
    longitude: '116.464609479',
    latitude: '38.87895049307'
  },
  131028:
  {
    name: '大厂回族自治县',
    parseid: '1310',
    longitude: '116.99640912565',
    latitude: '39.892208394086'
  },
  131071:
  {
    name: '廊坊经济技术开发区',
    parseid: '1310',
    longitude: '116.69058173343',
    latitude: '39.543366662759'
  },
  131081:
  {
    name: '霸州市',
    parseid: '1310',
    longitude: '116.3983972663',
    latitude: '39.130920596981'
  },
  131082:
  {
    name: '三河市',
    parseid: '1310',
    longitude: '117.08458787248',
    latitude: '39.988099552443'
  },
  131102:
  {
    name: '桃城区',
    parseid: '1311',
    longitude: '115.68139532011',
    latitude: '37.741636751694'
  },
  131103:
  {
    name: '冀州区',
    parseid: '1311',
    longitude: '115.58542988146',
    latitude: '37.557086025833'
  },
  131121:
  {
    name: '枣强县',
    parseid: '1311',
    longitude: '115.7305629044',
    latitude: '37.519363689764'
  },
  131122:
  {
    name: '武邑县',
    parseid: '1311',
    longitude: '115.89451363117',
    latitude: '37.807764276867'
  },
  131123:
  {
    name: '武强县',
    parseid: '1311',
    longitude: '115.98961391178',
    latitude: '38.046856805237'
  },
  131124:
  {
    name: '饶阳县',
    parseid: '1311',
    longitude: '115.73257160535',
    latitude: '38.241037525428'
  },
  131125:
  {
    name: '安平县',
    parseid: '1311',
    longitude: '115.52554928532',
    latitude: '38.240506922191'
  },
  131126:
  {
    name: '故城县',
    parseid: '1311',
    longitude: '115.97260216135',
    latitude: '37.353347552477'
  },
  131127:
  {
    name: '景县',
    parseid: '1311',
    longitude: '116.2774107853',
    latitude: '37.698814551395'
  },
  131128:
  {
    name: '阜城县',
    parseid: '1311',
    longitude: '116.18242153525',
    latitude: '37.868732457906'
  },
  131171:
  {
    name: '河北衡水高新技术产业开发区',
    parseid: '1311',
    longitude: '117.20359278136',
    latitude: '39.153485144705'
  },
  131172:
  {
    name: '衡水滨湖新区',
    parseid: '1311',
    longitude: '115.70627999969',
    latitude: '37.701616037093'
  },
  131182:
  {
    name: '深州市',
    parseid: '1311',
    longitude: '115.56636927583',
    latitude: '38.006941234922'
  },
  140105:
  {
    name: '小店区',
    parseid: '1401',
    longitude: '112.57239624162',
    latitude: '37.742322528645'
  },
  140106:
  {
    name: '迎泽区',
    parseid: '1401',
    longitude: '112.5693846724',
    latitude: '37.869532484225'
  },
  140107:
  {
    name: '杏花岭区',
    parseid: '1401',
    longitude: '112.5763830113',
    latitude: '37.900186246845'
  },
  140108:
  {
    name: '尖草坪区',
    parseid: '1401',
    longitude: '112.49360496704',
    latitude: '37.945943354548'
  },
  140109:
  {
    name: '万柏林区',
    parseid: '1401',
    longitude: '112.52257675702',
    latitude: '37.864974410402'
  },
  140110:
  {
    name: '晋源区',
    parseid: '1401',
    longitude: '112.48456424072',
    latitude: '37.721168857849'
  },
  140121:
  {
    name: '清徐县',
    parseid: '1401',
    longitude: '112.36455763137',
    latitude: '37.613066838238'
  },
  140122:
  {
    name: '阳曲县',
    parseid: '1401',
    longitude: '112.6794089516',
    latitude: '38.064620819448'
  },
  140123:
  {
    name: '娄烦县',
    parseid: '1401',
    longitude: '111.80359063362',
    latitude: '38.073195368896'
  },
  140171:
  {
    name: '山西转型综合改革示范区',
    parseid: '1401',
    longitude: '112.60392999892',
    latitude: '37.740098028383'
  },
  140181:
  {
    name: '古交市',
    parseid: '1401',
    longitude: '112.1824528689',
    latitude: '37.912999960962'
  },
  140212:
  {
    name: '新荣区',
    parseid: '1402',
    longitude: '113.14644373539',
    latitude: '40.261971219328'
  },
  140213:
  {
    name: '平城区',
    parseid: '1402',
    longitude: '113.30442522204',
    latitude: '40.081998375025'
  },
  140214:
  {
    name: '云冈区',
    parseid: '1402',
    longitude: '113.16240150396',
    latitude: '39.996838811279'
  },
  140215:
  {
    name: '云州区',
    parseid: '1402',
    longitude: '113.61847103172',
    latitude: '40.046229886508'
  },
  140221:
  {
    name: '阳高县',
    parseid: '1402',
    longitude: '113.75541420332',
    latitude: '40.367391842472'
  },
  140222:
  {
    name: '天镇县',
    parseid: '1402',
    longitude: '114.09747753304',
    latitude: '40.426412198691'
  },
  140223:
  {
    name: '广灵县',
    parseid: '1402',
    longitude: '114.28858637097',
    latitude: '39.766004217139'
  },
  140224:
  {
    name: '灵丘县',
    parseid: '1402',
    longitude: '114.24136819946',
    latitude: '39.448825128052'
  },
  140225:
  {
    name: '浑源县',
    parseid: '1402',
    longitude: '113.70560028822',
    latitude: '39.698952969845'
  },
  140226:
  {
    name: '左云县',
    parseid: '1402',
    longitude: '112.70946328956',
    latitude: '40.019623449015'
  },
  140271:
  {
    name: '山西大同经济开发区',
    parseid: '1402',
    longitude: '113.40230261414',
    latitude: '40.076291639551'
  },
  140302:
  {
    name: '城区',
    parseid: '1403',
    longitude: '113.60656821422',
    latitude: '37.853433420712'
  },
  140303:
  {
    name: '矿区',
    parseid: '1403',
    longitude: '113.56152124713',
    latitude: '37.874409150948'
  },
  140311:
  {
    name: '郊区',
    parseid: '1403',
    longitude: '113.60060283682',
    latitude: '37.950352892943'
  },
  140321:
  {
    name: '平定县',
    parseid: '1403',
    longitude: '113.66442115516',
    latitude: '37.792796383591'
  },
  140322:
  {
    name: '盂县',
    parseid: '1403',
    longitude: '113.41842046075',
    latitude: '38.091979630201'
  },
  140403:
  {
    name: '潞州区',
    parseid: '1404',
    longitude: '113.12952091721',
    latitude: '36.209472481338'
  },
  140404:
  {
    name: '上党区',
    parseid: '1404',
    longitude: '113.05741608986',
    latitude: '36.059286479291'
  },
  140405:
  {
    name: '屯留区',
    parseid: '1404',
    longitude: '112.89847476377',
    latitude: '36.321630843108'
  },
  140406:
  {
    name: '潞城区',
    parseid: '1404',
    longitude: '113.23557845894',
    latitude: '36.339691267612'
  },
  140423:
  {
    name: '襄垣县',
    parseid: '1404',
    longitude: '113.05741258647',
    latitude: '36.541685821155'
  },
  140425:
  {
    name: '平顺县',
    parseid: '1404',
    longitude: '113.44251696707',
    latitude: '36.205989459384'
  },
  140426:
  {
    name: '黎城县',
    parseid: '1404',
    longitude: '113.39343247604',
    latitude: '36.508669901441'
  },
  140427:
  {
    name: '壶关县',
    parseid: '1404',
    longitude: '113.21357985531',
    latitude: '36.121334604237'
  },
  140428:
  {
    name: '长子县',
    parseid: '1404',
    longitude: '112.88456585041',
    latitude: '36.128001557794'
  },
  140429:
  {
    name: '武乡县',
    parseid: '1404',
    longitude: '112.8706056438',
    latitude: '36.843167949301'
  },
  140430:
  {
    name: '沁县',
    parseid: '1404',
    longitude: '112.70545801478',
    latitude: '36.762189938552'
  },
  140431:
  {
    name: '沁源县',
    parseid: '1404',
    longitude: '112.34445202694',
    latitude: '36.506103350913'
  },
  140471:
  {
    name: '山西长治高新技术产业园区',
    parseid: '1404',
    longitude: '113.12255886985',
    latitude: '36.201268372155'
  },
  140502:
  {
    name: '城区',
    parseid: '1405',
    longitude: '112.85958379452',
    latitude: '35.507278924584'
  },
  140521:
  {
    name: '沁水县',
    parseid: '1405',
    longitude: '112.19342620969',
    latitude: '35.696364462457'
  },
  140522:
  {
    name: '阳城县',
    parseid: '1405',
    longitude: '112.42145378712',
    latitude: '35.492181320425'
  },
  140524:
  {
    name: '陵川县',
    parseid: '1405',
    longitude: '113.28740655466',
    latitude: '35.781743639538'
  },
  140525:
  {
    name: '泽州县',
    parseid: '1405',
    longitude: '112.79440121959',
    latitude: '35.599769729488'
  },
  140581:
  {
    name: '高平市',
    parseid: '1405',
    longitude: '112.93041239923',
    latitude: '35.804336798578'
  },
  140602:
  {
    name: '朔城区',
    parseid: '1406',
    longitude: '112.43837642564',
    latitude: '39.325302712534'
  },
  140603:
  {
    name: '平鲁区',
    parseid: '1406',
    longitude: '112.29552500886',
    latitude: '39.517389104237'
  },
  140621:
  {
    name: '山阴县',
    parseid: '1406',
    longitude: '112.82243194473',
    latitude: '39.534030498011'
  },
  140622:
  {
    name: '应县',
    parseid: '1406',
    longitude: '113.19749353922',
    latitude: '39.560077852375'
  },
  140623:
  {
    name: '右玉县',
    parseid: '1406',
    longitude: '112.47350008125',
    latitude: '39.994859555431'
  },
  140671:
  {
    name: '山西朔州经济开发区',
    parseid: '1406',
    longitude: '112.43937093967',
    latitude: '39.337108370542'
  },
  140681:
  {
    name: '怀仁市',
    parseid: '1406',
    longitude: '113.10660846738',
    latitude: '39.833756889522'
  },
  140702:
  {
    name: '榆次区',
    parseid: '1407',
    longitude: '112.71450350211',
    latitude: '37.703940486801'
  },
  140721:
  {
    name: '榆社县',
    parseid: '1407',
    longitude: '112.98159856583',
    latitude: '37.0763696687'
  },
  140722:
  {
    name: '左权县',
    parseid: '1407',
    longitude: '113.38545184006',
    latitude: '37.088555147171'
  },
  140723:
  {
    name: '和顺县',
    parseid: '1407',
    longitude: '113.57660568309',
    latitude: '37.334807738688'
  },
  140724:
  {
    name: '昔阳县',
    parseid: '1407',
    longitude: '113.71361290387',
    latitude: '37.617884042996'
  },
  140725:
  {
    name: '寿阳县',
    parseid: '1407',
    longitude: '113.18341017493',
    latitude: '37.901307606957'
  },
  140726:
  {
    name: '太谷县',
    parseid: '1407',
    longitude: '112.55738411926',
    latitude: '37.427395577313'
  },
  140727:
  {
    name: '祁县',
    parseid: '1407',
    longitude: '112.34244242768',
    latitude: '37.364131283475'
  },
  140728:
  {
    name: '平遥县',
    parseid: '1407',
    longitude: '112.18245556381',
    latitude: '37.195600690703'
  },
  140729:
  {
    name: '灵石县',
    parseid: '1407',
    longitude: '111.78561787596',
    latitude: '36.85336750127'
  },
  140781:
  {
    name: '介休市',
    parseid: '1407',
    longitude: '111.92356319719',
    latitude: '37.032686403603'
  },
  140802:
  {
    name: '盐湖区',
    parseid: '1408',
    longitude: '111.00437711462',
    latitude: '35.021425327829'
  },
  140821:
  {
    name: '临猗县',
    parseid: '1408',
    longitude: '110.78040700351',
    latitude: '35.149542242622'
  },
  140822:
  {
    name: '万荣县',
    parseid: '1408',
    longitude: '110.84457611016',
    latitude: '35.421108800536'
  },
  140823:
  {
    name: '闻喜县',
    parseid: '1408',
    longitude: '111.23141035768',
    latitude: '35.362931196381'
  },
  140824:
  {
    name: '稷山县',
    parseid: '1408',
    longitude: '110.98941457872',
    latitude: '35.610403569616'
  },
  140825:
  {
    name: '新绛县',
    parseid: '1408',
    longitude: '111.23140649497',
    latitude: '35.622630103082'
  },
  140826:
  {
    name: '绛县',
    parseid: '1408',
    longitude: '111.57548652056',
    latitude: '35.497276373896'
  },
  140827:
  {
    name: '垣曲县',
    parseid: '1408',
    longitude: '111.67660670572',
    latitude: '35.303014517418'
  },
  140828:
  {
    name: '夏县',
    parseid: '1408',
    longitude: '111.2264314994',
    latitude: '35.147461779807'
  },
  140829:
  {
    name: '平陆县',
    parseid: '1408',
    longitude: '111.22348047596',
    latitude: '34.842925154581'
  },
  140830:
  {
    name: '芮城县',
    parseid: '1408',
    longitude: '110.7006115132',
    latitude: '34.699388110563'
  },
  140881:
  {
    name: '永济市',
    parseid: '1408',
    longitude: '110.45457767131',
    latitude: '34.872829714714'
  },
  140882:
  {
    name: '河津市',
    parseid: '1408',
    longitude: '110.71857214373',
    latitude: '35.601926575322'
  },
  140902:
  {
    name: '忻府区',
    parseid: '1409',
    longitude: '112.75261366422',
    latitude: '38.40987981762'
  },
  140921:
  {
    name: '定襄县',
    parseid: '1409',
    longitude: '112.96352861152',
    latitude: '38.479974305847'
  },
  140922:
  {
    name: '五台县',
    parseid: '1409',
    longitude: '113.26145109492',
    latitude: '38.734181590565'
  },
  140923:
  {
    name: '代县',
    parseid: '1409',
    longitude: '112.96655194854',
    latitude: '39.072728346381'
  },
  140924:
  {
    name: '繁峙县',
    parseid: '1409',
    longitude: '113.27140827251',
    latitude: '39.195237430734'
  },
  140925:
  {
    name: '宁武县',
    parseid: '1409',
    longitude: '112.32639824212',
    latitude: '39.024342381431'
  },
  140926:
  {
    name: '静乐县',
    parseid: '1409',
    longitude: '111.94543190585',
    latitude: '38.365147088438'
  },
  140927:
  {
    name: '神池县',
    parseid: '1409',
    longitude: '112.21738276001',
    latitude: '39.096875824863'
  },
  140928:
  {
    name: '五寨县',
    parseid: '1409',
    longitude: '111.85340993856',
    latitude: '38.917019909692'
  },
  140929:
  {
    name: '岢岚县',
    parseid: '1409',
    longitude: '111.57947778177',
    latitude: '38.710151038936'
  },
  140930:
  {
    name: '河曲县',
    parseid: '1409',
    longitude: '111.14444863516',
    latitude: '39.390702488715'
  },
  140931:
  {
    name: '保德县',
    parseid: '1409',
    longitude: '111.09254175805',
    latitude: '39.028336932396'
  },
  140932:
  {
    name: '偏关县',
    parseid: '1409',
    longitude: '111.51447352049',
    latitude: '39.442230090387'
  },
  140971:
  {
    name: '五台山风景名胜区',
    parseid: '1409',
    longitude: '113.59570814976',
    latitude: '38.976197885135'
  },
  140981:
  {
    name: '原平市',
    parseid: '1409',
    longitude: '112.71748713403',
    latitude: '38.736475897605'
  },
  141002:
  {
    name: '尧都区',
    parseid: '1410',
    longitude: '111.58643021727',
    latitude: '36.084562230192'
  },
  141021:
  {
    name: '曲沃县',
    parseid: '1410',
    longitude: '111.48239637819',
    latitude: '35.647327335982'
  },
  141022:
  {
    name: '翼城县',
    parseid: '1410',
    longitude: '111.72537553219',
    latitude: '35.744429075039'
  },
  141023:
  {
    name: '襄汾县',
    parseid: '1410',
    longitude: '111.44854005199',
    latitude: '35.882062670676'
  },
  141024:
  {
    name: '洪洞县',
    parseid: '1410',
    longitude: '111.68158942672',
    latitude: '36.259467079377'
  },
  141025:
  {
    name: '古县',
    parseid: '1410',
    longitude: '111.92657314947',
    latitude: '36.272338064827'
  },
  141026:
  {
    name: '安泽县',
    parseid: '1410',
    longitude: '112.2566128396',
    latitude: '36.153514380523'
  },
  141027:
  {
    name: '浮山县',
    parseid: '1410',
    longitude: '111.85538495306',
    latitude: '35.974392753943'
  },
  141028:
  {
    name: '吉县',
    parseid: '1410',
    longitude: '110.68854637189',
    latitude: '36.103999062021'
  },
  141029:
  {
    name: '乡宁县',
    parseid: '1410',
    longitude: '110.85349790083',
    latitude: '35.976441665474'
  },
  141030:
  {
    name: '大宁县',
    parseid: '1410',
    longitude: '110.75938440882',
    latitude: '36.471305687097'
  },
  141031:
  {
    name: '隰县',
    parseid: '1410',
    longitude: '110.94759127079',
    latitude: '36.699061383227'
  },
  141032:
  {
    name: '永和县',
    parseid: '1410',
    longitude: '110.63841589393',
    latitude: '36.765908673933'
  },
  141033:
  {
    name: '蒲县',
    parseid: '1410',
    longitude: '111.10247405258',
    latitude: '36.418005429177'
  },
  141034:
  {
    name: '汾西县',
    parseid: '1410',
    longitude: '111.56954629571',
    latitude: '36.658782264232'
  },
  141081:
  {
    name: '侯马市',
    parseid: '1410',
    longitude: '111.37839658489',
    latitude: '35.625364816258'
  },
  141082:
  {
    name: '霍州市',
    parseid: '1410',
    longitude: '111.76150942218',
    latitude: '36.574606950709'
  },
  141102:
  {
    name: '离石区',
    parseid: '1411',
    longitude: '111.15749077354',
    latitude: '37.523577475907'
  },
  141121:
  {
    name: '文水县',
    parseid: '1411',
    longitude: '112.0355986926',
    latitude: '37.444300082651'
  },
  141122:
  {
    name: '交城县',
    parseid: '1411',
    longitude: '112.16256770864',
    latitude: '37.557772236259'
  },
  141123:
  {
    name: '兴县',
    parseid: '1411',
    longitude: '111.13439210498',
    latitude: '38.468803780991'
  },
  141124:
  {
    name: '临县',
    parseid: '1411',
    longitude: '110.99841488129',
    latitude: '37.957210672321'
  },
  141125:
  {
    name: '柳林县',
    parseid: '1411',
    longitude: '110.8953898393',
    latitude: '37.435492964934'
  },
  141126:
  {
    name: '石楼县',
    parseid: '1411',
    longitude: '110.84159553248',
    latitude: '37.004470503012'
  },
  141127:
  {
    name: '岚县',
    parseid: '1411',
    longitude: '111.67859223038',
    latitude: '38.28502878885'
  },
  141128:
  {
    name: '方山县',
    parseid: '1411',
    longitude: '111.25037044293',
    latitude: '37.90102023916'
  },
  141129:
  {
    name: '中阳县',
    parseid: '1411',
    longitude: '111.18562956483',
    latitude: '37.36287279238'
  },
  141130:
  {
    name: '交口县',
    parseid: '1411',
    longitude: '111.18762820476',
    latitude: '36.987872666553'
  },
  141181:
  {
    name: '孝义市',
    parseid: '1411',
    longitude: '111.78560601833',
    latitude: '37.151063319102'
  },
  141182:
  {
    name: '汾阳市',
    parseid: '1411',
    longitude: '111.7945966192',
    latitude: '37.271291794518'
  },
  150102:
  {
    name: '新城区',
    parseid: '1501',
    longitude: '111.671620122',
    latitude: '40.863877021183'
  },
  150103:
  {
    name: '回民区',
    parseid: '1501',
    longitude: '111.63047018388',
    latitude: '40.814506362944'
  },
  150104:
  {
    name: '玉泉区',
    parseid: '1501',
    longitude: '111.68157514366',
    latitude: '40.758058968635'
  },
  150105:
  {
    name: '赛罕区',
    parseid: '1501',
    longitude: '111.7084206445',
    latitude: '40.798394236975'
  },
  150121:
  {
    name: '土默特左旗',
    parseid: '1501',
    longitude: '111.16958672672',
    latitude: '40.735293711759'
  },
  150122:
  {
    name: '托克托县',
    parseid: '1501',
    longitude: '111.20057494309',
    latitude: '40.283146729007'
  },
  150123:
  {
    name: '和林格尔县',
    parseid: '1501',
    longitude: '111.82843021826',
    latitude: '40.384797744251'
  },
  150124:
  {
    name: '清水河县',
    parseid: '1501',
    longitude: '111.65357648803',
    latitude: '39.926333854389'
  },
  150125:
  {
    name: '武川县',
    parseid: '1501',
    longitude: '111.45749705623',
    latitude: '41.102418723793'
  },
  150171:
  {
    name: '呼和浩特金海工业园区',
    parseid: '1501',
    longitude: '111.61218203115',
    latitude: '40.810666404707'
  },
  150172:
  {
    name: '呼和浩特经济技术开发区',
    parseid: '1501',
    longitude: '111.54846764675',
    latitude: '40.789838887267'
  },
  150202:
  {
    name: '东河区',
    parseid: '1502',
    longitude: '110.05039480879',
    latitude: '40.582228038324'
  },
  150203:
  {
    name: '昆都仑区',
    parseid: '1502',
    longitude: '109.84553830335',
    latitude: '40.647644106921'
  },
  150204:
  {
    name: '青山区',
    parseid: '1502',
    longitude: '109.9074160123',
    latitude: '40.649473068783'
  },
  150205:
  {
    name: '石拐区',
    parseid: '1502',
    longitude: '110.27838088451',
    latitude: '40.67829939834'
  },
  150206:
  {
    name: '白云鄂博矿区',
    parseid: '1502',
    longitude: '109.97962576174',
    latitude: '41.774995234182'
  },
  150207:
  {
    name: '九原区',
    parseid: '1502',
    longitude: '109.96958800614',
    latitude: '40.613396589444'
  },
  150221:
  {
    name: '土默特右旗',
    parseid: '1502',
    longitude: '110.53038926652',
    latitude: '40.575127429108'
  },
  150222:
  {
    name: '固阳县',
    parseid: '1502',
    longitude: '110.06643261639',
    latitude: '41.040162852726'
  },
  150223:
  {
    name: '达尔罕茂明安联合旗',
    parseid: '1502',
    longitude: '110.43952090317',
    latitude: '41.704548551002'
  },
  150271:
  {
    name: '包头稀土高新技术产业开发区',
    parseid: '1502',
    longitude: '109.8458648374',
    latitude: '40.63692070772'
  },
  150302:
  {
    name: '海勃湾区',
    parseid: '1503',
    longitude: '106.82943856714',
    latitude: '39.696907993535'
  },
  150303:
  {
    name: '海南区',
    parseid: '1503',
    longitude: '106.89847100998',
    latitude: '39.446827515087'
  },
  150304:
  {
    name: '乌达区',
    parseid: '1503',
    longitude: '106.7326063535',
    latitude: '39.511468916129'
  },
  150402:
  {
    name: '红山区',
    parseid: '1504',
    longitude: '118.96356353651',
    latitude: '42.27047843525'
  },
  150403:
  {
    name: '元宝山区',
    parseid: '1504',
    longitude: '119.29540450885',
    latitude: '42.045124715638'
  },
  150404:
  {
    name: '松山区',
    parseid: '1504',
    longitude: '118.9394138505',
    latitude: '42.292481572694'
  },
  150421:
  {
    name: '阿鲁科尔沁旗',
    parseid: '1504',
    longitude: '120.07261385472',
    latitude: '43.877953412182'
  },
  150422:
  {
    name: '巴林左旗',
    parseid: '1504',
    longitude: '119.38644328076',
    latitude: '43.97638259461'
  },
  150423:
  {
    name: '巴林右旗',
    parseid: '1504',
    longitude: '118.67039425705',
    latitude: '43.540131553108'
  },
  150424:
  {
    name: '林西县',
    parseid: '1504',
    longitude: '118.06246142182',
    latitude: '43.624210259291'
  },
  150425:
  {
    name: '克什克腾旗',
    parseid: '1504',
    longitude: '117.55162041051',
    latitude: '43.270757591896'
  },
  150426:
  {
    name: '翁牛特旗',
    parseid: '1504',
    longitude: '119.01250888002',
    latitude: '42.942019262236'
  },
  150428:
  {
    name: '喀喇沁旗',
    parseid: '1504',
    longitude: '118.7104736845',
    latitude: '41.932214335643'
  },
  150429:
  {
    name: '宁城县',
    parseid: '1504',
    longitude: '119.35060897566',
    latitude: '41.600245148269'
  },
  150430:
  {
    name: '敖汉旗',
    parseid: '1504',
    longitude: '119.92757793861',
    latitude: '42.296507085243'
  },
  150502:
  {
    name: '科尔沁区',
    parseid: '1505',
    longitude: '122.2624570337',
    latitude: '43.628712488829'
  },
  150521:
  {
    name: '科尔沁左翼中旗',
    parseid: '1505',
    longitude: '122.2624570337',
    latitude: '43.628712488829'
  },
  150522:
  {
    name: '科尔沁左翼后旗',
    parseid: '1505',
    longitude: '122.2624570337',
    latitude: '43.628712488829'
  },
  150523:
  {
    name: '开鲁县',
    parseid: '1505',
    longitude: '121.32538568843',
    latitude: '43.606369431362'
  },
  150524:
  {
    name: '库伦旗',
    parseid: '1505',
    longitude: '121.81740576201',
    latitude: '42.741211100235'
  },
  150525:
  {
    name: '奈曼旗',
    parseid: '1505',
    longitude: '120.66464641294',
    latitude: '42.87184654666'
  },
  150526:
  {
    name: '扎鲁特旗',
    parseid: '1505',
    longitude: '120.91862585689',
    latitude: '44.562213133099'
  },
  150571:
  {
    name: '通辽经济技术开发区',
    parseid: '1505',
    longitude: '122.25557197112',
    latitude: '43.65780711531'
  },
  150581:
  {
    name: '霍林郭勒市',
    parseid: '1505',
    longitude: '119.67046591394',
    latitude: '45.53751332061'
  },
  150602:
  {
    name: '东胜区',
    parseid: '1506',
    longitude: '109.96956006883',
    latitude: '39.827986984444'
  },
  150603:
  {
    name: '康巴什区',
    parseid: '1506',
    longitude: '109.86962735373',
    latitude: '39.616378146766'
  },
  150621:
  {
    name: '达拉特旗',
    parseid: '1506',
    longitude: '110.04036612608',
    latitude: '40.418907154391'
  },
  150622:
  {
    name: '准格尔旗',
    parseid: '1506',
    longitude: '111.24639840546',
    latitude: '39.870540265037'
  },
  150623:
  {
    name: '鄂托克前旗',
    parseid: '1506',
    longitude: '107.48458472303',
    latitude: '38.188216741284'
  },
  150624:
  {
    name: '鄂托克旗',
    parseid: '1506',
    longitude: '107.98244495023',
    latitude: '39.095293413608'
  },
  150625:
  {
    name: '杭锦旗',
    parseid: '1506',
    longitude: '108.74241293879',
    latitude: '39.838815768815'
  },
  150626:
  {
    name: '乌审旗',
    parseid: '1506',
    longitude: '108.82443496914',
    latitude: '38.610026521177'
  },
  150627:
  {
    name: '伊金霍洛旗',
    parseid: '1506',
    longitude: '109.75459043996',
    latitude: '39.570092815193'
  },
  150702:
  {
    name: '海拉尔区',
    parseid: '1507',
    longitude: '119.74246537006',
    latitude: '49.218215799363'
  },
  150703:
  {
    name: '扎赉诺尔区',
    parseid: '1507',
    longitude: '117.69453227349',
    latitude: '49.467770183628'
  },
  150721:
  {
    name: '阿荣旗',
    parseid: '1507',
    longitude: '123.46544000531',
    latitude: '48.131971245042'
  },
  150722:
  {
    name: '莫力达瓦达斡尔族自治旗',
    parseid: '1507',
    longitude: '124.52547661897',
    latitude: '48.483463826021'
  },
  150723:
  {
    name: '鄂伦春自治旗',
    parseid: '1507',
    longitude: '123.73234507742',
    latitude: '50.597947928064'
  },
  150724:
  {
    name: '鄂温克族自治旗',
    parseid: '1507',
    longitude: '119.76135125527',
    latitude: '49.15304476395'
  },
  150725:
  {
    name: '陈巴尔虎旗',
    parseid: '1507',
    longitude: '119.43046248677',
    latitude: '49.334914288885'
  },
  150726:
  {
    name: '新巴尔虎左旗',
    parseid: '1507',
    longitude: '118.27660837276',
    latitude: '48.223786760037'
  },
  150727:
  {
    name: '新巴尔虎右旗',
    parseid: '1507',
    longitude: '116.83063240352',
    latitude: '48.677053599089'
  },
  150781:
  {
    name: '满洲里市',
    parseid: '1507',
    longitude: '117.38543585768',
    latitude: '49.604098854866'
  },
  150782:
  {
    name: '牙克石市',
    parseid: '1507',
    longitude: '120.7183468371',
    latitude: '49.292023693206'
  },
  150783:
  {
    name: '扎兰屯市',
    parseid: '1507',
    longitude: '122.74445371486',
    latitude: '48.01995552011'
  },
  150784:
  {
    name: '额尔古纳市',
    parseid: '1507',
    longitude: '120.18663369726',
    latitude: '50.248131758636'
  },
  150785:
  {
    name: '根河市',
    parseid: '1507',
    longitude: '121.52758526594',
    latitude: '50.786140434318'
  },
  150802:
  {
    name: '临河区',
    parseid: '1508',
    longitude: '107.36953379568',
    latitude: '40.75668072584'
  },
  150821:
  {
    name: '五原县',
    parseid: '1508',
    longitude: '108.2734913541',
    latitude: '41.094454821479'
  },
  150822:
  {
    name: '磴口县',
    parseid: '1508',
    longitude: '107.01452247',
    latitude: '40.336470177103'
  },
  150823:
  {
    name: '乌拉特前旗',
    parseid: '1508',
    longitude: '108.6586151381',
    latitude: '40.742103512928'
  },
  150824:
  {
    name: '乌拉特中旗',
    parseid: '1508',
    longitude: '108.51951244005',
    latitude: '41.593346263746'
  },
  150825:
  {
    name: '乌拉特后旗',
    parseid: '1508',
    longitude: '107.08154612207',
    latitude: '41.089422269258'
  },
  150826:
  {
    name: '杭锦后旗',
    parseid: '1508',
    longitude: '107.15737244949',
    latitude: '40.892179419823'
  },
  150902:
  {
    name: '集宁区',
    parseid: '1509',
    longitude: '113.12058699942',
    latitude: '41.041146171787'
  },
  150921:
  {
    name: '卓资县',
    parseid: '1509',
    longitude: '112.5844095507',
    latitude: '40.900291837834'
  },
  150922:
  {
    name: '化德县',
    parseid: '1509',
    longitude: '114.0164087845',
    latitude: '41.909602587109'
  },
  150923:
  {
    name: '商都县',
    parseid: '1509',
    longitude: '113.58463922926',
    latitude: '41.567566637224'
  },
  150924:
  {
    name: '兴和县',
    parseid: '1509',
    longitude: '113.84057886567',
    latitude: '40.879341798933'
  },
  150925:
  {
    name: '凉城县',
    parseid: '1509',
    longitude: '112.51060018864',
    latitude: '40.5371631252'
  },
  150926:
  {
    name: '察哈尔右翼前旗',
    parseid: '1509',
    longitude: '113.22160531673',
    latitude: '40.791267302593'
  },
  150927:
  {
    name: '察哈尔右翼中旗',
    parseid: '1509',
    longitude: '112.64258040196',
    latitude: '41.283272943291'
  },
  150928:
  {
    name: '察哈尔右翼后旗',
    parseid: '1509',
    longitude: '113.19853090242',
    latitude: '41.441770999655'
  },
  150929:
  {
    name: '四子王旗',
    parseid: '1509',
    longitude: '111.71241927182',
    latitude: '41.539353349915'
  },
  150981:
  {
    name: '丰镇市',
    parseid: '1509',
    longitude: '113.11660121788',
    latitude: '40.441804808844'
  },
  152201:
  {
    name: '乌兰浩特市',
    parseid: '1522',
    longitude: '122.09962235198',
    latitude: '46.078654343582'
  },
  152202:
  {
    name: '阿尔山市',
    parseid: '1522',
    longitude: '119.95065315166',
    latitude: '47.18305415375'
  },
  152221:
  {
    name: '科尔沁右翼前旗',
    parseid: '1522',
    longitude: '121.9645531355',
    latitude: '46.082648853819'
  },
  152222:
  {
    name: '科尔沁右翼中旗',
    parseid: '1522',
    longitude: '121.48354781458',
    latitude: '45.066470993428'
  },
  152223:
  {
    name: '扎赉特旗',
    parseid: '1522',
    longitude: '122.90644442883',
    latitude: '46.729189539358'
  },
  152224:
  {
    name: '突泉县',
    parseid: '1522',
    longitude: '121.60054536997',
    latitude: '45.387830342585'
  },
  152501:
  {
    name: '二连浩特市',
    parseid: '1525',
    longitude: '111.95836319333',
    latitude: '43.648800184052'
  },
  152502:
  {
    name: '锡林浩特市',
    parseid: '1525',
    longitude: '116.09361388474',
    latitude: '43.93833380136'
  },
  152522:
  {
    name: '阿巴嘎旗',
    parseid: '1525',
    longitude: '114.95736709772',
    latitude: '44.028101587023'
  },
  152523:
  {
    name: '苏尼特左旗',
    parseid: '1525',
    longitude: '113.67347993742',
    latitude: '43.865553657792'
  },
  152524:
  {
    name: '苏尼特右旗',
    parseid: '1525',
    longitude: '112.64856904548',
    latitude: '42.747368922463'
  },
  152525:
  {
    name: '东乌珠穆沁旗',
    parseid: '1525',
    longitude: '116.97850435996',
    latitude: '45.515743305312'
  },
  152526:
  {
    name: '西乌珠穆沁旗',
    parseid: '1525',
    longitude: '117.61637700896',
    latitude: '44.593802912007'
  },
  152527:
  {
    name: '太仆寺旗',
    parseid: '1525',
    longitude: '115.29053531645',
    latitude: '41.882291746043'
  },
  152528:
  {
    name: '镶黄旗',
    parseid: '1525',
    longitude: '113.85450538582',
    latitude: '42.237661285279'
  },
  152529:
  {
    name: '正镶白旗',
    parseid: '1525',
    longitude: '115.03662171828',
    latitude: '42.292605429249'
  },
  152530:
  {
    name: '正蓝旗',
    parseid: '1525',
    longitude: '115.99860388383',
    latitude: '42.247118844188'
  },
  152531:
  {
    name: '多伦县',
    parseid: '1525',
    longitude: '116.49250878204',
    latitude: '42.208920864211'
  },
  152571:
  {
    name: '乌拉盖管委会',
    parseid: '1525',
    longitude: '114.09841877756',
    latitude: '42.805812764043'
  },
  152921:
  {
    name: '阿拉善左旗',
    parseid: '1529',
    longitude: '105.67259866528',
    latitude: '38.839094137436'
  },
  152922:
  {
    name: '阿拉善右旗',
    parseid: '1529',
    longitude: '101.67346389594',
    latitude: '39.222240969855'
  },
  152923:
  {
    name: '额济纳旗',
    parseid: '1529',
    longitude: '101.06240334058',
    latitude: '41.960297611813'
  },
  152971:
  {
    name: '内蒙古阿拉善经济开发区',
    parseid: '1529',
    longitude: '105.73537746449',
    latitude: '38.858275883057'
  },
  210102:
  {
    name: '和平区',
    parseid: '2101',
    longitude: '123.42664426615',
    latitude: '41.795236052902'
  },
  210103:
  {
    name: '沈河区',
    parseid: '2101',
    longitude: '123.46546103538',
    latitude: '41.802274138805'
  },
  210104:
  {
    name: '大东区',
    parseid: '2101',
    longitude: '123.47640473208',
    latitude: '41.811425174494'
  },
  210105:
  {
    name: '皇姑区',
    parseid: '2101',
    longitude: '123.43162078885',
    latitude: '41.826042120277'
  },
  210106:
  {
    name: '铁西区',
    parseid: '2101',
    longitude: '123.38343595078',
    latitude: '41.809037832217'
  },
  210111:
  {
    name: '苏家屯区',
    parseid: '2101',
    longitude: '123.35043463177',
    latitude: '41.671253644959'
  },
  210112:
  {
    name: '浑南区',
    parseid: '2101',
    longitude: '123.45598993089',
    latitude: '41.720915668889'
  },
  210113:
  {
    name: '沈北新区',
    parseid: '2101',
    longitude: '123.53360460492',
    latitude: '42.058914115763'
  },
  210114:
  {
    name: '于洪区',
    parseid: '2101',
    longitude: '123.31463302499',
    latitude: '41.799668255615'
  },
  210115:
  {
    name: '辽中区',
    parseid: '2101',
    longitude: '122.77237835983',
    latitude: '41.523149081842'
  },
  210123:
  {
    name: '康平县',
    parseid: '2101',
    longitude: '123.33751124938',
    latitude: '42.749925495719'
  },
  210124:
  {
    name: '法库县',
    parseid: '2101',
    longitude: '123.41462107572',
    latitude: '42.509606549903'
  },
  210181:
  {
    name: '新民市',
    parseid: '2101',
    longitude: '122.87539513741',
    latitude: '42.007109320665'
  },
  210202:
  {
    name: '中山区',
    parseid: '2102',
    longitude: '121.65154739367',
    latitude: '38.924511115496'
  },
  210203:
  {
    name: '西岗区',
    parseid: '2102',
    longitude: '121.61862512554',
    latitude: '38.920472689273'
  },
  210204:
  {
    name: '沙河口区',
    parseid: '2102',
    longitude: '121.59450670057',
    latitude: '38.913544290956'
  },
  210211:
  {
    name: '甘井子区',
    parseid: '2102',
    longitude: '121.5315189555',
    latitude: '38.958002162932'
  },
  210212:
  {
    name: '旅顺口区',
    parseid: '2102',
    longitude: '121.26859688019',
    latitude: '38.856832222859'
  },
  210213:
  {
    name: '金州区',
    parseid: '2102',
    longitude: '121.78943558267',
    latitude: '39.056432991661'
  },
  210214:
  {
    name: '普兰店区',
    parseid: '2102',
    longitude: '121.94645983497',
    latitude: '39.398089145183'
  },
  210224:
  {
    name: '长海县',
    parseid: '2102',
    longitude: '122.59462651637',
    latitude: '39.278270217167'
  },
  210281:
  {
    name: '瓦房店市',
    parseid: '2102',
    longitude: '121.98563754334',
    latitude: '39.632740747388'
  },
  210283:
  {
    name: '庄河市',
    parseid: '2102',
    longitude: '122.97449548263',
    latitude: '39.686956078878'
  },
  210302:
  {
    name: '铁东区',
    parseid: '2103',
    longitude: '122.99739966805',
    latitude: '41.096331870506'
  },
  210303:
  {
    name: '铁西区',
    parseid: '2103',
    longitude: '122.97549026615',
    latitude: '41.125475259583'
  },
  210304:
  {
    name: '立山区',
    parseid: '2103',
    longitude: '123.03548413862',
    latitude: '41.156116121102'
  },
  210311:
  {
    name: '千山区',
    parseid: '2103',
    longitude: '122.96757421833',
    latitude: '41.080938608935'
  },
  210321:
  {
    name: '台安县',
    parseid: '2103',
    longitude: '122.44255004099',
    latitude: '41.418590371099'
  },
  210323:
  {
    name: '岫岩满族自治县',
    parseid: '2103',
    longitude: '123.28754677827',
    latitude: '40.295892396362'
  },
  210381:
  {
    name: '海城市',
    parseid: '2103',
    longitude: '122.69156940124',
    latitude: '40.887633947097'
  },
  210402:
  {
    name: '新抚区',
    parseid: '2104',
    longitude: '123.91958231814',
    latitude: '41.867805858593'
  },
  210403:
  {
    name: '东洲区',
    parseid: '2104',
    longitude: '124.04554972353',
    latitude: '41.859190936634'
  },
  210404:
  {
    name: '望花区',
    parseid: '2104',
    longitude: '123.790604152',
    latitude: '41.859030362749'
  },
  210411:
  {
    name: '顺城区',
    parseid: '2104',
    longitude: '123.95141404338',
    latitude: '41.889163788467'
  },
  210421:
  {
    name: '抚顺县',
    parseid: '2104',
    longitude: '123.92159012079',
    latitude: '41.887037475382'
  },
  210422:
  {
    name: '新宾满族自治县',
    parseid: '2104',
    longitude: '125.04635620406',
    latitude: '41.739968775071'
  },
  210423:
  {
    name: '清原满族自治县',
    parseid: '2104',
    longitude: '124.93036025933',
    latitude: '42.106760992634'
  },
  210502:
  {
    name: '平山区',
    parseid: '2105',
    longitude: '123.77461422409',
    latitude: '41.301604181774'
  },
  210503:
  {
    name: '溪湖区',
    parseid: '2105',
    longitude: '123.77461054104',
    latitude: '41.334802931364'
  },
  210504:
  {
    name: '明山区',
    parseid: '2105',
    longitude: '123.82347449807',
    latitude: '41.314939368877'
  },
  210505:
  {
    name: '南芬区',
    parseid: '2105',
    longitude: '123.75146713686',
    latitude: '41.10709572322'
  },
  210521:
  {
    name: '本溪满族自治县',
    parseid: '2105',
    longitude: '124.12758486914',
    latitude: '41.307902881353'
  },
  210522:
  {
    name: '桓仁满族自治县',
    parseid: '2105',
    longitude: '125.36754435102',
    latitude: '41.27292530103'
  },
  210602:
  {
    name: '元宝区',
    parseid: '2106',
    longitude: '124.40258403322',
    latitude: '40.142251463139'
  },
  210603:
  {
    name: '振兴区',
    parseid: '2106',
    longitude: '124.32597752746',
    latitude: '40.06130509276'
  },
  210604:
  {
    name: '振安区',
    parseid: '2106',
    longitude: '124.43438692285',
    latitude: '40.164697025661'
  },
  210624:
  {
    name: '宽甸满族自治县',
    parseid: '2106',
    longitude: '124.79042662868',
    latitude: '40.73755320049'
  },
  210681:
  {
    name: '东港市',
    parseid: '2106',
    longitude: '124.15961035888',
    latitude: '39.867716187286'
  },
  210682:
  {
    name: '凤城市',
    parseid: '2106',
    longitude: '124.07242172439',
    latitude: '40.459180482456'
  },
  210702:
  {
    name: '古塔区',
    parseid: '2107',
    longitude: '121.13458496929',
    latitude: '41.122900925898'
  },
  210703:
  {
    name: '凌河区',
    parseid: '2107',
    longitude: '121.15759003442',
    latitude: '41.120690614472'
  },
  210711:
  {
    name: '太和区',
    parseid: '2107',
    longitude: '121.1104532494',
    latitude: '41.115109307132'
  },
  210726:
  {
    name: '黑山县',
    parseid: '2107',
    longitude: '122.13055703906',
    latitude: '41.671592983776'
  },
  210727:
  {
    name: '义县',
    parseid: '2107',
    longitude: '121.24556854895',
    latitude: '41.538938862271'
  },
  210781:
  {
    name: '凌海市',
    parseid: '2107',
    longitude: '121.36253879584',
    latitude: '41.166487628588'
  },
  210782:
  {
    name: '北镇市',
    parseid: '2107',
    longitude: '121.78344729848',
    latitude: '41.594428096803'
  },
  210802:
  {
    name: '站前区',
    parseid: '2108',
    longitude: '122.26543743173',
    latitude: '40.678764125936'
  },
  210803:
  {
    name: '西市区',
    parseid: '2108',
    longitude: '122.21358238684',
    latitude: '40.672110926311'
  },
  210804:
  {
    name: '鲅鱼圈区',
    parseid: '2108',
    longitude: '122.12757349697',
    latitude: '40.232339850773'
  },
  210811:
  {
    name: '老边区',
    parseid: '2108',
    longitude: '122.38643918392',
    latitude: '40.686383619803'
  },
  210881:
  {
    name: '盖州市',
    parseid: '2108',
    longitude: '122.35559128288',
    latitude: '40.406167457268'
  },
  210882:
  {
    name: '大石桥市',
    parseid: '2108',
    longitude: '122.5153795314',
    latitude: '40.650802164815'
  },
  210902:
  {
    name: '海州区',
    parseid: '2109',
    longitude: '121.66943571061',
    latitude: '42.023734789385'
  },
  210903:
  {
    name: '新邱区',
    parseid: '2109',
    longitude: '121.79936338568',
    latitude: '42.093934514765'
  },
  210904:
  {
    name: '太平区',
    parseid: '2109',
    longitude: '121.68538413681',
    latitude: '42.016967854141'
  },
  210905:
  {
    name: '清河门区',
    parseid: '2109',
    longitude: '121.42247894964',
    latitude: '41.789318551009'
  },
  210911:
  {
    name: '细河区',
    parseid: '2109',
    longitude: '121.68639230508',
    latitude: '42.03187124588'
  },
  210921:
  {
    name: '阜新蒙古族自治县',
    parseid: '2109',
    longitude: '121.76357399585',
    latitude: '42.071368153837'
  },
  210922:
  {
    name: '彰武县',
    parseid: '2109',
    longitude: '122.54544932021',
    latitude: '42.392706534364'
  },
  211002:
  {
    name: '白塔区',
    parseid: '2110',
    longitude: '123.18115668384',
    latitude: '41.276047320001'
  },
  211003:
  {
    name: '文圣区',
    parseid: '2110',
    longitude: '123.23800352262',
    latitude: '41.289998735723'
  },
  211004:
  {
    name: '宏伟区',
    parseid: '2110',
    longitude: '123.20358018598',
    latitude: '41.223368108445'
  },
  211005:
  {
    name: '弓长岭区',
    parseid: '2110',
    longitude: '123.42661543055',
    latitude: '41.157327042722'
  },
  211011:
  {
    name: '太子河区',
    parseid: '2110',
    longitude: '123.18845658391',
    latitude: '41.259253903616'
  },
  211021:
  {
    name: '辽阳县',
    parseid: '2110',
    longitude: '123.1124212208',
    latitude: '41.211678771808'
  },
  211081:
  {
    name: '灯塔市',
    parseid: '2110',
    longitude: '123.34546215145',
    latitude: '41.432474125926'
  },
  211102:
  {
    name: '双台子区',
    parseid: '2111',
    longitude: '122.04639299922',
    latitude: '41.206071617512'
  },
  211103:
  {
    name: '兴隆台区',
    parseid: '2111',
    longitude: '122.07649854059',
    latitude: '41.164499432425'
  },
  211104:
  {
    name: '大洼区',
    parseid: '2111',
    longitude: '122.08855478867',
    latitude: '41.00817878896'
  },
  211122:
  {
    name: '盘山县',
    parseid: '2111',
    longitude: '122.00356035522',
    latitude: '41.248263682582'
  },
  211202:
  {
    name: '银州区',
    parseid: '2112',
    longitude: '123.8483863963',
    latitude: '42.292573681442'
  },
  211204:
  {
    name: '清河区',
    parseid: '2112',
    longitude: '124.16556298034',
    latitude: '42.552494793453'
  },
  211221:
  {
    name: '铁岭县',
    parseid: '2112',
    longitude: '123.7353723767',
    latitude: '42.229225608048'
  },
  211223:
  {
    name: '西丰县',
    parseid: '2112',
    longitude: '124.73361509331',
    latitude: '42.744014442436'
  },
  211224:
  {
    name: '昌图县',
    parseid: '2112',
    longitude: '124.11750067115',
    latitude: '42.792178371844'
  },
  211281:
  {
    name: '调兵山市',
    parseid: '2112',
    longitude: '123.57350868313',
    latitude: '42.473738012058'
  },
  211282:
  {
    name: '开原市',
    parseid: '2112',
    longitude: '124.04456886375',
    latitude: '42.552079074779'
  },
  211302:
  {
    name: '双塔区',
    parseid: '2113',
    longitude: '120.46048690274',
    latitude: '41.571779500856'
  },
  211303:
  {
    name: '龙城区',
    parseid: '2113',
    longitude: '120.4435668693',
    latitude: '41.59846852305'
  },
  211321:
  {
    name: '朝阳县',
    parseid: '2113',
    longitude: '120.25939061432',
    latitude: '41.241075720873'
  },
  211322:
  {
    name: '建平县',
    parseid: '2113',
    longitude: '119.64938035777',
    latitude: '41.409455511027'
  },
  211324:
  {
    name: '喀喇沁左翼蒙古族自治县',
    parseid: '2113',
    longitude: '119.74741405502',
    latitude: '41.133689119828'
  },
  211381:
  {
    name: '北票市',
    parseid: '2113',
    longitude: '120.77762773422',
    latitude: '41.80648256895'
  },
  211382:
  {
    name: '凌源市',
    parseid: '2113',
    longitude: '119.40735807879',
    latitude: '41.251651297148'
  },
  211402:
  {
    name: '连山区',
    parseid: '2114',
    longitude: '120.87648167423',
    latitude: '40.780893808442'
  },
  211403:
  {
    name: '龙港区',
    parseid: '2114',
    longitude: '120.90062076024',
    latitude: '40.741056601241'
  },
  211404:
  {
    name: '南票区',
    parseid: '2114',
    longitude: '120.75649312082',
    latitude: '41.113097595823'
  },
  211421:
  {
    name: '绥中县',
    parseid: '2114',
    longitude: '120.35042453538',
    latitude: '40.331843475397'
  },
  211422:
  {
    name: '建昌县',
    parseid: '2114',
    longitude: '119.84359526665',
    latitude: '40.830379953809'
  },
  211481:
  {
    name: '兴城市',
    parseid: '2114',
    longitude: '120.76455846701',
    latitude: '40.616555664044'
  },
  220102:
  {
    name: '南关区',
    parseid: '2201',
    longitude: '125.35660981703',
    latitude: '43.869873025193'
  },
  220103:
  {
    name: '宽城区',
    parseid: '2201',
    longitude: '125.33462450832',
    latitude: '43.949502239804'
  },
  220104:
  {
    name: '朝阳区',
    parseid: '2201',
    longitude: '125.29540125585',
    latitude: '43.840641474962'
  },
  220105:
  {
    name: '二道区',
    parseid: '2201',
    longitude: '125.38046755375',
    latitude: '43.871276524271'
  },
  220106:
  {
    name: '绿园区',
    parseid: '2201',
    longitude: '125.26244260635',
    latitude: '43.886810403937'
  },
  220112:
  {
    name: '双阳区',
    parseid: '2201',
    longitude: '125.67144793217',
    latitude: '43.531091309119'
  },
  220113:
  {
    name: '九台区',
    parseid: '2201',
    longitude: '125.84556442307',
    latitude: '44.157791853861'
  },
  220122:
  {
    name: '农安县',
    parseid: '2201',
    longitude: '125.19148410666',
    latitude: '44.438903951261'
  },
  220171:
  {
    name: '长春经济技术开发区',
    parseid: '2201',
    longitude: '125.43374524507',
    latitude: '43.885100796964'
  },
  220172:
  {
    name: '长春净月高新技术产业开发区',
    parseid: '2201',
    longitude: '125.40480121273',
    latitude: '43.805531775968'
  },
  220173:
  {
    name: '长春高新技术产业开发区',
    parseid: '2201',
    longitude: '125.26436722591',
    latitude: '43.800141616574'
  },
  220174:
  {
    name: '长春汽车经济技术开发区',
    parseid: '2201',
    longitude: '125.2577349465',
    latitude: '43.867633505689'
  },
  220182:
  {
    name: '榆树市',
    parseid: '2201',
    longitude: '126.53960936347',
    latitude: '44.845439727693'
  },
  220183:
  {
    name: '德惠市',
    parseid: '2201',
    longitude: '125.73451517728',
    latitude: '44.527161066608'
  },
  220202:
  {
    name: '昌邑区',
    parseid: '2202',
    longitude: '126.58144866124',
    latitude: '43.887992474736'
  },
  220203:
  {
    name: '龙潭区',
    parseid: '2202',
    longitude: '126.56854459242',
    latitude: '43.91634255363'
  },
  220204:
  {
    name: '船营区',
    parseid: '2202',
    longitude: '126.54764973677',
    latitude: '43.83992740229'
  },
  220211:
  {
    name: '丰满区',
    parseid: '2202',
    longitude: '126.56857046362',
    latitude: '43.827151576836'
  },
  220221:
  {
    name: '永吉县',
    parseid: '2202',
    longitude: '126.50441572986',
    latitude: '43.678720676989'
  },
  220271:
  {
    name: '吉林经济开发区',
    parseid: '2202',
    longitude: '126.45013499061',
    latitude: '44.137200153752'
  },
  220272:
  {
    name: '吉林高新技术产业开发区',
    parseid: '2202',
    longitude: '126.60786099917',
    latitude: '43.798678130928'
  },
  220273:
  {
    name: '吉林中国新加坡食品区',
    parseid: '2202',
    longitude: '125.98827184147',
    latitude: '43.717305751111'
  },
  220281:
  {
    name: '蛟河市',
    parseid: '2202',
    longitude: '127.35148018677',
    latitude: '43.730003870507'
  },
  220282:
  {
    name: '桦甸市',
    parseid: '2202',
    longitude: '126.75248423373',
    latitude: '42.977982779881'
  },
  220283:
  {
    name: '舒兰市',
    parseid: '2202',
    longitude: '126.97137703226',
    latitude: '44.412270028324'
  },
  220284:
  {
    name: '磐石市',
    parseid: '2202',
    longitude: '126.06661629889',
    latitude: '42.951817500114'
  },
  220302:
  {
    name: '铁西区',
    parseid: '2203',
    longitude: '124.35246676034',
    latitude: '43.152575391803'
  },
  220303:
  {
    name: '铁东区',
    parseid: '2203',
    longitude: '124.4164827059',
    latitude: '43.167993993185'
  },
  220322:
  {
    name: '梨树县',
    parseid: '2203',
    longitude: '124.3424012471',
    latitude: '43.313345515553'
  },
  220323:
  {
    name: '伊通满族自治县',
    parseid: '2203',
    longitude: '125.31148460754',
    latitude: '43.351103666821'
  },
  220381:
  {
    name: '公主岭市',
    parseid: '2203',
    longitude: '124.82944866071',
    latitude: '43.510832663153'
  },
  220382:
  {
    name: '双辽市',
    parseid: '2203',
    longitude: '123.50943776128',
    latitude: '43.524527382171'
  },
  220402:
  {
    name: '龙山区',
    parseid: '2204',
    longitude: '125.14345242969',
    latitude: '42.907634012133'
  },
  220403:
  {
    name: '西安区',
    parseid: '2204',
    longitude: '125.15537330313',
    latitude: '42.933308420625'
  },
  220421:
  {
    name: '东丰县',
    parseid: '2204',
    longitude: '125.53737790091',
    latitude: '42.683310778553'
  },
  220422:
  {
    name: '东辽县',
    parseid: '2204',
    longitude: '124.99758944369',
    latitude: '42.931879101776'
  },
  220502:
  {
    name: '东昌区',
    parseid: '2205',
    longitude: '125.93359459016',
    latitude: '41.70840538484'
  },
  220503:
  {
    name: '二道江区',
    parseid: '2205',
    longitude: '126.0495917027',
    latitude: '41.779966174493'
  },
  220521:
  {
    name: '通化县',
    parseid: '2205',
    longitude: '125.76539191393',
    latitude: '41.685682238068'
  },
  220523:
  {
    name: '辉南县',
    parseid: '2205',
    longitude: '126.05358125713',
    latitude: '42.690699881882'
  },
  220524:
  {
    name: '柳河县',
    parseid: '2205',
    longitude: '125.75142398189',
    latitude: '42.290871215056'
  },
  220581:
  {
    name: '梅河口市',
    parseid: '2205',
    longitude: '125.71760780995',
    latitude: '42.544883890284'
  },
  220582:
  {
    name: '集安市',
    parseid: '2205',
    longitude: '126.199577372',
    latitude: '41.131299724033'
  },
  220602:
  {
    name: '浑江区',
    parseid: '2206',
    longitude: '126.42361952721',
    latitude: '41.95042372822'
  },
  220605:
  {
    name: '江源区',
    parseid: '2206',
    longitude: '126.59739097896',
    latitude: '42.062939372081'
  },
  220621:
  {
    name: '抚松县',
    parseid: '2206',
    longitude: '127.45537119527',
    latitude: '42.227335272553'
  },
  220622:
  {
    name: '靖宇县',
    parseid: '2206',
    longitude: '126.81949899257',
    latitude: '42.394765734578'
  },
  220623:
  {
    name: '长白朝鲜族自治县',
    parseid: '2206',
    longitude: '128.20758420219',
    latitude: '41.425895812594'
  },
  220681:
  {
    name: '临江市',
    parseid: '2206',
    longitude: '126.9245815135',
    latitude: '41.817678643992'
  },
  220702:
  {
    name: '宁江区',
    parseid: '2207',
    longitude: '124.82342254815',
    latitude: '45.178039438667'
  },
  220721:
  {
    name: '前郭尔罗斯蒙古族自治县',
    parseid: '2207',
    longitude: '124.83045556165',
    latitude: '45.123416092926'
  },
  220722:
  {
    name: '长岭县',
    parseid: '2207',
    longitude: '123.9743741034',
    latitude: '44.281638280052'
  },
  220723:
  {
    name: '乾安县',
    parseid: '2207',
    longitude: '124.0475638046',
    latitude: '45.008434321605'
  },
  220771:
  {
    name: '吉林松原经济开发区',
    parseid: '2207',
    longitude: '124.83148187569',
    latitude: '45.147404193414'
  },
  220781:
  {
    name: '扶余市',
    parseid: '2207',
    longitude: '126.0566062111',
    latitude: '44.994168421151'
  },
  220802:
  {
    name: '洮北区',
    parseid: '2208',
    longitude: '122.85750977516',
    latitude: '45.627524686514'
  },
  220821:
  {
    name: '镇赉县',
    parseid: '2208',
    longitude: '123.20657575565',
    latitude: '45.853116635389'
  },
  220822:
  {
    name: '通榆县',
    parseid: '2208',
    longitude: '123.09452077673',
    latitude: '44.818963735882'
  },
  220871:
  {
    name: '吉林白城经济开发区',
    parseid: '2208',
    longitude: '122.85178967109',
    latitude: '45.62527410134'
  },
  220881:
  {
    name: '洮南市',
    parseid: '2208',
    longitude: '122.7944676826',
    latitude: '45.341131872567'
  },
  220882:
  {
    name: '大安市',
    parseid: '2208',
    longitude: '124.29850428102',
    latitude: '45.513045149628'
  },
  222401:
  {
    name: '延吉市',
    parseid: '2224',
    longitude: '129.52052013726',
    latitude: '42.91271700988'
  },
  222402:
  {
    name: '图们市',
    parseid: '2224',
    longitude: '129.85038151375',
    latitude: '42.974283499075'
  },
  222403:
  {
    name: '敦化市',
    parseid: '2224',
    longitude: '128.23861239315',
    latitude: '43.378291274517'
  },
  222404:
  {
    name: '珲春市',
    parseid: '2224',
    longitude: '130.37261321858',
    latitude: '42.868515115192'
  },
  222405:
  {
    name: '龙井市',
    parseid: '2224',
    longitude: '129.43263477701',
    latitude: '42.771534868349'
  },
  222406:
  {
    name: '和龙市',
    parseid: '2224',
    longitude: '129.01738712621',
    latitude: '42.552322568432'
  },
  222424:
  {
    name: '汪清县',
    parseid: '2224',
    longitude: '129.77760879625',
    latitude: '43.318450833865'
  },
  222426:
  {
    name: '安图县',
    parseid: '2224',
    longitude: '128.90544846814',
    latitude: '43.117916954912'
  },
  230102:
  {
    name: '道里区',
    parseid: '2301',
    longitude: '126.62343158837',
    latitude: '45.761844478815'
  },
  230103:
  {
    name: '南岗区',
    parseid: '2301',
    longitude: '126.67563849952',
    latitude: '45.765866163758'
  },
  230104:
  {
    name: '道外区',
    parseid: '2301',
    longitude: '126.65560404089',
    latitude: '45.797776220434'
  },
  230108:
  {
    name: '平房区',
    parseid: '2301',
    longitude: '126.64354707416',
    latitude: '45.603862295555'
  },
  230109:
  {
    name: '松北区',
    parseid: '2301',
    longitude: '126.51648256825',
    latitude: '45.808592561429'
  },
  230110:
  {
    name: '香坊区',
    parseid: '2301',
    longitude: '126.66962434413',
    latitude: '45.713619645389'
  },
  230111:
  {
    name: '呼兰区',
    parseid: '2301',
    longitude: '126.5943989831',
    latitude: '45.895209780863'
  },
  230112:
  {
    name: '阿城区',
    parseid: '2301',
    longitude: '126.96435649552',
    latitude: '45.554275304352'
  },
  230113:
  {
    name: '双城区',
    parseid: '2301',
    longitude: '126.31962313777',
    latitude: '45.388111522394'
  },
  230123:
  {
    name: '依兰县',
    parseid: '2301',
    longitude: '129.57451969721',
    latitude: '46.331260289052'
  },
  230124:
  {
    name: '方正县',
    parseid: '2301',
    longitude: '128.83563368134',
    latitude: '45.857758440062'
  },
  230125:
  {
    name: '宾县',
    parseid: '2301',
    longitude: '127.4734970145',
    latitude: '45.752465386742'
  },
  230126:
  {
    name: '巴彦县',
    parseid: '2301',
    longitude: '127.4105479864',
    latitude: '46.091282657815'
  },
  230127:
  {
    name: '木兰县',
    parseid: '2301',
    longitude: '128.05035620452',
    latitude: '45.956871319448'
  },
  230128:
  {
    name: '通河县',
    parseid: '2301',
    longitude: '128.75241627584',
    latitude: '45.996392590921'
  },
  230129:
  {
    name: '延寿县',
    parseid: '2301',
    longitude: '128.33860582402',
    latitude: '45.457641195714'
  },
  230183:
  {
    name: '尚志市',
    parseid: '2301',
    longitude: '128.01548820666',
    latitude: '45.215473941867'
  },
  230184:
  {
    name: '五常市',
    parseid: '2301',
    longitude: '127.17352882965',
    latitude: '44.937842855774'
  },
  230202:
  {
    name: '龙沙区',
    parseid: '2302',
    longitude: '123.96437622285',
    latitude: '47.323576977429'
  },
  230203:
  {
    name: '建华区',
    parseid: '2302',
    longitude: '123.96135010108',
    latitude: '47.360554871046'
  },
  230204:
  {
    name: '铁锋区',
    parseid: '2302',
    longitude: '123.984415712',
    latitude: '47.347018863772'
  },
  230205:
  {
    name: '昂昂溪区',
    parseid: '2302',
    longitude: '123.82940626913',
    latitude: '47.161332243626'
  },
  230206:
  {
    name: '富拉尔基区',
    parseid: '2302',
    longitude: '123.63650980324',
    latitude: '47.215504082791'
  },
  230207:
  {
    name: '碾子山区',
    parseid: '2302',
    longitude: '122.89436680108',
    latitude: '47.523236298133'
  },
  230208:
  {
    name: '梅里斯达斡尔族区',
    parseid: '2302',
    longitude: '123.75954091741',
    latitude: '47.315549574077'
  },
  230221:
  {
    name: '龙江县',
    parseid: '2302',
    longitude: '123.21153898342',
    latitude: '47.343605740151'
  },
  230223:
  {
    name: '依安县',
    parseid: '2302',
    longitude: '125.3124821661',
    latitude: '47.899483651368'
  },
  230224:
  {
    name: '泰来县',
    parseid: '2302',
    longitude: '123.42362630925',
    latitude: '46.39782928518'
  },
  230225:
  {
    name: '甘南县',
    parseid: '2302',
    longitude: '123.51248588182',
    latitude: '47.92688406951'
  },
  230227:
  {
    name: '富裕县',
    parseid: '2302',
    longitude: '124.48054247906',
    latitude: '47.780228063275'
  },
  230229:
  {
    name: '克山县',
    parseid: '2302',
    longitude: '125.88137832693',
    latitude: '48.043172360737'
  },
  230230:
  {
    name: '克东县',
    parseid: '2302',
    longitude: '126.25538674804',
    latitude: '48.048244160483'
  },
  230231:
  {
    name: '拜泉县',
    parseid: '2302',
    longitude: '126.10542147027',
    latitude: '47.601867301959'
  },
  230281:
  {
    name: '讷河市',
    parseid: '2302',
    longitude: '124.8905490562',
    latitude: '48.490086593264'
  },
  230302:
  {
    name: '鸡冠区',
    parseid: '2303',
    longitude: '130.98763160852',
    latitude: '45.309806344312'
  },
  230303:
  {
    name: '恒山区',
    parseid: '2303',
    longitude: '130.91138523344',
    latitude: '45.216971883154'
  },
  230304:
  {
    name: '滴道区',
    parseid: '2303',
    longitude: '130.85058046059',
    latitude: '45.354433617216'
  },
  230305:
  {
    name: '梨树区',
    parseid: '2303',
    longitude: '130.70339606719',
    latitude: '45.098241780981'
  },
  230306:
  {
    name: '城子河区',
    parseid: '2303',
    longitude: '131.01846864007',
    latitude: '45.344435193918'
  },
  230307:
  {
    name: '麻山区',
    parseid: '2303',
    longitude: '130.48453641613',
    latitude: '45.217934996767'
  },
  230321:
  {
    name: '鸡东县',
    parseid: '2303',
    longitude: '131.13055848296',
    latitude: '45.266184560826'
  },
  230381:
  {
    name: '虎林市',
    parseid: '2303',
    longitude: '132.94346566318',
    latitude: '45.768946912884'
  },
  230382:
  {
    name: '密山市',
    parseid: '2303',
    longitude: '131.85353110655',
    latitude: '45.535640809748'
  },
  230402:
  {
    name: '向阳区',
    parseid: '2304',
    longitude: '130.30046804764',
    latitude: '47.348580889067'
  },
  230403:
  {
    name: '工农区',
    parseid: '2304',
    longitude: '130.28161728617',
    latitude: '47.324430299458'
  },
  230404:
  {
    name: '南山区',
    parseid: '2304',
    longitude: '130.29354031555',
    latitude: '47.321245938809'
  },
  230405:
  {
    name: '兴安区',
    parseid: '2304',
    longitude: '130.24554573859',
    latitude: '47.258716269483'
  },
  230406:
  {
    name: '东山区',
    parseid: '2304',
    longitude: '130.32336109407',
    latitude: '47.344987135573'
  },
  230407:
  {
    name: '兴山区',
    parseid: '2304',
    longitude: '130.31736364716',
    latitude: '47.396045381282'
  },
  230421:
  {
    name: '萝北县',
    parseid: '2304',
    longitude: '130.8354950365',
    latitude: '47.583422197029'
  },
  230422:
  {
    name: '绥滨县',
    parseid: '2304',
    longitude: '131.85948651276',
    latitude: '47.295265458073'
  },
  230502:
  {
    name: '尖山区',
    parseid: '2305',
    longitude: '131.16534177061',
    latitude: '46.652585923812'
  },
  230503:
  {
    name: '岭东区',
    parseid: '2305',
    longitude: '131.164376721',
    latitude: '46.464596047853'
  },
  230505:
  {
    name: '四方台区',
    parseid: '2305',
    longitude: '131.345657378',
    latitude: '46.602012285083'
  },
  230506:
  {
    name: '宝山区',
    parseid: '2305',
    longitude: '131.40737518857',
    latitude: '46.583598340241'
  },
  230521:
  {
    name: '集贤县',
    parseid: '2305',
    longitude: '131.14743449942',
    latitude: '46.734517788557'
  },
  230522:
  {
    name: '友谊县',
    parseid: '2305',
    longitude: '131.8145948627',
    latitude: '46.772973223022'
  },
  230523:
  {
    name: '宝清县',
    parseid: '2305',
    longitude: '132.20359411633',
    latitude: '46.332651823572'
  },
  230524:
  {
    name: '饶河县',
    parseid: '2305',
    longitude: '134.02046893233',
    latitude: '46.804182744162'
  },
  230602:
  {
    name: '萨尔图区',
    parseid: '2306',
    longitude: '125.13351006443',
    latitude: '46.638936435554'
  },
  230603:
  {
    name: '龙凤区',
    parseid: '2306',
    longitude: '125.14047256095',
    latitude: '46.567678067125'
  },
  230604:
  {
    name: '让胡路区',
    parseid: '2306',
    longitude: '124.87759881447',
    latitude: '46.658078458609'
  },
  230605:
  {
    name: '红岗区',
    parseid: '2306',
    longitude: '124.8974774171',
    latitude: '46.404313108628'
  },
  230606:
  {
    name: '大同区',
    parseid: '2306',
    longitude: '124.81937675979',
    latitude: '46.045583951311'
  },
  230621:
  {
    name: '肇州县',
    parseid: '2306',
    longitude: '125.2753682248',
    latitude: '45.705107986871'
  },
  230622:
  {
    name: '肇源县',
    parseid: '2306',
    longitude: '125.08457262601',
    latitude: '45.524152914206'
  },
  230623:
  {
    name: '林甸县',
    parseid: '2306',
    longitude: '124.86965042766',
    latitude: '47.177234395243'
  },
  230624:
  {
    name: '杜尔伯特蒙古族自治县',
    parseid: '2306',
    longitude: '124.44935879141',
    latitude: '46.868767758452'
  },
  230671:
  {
    name: '大庆高新技术产业开发区',
    parseid: '2306',
    longitude: '125.1577684454',
    latitude: '46.581284253883'
  },
  230717:
  {
    name: '伊美区',
    parseid: '2307',
    longitude: '128.8475463802',
    latitude: '47.733318457231'
  },
  230718:
  {
    name: '乌翠区',
    parseid: '2307',
    longitude: '128.8475463802',
    latitude: '47.733318457231'
  },
  230719:
  {
    name: '友好区',
    parseid: '2307',
    longitude: '128.84257946937',
    latitude: '47.846436100332'
  },
  230722:
  {
    name: '嘉荫县',
    parseid: '2307',
    longitude: '130.41055547772',
    latitude: '48.894983469564'
  },
  230723:
  {
    name: '汤旺县',
    parseid: '2307',
    longitude: '129.04351846449',
    latitude: '47.669025471653'
  },
  230724:
  {
    name: '丰林县',
    parseid: '2307',
    longitude: '129.02563787298',
    latitude: '48.210030039889'
  },
  230725:
  {
    name: '大箐山县',
    parseid: '2307',
    longitude: '129.00716799305',
    latitude: '46.955113497718'
  },
  230726:
  {
    name: '南岔县',
    parseid: '2307',
    longitude: '129.28957179961',
    latitude: '47.143749913595'
  },
  230751:
  {
    name: '金林区',
    parseid: '2307',
    longitude: '128.8475463802',
    latitude: '47.733318457231'
  },
  230781:
  {
    name: '铁力市',
    parseid: '2307',
    longitude: '128.03836490393',
    latitude: '46.992948620259'
  },
  230803:
  {
    name: '向阳区',
    parseid: '2308',
    longitude: '130.37261186145',
    latitude: '46.813511816781'
  },
  230804:
  {
    name: '前进区',
    parseid: '2308',
    longitude: '130.3816482759',
    latitude: '46.819626508482'
  },
  230805:
  {
    name: '东风区',
    parseid: '2308',
    longitude: '130.41056077772',
    latitude: '46.828385151991'
  },
  230811:
  {
    name: '郊区',
    parseid: '2308',
    longitude: '130.33337809881',
    latitude: '46.816168112829'
  },
  230822:
  {
    name: '桦南县',
    parseid: '2308',
    longitude: '130.56038502153',
    latitude: '46.24507747688'
  },
  230826:
  {
    name: '桦川县',
    parseid: '2308',
    longitude: '130.72554944886',
    latitude: '47.028816852926'
  },
  230828:
  {
    name: '汤原县',
    parseid: '2308',
    longitude: '129.91164504155',
    latitude: '46.735326720461'
  },
  230881:
  {
    name: '同江市',
    parseid: '2308',
    longitude: '132.51750949205',
    latitude: '47.647980676666'
  },
  230882:
  {
    name: '富锦市',
    parseid: '2308',
    longitude: '132.04453879528',
    latitude: '47.255932571848'
  },
  230883:
  {
    name: '抚远市',
    parseid: '2308',
    longitude: '134.31448962575',
    latitude: '48.370944696273'
  },
  230902:
  {
    name: '新兴区',
    parseid: '2309',
    longitude: '130.93837086995',
    latitude: '45.822310328543'
  },
  230903:
  {
    name: '桃山区',
    parseid: '2309',
    longitude: '131.02644424554',
    latitude: '45.771799915696'
  },
  230904:
  {
    name: '茄子河区',
    parseid: '2309',
    longitude: '131.0744805937',
    latitude: '45.791238180152'
  },
  230921:
  {
    name: '勃利县',
    parseid: '2309',
    longitude: '130.59853255314',
    latitude: '45.760964313167'
  },
  231002:
  {
    name: '东安区',
    parseid: '2310',
    longitude: '129.63347765344',
    latitude: '44.587460377571'
  },
  231003:
  {
    name: '阳明区',
    parseid: '2310',
    longitude: '129.64252736281',
    latitude: '44.601775026515'
  },
  231004:
  {
    name: '爱民区',
    parseid: '2310',
    longitude: '129.59836369953',
    latitude: '44.602350339442'
  },
  231005:
  {
    name: '西安区',
    parseid: '2310',
    longitude: '129.62241286515',
    latitude: '44.583861081842'
  },
  231025:
  {
    name: '林口县',
    parseid: '2310',
    longitude: '130.28757880086',
    latitude: '45.28412885062'
  },
  231071:
  {
    name: '牡丹江经济技术开发区',
    parseid: '2310',
    longitude: '129.38724286061',
    latitude: '44.289595066474'
  },
  231081:
  {
    name: '绥芬河市',
    parseid: '2310',
    longitude: '131.15739222567',
    latitude: '44.418154372388'
  },
  231083:
  {
    name: '海林市',
    parseid: '2310',
    longitude: '129.38742683358',
    latitude: '44.599871973195'
  },
  231084:
  {
    name: '宁安市',
    parseid: '2310',
    longitude: '129.48936798014',
    latitude: '44.3469835775'
  },
  231085:
  {
    name: '穆棱市',
    parseid: '2310',
    longitude: '130.53055850352',
    latitude: '44.924784589588'
  },
  231086:
  {
    name: '东宁市',
    parseid: '2310',
    longitude: '131.13154357445',
    latitude: '44.096101486248'
  },
  231102:
  {
    name: '爱辉区',
    parseid: '2311',
    longitude: '127.50663227086',
    latitude: '50.257709616452'
  },
  231123:
  {
    name: '逊克县',
    parseid: '2311',
    longitude: '128.48558459529',
    latitude: '49.5694914357'
  },
  231124:
  {
    name: '孙吴县',
    parseid: '2311',
    longitude: '127.34238770837',
    latitude: '49.431450606859'
  },
  231181:
  {
    name: '北安市',
    parseid: '2311',
    longitude: '126.49737974226',
    latitude: '48.247419532219'
  },
  231182:
  {
    name: '五大连池市',
    parseid: '2311',
    longitude: '126.21155518831',
    latitude: '48.522609551763'
  },
  231183:
  {
    name: '嫩江市',
    parseid: '2311',
    longitude: '125.22763469543',
    latitude: '49.191320184756'
  },
  231202:
  {
    name: '北林区',
    parseid: '2312',
    longitude: '126.99144894055',
    latitude: '46.643492672111'
  },
  231221:
  {
    name: '望奎县',
    parseid: '2312',
    longitude: '126.49238489413',
    latitude: '46.839167601749'
  },
  231222:
  {
    name: '兰西县',
    parseid: '2312',
    longitude: '126.29461952255',
    latitude: '46.258095172245'
  },
  231223:
  {
    name: '青冈县',
    parseid: '2312',
    longitude: '126.10048887472',
    latitude: '46.71068498305'
  },
  231224:
  {
    name: '庆安县',
    parseid: '2312',
    longitude: '127.5146121882',
    latitude: '46.885744465245'
  },
  231225:
  {
    name: '明水县',
    parseid: '2312',
    longitude: '125.91248269419',
    latitude: '47.179483374941'
  },
  231226:
  {
    name: '绥棱县',
    parseid: '2312',
    longitude: '127.12051514063',
    latitude: '47.242515793854'
  },
  231281:
  {
    name: '安达市',
    parseid: '2312',
    longitude: '125.34862234422',
    latitude: '46.425719232144'
  },
  231282:
  {
    name: '肇东市',
    parseid: '2312',
    longitude: '125.96853740717',
    latitude: '46.056938289303'
  },
  231283:
  {
    name: '海伦市',
    parseid: '2312',
    longitude: '126.93650857556',
    latitude: '47.456903841096'
  },
  232701:
  {
    name: '漠河市',
    parseid: '2327',
    longitude: '122.5454208342',
    latitude: '52.978303678377'
  },
  232721:
  {
    name: '呼玛县',
    parseid: '2327',
    longitude: '126.65964991907',
    latitude: '51.73094674724'
  },
  232722:
  {
    name: '塔河县',
    parseid: '2327',
    longitude: '124.71651251449',
    latitude: '52.340305081113'
  },
  232761:
  {
    name: '加格达奇区',
    parseid: '2327',
    longitude: '124.15292785448',
    latitude: '50.420025955028'
  },
  232762:
  {
    name: '松岭区',
    parseid: '2327',
    longitude: '124.15292785448',
    latitude: '50.420025955028'
  },
  232763:
  {
    name: '新林区',
    parseid: '2327',
    longitude: '124.53914092375',
    latitude: '51.801225110533'
  },
  232764:
  {
    name: '呼中区',
    parseid: '2327',
    longitude: '123.58143136869',
    latitude: '52.037468814622'
  },
  310101:
  {
    name: '黄浦区',
    parseid: '3101',
    longitude: '121.49158559252',
    latitude: '31.237247152064'
  },
  310104:
  {
    name: '徐汇区',
    parseid: '3101',
    longitude: '121.44339635276',
    latitude: '31.194556772823'
  },
  310105:
  {
    name: '长宁区',
    parseid: '3101',
    longitude: '121.43045437545',
    latitude: '31.226847968225'
  },
  310106:
  {
    name: '静安区',
    parseid: '3101',
    longitude: '121.45343177277',
    latitude: '31.233844930402'
  },
  310107:
  {
    name: '普陀区',
    parseid: '3101',
    longitude: '121.40356934917',
    latitude: '31.25497336828'
  },
  310109:
  {
    name: '虹口区',
    parseid: '3101',
    longitude: '121.51158645453',
    latitude: '31.269746698931'
  },
  310110:
  {
    name: '杨浦区',
    parseid: '3101',
    longitude: '121.53251993733',
    latitude: '31.265524144657'
  },
  310112:
  {
    name: '闵行区',
    parseid: '3101',
    longitude: '121.38861193361',
    latitude: '31.118842580087'
  },
  310113:
  {
    name: '宝山区',
    parseid: '3101',
    longitude: '121.49656301352',
    latitude: '31.410279473476'
  },
  310114:
  {
    name: '嘉定区',
    parseid: '3101',
    longitude: '121.27259505835',
    latitude: '31.380155339677'
  },
  310115:
  {
    name: '浦东新区',
    parseid: '3101',
    longitude: '121.55045460683',
    latitude: '31.227348292436'
  },
  310116:
  {
    name: '金山区',
    parseid: '3101',
    longitude: '121.34848004512',
    latitude: '30.74785237657'
  },
  310117:
  {
    name: '松江区',
    parseid: '3101',
    longitude: '121.23447959624',
    latitude: '31.037135176464'
  },
  310118:
  {
    name: '青浦区',
    parseid: '3101',
    longitude: '121.13055310467',
    latitude: '31.155454317981'
  },
  310120:
  {
    name: '奉贤区',
    parseid: '3101',
    longitude: '121.48050373643',
    latitude: '30.923720110285'
  },
  310151:
  {
    name: '崇明区',
    parseid: '3101',
    longitude: '121.40951379605',
    latitude: '31.336247198797'
  },
  320102:
  {
    name: '玄武区',
    parseid: '3201',
    longitude: '118.80441263575',
    latitude: '32.054756682949'
  },
  320104:
  {
    name: '秦淮区',
    parseid: '3201',
    longitude: '118.80040736097',
    latitude: '32.045138606405'
  },
  320105:
  {
    name: '建邺区',
    parseid: '3201',
    longitude: '118.73856944695',
    latitude: '32.009369695446'
  },
  320106:
  {
    name: '鼓楼区',
    parseid: '3201',
    longitude: '118.77651899204',
    latitude: '32.072405160557'
  },
  320111:
  {
    name: '浦口区',
    parseid: '3201',
    longitude: '118.63460405875',
    latitude: '32.064679277923'
  },
  320113:
  {
    name: '栖霞区',
    parseid: '3201',
    longitude: '118.91542298491',
    latitude: '32.10260020783'
  },
  320114:
  {
    name: '雨花台区',
    parseid: '3201',
    longitude: '118.78544536406',
    latitude: '31.997858805466'
  },
  320115:
  {
    name: '江宁区',
    parseid: '3201',
    longitude: '118.84656705909',
    latitude: '31.958526869177'
  },
  320116:
  {
    name: '六合区',
    parseid: '3201',
    longitude: '118.82747132971',
    latitude: '32.32866604102'
  },
  320117:
  {
    name: '溧水区',
    parseid: '3201',
    longitude: '119.03440390903',
    latitude: '31.657283696314'
  },
  320118:
  {
    name: '高淳区',
    parseid: '3201',
    longitude: '118.89849765147',
    latitude: '31.333639123905'
  },
  320205:
  {
    name: '锡山区',
    parseid: '3202',
    longitude: '120.36342571103',
    latitude: '31.594761632814'
  },
  320206:
  {
    name: '惠山区',
    parseid: '3202',
    longitude: '120.30459559335',
    latitude: '31.686741337275'
  },
  320211:
  {
    name: '滨湖区',
    parseid: '3202',
    longitude: '120.29154752616',
    latitude: '31.534639699974'
  },
  320213:
  {
    name: '梁溪区',
    parseid: '3202',
    longitude: '120.30959951436',
    latitude: '31.571645024135'
  },
  320214:
  {
    name: '新吴区',
    parseid: '3202',
    longitude: '120.37039647195',
    latitude: '31.554850239842'
  },
  320281:
  {
    name: '江阴市',
    parseid: '3202',
    longitude: '120.29156800752',
    latitude: '31.926044909769'
  },
  320282:
  {
    name: '宜兴市',
    parseid: '3202',
    longitude: '119.83160603216',
    latitude: '31.342956624268'
  },
  320302:
  {
    name: '鼓楼区',
    parseid: '3203',
    longitude: '117.19257874733',
    latitude: '34.293760084221'
  },
  320303:
  {
    name: '云龙区',
    parseid: '3203',
    longitude: '117.2584239124',
    latitude: '34.259086691031'
  },
  320305:
  {
    name: '贾汪区',
    parseid: '3203',
    longitude: '117.46943039703',
    latitude: '34.441620400617'
  },
  320311:
  {
    name: '泉山区',
    parseid: '3203',
    longitude: '117.20059046468',
    latitude: '34.249942871606'
  },
  320312:
  {
    name: '铜山区',
    parseid: '3203',
    longitude: '117.17556960199',
    latitude: '34.186100449885'
  },
  320321:
  {
    name: '丰县',
    parseid: '3203',
    longitude: '116.60258246804',
    latitude: '34.699769765634'
  },
  320322:
  {
    name: '沛县',
    parseid: '3203',
    longitude: '116.9425856239',
    latitude: '34.765151955415'
  },
  320324:
  {
    name: '睢宁县',
    parseid: '3203',
    longitude: '117.94743277245',
    latitude: '33.918789417818'
  },
  320371:
  {
    name: '徐州经济技术开发区',
    parseid: '3203',
    longitude: '117.33167229434',
    latitude: '34.292097076324'
  },
  320381:
  {
    name: '新沂市',
    parseid: '3203',
    longitude: '118.36153652102',
    latitude: '34.375610954637'
  },
  320382:
  {
    name: '邳州市',
    parseid: '3203',
    longitude: '118.0191233013',
    latitude: '34.344645519326'
  },
  320402:
  {
    name: '天宁区',
    parseid: '3204',
    longitude: '119.98046316025',
    latitude: '31.785570271253'
  },
  320404:
  {
    name: '钟楼区',
    parseid: '3204',
    longitude: '119.908462716',
    latitude: '31.807646657754'
  },
  320411:
  {
    name: '新北区',
    parseid: '3204',
    longitude: '119.97751429276',
    latitude: '31.836323947624'
  },
  320412:
  {
    name: '武进区',
    parseid: '3204',
    longitude: '119.94861167229',
    latitude: '31.706446611742'
  },
  320413:
  {
    name: '金坛区',
    parseid: '3204',
    longitude: '119.60457090266',
    latitude: '31.72889303001'
  },
  320481:
  {
    name: '溧阳市',
    parseid: '3204',
    longitude: '119.49150603896',
    latitude: '31.422102292159'
  },
  320505:
  {
    name: '虎丘区',
    parseid: '3205',
    longitude: '120.57847178571',
    latitude: '31.301932876554'
  },
  320506:
  {
    name: '吴中区',
    parseid: '3205',
    longitude: '120.63850751921',
    latitude: '31.268261445846'
  },
  320507:
  {
    name: '相城区',
    parseid: '3205',
    longitude: '120.64856593584',
    latitude: '31.374689921493'
  },
  320508:
  {
    name: '姑苏区',
    parseid: '3205',
    longitude: '120.6234549731',
    latitude: '31.341831300993'
  },
  320509:
  {
    name: '吴江区',
    parseid: '3205',
    longitude: '120.65156717454',
    latitude: '31.144644190473'
  },
  320571:
  {
    name: '苏州工业园区',
    parseid: '3205',
    longitude: '120.72988971332',
    latitude: '31.330443143709'
  },
  320581:
  {
    name: '常熟市',
    parseid: '3205',
    longitude: '120.75949588665',
    latitude: '31.659538276741'
  },
  320582:
  {
    name: '张家港市',
    parseid: '3205',
    longitude: '120.56155363871',
    latitude: '31.88114053634'
  },
  320583:
  {
    name: '昆山市',
    parseid: '3205',
    longitude: '120.98745249795',
    latitude: '31.390863425082'
  },
  320585:
  {
    name: '太仓市',
    parseid: '3205',
    longitude: '121.1355952935',
    latitude: '31.464599352978'
  },
  320602:
  {
    name: '崇川区',
    parseid: '3206',
    longitude: '120.86342022229',
    latitude: '32.015923029631'
  },
  320611:
  {
    name: '港闸区',
    parseid: '3206',
    longitude: '120.82445235808',
    latitude: '32.037345124875'
  },
  320612:
  {
    name: '通州区',
    parseid: '3206',
    longitude: '121.08142549498',
    latitude: '32.070355739676'
  },
  320623:
  {
    name: '如东县',
    parseid: '3206',
    longitude: '121.19243791024',
    latitude: '32.335872886155'
  },
  320671:
  {
    name: '南通经济技术开发区',
    parseid: '3206',
    longitude: '120.95923348798',
    latitude: '31.938612483813'
  },
  320681:
  {
    name: '启东市',
    parseid: '3206',
    longitude: '121.66347374677',
    latitude: '31.814232849643'
  },
  320682:
  {
    name: '如皋市',
    parseid: '3206',
    longitude: '120.57946558109',
    latitude: '32.377851486109'
  },
  320684:
  {
    name: '海门市',
    parseid: '3206',
    longitude: '121.18843649817',
    latitude: '31.87361172603'
  },
  320685:
  {
    name: '海安市',
    parseid: '3206',
    longitude: '120.47443309578',
    latitude: '32.53919574424'
  },
  320703:
  {
    name: '连云区',
    parseid: '3207',
    longitude: '119.34658780087',
    latitude: '34.76533714403'
  },
  320706:
  {
    name: '海州区',
    parseid: '3207',
    longitude: '119.16940808819',
    latitude: '34.577456118597'
  },
  320707:
  {
    name: '赣榆区',
    parseid: '3207',
    longitude: '119.17943461497',
    latitude: '34.847682460846'
  },
  320722:
  {
    name: '东海县',
    parseid: '3207',
    longitude: '118.75956509248',
    latitude: '34.547918627364'
  },
  320723:
  {
    name: '灌云县',
    parseid: '3207',
    longitude: '119.24653354504',
    latitude: '34.288616060258'
  },
  320724:
  {
    name: '灌南县',
    parseid: '3207',
    longitude: '119.3225381861',
    latitude: '34.09259130777'
  },
  320771:
  {
    name: '连云港经济技术开发区',
    parseid: '3207',
    longitude: '119.32786882082',
    latitude: '34.092698259646'
  },
  320772:
  {
    name: '连云港高新技术产业开发区',
    parseid: '3207',
    longitude: '118.71014598265',
    latitude: '34.513478033894'
  },
  320803:
  {
    name: '淮安区',
    parseid: '3208',
    longitude: '119.14746320322',
    latitude: '33.508999838208'
  },
  320804:
  {
    name: '淮阴区',
    parseid: '3208',
    longitude: '119.04142174116',
    latitude: '33.638150424768'
  },
  320812:
  {
    name: '清江浦区',
    parseid: '3208',
    longitude: '119.03241362334',
    latitude: '33.558562240066'
  },
  320813:
  {
    name: '洪泽区',
    parseid: '3208',
    longitude: '118.8795836493',
    latitude: '33.29962468147'
  },
  320826:
  {
    name: '涟水县',
    parseid: '3208',
    longitude: '119.26644843921',
    latitude: '33.7870787079'
  },
  320830:
  {
    name: '盱眙县',
    parseid: '3208',
    longitude: '118.55144127024',
    latitude: '33.01825474166'
  },
  320831:
  {
    name: '金湖县',
    parseid: '3208',
    longitude: '119.02646908663',
    latitude: '33.031283826757'
  },
  320871:
  {
    name: '淮安经济技术开发区',
    parseid: '3208',
    longitude: '119.14746320322',
    latitude: '33.508999838208'
  },
  320902:
  {
    name: '亭湖区',
    parseid: '3209',
    longitude: '120.20457816804',
    latitude: '33.395893486907'
  },
  320903:
  {
    name: '盐都区',
    parseid: '3209',
    longitude: '120.16050325734',
    latitude: '33.344020315599'
  },
  320904:
  {
    name: '大丰区',
    parseid: '3209',
    longitude: '120.50743881649',
    latitude: '33.20475984971'
  },
  320921:
  {
    name: '响水县',
    parseid: '3209',
    longitude: '119.58460112202',
    latitude: '34.20474300276'
  },
  320922:
  {
    name: '滨海县',
    parseid: '3209',
    longitude: '119.82762105909',
    latitude: '33.995646547467'
  },
  320923:
  {
    name: '阜宁县',
    parseid: '3209',
    longitude: '119.80958074885',
    latitude: '33.765078727087'
  },
  320924:
  {
    name: '射阳县',
    parseid: '3209',
    longitude: '120.26444564892',
    latitude: '33.78101359213'
  },
  320925:
  {
    name: '建湖县',
    parseid: '3209',
    longitude: '119.80553127745',
    latitude: '33.469832978385'
  },
  320971:
  {
    name: '盐城经济技术开发区',
    parseid: '3209',
    longitude: '120.22374917542',
    latitude: '33.385830793651'
  },
  320981:
  {
    name: '东台市',
    parseid: '3209',
    longitude: '120.32653706475',
    latitude: '32.872716312488'
  },
  321002:
  {
    name: '广陵区',
    parseid: '3210',
    longitude: '119.43850484608',
    latitude: '32.40066115972'
  },
  321003:
  {
    name: '邗江区',
    parseid: '3210',
    longitude: '119.40438513671',
    latitude: '32.38275135526'
  },
  321012:
  {
    name: '江都区',
    parseid: '3210',
    longitude: '119.57660296908',
    latitude: '32.440294506243'
  },
  321023:
  {
    name: '宝应县',
    parseid: '3210',
    longitude: '119.36555570138',
    latitude: '33.247205461148'
  },
  321071:
  {
    name: '扬州经济技术开发区',
    parseid: '3210',
    longitude: '119.41105397715',
    latitude: '32.295832055282'
  },
  321081:
  {
    name: '仪征市',
    parseid: '3210',
    longitude: '119.19146705795',
    latitude: '32.278090483161'
  },
  321084:
  {
    name: '高邮市',
    parseid: '3210',
    longitude: '119.46561561654',
    latitude: '32.787147020528'
  },
  321102:
  {
    name: '京口区',
    parseid: '3211',
    longitude: '119.47560369584',
    latitude: '32.203785483528'
  },
  321111:
  {
    name: '润州区',
    parseid: '3211',
    longitude: '119.41844047387',
    latitude: '32.201494843152'
  },
  321112:
  {
    name: '丹徒区',
    parseid: '3211',
    longitude: '119.44050079109',
    latitude: '32.13792039565'
  },
  321171:
  {
    name: '镇江新区',
    parseid: '3211',
    longitude: '119.52265397405',
    latitude: '32.169142010413'
  },
  321181:
  {
    name: '丹阳市',
    parseid: '3211',
    longitude: '119.61250060471',
    latitude: '32.01592027417'
  },
  321182:
  {
    name: '扬中市',
    parseid: '3211',
    longitude: '119.80351961209',
    latitude: '32.242967194122'
  },
  321183:
  {
    name: '句容市',
    parseid: '3211',
    longitude: '119.1754332029',
    latitude: '31.950923490521'
  },
  321202:
  {
    name: '海陵区',
    parseid: '3212',
    longitude: '119.9255249512',
    latitude: '32.496731549227'
  },
  321203:
  {
    name: '高港区',
    parseid: '3212',
    longitude: '119.88842098109',
    latitude: '32.32486247444'
  },
  321204:
  {
    name: '姜堰区',
    parseid: '3212',
    longitude: '120.13339832587',
    latitude: '32.515233674759'
  },
  321271:
  {
    name: '泰州医药高新技术产业开发区',
    parseid: '3212',
    longitude: '119.91416057802',
    latitude: '32.452657449903'
  },
  321281:
  {
    name: '兴化市',
    parseid: '3212',
    longitude: '119.85751406137',
    latitude: '32.917824213889'
  },
  321282:
  {
    name: '靖江市',
    parseid: '3212',
    longitude: '120.28353203592',
    latitude: '31.988170075211'
  },
  321283:
  {
    name: '泰兴市',
    parseid: '3212',
    longitude: '120.05859939046',
    latitude: '32.177474023712'
  },
  321302:
  {
    name: '宿城区',
    parseid: '3213',
    longitude: '118.24956705107',
    latitude: '33.968677630731'
  },
  321311:
  {
    name: '宿豫区',
    parseid: '3213',
    longitude: '118.33640094471',
    latitude: '33.954804396327'
  },
  321322:
  {
    name: '沭阳县',
    parseid: '3213',
    longitude: '118.81041906571',
    latitude: '34.117454209479'
  },
  321323:
  {
    name: '泗阳县',
    parseid: '3213',
    longitude: '118.70946596538',
    latitude: '33.728328313047'
  },
  321324:
  {
    name: '泗洪县',
    parseid: '3213',
    longitude: '118.22241594669',
    latitude: '33.465732594595'
  },
  321371:
  {
    name: '宿迁经济技术开发区',
    parseid: '3213',
    longitude: '118.28157403571',
    latitude: '33.96774971569'
  },
  330102:
  {
    name: '上城区',
    parseid: '3301',
    longitude: '120.17557880007',
    latitude: '30.248398420426'
  },
  330103:
  {
    name: '下城区',
    parseid: '3301',
    longitude: '120.18760693119',
    latitude: '30.286744052562'
  },
  330104:
  {
    name: '江干区',
    parseid: '3301',
    longitude: '120.21153877811',
    latitude: '30.263310567012'
  },
  330105:
  {
    name: '拱墅区',
    parseid: '3301',
    longitude: '120.14844700926',
    latitude: '30.32464256663'
  },
  330106:
  {
    name: '西湖区',
    parseid: '3301',
    longitude: '120.13643801205',
    latitude: '30.265916325589'
  },
  330108:
  {
    name: '滨江区',
    parseid: '3301',
    longitude: '120.21847118139',
    latitude: '30.214332950144'
  },
  330109:
  {
    name: '萧山区',
    parseid: '3301',
    longitude: '120.27047058397',
    latitude: '30.187511222214'
  },
  330110:
  {
    name: '余杭区',
    parseid: '3301',
    longitude: '120.30659216718',
    latitude: '30.424739268745'
  },
  330111:
  {
    name: '富阳区',
    parseid: '3301',
    longitude: '119.96655568418',
    latitude: '30.054722967304'
  },
  330112:
  {
    name: '临安区',
    parseid: '3301',
    longitude: '119.73151737122',
    latitude: '30.239805598054'
  },
  330122:
  {
    name: '桐庐县',
    parseid: '3301',
    longitude: '119.69759877583',
    latitude: '29.798584790143'
  },
  330127:
  {
    name: '淳安县',
    parseid: '3301',
    longitude: '119.04839230601',
    latitude: '29.614950366034'
  },
  330182:
  {
    name: '建德市',
    parseid: '3301',
    longitude: '119.28739807501',
    latitude: '29.481154026968'
  },
  330203:
  {
    name: '海曙区',
    parseid: '3302',
    longitude: '121.55740307254',
    latitude: '29.865720708366'
  },
  330205:
  {
    name: '江北区',
    parseid: '3302',
    longitude: '121.56042128922',
    latitude: '29.892948379476'
  },
  330206:
  {
    name: '北仑区',
    parseid: '3302',
    longitude: '121.85057621461',
    latitude: '29.904659359939'
  },
  330211:
  {
    name: '镇海区',
    parseid: '3302',
    longitude: '121.72251899132',
    latitude: '29.954884963349'
  },
  330212:
  {
    name: '鄞州区',
    parseid: '3302',
    longitude: '121.55542706991',
    latitude: '29.824206349996'
  },
  330213:
  {
    name: '奉化区',
    parseid: '3302',
    longitude: '121.41352776719',
    latitude: '29.66114641278'
  },
  330225:
  {
    name: '象山县',
    parseid: '3302',
    longitude: '121.87556392982',
    latitude: '29.482270653805'
  },
  330226:
  {
    name: '宁海县',
    parseid: '3302',
    longitude: '121.43643177294',
    latitude: '29.294317441106'
  },
  330281:
  {
    name: '余姚市',
    parseid: '3302',
    longitude: '121.16058507482',
    latitude: '30.042734639571'
  },
  330282:
  {
    name: '慈溪市',
    parseid: '3302',
    longitude: '121.27259613632',
    latitude: '30.17525661072'
  },
  330302:
  {
    name: '鹿城区',
    parseid: '3303',
    longitude: '120.66158649793',
    latitude: '28.020351607763'
  },
  330303:
  {
    name: '龙湾区',
    parseid: '3303',
    longitude: '120.81946755397',
    latitude: '27.938652244916'
  },
  330304:
  {
    name: '瓯海区',
    parseid: '3303',
    longitude: '120.62144724335',
    latitude: '27.972857351643'
  },
  330305:
  {
    name: '洞头区',
    parseid: '3303',
    longitude: '121.16354856759',
    latitude: '27.841870324587'
  },
  330324:
  {
    name: '永嘉县',
    parseid: '3303',
    longitude: '120.68852407508',
    latitude: '28.156450332206'
  },
  330326:
  {
    name: '平阳县',
    parseid: '3303',
    longitude: '120.57251537444',
    latitude: '27.667724401093'
  },
  330327:
  {
    name: '苍南县',
    parseid: '3303',
    longitude: '120.43359512229',
    latitude: '27.523066788447'
  },
  330328:
  {
    name: '文成县',
    parseid: '3303',
    longitude: '120.09748845652',
    latitude: '27.79321715229'
  },
  330329:
  {
    name: '泰顺县',
    parseid: '3303',
    longitude: '119.72353725759',
    latitude: '27.562170559597'
  },
  330371:
  {
    name: '温州经济技术开发区',
    parseid: '3303',
    longitude: '120.82367611529',
    latitude: '27.878891980453'
  },
  330381:
  {
    name: '瑞安市',
    parseid: '3303',
    longitude: '120.66158218607',
    latitude: '27.783950736232'
  },
  330382:
  {
    name: '乐清市',
    parseid: '3303',
    longitude: '120.99250185617',
    latitude: '28.118179995228'
  },
  330383:
  {
    name: '龙港市',
    parseid: '3303',
    longitude: '120.54224706013',
    latitude: '27.579911437331'
  },
  330402:
  {
    name: '南湖区',
    parseid: '3304',
    longitude: '120.78961005175',
    latitude: '30.751546813315'
  },
  330411:
  {
    name: '秀洲区',
    parseid: '3304',
    longitude: '120.71543705563',
    latitude: '30.770207214174'
  },
  330421:
  {
    name: '嘉善县',
    parseid: '3304',
    longitude: '120.93251060584',
    latitude: '30.83712219382'
  },
  330424:
  {
    name: '海盐县',
    parseid: '3304',
    longitude: '120.95244526273',
    latitude: '30.531872894538'
  },
  330481:
  {
    name: '海宁市',
    parseid: '3304',
    longitude: '120.68656506738',
    latitude: '30.517923769776'
  },
  330482:
  {
    name: '平湖市',
    parseid: '3304',
    longitude: '121.02257525525',
    latitude: '30.682240998058'
  },
  330483:
  {
    name: '桐乡市',
    parseid: '3304',
    longitude: '120.57154315531',
    latitude: '30.63631118771'
  },
  330502:
  {
    name: '吴兴区',
    parseid: '3305',
    longitude: '120.1916046602',
    latitude: '30.862955454986'
  },
  330503:
  {
    name: '南浔区',
    parseid: '3305',
    longitude: '120.42460139422',
    latitude: '30.855242982243'
  },
  330521:
  {
    name: '德清县',
    parseid: '3305',
    longitude: '119.98346466845',
    latitude: '30.548628239139'
  },
  330522:
  {
    name: '长兴县',
    parseid: '3305',
    longitude: '119.91749832197',
    latitude: '31.032579326835'
  },
  330523:
  {
    name: '安吉县',
    parseid: '3305',
    longitude: '119.68656337876',
    latitude: '30.644424794114'
  },
  330602:
  {
    name: '越城区',
    parseid: '3306',
    longitude: '120.58843667181',
    latitude: '29.995309962798'
  },
  330603:
  {
    name: '柯桥区',
    parseid: '3306',
    longitude: '120.45151103408',
    latitude: '30.07900360495'
  },
  330604:
  {
    name: '上虞区',
    parseid: '3306',
    longitude: '120.87450989364',
    latitude: '30.038242967062'
  },
  330624:
  {
    name: '新昌县',
    parseid: '3306',
    longitude: '120.91056965639',
    latitude: '29.50554107531'
  },
  330681:
  {
    name: '诸暨市',
    parseid: '3306',
    longitude: '120.25340833197',
    latitude: '29.714934649195'
  },
  330683:
  {
    name: '嵊州市',
    parseid: '3306',
    longitude: '120.83743725739',
    latitude: '29.567326991294'
  },
  330702:
  {
    name: '婺城区',
    parseid: '3307',
    longitude: '119.57859260936',
    latitude: '29.091775438186'
  },
  330703:
  {
    name: '金东区',
    parseid: '3307',
    longitude: '119.69958241405',
    latitude: '29.104765016118'
  },
  330723:
  {
    name: '武义县',
    parseid: '3307',
    longitude: '119.82256555867',
    latitude: '28.89824378665'
  },
  330726:
  {
    name: '浦江县',
    parseid: '3307',
    longitude: '119.8984360827',
    latitude: '29.458692851855'
  },
  330727:
  {
    name: '磐安县',
    parseid: '3307',
    longitude: '120.45651305177',
    latitude: '29.060103175107'
  },
  330781:
  {
    name: '兰溪市',
    parseid: '3307',
    longitude: '119.46659870554',
    latitude: '29.214044345079'
  },
  330782:
  {
    name: '义乌市',
    parseid: '3307',
    longitude: '120.08158099306',
    latitude: '29.31114987541'
  },
  330783:
  {
    name: '东阳市',
    parseid: '3307',
    longitude: '120.24842192791',
    latitude: '29.295861065151'
  },
  330784:
  {
    name: '永康市',
    parseid: '3307',
    longitude: '120.05455071078',
    latitude: '28.894203967255'
  },
  330802:
  {
    name: '柯城区',
    parseid: '3308',
    longitude: '118.87758391504',
    latitude: '28.974203651128'
  },
  330803:
  {
    name: '衢江区',
    parseid: '3308',
    longitude: '118.9655390736',
    latitude: '28.986237907969'
  },
  330822:
  {
    name: '常山县',
    parseid: '3308',
    longitude: '118.51755663118',
    latitude: '28.906997949113'
  },
  330824:
  {
    name: '开化县',
    parseid: '3308',
    longitude: '118.42145932131',
    latitude: '29.143187521187'
  },
  330825:
  {
    name: '龙游县',
    parseid: '3308',
    longitude: '119.17841825566',
    latitude: '29.034486553295'
  },
  330881:
  {
    name: '江山市',
    parseid: '3308',
    longitude: '118.63358329793',
    latitude: '28.742868480118'
  },
  330902:
  {
    name: '定海区',
    parseid: '3309',
    longitude: '122.11360080392',
    latitude: '30.025462378363'
  },
  330903:
  {
    name: '普陀区',
    parseid: '3309',
    longitude: '122.33154416586',
    latitude: '29.976835696536'
  },
  330921:
  {
    name: '岱山县',
    parseid: '3309',
    longitude: '122.23260481449',
    latitude: '30.269655894035'
  },
  330922:
  {
    name: '嵊泗县',
    parseid: '3309',
    longitude: '122.45758776506',
    latitude: '30.731273949024'
  },
  331002:
  {
    name: '椒江区',
    parseid: '3310',
    longitude: '121.44940797569',
    latitude: '28.679258224903'
  },
  331003:
  {
    name: '黄岩区',
    parseid: '3310',
    longitude: '121.26856605116',
    latitude: '28.655333607551'
  },
  331004:
  {
    name: '路桥区',
    parseid: '3310',
    longitude: '121.37157806769',
    latitude: '28.586946666726'
  },
  331022:
  {
    name: '三门县',
    parseid: '3310',
    longitude: '121.40255379759',
    latitude: '29.110355206289'
  },
  331023:
  {
    name: '天台县',
    parseid: '3310',
    longitude: '121.01355337629',
    latitude: '29.149514378149'
  },
  331024:
  {
    name: '仙居县',
    parseid: '3310',
    longitude: '120.73543520575',
    latitude: '28.853225693258'
  },
  331081:
  {
    name: '温岭市',
    parseid: '3310',
    longitude: '121.39258889458',
    latitude: '28.37765548985'
  },
  331082:
  {
    name: '临海市',
    parseid: '3310',
    longitude: '121.15158529413',
    latitude: '28.864049329083'
  },
  331083:
  {
    name: '玉环市',
    parseid: '3310',
    longitude: '121.23851297084',
    latitude: '28.141862986829'
  },
  331102:
  {
    name: '莲都区',
    parseid: '3311',
    longitude: '119.91951913335',
    latitude: '28.451745135046'
  },
  331121:
  {
    name: '青田县',
    parseid: '3311',
    longitude: '120.296573349',
    latitude: '28.14548755633'
  },
  331122:
  {
    name: '缙云县',
    parseid: '3311',
    longitude: '120.09747830566',
    latitude: '28.665214747164'
  },
  331123:
  {
    name: '遂昌县',
    parseid: '3311',
    longitude: '119.28243538622',
    latitude: '28.59845467671'
  },
  331124:
  {
    name: '松阳县',
    parseid: '3311',
    longitude: '119.48854377016',
    latitude: '28.455056404273'
  },
  331125:
  {
    name: '云和县',
    parseid: '3311',
    longitude: '119.57959736407',
    latitude: '28.121469507454'
  },
  331126:
  {
    name: '庆元县',
    parseid: '3311',
    longitude: '119.06948685498',
    latitude: '27.625431778354'
  },
  331127:
  {
    name: '景宁畲族自治县',
    parseid: '3311',
    longitude: '119.64243033109',
    latitude: '27.979553966951'
  },
  331181:
  {
    name: '龙泉市',
    parseid: '3311',
    longitude: '119.14844476521',
    latitude: '28.080508725251'
  },
  340102:
  {
    name: '瑶海区',
    parseid: '3401',
    longitude: '117.31558704454',
    latitude: '31.863786941657'
  },
  340103:
  {
    name: '庐阳区',
    parseid: '3401',
    longitude: '117.27145913382',
    latitude: '31.884886695554'
  },
  340104:
  {
    name: '蜀山区',
    parseid: '3401',
    longitude: '117.2664607823',
    latitude: '31.857378217104'
  },
  340111:
  {
    name: '包河区',
    parseid: '3401',
    longitude: '117.31657625857',
    latitude: '31.799293467782'
  },
  340121:
  {
    name: '长丰县',
    parseid: '3401',
    longitude: '117.17356009256',
    latitude: '32.483722623763'
  },
  340122:
  {
    name: '肥东县',
    parseid: '3401',
    longitude: '117.47540062528',
    latitude: '31.893890354487'
  },
  340123:
  {
    name: '肥西县',
    parseid: '3401',
    longitude: '117.16455781372',
    latitude: '31.712962132717'
  },
  340124:
  {
    name: '庐江县',
    parseid: '3401',
    longitude: '117.29357730192',
    latitude: '31.261327637478'
  },
  340171:
  {
    name: '合肥高新技术产业开发区',
    parseid: '3401',
    longitude: '117.18321378752',
    latitude: '31.840582790503'
  },
  340172:
  {
    name: '合肥经济技术开发区',
    parseid: '3401',
    longitude: '117.21606467539',
    latitude: '31.784406512425'
  },
  340173:
  {
    name: '合肥新站高新技术产业开发区',
    parseid: '3401',
    longitude: '117.18321378752',
    latitude: '31.840582790503'
  },
  340181:
  {
    name: '巢湖市',
    parseid: '3401',
    longitude: '117.89557620045',
    latitude: '31.629002428816'
  },
  340202:
  {
    name: '镜湖区',
    parseid: '3402',
    longitude: '118.39260630352',
    latitude: '31.345866595569'
  },
  340203:
  {
    name: '弋江区',
    parseid: '3402',
    longitude: '118.37957970583',
    latitude: '31.317566272497'
  },
  340207:
  {
    name: '鸠江区',
    parseid: '3402',
    longitude: '118.39758848554',
    latitude: '31.375804519517'
  },
  340208:
  {
    name: '三山区',
    parseid: '3402',
    longitude: '118.27460210698',
    latitude: '31.225280124269'
  },
  340221:
  {
    name: '芜湖县',
    parseid: '3402',
    longitude: '118.58244251203',
    latitude: '31.141239223464'
  },
  340222:
  {
    name: '繁昌县',
    parseid: '3402',
    longitude: '118.20542431831',
    latitude: '31.107958593586'
  },
  340223:
  {
    name: '南陵县',
    parseid: '3402',
    longitude: '118.34041816695',
    latitude: '30.920260298683'
  },
  340225:
  {
    name: '无为县',
    parseid: '3402',
    longitude: '117.90857854389',
    latitude: '31.308844155979'
  },
  340271:
  {
    name: '芜湖经济技术开发区',
    parseid: '3402',
    longitude: '118.45417889043',
    latitude: '31.417327574449'
  },
  340272:
  {
    name: '安徽芜湖长江大桥经济开发区',
    parseid: '3402',
    longitude: '118.37946121933',
    latitude: '31.391647770998'
  },
  340302:
  {
    name: '龙子湖区',
    parseid: '3403',
    longitude: '117.39951276393',
    latitude: '32.948644262929'
  },
  340303:
  {
    name: '蚌山区',
    parseid: '3403',
    longitude: '117.37944120527',
    latitude: '32.923378770395'
  },
  340304:
  {
    name: '禹会区',
    parseid: '3403',
    longitude: '117.3484523601',
    latitude: '32.935309988858'
  },
  340311:
  {
    name: '淮上区',
    parseid: '3403',
    longitude: '117.36638271774',
    latitude: '32.970547011885'
  },
  340321:
  {
    name: '怀远县',
    parseid: '3403',
    longitude: '117.21150631391',
    latitude: '32.976003726624'
  },
  340322:
  {
    name: '五河县',
    parseid: '3403',
    longitude: '117.88756088987',
    latitude: '33.132709462866'
  },
  340323:
  {
    name: '固镇县',
    parseid: '3403',
    longitude: '117.32354764831',
    latitude: '33.323274297744'
  },
  340371:
  {
    name: '蚌埠市高新技术开发区',
    parseid: '3403',
    longitude: '117.25428507127',
    latitude: '32.838735637615'
  },
  340372:
  {
    name: '蚌埠市经济开发区',
    parseid: '3403',
    longitude: '117.25979226075',
    latitude: '32.986437718091'
  },
  340402:
  {
    name: '大通区',
    parseid: '3404',
    longitude: '117.05958317929',
    latitude: '32.637269959538'
  },
  340403:
  {
    name: '田家庵区',
    parseid: '3404',
    longitude: '117.02344533676',
    latitude: '32.653323007096'
  },
  340404:
  {
    name: '谢家集区',
    parseid: '3404',
    longitude: '116.86543887721',
    latitude: '32.606254588196'
  },
  340405:
  {
    name: '八公山区',
    parseid: '3404',
    longitude: '116.84056434849',
    latitude: '32.637137318437'
  },
  340406:
  {
    name: '潘集区',
    parseid: '3404',
    longitude: '116.84158096084',
    latitude: '32.777955491108'
  },
  340421:
  {
    name: '凤台县',
    parseid: '3404',
    longitude: '116.71757320891',
    latitude: '32.715103905085'
  },
  340422:
  {
    name: '寿县',
    parseid: '3404',
    longitude: '116.8055627726',
    latitude: '32.561546151201'
  },
  340503:
  {
    name: '花山区',
    parseid: '3405',
    longitude: '118.49960562875',
    latitude: '31.725472572001'
  },
  340504:
  {
    name: '雨山区',
    parseid: '3405',
    longitude: '118.50559705701',
    latitude: '31.687745482904'
  },
  340506:
  {
    name: '博望区',
    parseid: '3405',
    longitude: '118.82477524539',
    latitude: '31.557510028418'
  },
  340521:
  {
    name: '当涂县',
    parseid: '3405',
    longitude: '118.50460469891',
    latitude: '31.576649154711'
  },
  340522:
  {
    name: '含山县',
    parseid: '3405',
    longitude: '118.10746203634',
    latitude: '31.740862208736'
  },
  340523:
  {
    name: '和县',
    parseid: '3405',
    longitude: '118.35951254887',
    latitude: '31.748243815854'
  },
  340602:
  {
    name: '杜集区',
    parseid: '3406',
    longitude: '116.83461226601',
    latitude: '33.997285436391'
  },
  340603:
  {
    name: '相山区',
    parseid: '3406',
    longitude: '116.80052112276',
    latitude: '33.96582716177'
  },
  340604:
  {
    name: '烈山区',
    parseid: '3406',
    longitude: '116.81959906569',
    latitude: '33.901574061832'
  },
  340621:
  {
    name: '濉溪县',
    parseid: '3406',
    longitude: '116.77238942808',
    latitude: '33.921629194823'
  },
  340705:
  {
    name: '铜官区',
    parseid: '3407',
    longitude: '117.82145710265',
    latitude: '30.940386340633'
  },
  340706:
  {
    name: '义安区',
    parseid: '3407',
    longitude: '117.79856800876',
    latitude: '30.958512099098'
  },
  340711:
  {
    name: '郊区',
    parseid: '3407',
    longitude: '117.80755007573',
    latitude: '30.897741483658'
  },
  340722:
  {
    name: '枞阳县',
    parseid: '3407',
    longitude: '117.22643695997',
    latitude: '30.705671267725'
  },
  340802:
  {
    name: '迎江区',
    parseid: '3408',
    longitude: '117.09751448877',
    latitude: '30.517523291408'
  },
  340803:
  {
    name: '大观区',
    parseid: '3408',
    longitude: '117.04053820417',
    latitude: '30.518231924651'
  },
  340811:
  {
    name: '宜秀区',
    parseid: '3408',
    longitude: '116.99344112425',
    latitude: '30.619675877796'
  },
  340822:
  {
    name: '怀宁县',
    parseid: '3408',
    longitude: '116.83659258051',
    latitude: '30.739399674607'
  },
  340825:
  {
    name: '太湖县',
    parseid: '3408',
    longitude: '116.31547630162',
    latitude: '30.460113290448'
  },
  340826:
  {
    name: '宿松县',
    parseid: '3408',
    longitude: '116.13552369949',
    latitude: '30.159786861375'
  },
  340827:
  {
    name: '望江县',
    parseid: '3408',
    longitude: '116.7005902941',
    latitude: '30.129968329229'
  },
  340828:
  {
    name: '岳西县',
    parseid: '3408',
    longitude: '116.36655539021',
    latitude: '30.855227714002'
  },
  340871:
  {
    name: '安徽安庆经济开发区',
    parseid: '3408',
    longitude: '116.3452374659',
    latitude: '30.46332717963'
  },
  340881:
  {
    name: '桐城市',
    parseid: '3408',
    longitude: '116.98046635878',
    latitude: '31.041969037674'
  },
  340882:
  {
    name: '潜山市',
    parseid: '3408',
    longitude: '116.58761103892',
    latitude: '30.636755682399'
  },
  341002:
  {
    name: '屯溪区',
    parseid: '3410',
    longitude: '118.32141818077',
    latitude: '29.702143908546'
  },
  341003:
  {
    name: '黄山区',
    parseid: '3410',
    longitude: '118.14760982484',
    latitude: '30.278650980188'
  },
  341004:
  {
    name: '徽州区',
    parseid: '3410',
    longitude: '118.34343582847',
    latitude: '29.834221385317'
  },
  341021:
  {
    name: '歙县',
    parseid: '3410',
    longitude: '118.42146012979',
    latitude: '29.866287675757'
  },
  341022:
  {
    name: '休宁县',
    parseid: '3410',
    longitude: '118.20543014116',
    latitude: '29.795459004963'
  },
  341023:
  {
    name: '黟县',
    parseid: '3410',
    longitude: '117.94447724144',
    latitude: '29.931047330704'
  },
  341024:
  {
    name: '祁门县',
    parseid: '3410',
    longitude: '117.72339257754',
    latitude: '29.86034394808'
  },
  341102:
  {
    name: '琅琊区',
    parseid: '3411',
    longitude: '118.31244134015',
    latitude: '32.300867492599'
  },
  341103:
  {
    name: '南谯区',
    parseid: '3411',
    longitude: '118.42348205204',
    latitude: '32.206131899264'
  },
  341122:
  {
    name: '来安县',
    parseid: '3411',
    longitude: '118.4424124932',
    latitude: '32.458449762427'
  },
  341124:
  {
    name: '全椒县',
    parseid: '3411',
    longitude: '118.2805842827',
    latitude: '32.091939797603'
  },
  341125:
  {
    name: '定远县',
    parseid: '3411',
    longitude: '117.70447068625',
    latitude: '32.537046613487'
  },
  341126:
  {
    name: '凤阳县',
    parseid: '3411',
    longitude: '117.53858536874',
    latitude: '32.880976725258'
  },
  341171:
  {
    name: '苏滁现代产业园',
    parseid: '3411',
    longitude: '118.42323968921',
    latitude: '32.314044940428'
  },
  341172:
  {
    name: '滁州经济技术开发区',
    parseid: '3411',
    longitude: '118.33940613597',
    latitude: '32.261270872041'
  },
  341181:
  {
    name: '天长市',
    parseid: '3411',
    longitude: '119.01138527949',
    latitude: '32.67341003277'
  },
  341182:
  {
    name: '明光市',
    parseid: '3411',
    longitude: '117.99550981385',
    latitude: '32.783022823418'
  },
  341202:
  {
    name: '颍州区',
    parseid: '3412',
    longitude: '115.81341119616',
    latitude: '32.88962541655'
  },
  341203:
  {
    name: '颍东区',
    parseid: '3412',
    longitude: '115.86361668264',
    latitude: '32.917362240172'
  },
  341204:
  {
    name: '颍泉区',
    parseid: '3412',
    longitude: '115.81542555644',
    latitude: '32.931313576025'
  },
  341221:
  {
    name: '临泉县',
    parseid: '3412',
    longitude: '115.26761550051',
    latitude: '33.045959528363'
  },
  341222:
  {
    name: '太和县',
    parseid: '3412',
    longitude: '115.6286154697',
    latitude: '33.165959850096'
  },
  341225:
  {
    name: '阜南县',
    parseid: '3412',
    longitude: '115.60254592516',
    latitude: '32.664097385125'
  },
  341226:
  {
    name: '颍上县',
    parseid: '3412',
    longitude: '116.26347689904',
    latitude: '32.659028468804'
  },
  341271:
  {
    name: '阜阳合肥现代产业园区',
    parseid: '3412',
    longitude: '115.91484048825',
    latitude: '32.815750041269'
  },
  341272:
  {
    name: '阜阳经济技术开发区',
    parseid: '3412',
    longitude: '115.8633231164',
    latitude: '32.870018592698'
  },
  341282:
  {
    name: '界首市',
    parseid: '3412',
    longitude: '115.38060984722',
    latitude: '33.262775236231'
  },
  341302:
  {
    name: '埇桥区',
    parseid: '3413',
    longitude: '116.98348044326',
    latitude: '33.646130650445'
  },
  341321:
  {
    name: '砀山县',
    parseid: '3413',
    longitude: '116.37252400151',
    latitude: '34.448428171397'
  },
  341322:
  {
    name: '萧县',
    parseid: '3413',
    longitude: '116.95358492572',
    latitude: '34.194269344319'
  },
  341323:
  {
    name: '灵璧县',
    parseid: '3413',
    longitude: '117.56455699799',
    latitude: '33.547892231948'
  },
  341324:
  {
    name: '泗县',
    parseid: '3413',
    longitude: '117.91658999175',
    latitude: '33.488694630134'
  },
  341371:
  {
    name: '宿州马鞍山现代产业园区',
    parseid: '3413',
    longitude: '117.28195125235',
    latitude: '33.686876334594'
  },
  341372:
  {
    name: '宿州经济技术开发区',
    parseid: '3413',
    longitude: '116.97054394561',
    latitude: '33.652095326452'
  },
  341502:
  {
    name: '金安区',
    parseid: '3415',
    longitude: '116.54543837997',
    latitude: '31.756287719901'
  },
  341503:
  {
    name: '裕安区',
    parseid: '3415',
    longitude: '116.48654978261',
    latitude: '31.74362587083'
  },
  341504:
  {
    name: '叶集区',
    parseid: '3415',
    longitude: '115.94747592742',
    latitude: '31.83526314225'
  },
  341522:
  {
    name: '霍邱县',
    parseid: '3415',
    longitude: '116.28439133776',
    latitude: '32.359343590922'
  },
  341523:
  {
    name: '舒城县',
    parseid: '3415',
    longitude: '116.95560171142',
    latitude: '31.467692010556'
  },
  341524:
  {
    name: '金寨县',
    parseid: '3415',
    longitude: '115.94044120714',
    latitude: '31.733461734381'
  },
  341525:
  {
    name: '霍山县',
    parseid: '3415',
    longitude: '116.33957586218',
    latitude: '31.398570812489'
  },
  341602:
  {
    name: '谯城区',
    parseid: '3416',
    longitude: '115.78547191853',
    latitude: '33.882663087443'
  },
  341621:
  {
    name: '涡阳县',
    parseid: '3416',
    longitude: '116.22160903516',
    latitude: '33.498566835004'
  },
  341622:
  {
    name: '蒙城县',
    parseid: '3416',
    longitude: '116.57158940083',
    latitude: '33.271658239674'
  },
  341623:
  {
    name: '利辛县',
    parseid: '3416',
    longitude: '116.1914935226',
    latitude: '33.155595841529'
  },
  341702:
  {
    name: '贵池区',
    parseid: '3417',
    longitude: '117.57449037049',
    latitude: '30.693857943819'
  },
  341721:
  {
    name: '东至县',
    parseid: '3417',
    longitude: '117.03448128944',
    latitude: '30.116534528265'
  },
  341722:
  {
    name: '石台县',
    parseid: '3417',
    longitude: '117.49239440959',
    latitude: '30.216530337189'
  },
  341723:
  {
    name: '青阳县',
    parseid: '3417',
    longitude: '117.85343129914',
    latitude: '30.645634346235'
  },
  341802:
  {
    name: '宣州区',
    parseid: '3418',
    longitude: '118.76254944305',
    latitude: '30.952158157984'
  },
  341821:
  {
    name: '郎溪县',
    parseid: '3418',
    longitude: '119.18646592169',
    latitude: '31.132681870443'
  },
  341823:
  {
    name: '泾县',
    parseid: '3418',
    longitude: '118.42643469242',
    latitude: '30.694672488542'
  },
  341824:
  {
    name: '绩溪县',
    parseid: '3418',
    longitude: '118.58544384057',
    latitude: '30.073292199533'
  },
  341825:
  {
    name: '旌德县',
    parseid: '3418',
    longitude: '118.54646735263',
    latitude: '30.292481093722'
  },
  341871:
  {
    name: '宣城市经济开发区',
    parseid: '3418',
    longitude: '118.76553424277',
    latitude: '30.946601545293'
  },
  341881:
  {
    name: '宁国市',
    parseid: '3418',
    longitude: '118.98960981494',
    latitude: '30.639352229689'
  },
  341882:
  {
    name: '广德市',
    parseid: '3418',
    longitude: '119.42747581035',
    latitude: '30.883667102643'
  },
  350102:
  {
    name: '鼓楼区',
    parseid: '3501',
    longitude: '119.31049162322',
    latitude: '26.088114037555'
  },
  350103:
  {
    name: '台江区',
    parseid: '3501',
    longitude: '119.32052821102',
    latitude: '26.058528150645'
  },
  350104:
  {
    name: '仓山区',
    parseid: '3501',
    longitude: '119.28043216493',
    latitude: '26.052841691927'
  },
  350105:
  {
    name: '马尾区',
    parseid: '3501',
    longitude: '119.44551915828',
    latitude: '26.004533771063'
  },
  350111:
  {
    name: '晋安区',
    parseid: '3501',
    longitude: '119.33457941597',
    latitude: '26.087213904434'
  },
  350112:
  {
    name: '长乐区',
    parseid: '3501',
    longitude: '119.52943832001',
    latitude: '25.969257448077'
  },
  350121:
  {
    name: '闽侯县',
    parseid: '3501',
    longitude: '119.13848201812',
    latitude: '26.156035214577'
  },
  350122:
  {
    name: '连江县',
    parseid: '3501',
    longitude: '119.54647881621',
    latitude: '26.203583291029'
  },
  350123:
  {
    name: '罗源县',
    parseid: '3501',
    longitude: '119.55648045992',
    latitude: '26.495495660324'
  },
  350124:
  {
    name: '闽清县',
    parseid: '3501',
    longitude: '118.86957650956',
    latitude: '26.226847540202'
  },
  350125:
  {
    name: '永泰县',
    parseid: '3501',
    longitude: '118.93843072857',
    latitude: '25.872787263196'
  },
  350128:
  {
    name: '平潭县',
    parseid: '3501',
    longitude: '119.79650131414',
    latitude: '25.504700273945'
  },
  350181:
  {
    name: '福清市',
    parseid: '3501',
    longitude: '119.39046524749',
    latitude: '25.726343299035'
  },
  350203:
  {
    name: '思明区',
    parseid: '3502',
    longitude: '118.08840797224',
    latitude: '24.451948395671'
  },
  350205:
  {
    name: '海沧区',
    parseid: '3502',
    longitude: '118.03956171185',
    latitude: '24.490325818598'
  },
  350206:
  {
    name: '湖里区',
    parseid: '3502',
    longitude: '118.15358812172',
    latitude: '24.517573138112'
  },
  350211:
  {
    name: '集美区',
    parseid: '3502',
    longitude: '118.10343491664',
    latitude: '24.58201906225'
  },
  350212:
  {
    name: '同安区',
    parseid: '3502',
    longitude: '118.15856347661',
    latitude: '24.729113975347'
  },
  350213:
  {
    name: '翔安区',
    parseid: '3502',
    longitude: '118.25457589661',
    latitude: '24.624216383593'
  },
  350302:
  {
    name: '城厢区',
    parseid: '3503',
    longitude: '119.00153633131',
    latitude: '25.424343792482'
  },
  350303:
  {
    name: '涵江区',
    parseid: '3503',
    longitude: '119.12256736822',
    latitude: '25.464464388124'
  },
  350304:
  {
    name: '荔城区',
    parseid: '3503',
    longitude: '119.01948169064',
    latitude: '25.439754478806'
  },
  350305:
  {
    name: '秀屿区',
    parseid: '3503',
    longitude: '119.11157130031',
    latitude: '25.323654397561'
  },
  350322:
  {
    name: '仙游县',
    parseid: '3503',
    longitude: '118.69845425065',
    latitude: '25.368291498104'
  },
  350402:
  {
    name: '梅列区',
    parseid: '3504',
    longitude: '117.65255022877',
    latitude: '26.277335878355'
  },
  350403:
  {
    name: '三元区',
    parseid: '3504',
    longitude: '117.61441509378',
    latitude: '26.240219374574'
  },
  350421:
  {
    name: '明溪县',
    parseid: '3504',
    longitude: '117.20851763568',
    latitude: '26.361853685277'
  },
  350423:
  {
    name: '清流县',
    parseid: '3504',
    longitude: '116.8235931858',
    latitude: '26.18335735321'
  },
  350424:
  {
    name: '宁化县',
    parseid: '3504',
    longitude: '116.660425512',
    latitude: '26.26795649054'
  },
  350425:
  {
    name: '大田县',
    parseid: '3504',
    longitude: '117.85343999668',
    latitude: '25.698932641879'
  },
  350426:
  {
    name: '尤溪县',
    parseid: '3504',
    longitude: '118.19743971365',
    latitude: '26.17621803946'
  },
  350427:
  {
    name: '沙县',
    parseid: '3504',
    longitude: '117.79856107581',
    latitude: '26.402813444346'
  },
  350428:
  {
    name: '将乐县',
    parseid: '3504',
    longitude: '117.47740904084',
    latitude: '26.735209519833'
  },
  350429:
  {
    name: '泰宁县',
    parseid: '3504',
    longitude: '117.1825958624',
    latitude: '26.905660032285'
  },
  350430:
  {
    name: '建宁县',
    parseid: '3504',
    longitude: '116.85250622659',
    latitude: '26.836824655349'
  },
  350481:
  {
    name: '永安市',
    parseid: '3504',
    longitude: '117.37144258732',
    latitude: '25.948143989824'
  },
  350502:
  {
    name: '鲤城区',
    parseid: '3505',
    longitude: '118.59348105353',
    latitude: '24.913354167054'
  },
  350503:
  {
    name: '丰泽区',
    parseid: '3505',
    longitude: '118.61958015232',
    latitude: '24.894969993262'
  },
  350504:
  {
    name: '洛江区',
    parseid: '3505',
    longitude: '118.67741629493',
    latitude: '24.94621365376'
  },
  350505:
  {
    name: '泉港区',
    parseid: '3505',
    longitude: '118.92243298541',
    latitude: '25.139650393954'
  },
  350521:
  {
    name: '惠安县',
    parseid: '3505',
    longitude: '118.8034155003',
    latitude: '25.036949815039'
  },
  350524:
  {
    name: '安溪县',
    parseid: '3505',
    longitude: '118.19242537229',
    latitude: '25.061759553382'
  },
  350525:
  {
    name: '永春县',
    parseid: '3505',
    longitude: '118.30048613527',
    latitude: '25.327974202083'
  },
  350526:
  {
    name: '德化县',
    parseid: '3505',
    longitude: '118.24755006956',
    latitude: '25.497308594179'
  },
  350527:
  {
    name: '金门县',
    parseid: '3505',
    longitude: '118.3304151596',
    latitude: '24.440444541055'
  },
  350581:
  {
    name: '石狮市',
    parseid: '3505',
    longitude: '118.65451902647',
    latitude: '24.737665160883'
  },
  350582:
  {
    name: '晋江市',
    parseid: '3505',
    longitude: '118.55843052',
    latitude: '24.787824575145'
  },
  350583:
  {
    name: '南安市',
    parseid: '3505',
    longitude: '118.39257197205',
    latitude: '24.966362350468'
  },
  350602:
  {
    name: '芗城区',
    parseid: '3506',
    longitude: '117.6605895241',
    latitude: '24.516268416111'
  },
  350603:
  {
    name: '龙文区',
    parseid: '3506',
    longitude: '117.7164546946',
    latitude: '24.509509680945'
  },
  350622:
  {
    name: '云霄县',
    parseid: '3506',
    longitude: '117.34644831448',
    latitude: '23.964072828248'
  },
  350623:
  {
    name: '漳浦县',
    parseid: '3506',
    longitude: '117.62044335257',
    latitude: '24.123461614812'
  },
  350624:
  {
    name: '诏安县',
    parseid: '3506',
    longitude: '117.18255858272',
    latitude: '23.717053963784'
  },
  350625:
  {
    name: '长泰县',
    parseid: '3506',
    longitude: '117.76555257036',
    latitude: '24.631243628383'
  },
  350626:
  {
    name: '东山县',
    parseid: '3506',
    longitude: '117.43656030457',
    latitude: '23.706894688691'
  },
  350627:
  {
    name: '南靖县',
    parseid: '3506',
    longitude: '117.36344641066',
    latitude: '24.52085173207'
  },
  350628:
  {
    name: '平和县',
    parseid: '3506',
    longitude: '117.32255159131',
    latitude: '24.368365040126'
  },
  350629:
  {
    name: '华安县',
    parseid: '3506',
    longitude: '117.54058560971',
    latitude: '25.010067731399'
  },
  350681:
  {
    name: '龙海市',
    parseid: '3506',
    longitude: '117.82445086941',
    latitude: '24.452939738547'
  },
  350702:
  {
    name: '延平区',
    parseid: '3507',
    longitude: '118.18845055007',
    latitude: '26.643807791057'
  },
  350703:
  {
    name: '建阳区',
    parseid: '3507',
    longitude: '118.12752522464',
    latitude: '27.337502466188'
  },
  350721:
  {
    name: '顺昌县',
    parseid: '3507',
    longitude: '117.81651928091',
    latitude: '26.799104367214'
  },
  350722:
  {
    name: '浦城县',
    parseid: '3507',
    longitude: '118.54743912328',
    latitude: '27.923390046145'
  },
  350723:
  {
    name: '光泽县',
    parseid: '3507',
    longitude: '117.34048158963',
    latitude: '27.547272859205'
  },
  350724:
  {
    name: '松溪县',
    parseid: '3507',
    longitude: '118.79145438278',
    latitude: '27.532554907167'
  },
  350725:
  {
    name: '政和县',
    parseid: '3507',
    longitude: '118.86358723724',
    latitude: '27.371749198234'
  },
  350781:
  {
    name: '邵武市',
    parseid: '3507',
    longitude: '117.4994195021',
    latitude: '27.346469966261'
  },
  350782:
  {
    name: '武夷山市',
    parseid: '3507',
    longitude: '118.04157715009',
    latitude: '27.762553910259'
  },
  350783:
  {
    name: '建瓯市',
    parseid: '3507',
    longitude: '118.31146073369',
    latitude: '27.028955089429'
  },
  350802:
  {
    name: '新罗区',
    parseid: '3508',
    longitude: '117.04354293052',
    latitude: '25.104077629635'
  },
  350803:
  {
    name: '永定区',
    parseid: '3508',
    longitude: '116.73850038792',
    latitude: '24.730107532179'
  },
  350821:
  {
    name: '长汀县',
    parseid: '3508',
    longitude: '116.36356796988',
    latitude: '25.83918461828'
  },
  350823:
  {
    name: '上杭县',
    parseid: '3508',
    longitude: '116.42644288776',
    latitude: '25.055570401525'
  },
  350824:
  {
    name: '武平县',
    parseid: '3508',
    longitude: '116.10758916743',
    latitude: '25.100855173343'
  },
  350825:
  {
    name: '连城县',
    parseid: '3508',
    longitude: '116.76044617118',
    latitude: '25.716337381852'
  },
  350881:
  {
    name: '漳平市',
    parseid: '3508',
    longitude: '117.42655632526',
    latitude: '25.295743499252'
  },
  350902:
  {
    name: '蕉城区',
    parseid: '3509',
    longitude: '119.53344242699',
    latitude: '26.666738555955'
  },
  350921:
  {
    name: '霞浦县',
    parseid: '3509',
    longitude: '120.01142710564',
    latitude: '26.891348873767'
  },
  350922:
  {
    name: '古田县',
    parseid: '3509',
    longitude: '118.75257823557',
    latitude: '26.583261752073'
  },
  350923:
  {
    name: '屏南县',
    parseid: '3509',
    longitude: '118.99259621521',
    latitude: '26.914264918059'
  },
  350924:
  {
    name: '寿宁县',
    parseid: '3509',
    longitude: '119.51142504878',
    latitude: '27.466649659969'
  },
  350925:
  {
    name: '周宁县',
    parseid: '3509',
    longitude: '119.34556712964',
    latitude: '27.110239280448'
  },
  350926:
  {
    name: '柘荣县',
    parseid: '3509',
    longitude: '119.90745668696',
    latitude: '27.239961876352'
  },
  350981:
  {
    name: '福安市',
    parseid: '3509',
    longitude: '119.65440636048',
    latitude: '27.09432350806'
  },
  350982:
  {
    name: '福鼎市',
    parseid: '3509',
    longitude: '120.22345190932',
    latitude: '27.330524972528'
  },
  360102:
  {
    name: '东湖区',
    parseid: '3601',
    longitude: '115.90546602606',
    latitude: '28.691259179775'
  },
  360103:
  {
    name: '西湖区',
    parseid: '3601',
    longitude: '115.88353569365',
    latitude: '28.661976709901'
  },
  360104:
  {
    name: '青云谱区',
    parseid: '3601',
    longitude: '115.93141618579',
    latitude: '28.627235736484'
  },
  360105:
  {
    name: '湾里区',
    parseid: '3601',
    longitude: '115.73759563309',
    latitude: '28.720195384308'
  },
  360111:
  {
    name: '青山湖区',
    parseid: '3601',
    longitude: '115.96855240505',
    latitude: '28.687596006173'
  },
  360112:
  {
    name: '新建区',
    parseid: '3601',
    longitude: '115.8214509253',
    latitude: '28.698748625155'
  },
  360121:
  {
    name: '南昌县',
    parseid: '3601',
    longitude: '115.95046017277',
    latitude: '28.551604186108'
  },
  360123:
  {
    name: '安义县',
    parseid: '3601',
    longitude: '115.55544146387',
    latitude: '28.850794273751'
  },
  360124:
  {
    name: '进贤县',
    parseid: '3601',
    longitude: '116.24853779343',
    latitude: '28.382758944474'
  },
  360202:
  {
    name: '昌江区',
    parseid: '3602',
    longitude: '117.19057910346',
    latitude: '29.27885446447'
  },
  360203:
  {
    name: '珠山区',
    parseid: '3602',
    longitude: '117.20954826159',
    latitude: '29.305778220374'
  },
  360222:
  {
    name: '浮梁县',
    parseid: '3602',
    longitude: '117.22146608079',
    latitude: '29.357788237529'
  },
  360281:
  {
    name: '乐平市',
    parseid: '3602',
    longitude: '117.15851067473',
    latitude: '28.984363669039'
  },
  360302:
  {
    name: '安源区',
    parseid: '3603',
    longitude: '113.87743991926',
    latitude: '27.621307703862'
  },
  360313:
  {
    name: '湘东区',
    parseid: '3603',
    longitude: '113.74049971211',
    latitude: '27.645875074875'
  },
  360321:
  {
    name: '莲花县',
    parseid: '3603',
    longitude: '113.96854067422',
    latitude: '27.133462711028'
  },
  360322:
  {
    name: '上栗县',
    parseid: '3603',
    longitude: '113.80153822404',
    latitude: '27.886415692068'
  },
  360323:
  {
    name: '芦溪县',
    parseid: '3603',
    longitude: '114.03651940468',
    latitude: '27.6366047187'
  },
  360402:
  {
    name: '濂溪区',
    parseid: '3604',
    longitude: '115.99559858734',
    latitude: '29.67749487743'
  },
  360403:
  {
    name: '浔阳区',
    parseid: '3604',
    longitude: '115.99655806746',
    latitude: '29.733093751939'
  },
  360404:
  {
    name: '柴桑区',
    parseid: '3604',
    longitude: '115.91740154188',
    latitude: '29.614804909379'
  },
  360423:
  {
    name: '武宁县',
    parseid: '3604',
    longitude: '115.10744177399',
    latitude: '29.2623521507'
  },
  360424:
  {
    name: '修水县',
    parseid: '3604',
    longitude: '114.55356797639',
    latitude: '29.031175867959'
  },
  360425:
  {
    name: '永修县',
    parseid: '3604',
    longitude: '115.81540658685',
    latitude: '29.028005616261'
  },
  360426:
  {
    name: '德安县',
    parseid: '3604',
    longitude: '115.76257795847',
    latitude: '29.319172496312'
  },
  360428:
  {
    name: '都昌县',
    parseid: '3604',
    longitude: '116.21055204665',
    latitude: '29.278965044767'
  },
  360429:
  {
    name: '湖口县',
    parseid: '3604',
    longitude: '116.25847134559',
    latitude: '29.737131514562'
  },
  360430:
  {
    name: '彭泽县',
    parseid: '3604',
    longitude: '116.55550980644',
    latitude: '29.902122004906'
  },
  360481:
  {
    name: '瑞昌市',
    parseid: '3604',
    longitude: '115.68742967207',
    latitude: '29.681951286531'
  },
  360482:
  {
    name: '共青城市',
    parseid: '3604',
    longitude: '115.82142002359',
    latitude: '29.248741173716'
  },
  360483:
  {
    name: '庐山市',
    parseid: '3604',
    longitude: '116.05142593917',
    latitude: '29.454539165717'
  },
  360502:
  {
    name: '渝水区',
    parseid: '3605',
    longitude: '114.9514238934',
    latitude: '27.806839650444'
  },
  360521:
  {
    name: '分宜县',
    parseid: '3605',
    longitude: '114.69847247036',
    latitude: '27.820731344374'
  },
  360602:
  {
    name: '月湖区',
    parseid: '3606',
    longitude: '117.04354760171',
    latitude: '28.245078331555'
  },
  360603:
  {
    name: '余江区',
    parseid: '3606',
    longitude: '116.82459362864',
    latitude: '28.215353761359'
  },
  360681:
  {
    name: '贵溪市',
    parseid: '3606',
    longitude: '117.25139869833',
    latitude: '28.298735072105'
  },
  360702:
  {
    name: '章贡区',
    parseid: '3607',
    longitude: '114.9275508855',
    latitude: '25.823747013882'
  },
  360703:
  {
    name: '南康区',
    parseid: '3607',
    longitude: '114.77153821509',
    latitude: '25.66705293056'
  },
  360704:
  {
    name: '赣县区',
    parseid: '3607',
    longitude: '115.01857016415',
    latitude: '25.866384616621'
  },
  360722:
  {
    name: '信丰县',
    parseid: '3607',
    longitude: '114.92952113897',
    latitude: '25.391975120014'
  },
  360723:
  {
    name: '大余县',
    parseid: '3607',
    longitude: '114.36840663965',
    latitude: '25.407637298367'
  },
  360724:
  {
    name: '上犹县',
    parseid: '3607',
    longitude: '114.55854863129',
    latitude: '25.790518799476'
  },
  360725:
  {
    name: '崇义县',
    parseid: '3607',
    longitude: '114.31457244808',
    latitude: '25.687687192664'
  },
  360726:
  {
    name: '安远县',
    parseid: '3607',
    longitude: '115.40055913129',
    latitude: '25.142743431732'
  },
  360727:
  {
    name: '龙南县',
    parseid: '3607',
    longitude: '114.79655413709',
    latitude: '24.916599461157'
  },
  360728:
  {
    name: '定南县',
    parseid: '3607',
    longitude: '115.0345637751',
    latitude: '24.789783831846'
  },
  360729:
  {
    name: '全南县',
    parseid: '3607',
    longitude: '114.53658236666',
    latitude: '24.748206354967'
  },
  360730:
  {
    name: '宁都县',
    parseid: '3607',
    longitude: '116.01549443743',
    latitude: '26.47597950334'
  },
  360731:
  {
    name: '于都县',
    parseid: '3607',
    longitude: '115.42149926153',
    latitude: '25.957893942751'
  },
  360732:
  {
    name: '兴国县',
    parseid: '3607',
    longitude: '115.36955169119',
    latitude: '26.343882588243'
  },
  360733:
  {
    name: '会昌县',
    parseid: '3607',
    longitude: '115.79245964209',
    latitude: '25.606661833811'
  },
  360734:
  {
    name: '寻乌县',
    parseid: '3607',
    longitude: '115.65351531535',
    latitude: '24.96944654678'
  },
  360735:
  {
    name: '石城县',
    parseid: '3607',
    longitude: '116.35259426977',
    latitude: '26.318972346784'
  },
  360781:
  {
    name: '瑞金市',
    parseid: '3607',
    longitude: '116.03342066286',
    latitude: '25.891666273953'
  },
  360802:
  {
    name: '吉州区',
    parseid: '3608',
    longitude: '115.00153936965',
    latitude: '27.149314993877'
  },
  360803:
  {
    name: '青原区',
    parseid: '3608',
    longitude: '115.02156071302',
    latitude: '27.087662535191'
  },
  360821:
  {
    name: '吉安县',
    parseid: '3608',
    longitude: '114.9145913014',
    latitude: '27.044989078994'
  },
  360822:
  {
    name: '吉水县',
    parseid: '3608',
    longitude: '115.14256983128',
    latitude: '27.235259745039'
  },
  360823:
  {
    name: '峡江县',
    parseid: '3608',
    longitude: '115.32240322821',
    latitude: '27.588234617615'
  },
  360824:
  {
    name: '新干县',
    parseid: '3608',
    longitude: '115.39359474833',
    latitude: '27.746080951713'
  },
  360825:
  {
    name: '永丰县',
    parseid: '3608',
    longitude: '115.44740243989',
    latitude: '27.324342103714'
  },
  360826:
  {
    name: '泰和县',
    parseid: '3608',
    longitude: '114.91559111544',
    latitude: '26.795697341165'
  },
  360827:
  {
    name: '遂川县',
    parseid: '3608',
    longitude: '114.52756212171',
    latitude: '26.319517284146'
  },
  360828:
  {
    name: '万安县',
    parseid: '3608',
    longitude: '114.79257715894',
    latitude: '26.464072836341'
  },
  360829:
  {
    name: '安福县',
    parseid: '3608',
    longitude: '114.62647813461',
    latitude: '27.399076477105'
  },
  360830:
  {
    name: '永新县',
    parseid: '3608',
    longitude: '114.2494149359',
    latitude: '26.951537256563'
  },
  360881:
  {
    name: '井冈山市',
    parseid: '3608',
    longitude: '114.29555585942',
    latitude: '26.753709741566'
  },
  360902:
  {
    name: '袁州区',
    parseid: '3609',
    longitude: '114.43456118111',
    latitude: '27.802582705304'
  },
  360921:
  {
    name: '奉新县',
    parseid: '3609',
    longitude: '115.40655109853',
    latitude: '28.694028951458'
  },
  360922:
  {
    name: '万载县',
    parseid: '3609',
    longitude: '114.45253654385',
    latitude: '28.112133306116'
  },
  360923:
  {
    name: '上高县',
    parseid: '3609',
    longitude: '114.93154115857',
    latitude: '28.238815490252'
  },
  360924:
  {
    name: '宜丰县',
    parseid: '3609',
    longitude: '114.80951713475',
    latitude: '28.400373307265'
  },
  360925:
  {
    name: '靖安县',
    parseid: '3609',
    longitude: '115.36955312848',
    latitude: '28.867081916186'
  },
  360926:
  {
    name: '铜鼓县',
    parseid: '3609',
    longitude: '114.37741107441',
    latitude: '28.52708345654'
  },
  360981:
  {
    name: '丰城市',
    parseid: '3609',
    longitude: '115.77747842145',
    latitude: '28.166614024369'
  },
  360982:
  {
    name: '樟树市',
    parseid: '3609',
    longitude: '115.55241893533',
    latitude: '28.062153117648'
  },
  360983:
  {
    name: '高安市',
    parseid: '3609',
    longitude: '115.38256535328',
    latitude: '28.422857002119'
  },
  361002:
  {
    name: '临川区',
    parseid: '3610',
    longitude: '116.31848983161',
    latitude: '27.940458992864'
  },
  361003:
  {
    name: '东乡区',
    parseid: '3610',
    longitude: '116.60954171505',
    latitude: '28.253977397999'
  },
  361021:
  {
    name: '南城县',
    parseid: '3610',
    longitude: '116.64339884971',
    latitude: '27.57624096656'
  },
  361022:
  {
    name: '黎川县',
    parseid: '3610',
    longitude: '116.91450700338',
    latitude: '27.288340234831'
  },
  361023:
  {
    name: '南丰县',
    parseid: '3610',
    longitude: '116.53140350859',
    latitude: '27.224733524876'
  },
  361024:
  {
    name: '崇仁县',
    parseid: '3610',
    longitude: '116.08354898488',
    latitude: '27.759079756014'
  },
  361025:
  {
    name: '乐安县',
    parseid: '3610',
    longitude: '115.83749627865',
    latitude: '27.434079864498'
  },
  361026:
  {
    name: '宜黄县',
    parseid: '3610',
    longitude: '116.24254169398',
    latitude: '27.5605634607'
  },
  361027:
  {
    name: '金溪县',
    parseid: '3610',
    longitude: '116.76040404065',
    latitude: '27.925329188976'
  },
  361028:
  {
    name: '资溪县',
    parseid: '3610',
    longitude: '117.06657027361',
    latitude: '27.711845785732'
  },
  361030:
  {
    name: '广昌县',
    parseid: '3610',
    longitude: '116.34256064638',
    latitude: '26.848454446681'
  },
  361102:
  {
    name: '信州区',
    parseid: '3611',
    longitude: '117.97341184157',
    latitude: '28.437628311'
  },
  361103:
  {
    name: '广丰区',
    parseid: '3611',
    longitude: '118.19742022042',
    latitude: '28.442615061205'
  },
  361104:
  {
    name: '广信区',
    parseid: '3611',
    longitude: '117.91443700689',
    latitude: '28.454660861343'
  },
  361123:
  {
    name: '玉山县',
    parseid: '3611',
    longitude: '118.2515628901',
    latitude: '28.687749687317'
  },
  361124:
  {
    name: '铅山县',
    parseid: '3611',
    longitude: '117.71642163695',
    latitude: '28.321504694791'
  },
  361125:
  {
    name: '横峰县',
    parseid: '3611',
    longitude: '117.60239738302',
    latitude: '28.413440462384'
  },
  361126:
  {
    name: '弋阳县',
    parseid: '3611',
    longitude: '117.45550637624',
    latitude: '28.384082001231'
  },
  361127:
  {
    name: '余干县',
    parseid: '3611',
    longitude: '116.70160096199',
    latitude: '28.707866244419'
  },
  361128:
  {
    name: '鄱阳县',
    parseid: '3611',
    longitude: '116.7105661408',
    latitude: '29.011452830922'
  },
  361129:
  {
    name: '万年县',
    parseid: '3611',
    longitude: '117.06459894217',
    latitude: '28.700054054129'
  },
  361130:
  {
    name: '婺源县',
    parseid: '3611',
    longitude: '117.86844502243',
    latitude: '29.254039048097'
  },
  361181:
  {
    name: '德兴市',
    parseid: '3611',
    longitude: '117.58547968518',
    latitude: '28.952564863028'
  },
  370102:
  {
    name: '历下区',
    parseid: '3701',
    longitude: '117.0825673139',
    latitude: '36.672162950043'
  },
  370103:
  {
    name: '市中区',
    parseid: '3701',
    longitude: '117.00439910401',
    latitude: '36.657551673642'
  },
  370104:
  {
    name: '槐荫区',
    parseid: '3701',
    longitude: '116.90745837507',
    latitude: '36.657561734426'
  },
  370105:
  {
    name: '天桥区',
    parseid: '3701',
    longitude: '116.99339917338',
    latitude: '36.684067874353'
  },
  370112:
  {
    name: '历城区',
    parseid: '3701',
    longitude: '117.07158975107',
    latitude: '36.685655534711'
  },
  370113:
  {
    name: '长清区',
    parseid: '3701',
    longitude: '116.75838709095',
    latitude: '36.56021587991'
  },
  370114:
  {
    name: '章丘区',
    parseid: '3701',
    longitude: '117.53256537437',
    latitude: '36.68553275142'
  },
  370115:
  {
    name: '济阳区',
    parseid: '3701',
    longitude: '117.18062113319',
    latitude: '36.983970518315'
  },
  370116:
  {
    name: '莱芜区',
    parseid: '3701',
    longitude: '117.66659067002',
    latitude: '36.208841426817'
  },
  370117:
  {
    name: '钢城区',
    parseid: '3701',
    longitude: '117.81749566518',
    latitude: '36.064718807028'
  },
  370124:
  {
    name: '平阴县',
    parseid: '3701',
    longitude: '116.46261667806',
    latitude: '36.294861321066'
  },
  370126:
  {
    name: '商河县',
    parseid: '3701',
    longitude: '117.1635297929',
    latitude: '37.314970715556'
  },
  370171:
  {
    name: '济南高新技术产业开发区',
    parseid: '3701',
    longitude: '117.31767542519',
    latitude: '36.685549465009'
  },
  370202:
  {
    name: '市南区',
    parseid: '3702',
    longitude: '120.41858472358',
    latitude: '36.081465640234'
  },
  370203:
  {
    name: '市北区',
    parseid: '3702',
    longitude: '120.38140448734',
    latitude: '36.09344959486'
  },
  370211:
  {
    name: '黄岛区',
    parseid: '3702',
    longitude: '120.20454654768',
    latitude: '35.966382870945'
  },
  370212:
  {
    name: '崂山区',
    parseid: '3702',
    longitude: '120.47539724708',
    latitude: '36.113499423971'
  },
  370213:
  {
    name: '李沧区',
    parseid: '3702',
    longitude: '120.43960282675',
    latitude: '36.151024667784'
  },
  370214:
  {
    name: '城阳区',
    parseid: '3702',
    longitude: '120.40252679394',
    latitude: '36.31288619735'
  },
  370215:
  {
    name: '即墨区',
    parseid: '3702',
    longitude: '120.45353617402',
    latitude: '36.394749170322'
  },
  370271:
  {
    name: '青岛高新技术产业开发区',
    parseid: '3702',
    longitude: '120.53718907803',
    latitude: '36.520146096709'
  },
  370281:
  {
    name: '胶州市',
    parseid: '3702',
    longitude: '120.03953537127',
    latitude: '36.270349088049'
  },
  370283:
  {
    name: '平度市',
    parseid: '3702',
    longitude: '119.99441429398',
    latitude: '36.782692254089'
  },
  370285:
  {
    name: '莱西市',
    parseid: '3702',
    longitude: '120.52455620764',
    latitude: '36.893956298026'
  },
  370302:
  {
    name: '淄川区',
    parseid: '3703',
    longitude: '117.97341185763',
    latitude: '36.649834806022'
  },
  370303:
  {
    name: '张店区',
    parseid: '3703',
    longitude: '118.02459110728',
    latitude: '36.811941952144'
  },
  370304:
  {
    name: '博山区',
    parseid: '3703',
    longitude: '117.86846875372',
    latitude: '36.500847855131'
  },
  370305:
  {
    name: '临淄区',
    parseid: '3703',
    longitude: '118.31539460935',
    latitude: '36.832293635152'
  },
  370306:
  {
    name: '周村区',
    parseid: '3703',
    longitude: '117.87648217785',
    latitude: '36.808994352212'
  },
  370321:
  {
    name: '桓台县',
    parseid: '3703',
    longitude: '118.10443420779',
    latitude: '36.965607980118'
  },
  370322:
  {
    name: '高青县',
    parseid: '3703',
    longitude: '117.83339432525',
    latitude: '37.177268654333'
  },
  370323:
  {
    name: '沂源县',
    parseid: '3703',
    longitude: '118.17748944237',
    latitude: '36.190916985848'
  },
  370402:
  {
    name: '市中区',
    parseid: '3704',
    longitude: '117.56256581399',
    latitude: '34.86996272507'
  },
  370403:
  {
    name: '薛城区',
    parseid: '3704',
    longitude: '117.26945761931',
    latitude: '34.801124568639'
  },
  370404:
  {
    name: '峄城区',
    parseid: '3704',
    longitude: '117.59639060967',
    latitude: '34.778599873011'
  },
  370405:
  {
    name: '台儿庄区',
    parseid: '3704',
    longitude: '117.74042545412',
    latitude: '34.568763215633'
  },
  370406:
  {
    name: '山亭区',
    parseid: '3704',
    longitude: '117.46744316558',
    latitude: '35.105691980765'
  },
  370481:
  {
    name: '滕州市',
    parseid: '3704',
    longitude: '117.17256521921',
    latitude: '35.120034809574'
  },
  370502:
  {
    name: '东营区',
    parseid: '3705',
    longitude: '118.58846268607',
    latitude: '37.454847320166'
  },
  370503:
  {
    name: '河口区',
    parseid: '3705',
    longitude: '118.53250516975',
    latitude: '37.891120201056'
  },
  370505:
  {
    name: '垦利区',
    parseid: '3705',
    longitude: '118.58143173867',
    latitude: '37.578555133809'
  },
  370522:
  {
    name: '利津县',
    parseid: '3705',
    longitude: '118.26161799914',
    latitude: '37.495860299031'
  },
  370523:
  {
    name: '广饶县',
    parseid: '3705',
    longitude: '118.41349864392',
    latitude: '37.059638498906'
  },
  370571:
  {
    name: '东营经济技术开发区',
    parseid: '3705',
    longitude: '118.70206788052',
    latitude: '37.439685020024'
  },
  370572:
  {
    name: '东营港经济开发区',
    parseid: '3705',
    longitude: '118.58846268607',
    latitude: '37.454847320166'
  },
  370602:
  {
    name: '芝罘区',
    parseid: '3706',
    longitude: '121.40654004549',
    latitude: '37.546312866891'
  },
  370611:
  {
    name: '福山区',
    parseid: '3706',
    longitude: '121.27460474744',
    latitude: '37.503668228451'
  },
  370612:
  {
    name: '牟平区',
    parseid: '3706',
    longitude: '121.60654911474',
    latitude: '37.392915451796'
  },
  370613:
  {
    name: '莱山区',
    parseid: '3706',
    longitude: '121.4513806718',
    latitude: '37.517648584109'
  },
  370634:
  {
    name: '长岛县',
    parseid: '3706',
    longitude: '120.74342978244',
    latitude: '37.927628387579'
  },
  370671:
  {
    name: '烟台高新技术产业开发区',
    parseid: '3706',
    longitude: '121.53357724291',
    latitude: '37.427182510172'
  },
  370672:
  {
    name: '烟台经济技术开发区',
    parseid: '3706',
    longitude: '121.26038097799',
    latitude: '37.569873737967'
  },
  370681:
  {
    name: '龙口市',
    parseid: '3706',
    longitude: '120.48536852807',
    latitude: '37.652555125496'
  },
  370682:
  {
    name: '莱阳市',
    parseid: '3706',
    longitude: '120.71841430958',
    latitude: '36.984635568304'
  },
  370683:
  {
    name: '莱州市',
    parseid: '3706',
    longitude: '119.94859307737',
    latitude: '37.182636609074'
  },
  370684:
  {
    name: '蓬莱市',
    parseid: '3706',
    longitude: '120.76556151495',
    latitude: '37.816438725969'
  },
  370685:
  {
    name: '招远市',
    parseid: '3706',
    longitude: '120.44060165265',
    latitude: '37.361137142566'
  },
  370686:
  {
    name: '栖霞市',
    parseid: '3706',
    longitude: '120.85641658338',
    latitude: '37.3414181648'
  },
  370687:
  {
    name: '海阳市',
    parseid: '3706',
    longitude: '121.18045819779',
    latitude: '36.693269738228'
  },
  370702:
  {
    name: '潍城区',
    parseid: '3707',
    longitude: '119.03142854152',
    latitude: '36.73285441557'
  },
  370703:
  {
    name: '寒亭区',
    parseid: '3707',
    longitude: '119.22661514747',
    latitude: '36.780743786201'
  },
  370704:
  {
    name: '坊子区',
    parseid: '3707',
    longitude: '119.17240097265',
    latitude: '36.660741599701'
  },
  370705:
  {
    name: '奎文区',
    parseid: '3707',
    longitude: '119.13947052995',
    latitude: '36.712752014046'
  },
  370724:
  {
    name: '临朐县',
    parseid: '3707',
    longitude: '118.54944999641',
    latitude: '36.519129501828'
  },
  370725:
  {
    name: '昌乐县',
    parseid: '3707',
    longitude: '118.83648798144',
    latitude: '36.712996190845'
  },
  370772:
  {
    name: '潍坊滨海经济技术开发区',
    parseid: '3707',
    longitude: '119.18646969457',
    latitude: '37.137588004688'
  },
  370781:
  {
    name: '青州市',
    parseid: '3707',
    longitude: '118.48653672087',
    latitude: '36.690416508705'
  },
  370782:
  {
    name: '诸城市',
    parseid: '3707',
    longitude: '119.41640221867',
    latitude: '36.002008858076'
  },
  370783:
  {
    name: '寿光市',
    parseid: '3707',
    longitude: '118.79741537481',
    latitude: '36.861921746471'
  },
  370784:
  {
    name: '安丘市',
    parseid: '3707',
    longitude: '119.22560751818',
    latitude: '36.483842195596'
  },
  370785:
  {
    name: '高密市',
    parseid: '3707',
    longitude: '119.76241099602',
    latitude: '36.388956706465'
  },
  370786:
  {
    name: '昌邑市',
    parseid: '3707',
    longitude: '119.40440597739',
    latitude: '36.865161072622'
  },
  370811:
  {
    name: '任城区',
    parseid: '3708',
    longitude: '116.55446985374',
    latitude: '35.49373064026'
  },
  370812:
  {
    name: '兖州区',
    parseid: '3708',
    longitude: '116.79011515173',
    latitude: '35.557952373283'
  },
  370826:
  {
    name: '微山县',
    parseid: '3708',
    longitude: '117.13541381857',
    latitude: '34.813315104239'
  },
  370827:
  {
    name: '鱼台县',
    parseid: '3708',
    longitude: '116.65739284822',
    latitude: '35.017887717823'
  },
  370828:
  {
    name: '金乡县',
    parseid: '3708',
    longitude: '116.31852982171',
    latitude: '35.072569118665'
  },
  370829:
  {
    name: '嘉祥县',
    parseid: '3708',
    longitude: '116.34861308511',
    latitude: '35.413255044102'
  },
  370830:
  {
    name: '汶上县',
    parseid: '3708',
    longitude: '116.50544105765',
    latitude: '35.717055392628'
  },
  370831:
  {
    name: '泗水县',
    parseid: '3708',
    longitude: '117.25742858989',
    latitude: '35.670600481228'
  },
  370832:
  {
    name: '梁山县',
    parseid: '3708',
    longitude: '116.10262029578',
    latitude: '35.808063886611'
  },
  370871:
  {
    name: '济宁高新技术产业开发区',
    parseid: '3708',
    longitude: '116.62657180651',
    latitude: '35.430964154503'
  },
  370881:
  {
    name: '曲阜市',
    parseid: '3708',
    longitude: '116.99341597169',
    latitude: '35.587372286488'
  },
  370883:
  {
    name: '邹城市',
    parseid: '3708',
    longitude: '117.01440416129',
    latitude: '35.40752093245'
  },
  370902:
  {
    name: '泰山区',
    parseid: '3709',
    longitude: '117.14141108582',
    latitude: '36.199444601195'
  },
  370911:
  {
    name: '岱岳区',
    parseid: '3709',
    longitude: '117.04855647915',
    latitude: '36.193291242291'
  },
  370921:
  {
    name: '宁阳县',
    parseid: '3709',
    longitude: '116.81257853863',
    latitude: '35.764539097344'
  },
  370923:
  {
    name: '东平县',
    parseid: '3709',
    longitude: '116.47759421565',
    latitude: '35.941908015019'
  },
  370982:
  {
    name: '新泰市',
    parseid: '3709',
    longitude: '117.77460624827',
    latitude: '35.914619866588'
  },
  370983:
  {
    name: '肥城市',
    parseid: '3709',
    longitude: '116.77540081764',
    latitude: '36.188811224315'
  },
  371002:
  {
    name: '环翠区',
    parseid: '3710',
    longitude: '122.12953818095',
    latitude: '37.507968071219'
  },
  371003:
  {
    name: '文登区',
    parseid: '3710',
    longitude: '122.06442836878',
    latitude: '37.200113328316'
  },
  371071:
  {
    name: '威海火炬高技术产业开发区',
    parseid: '3710',
    longitude: '122.04062911175',
    latitude: '37.528114338517'
  },
  371072:
  {
    name: '威海经济技术开发区',
    parseid: '3710',
    longitude: '122.17787698858',
    latitude: '37.410552001588'
  },
  371073:
  {
    name: '威海临港经济技术开发区',
    parseid: '3710',
    longitude: '122.12754097831',
    latitude: '37.516430548015'
  },
  371082:
  {
    name: '荣成市',
    parseid: '3710',
    longitude: '122.49250463074',
    latitude: '37.171317939253'
  },
  371083:
  {
    name: '乳山市',
    parseid: '3710',
    longitude: '121.5464285812',
    latitude: '36.925177357878'
  },
  371102:
  {
    name: '东港区',
    parseid: '3711',
    longitude: '119.46862431118',
    latitude: '35.431049003942'
  },
  371103:
  {
    name: '岚山区',
    parseid: '3711',
    longitude: '119.32553044175',
    latitude: '35.127432330052'
  },
  371121:
  {
    name: '五莲县',
    parseid: '3711',
    longitude: '119.21558036259',
    latitude: '35.755697104104'
  },
  371122:
  {
    name: '莒县',
    parseid: '3711',
    longitude: '118.8435382424',
    latitude: '35.585872122989'
  },
  371171:
  {
    name: '日照经济技术开发区',
    parseid: '3711',
    longitude: '119.53341540457',
    latitude: '35.422838998438'
  },
  371302:
  {
    name: '兰山区',
    parseid: '3713',
    longitude: '118.35449973464',
    latitude: '35.057340229806'
  },
  371311:
  {
    name: '罗庄区',
    parseid: '3713',
    longitude: '118.29151252855',
    latitude: '35.002503733433'
  },
  371312:
  {
    name: '河东区',
    parseid: '3713',
    longitude: '118.40954744713',
    latitude: '35.095675536824'
  },
  371321:
  {
    name: '沂南县',
    parseid: '3713',
    longitude: '118.47149154086',
    latitude: '35.55609766695'
  },
  371322:
  {
    name: '郯城县',
    parseid: '3713',
    longitude: '118.37358710977',
    latitude: '34.619225932471'
  },
  371323:
  {
    name: '沂水县',
    parseid: '3713',
    longitude: '118.63461726385',
    latitude: '35.796180584718'
  },
  371324:
  {
    name: '兰陵县',
    parseid: '3713',
    longitude: '118.07740949499',
    latitude: '34.86361638544'
  },
  371325:
  {
    name: '费县',
    parseid: '3713',
    longitude: '117.98442508318',
    latitude: '35.272304128517'
  },
  371326:
  {
    name: '平邑县',
    parseid: '3713',
    longitude: '117.64654058086',
    latitude: '35.51201963664'
  },
  371327:
  {
    name: '莒南县',
    parseid: '3713',
    longitude: '118.84154077027',
    latitude: '35.180811631788'
  },
  371328:
  {
    name: '蒙阴县',
    parseid: '3713',
    longitude: '117.95141460145',
    latitude: '35.716347166232'
  },
  371329:
  {
    name: '临沭县',
    parseid: '3713',
    longitude: '118.6574945001',
    latitude: '34.926018591491'
  },
  371371:
  {
    name: '临沂高新技术产业开发区',
    parseid: '3713',
    longitude: '118.27104661378',
    latitude: '34.991223118411'
  },
  371372:
  {
    name: '临沂经济技术开发区',
    parseid: '3713',
    longitude: '118.41619203333',
    latitude: '35.029365911985'
  },
  371373:
  {
    name: '临沂临港经济开发区',
    parseid: '3713',
    longitude: '118.36353300501',
    latitude: '35.110671242365'
  },
  371402:
  {
    name: '德城区',
    parseid: '3714',
    longitude: '116.30544896637',
    latitude: '37.456993283021'
  },
  371403:
  {
    name: '陵城区',
    parseid: '3714',
    longitude: '116.58940001434',
    latitude: '37.347132434581'
  },
  371422:
  {
    name: '宁津县',
    parseid: '3714',
    longitude: '116.80653761374',
    latitude: '37.658018745855'
  },
  371423:
  {
    name: '庆云县',
    parseid: '3714',
    longitude: '117.39145244825',
    latitude: '37.781585318857'
  },
  371424:
  {
    name: '临邑县',
    parseid: '3714',
    longitude: '116.87340370302',
    latitude: '37.196169366727'
  },
  371425:
  {
    name: '齐河县',
    parseid: '3714',
    longitude: '116.76938747073',
    latitude: '36.78994480667'
  },
  371426:
  {
    name: '平原县',
    parseid: '3714',
    longitude: '116.44050470827',
    latitude: '37.171221463312'
  },
  371427:
  {
    name: '夏津县',
    parseid: '3714',
    longitude: '116.00853411226',
    latitude: '36.954154863323'
  },
  371428:
  {
    name: '武城县',
    parseid: '3714',
    longitude: '116.07550629142',
    latitude: '37.219222080288'
  },
  371471:
  {
    name: '德州经济技术开发区',
    parseid: '3714',
    longitude: '116.38252187234',
    latitude: '37.458692749867'
  },
  371472:
  {
    name: '德州运河经济开发区',
    parseid: '3714',
    longitude: '116.8386119713',
    latitude: '38.316522737476'
  },
  371481:
  {
    name: '乐陵市',
    parseid: '3714',
    longitude: '117.23840643173',
    latitude: '37.73592450081'
  },
  371482:
  {
    name: '禹城市',
    parseid: '3714',
    longitude: '116.64437110138',
    latitude: '36.940242008766'
  },
  371502:
  {
    name: '东昌府区',
    parseid: '3715',
    longitude: '115.99458657176',
    latitude: '36.440377840732'
  },
  371503:
  {
    name: '茌平区',
    parseid: '3715',
    longitude: '116.26145544215',
    latitude: '36.586785068842'
  },
  371521:
  {
    name: '阳谷县',
    parseid: '3715',
    longitude: '115.79839557041',
    latitude: '36.120815514687'
  },
  371522:
  {
    name: '莘县',
    parseid: '3715',
    longitude: '115.67739687246',
    latitude: '36.239907120546'
  },
  371524:
  {
    name: '东阿县',
    parseid: '3715',
    longitude: '116.25449294564',
    latitude: '36.340957707761'
  },
  371525:
  {
    name: '冠县',
    parseid: '3715',
    longitude: '115.44939579504',
    latitude: '36.490243225394'
  },
  371526:
  {
    name: '高唐县',
    parseid: '3715',
    longitude: '116.23560427568',
    latitude: '36.851591084095'
  },
  371581:
  {
    name: '临清市',
    parseid: '3715',
    longitude: '115.71146960045',
    latitude: '36.844289186694'
  },
  371602:
  {
    name: '滨城区',
    parseid: '3716',
    longitude: '118.02660385061',
    latitude: '37.436843207744'
  },
  371603:
  {
    name: '沾化区',
    parseid: '3716',
    longitude: '118.10545441336',
    latitude: '37.705298106724'
  },
  371621:
  {
    name: '惠民县',
    parseid: '3716',
    longitude: '117.5165096905',
    latitude: '37.49580310894'
  },
  371622:
  {
    name: '阳信县',
    parseid: '3716',
    longitude: '117.58443703791',
    latitude: '37.647338034957'
  },
  371623:
  {
    name: '无棣县',
    parseid: '3716',
    longitude: '117.63245748606',
    latitude: '37.777567312086'
  },
  371625:
  {
    name: '博兴县',
    parseid: '3716',
    longitude: '118.11749269533',
    latitude: '37.160477277651'
  },
  371681:
  {
    name: '邹平市',
    parseid: '3716',
    longitude: '117.74947848722',
    latitude: '36.870032216697'
  },
  371702:
  {
    name: '牡丹区',
    parseid: '3717',
    longitude: '115.42344303021',
    latitude: '35.257018176069'
  },
  371703:
  {
    name: '定陶区',
    parseid: '3717',
    longitude: '115.57943737524',
    latitude: '35.077275179757'
  },
  371721:
  {
    name: '曹县',
    parseid: '3717',
    longitude: '115.54845724362',
    latitude: '34.831809348415'
  },
  371722:
  {
    name: '单县',
    parseid: '3717',
    longitude: '116.11158367799',
    latitude: '34.784658433692'
  },
  371723:
  {
    name: '成武县',
    parseid: '3717',
    longitude: '115.89651900839',
    latitude: '34.95860565496'
  },
  371724:
  {
    name: '巨野县',
    parseid: '3717',
    longitude: '116.10159901224',
    latitude: '35.402062380609'
  },
  371725:
  {
    name: '郓城县',
    parseid: '3717',
    longitude: '115.95045057629',
    latitude: '35.605902319687'
  },
  371726:
  {
    name: '鄄城县',
    parseid: '3717',
    longitude: '115.51660692346',
    latitude: '35.569204259881'
  },
  371728:
  {
    name: '东明县',
    parseid: '3717',
    longitude: '115.09641733473',
    latitude: '35.295701692411'
  },
  371771:
  {
    name: '菏泽经济技术开发区',
    parseid: '3717',
    longitude: '115.48754503343',
    latitude: '35.239407424766'
  },
  371772:
  {
    name: '菏泽高新技术开发区',
    parseid: '3717',
    longitude: '115.4294357161',
    latitude: '35.288518500701'
  },
  410102:
  {
    name: '中原区',
    parseid: '4101',
    longitude: '113.61947551694',
    latitude: '34.754450781329'
  },
  410103:
  {
    name: '二七区',
    parseid: '4101',
    longitude: '113.63141920734',
    latitude: '34.753438850454'
  },
  410104:
  {
    name: '管城回族区',
    parseid: '4101',
    longitude: '113.6835246998',
    latitude: '34.759673874699'
  },
  410105:
  {
    name: '金水区',
    parseid: '4101',
    longitude: '113.6664477324',
    latitude: '34.806070445662'
  },
  410106:
  {
    name: '上街区',
    parseid: '4101',
    longitude: '113.3154972866',
    latitude: '34.808818610239'
  },
  410108:
  {
    name: '惠济区',
    parseid: '4101',
    longitude: '113.62345527984',
    latitude: '34.873519885776'
  },
  410122:
  {
    name: '中牟县',
    parseid: '4101',
    longitude: '113.98248490573',
    latitude: '34.725010848924'
  },
  410171:
  {
    name: '郑州经济技术开发区',
    parseid: '4101',
    longitude: '113.83237733637',
    latitude: '34.712877693039'
  },
  410172:
  {
    name: '郑州高新技术产业开发区',
    parseid: '4101',
    longitude: '114.01676208805',
    latitude: '34.696418574589'
  },
  410173:
  {
    name: '郑州航空港经济综合实验区',
    parseid: '4101',
    longitude: '113.82428126813',
    latitude: '34.524235688034'
  },
  410181:
  {
    name: '巩义市',
    parseid: '4101',
    longitude: '113.02843100495',
    latitude: '34.754096888697'
  },
  410182:
  {
    name: '荥阳市',
    parseid: '4101',
    longitude: '113.38942279956',
    latitude: '34.793810500346'
  },
  410183:
  {
    name: '新密市',
    parseid: '4101',
    longitude: '113.3973909491',
    latitude: '34.545897983445'
  },
  410184:
  {
    name: '新郑市',
    parseid: '4101',
    longitude: '113.74643447195',
    latitude: '34.401766379106'
  },
  410185:
  {
    name: '登封市',
    parseid: '4101',
    longitude: '113.05642283346',
    latitude: '34.45969746172'
  },
  410202:
  {
    name: '龙亭区',
    parseid: '4102',
    longitude: '114.36141316646',
    latitude: '34.822035612506'
  },
  410203:
  {
    name: '顺河回族区',
    parseid: '4102',
    longitude: '114.36739165912',
    latitude: '34.802241355559'
  },
  410204:
  {
    name: '鼓楼区',
    parseid: '4102',
    longitude: '114.35440485636',
    latitude: '34.794874251914'
  },
  410205:
  {
    name: '禹王台区',
    parseid: '4102',
    longitude: '114.35439775975',
    latitude: '34.783472105917'
  },
  410212:
  {
    name: '祥符区',
    parseid: '4102',
    longitude: '114.4475325479',
    latitude: '34.762739572224'
  },
  410221:
  {
    name: '杞县',
    parseid: '4102',
    longitude: '114.78959210474',
    latitude: '34.554856780687'
  },
  410222:
  {
    name: '通许县',
    parseid: '4102',
    longitude: '114.47343590593',
    latitude: '34.486771802655'
  },
  410223:
  {
    name: '尉氏县',
    parseid: '4102',
    longitude: '114.19956115086',
    latitude: '34.417228010354'
  },
  410225:
  {
    name: '兰考县',
    parseid: '4102',
    longitude: '114.82746071249',
    latitude: '34.828492897238'
  },
  410302:
  {
    name: '老城区',
    parseid: '4103',
    longitude: '112.47650356572',
    latitude: '34.689601063497'
  },
  410303:
  {
    name: '西工区',
    parseid: '4103',
    longitude: '112.43439953731',
    latitude: '34.666767847513'
  },
  410304:
  {
    name: '瀍河回族区',
    parseid: '4103',
    longitude: '112.50660380709',
    latitude: '34.685462421335'
  },
  410305:
  {
    name: '涧西区',
    parseid: '4103',
    longitude: '112.4025520019',
    latitude: '34.663468974309'
  },
  410306:
  {
    name: '吉利区',
    parseid: '4103',
    longitude: '112.59547847119',
    latitude: '34.907012657115'
  },
  410311:
  {
    name: '洛龙区',
    parseid: '4103',
    longitude: '112.47046928829',
    latitude: '34.624704713024'
  },
  410322:
  {
    name: '孟津县',
    parseid: '4103',
    longitude: '112.45141766571',
    latitude: '34.831731570285'
  },
  410323:
  {
    name: '新安县',
    parseid: '4103',
    longitude: '112.14060970841',
    latitude: '34.734383327344'
  },
  410324:
  {
    name: '栾川县',
    parseid: '4103',
    longitude: '111.62242666651',
    latitude: '33.791822464323'
  },
  410325:
  {
    name: '嵩县',
    parseid: '4103',
    longitude: '112.09240816187',
    latitude: '34.140721556406'
  },
  410326:
  {
    name: '汝阳县',
    parseid: '4103',
    longitude: '112.47950327731',
    latitude: '34.159843364893'
  },
  410327:
  {
    name: '宜阳县',
    parseid: '4103',
    longitude: '112.17946537426',
    latitude: '34.541046942554'
  },
  410328:
  {
    name: '洛宁县',
    parseid: '4103',
    longitude: '111.65958740952',
    latitude: '34.394984560215'
  },
  410329:
  {
    name: '伊川县',
    parseid: '4103',
    longitude: '112.43240745502',
    latitude: '34.427645796427'
  },
  410371:
  {
    name: '洛阳高新技术产业开发区',
    parseid: '4103',
    longitude: '112.38490101727',
    latitude: '34.614292979933'
  },
  410381:
  {
    name: '偃师市',
    parseid: '4103',
    longitude: '112.79642141885',
    latitude: '34.733796624013'
  },
  410402:
  {
    name: '新华区',
    parseid: '4104',
    longitude: '113.30043988965',
    latitude: '33.743657151646'
  },
  410403:
  {
    name: '卫东区',
    parseid: '4104',
    longitude: '113.34161111761',
    latitude: '33.7403756514'
  },
  410404:
  {
    name: '石龙区',
    parseid: '4104',
    longitude: '112.9054552264',
    latitude: '33.904754268397'
  },
  410411:
  {
    name: '湛河区',
    parseid: '4104',
    longitude: '113.25051467449',
    latitude: '33.685790171047'
  },
  410421:
  {
    name: '宝丰县',
    parseid: '4104',
    longitude: '113.06144723584',
    latitude: '33.874745598631'
  },
  410422:
  {
    name: '叶县',
    parseid: '4104',
    longitude: '113.36358241276',
    latitude: '33.632491674058'
  },
  410423:
  {
    name: '鲁山县',
    parseid: '4104',
    longitude: '112.91443396963',
    latitude: '33.744878863452'
  },
  410425:
  {
    name: '郏县',
    parseid: '4104',
    longitude: '113.21960622765',
    latitude: '33.977486289177'
  },
  410471:
  {
    name: '平顶山高新技术产业开发区',
    parseid: '4104',
    longitude: '113.39403784412',
    latitude: '33.738544518581'
  },
  410472:
  {
    name: '平顶山市城乡一体化示范区',
    parseid: '4104',
    longitude: '113.19952856052',
    latitude: '33.772050748691'
  },
  410481:
  {
    name: '舞钢市',
    parseid: '4104',
    longitude: '113.53141031593',
    latitude: '33.299431105301'
  },
  410482:
  {
    name: '汝州市',
    parseid: '4104',
    longitude: '112.85054971566',
    latitude: '34.172767788551'
  },
  410502:
  {
    name: '文峰区',
    parseid: '4105',
    longitude: '114.36337398772',
    latitude: '36.096832748136'
  },
  410503:
  {
    name: '北关区',
    parseid: '4105',
    longitude: '114.36238189912',
    latitude: '36.113131607765'
  },
  410505:
  {
    name: '殷都区',
    parseid: '4105',
    longitude: '114.30959755718',
    latitude: '36.115758255537'
  },
  410506:
  {
    name: '龙安区',
    parseid: '4105',
    longitude: '114.3075931681',
    latitude: '36.08275278362'
  },
  410522:
  {
    name: '安阳县',
    parseid: '4105',
    longitude: '114.23838187262',
    latitude: '36.218906964196'
  },
  410523:
  {
    name: '汤阴县',
    parseid: '4105',
    longitude: '114.36340938096',
    latitude: '35.927643740225'
  },
  410526:
  {
    name: '滑县',
    parseid: '4105',
    longitude: '114.52555316619',
    latitude: '35.581045400558'
  },
  410527:
  {
    name: '内黄县',
    parseid: '4105',
    longitude: '114.90758875551',
    latitude: '35.976949668061'
  },
  410571:
  {
    name: '安阳高新技术产业开发区',
    parseid: '4105',
    longitude: '114.3759080445',
    latitude: '36.03721191488'
  },
  410581:
  {
    name: '林州市',
    parseid: '4105',
    longitude: '113.82559018908',
    latitude: '36.088853208448'
  },
  410602:
  {
    name: '鹤山区',
    parseid: '4106',
    longitude: '114.16955478242',
    latitude: '35.960280248227'
  },
  410603:
  {
    name: '山城区',
    parseid: '4106',
    longitude: '114.19062058561',
    latitude: '35.903369613292'
  },
  410611:
  {
    name: '淇滨区',
    parseid: '4106',
    longitude: '114.30559120444',
    latitude: '35.746952546289'
  },
  410621:
  {
    name: '浚县',
    parseid: '4106',
    longitude: '114.55760785086',
    latitude: '35.681917305913'
  },
  410622:
  {
    name: '淇县',
    parseid: '4106',
    longitude: '114.2154897245',
    latitude: '35.627277020336'
  },
  410671:
  {
    name: '鹤壁经济技术开发区',
    parseid: '4106',
    longitude: '114.31626262474',
    latitude: '35.76650519238'
  },
  410702:
  {
    name: '红旗区',
    parseid: '4107',
    longitude: '113.88141583415',
    latitude: '35.310135512691'
  },
  410703:
  {
    name: '卫滨区',
    parseid: '4107',
    longitude: '113.8724387977',
    latitude: '35.308459209602'
  },
  410704:
  {
    name: '凤泉区',
    parseid: '4107',
    longitude: '113.91245884715',
    latitude: '35.375665060578'
  },
  410711:
  {
    name: '牧野区',
    parseid: '4107',
    longitude: '113.91551290623',
    latitude: '35.321023486499'
  },
  410721:
  {
    name: '新乡县',
    parseid: '4107',
    longitude: '113.81159378076',
    latitude: '35.196564408993'
  },
  410724:
  {
    name: '获嘉县',
    parseid: '4107',
    longitude: '113.66341666994',
    latitude: '35.265809284161'
  },
  410725:
  {
    name: '原阳县',
    parseid: '4107',
    longitude: '113.94662374129',
    latitude: '35.071163864469'
  },
  410726:
  {
    name: '延津县',
    parseid: '4107',
    longitude: '114.21151175821',
    latitude: '35.147806510509'
  },
  410727:
  {
    name: '封丘县',
    parseid: '4107',
    longitude: '114.42560616803',
    latitude: '35.046857531651'
  },
  410771:
  {
    name: '新乡高新技术产业开发区',
    parseid: '4107',
    longitude: '113.81159378076',
    latitude: '35.196564408993'
  },
  410772:
  {
    name: '新乡经济技术开发区',
    parseid: '4107',
    longitude: '113.81159378076',
    latitude: '35.196564408993'
  },
  410773:
  {
    name: '新乡市平原城乡一体化示范区',
    parseid: '4107',
    longitude: '113.81159378076',
    latitude: '35.196564408993'
  },
  410781:
  {
    name: '卫辉市',
    parseid: '4107',
    longitude: '114.07160094452',
    latitude: '35.404068882145'
  },
  410782:
  {
    name: '辉县市',
    parseid: '4107',
    longitude: '113.81157302991',
    latitude: '35.467957818376'
  },
  410783:
  {
    name: '长垣市',
    parseid: '4107',
    longitude: '114.67560989146',
    latitude: '35.207198224565'
  },
  410802:
  {
    name: '解放区',
    parseid: '4108',
    longitude: '113.23757179887',
    latitude: '35.246309807633'
  },
  410803:
  {
    name: '中站区',
    parseid: '4108',
    longitude: '113.18944759643',
    latitude: '35.242617103591'
  },
  410804:
  {
    name: '马村区',
    parseid: '4108',
    longitude: '113.32854400634',
    latitude: '35.261894441723'
  },
  410811:
  {
    name: '山阳区',
    parseid: '4108',
    longitude: '113.26048370971',
    latitude: '35.220272352977'
  },
  410821:
  {
    name: '修武县',
    parseid: '4108',
    longitude: '113.45458192871',
    latitude: '35.229323482594'
  },
  410822:
  {
    name: '博爱县',
    parseid: '4108',
    longitude: '113.07047799096',
    latitude: '35.177308063756'
  },
  410823:
  {
    name: '武陟县',
    parseid: '4108',
    longitude: '113.40839582041',
    latitude: '35.105838449217'
  },
  410825:
  {
    name: '温县',
    parseid: '4108',
    longitude: '113.08656906807',
    latitude: '34.946135492247'
  },
  410871:
  {
    name: '焦作城乡一体化示范区',
    parseid: '4108',
    longitude: '113.25975302801',
    latitude: '35.181633935132'
  },
  410882:
  {
    name: '沁阳市',
    parseid: '4108',
    longitude: '112.95751688155',
    latitude: '35.093785732346'
  },
  410883:
  {
    name: '孟州市',
    parseid: '4108',
    longitude: '112.79739491254',
    latitude: '34.913597817886'
  },
  410902:
  {
    name: '华龙区',
    parseid: '4109',
    longitude: '115.0804129441',
    latitude: '35.783632884536'
  },
  410922:
  {
    name: '清丰县',
    parseid: '4109',
    longitude: '115.11047186341',
    latitude: '35.891308168277'
  },
  410923:
  {
    name: '南乐县',
    parseid: '4109',
    longitude: '115.21138615695',
    latitude: '36.076030832875'
  },
  410926:
  {
    name: '范县',
    parseid: '4109',
    longitude: '115.51058621044',
    latitude: '35.857655087719'
  },
  410927:
  {
    name: '台前县',
    parseid: '4109',
    longitude: '115.87856816938',
    latitude: '35.975012712521'
  },
  410928:
  {
    name: '濮阳县',
    parseid: '4109',
    longitude: '115.03558408559',
    latitude: '35.717888889375'
  },
  410971:
  {
    name: '河南濮阳工业园区',
    parseid: '4109',
    longitude: '115.18890372596',
    latitude: '35.755603814018'
  },
  410972:
  {
    name: '濮阳经济技术开发区',
    parseid: '4109',
    longitude: '115.03558408559',
    latitude: '35.717888889375'
  },
  411002:
  {
    name: '魏都区',
    parseid: '4110',
    longitude: '113.83754070661',
    latitude: '34.053250752504'
  },
  411003:
  {
    name: '建安区',
    parseid: '4110',
    longitude: '113.82947787567',
    latitude: '34.130525476433'
  },
  411024:
  {
    name: '鄢陵县',
    parseid: '4110',
    longitude: '114.18463769125',
    latitude: '34.10888169766'
  },
  411025:
  {
    name: '襄城县',
    parseid: '4110',
    longitude: '113.51342013114',
    latitude: '33.857911821588'
  },
  411071:
  {
    name: '许昌经济技术开发区',
    parseid: '4110',
    longitude: '113.81238860148',
    latitude: '34.009367095161'
  },
  411081:
  {
    name: '禹州市',
    parseid: '4110',
    longitude: '113.49522360558',
    latitude: '34.148266522461'
  },
  411082:
  {
    name: '长葛市',
    parseid: '4110',
    longitude: '113.82065759353',
    latitude: '34.201538754321'
  },
  411102:
  {
    name: '源汇区',
    parseid: '4111',
    longitude: '113.99041352982',
    latitude: '33.578423262447'
  },
  411103:
  {
    name: '郾城区',
    parseid: '4111',
    longitude: '114.01339389154',
    latitude: '33.593415880865'
  },
  411104:
  {
    name: '召陵区',
    parseid: '4111',
    longitude: '114.1004665548',
    latitude: '33.592467538561'
  },
  411121:
  {
    name: '舞阳县',
    parseid: '4111',
    longitude: '113.61549000488',
    latitude: '33.443577799934'
  },
  411122:
  {
    name: '临颍县',
    parseid: '4111',
    longitude: '113.93757834379',
    latitude: '33.83269194793'
  },
  411171:
  {
    name: '漯河经济技术开发区',
    parseid: '4111',
    longitude: '114.05640296275',
    latitude: '33.556497120369'
  },
  411202:
  {
    name: '湖滨区',
    parseid: '4112',
    longitude: '111.19557389665',
    latitude: '34.775996792444'
  },
  411203:
  {
    name: '陕州区',
    parseid: '4112',
    longitude: '111.10945065249',
    latitude: '34.726914801527'
  },
  411221:
  {
    name: '渑池县',
    parseid: '4112',
    longitude: '111.76854234585',
    latitude: '34.773197042986'
  },
  411224:
  {
    name: '卢氏县',
    parseid: '4112',
    longitude: '111.05456400617',
    latitude: '34.059924845299'
  },
  411271:
  {
    name: '河南三门峡经济开发区',
    parseid: '4112',
    longitude: '111.19922496957',
    latitude: '34.787978962973'
  },
  411281:
  {
    name: '义马市',
    parseid: '4112',
    longitude: '111.88051478021',
    latitude: '34.753028009473'
  },
  411282:
  {
    name: '灵宝市',
    parseid: '4112',
    longitude: '110.90040831286',
    latitude: '34.523142624164'
  },
  411302:
  {
    name: '宛城区',
    parseid: '4113',
    longitude: '112.54645416663',
    latitude: '33.009870040626'
  },
  411303:
  {
    name: '卧龙区',
    parseid: '4113',
    longitude: '112.54146183376',
    latitude: '32.992483797527'
  },
  411321:
  {
    name: '南召县',
    parseid: '4113',
    longitude: '112.43542522255',
    latitude: '33.496185804625'
  },
  411322:
  {
    name: '方城县',
    parseid: '4113',
    longitude: '113.0185027528',
    latitude: '33.260539455832'
  },
  411323:
  {
    name: '西峡县',
    parseid: '4113',
    longitude: '111.48039809758',
    latitude: '33.313316115292'
  },
  411324:
  {
    name: '镇平县',
    parseid: '4113',
    longitude: '112.24154448331',
    latitude: '33.039718529225'
  },
  411325:
  {
    name: '内乡县',
    parseid: '4113',
    longitude: '111.85542528697',
    latitude: '33.051203105476'
  },
  411326:
  {
    name: '淅川县',
    parseid: '4113',
    longitude: '111.49743203615',
    latitude: '33.144185260027'
  },
  411327:
  {
    name: '社旗县',
    parseid: '4113',
    longitude: '112.9544934547',
    latitude: '33.062236685935'
  },
  411328:
  {
    name: '唐河县',
    parseid: '4113',
    longitude: '112.81342436589',
    latitude: '32.687720660005'
  },
  411329:
  {
    name: '新野县',
    parseid: '4113',
    longitude: '112.36654962384',
    latitude: '32.526631778818'
  },
  411330:
  {
    name: '桐柏县',
    parseid: '4113',
    longitude: '113.43447273106',
    latitude: '32.385130754956'
  },
  411371:
  {
    name: '南阳高新技术产业开发区',
    parseid: '4113',
    longitude: '112.54230992399',
    latitude: '33.037026177899'
  },
  411372:
  {
    name: '南阳市城乡一体化示范区',
    parseid: '4113',
    longitude: '112.58810769482',
    latitude: '32.981180407802'
  },
  411381:
  {
    name: '邓州市',
    parseid: '4113',
    longitude: '112.09342010302',
    latitude: '32.69391743997'
  },
  411402:
  {
    name: '梁园区',
    parseid: '4114',
    longitude: '115.62060204557',
    latitude: '34.449471246294'
  },
  411403:
  {
    name: '睢阳区',
    parseid: '4114',
    longitude: '115.65947594702',
    latitude: '34.394151920479'
  },
  411421:
  {
    name: '民权县',
    parseid: '4114',
    longitude: '115.15457605887',
    latitude: '34.652478726537'
  },
  411422:
  {
    name: '睢县',
    parseid: '4114',
    longitude: '115.07841089061',
    latitude: '34.451616965409'
  },
  411423:
  {
    name: '宁陵县',
    parseid: '4114',
    longitude: '115.32041843737',
    latitude: '34.46663402766'
  },
  411424:
  {
    name: '柘城县',
    parseid: '4114',
    longitude: '115.31243456749',
    latitude: '34.097360212415'
  },
  411425:
  {
    name: '虞城县',
    parseid: '4114',
    longitude: '115.83447295698',
    latitude: '34.405331502097'
  },
  411426:
  {
    name: '夏邑县',
    parseid: '4114',
    longitude: '116.13751236823',
    latitude: '34.243523472378'
  },
  411471:
  {
    name: '豫东综合物流产业聚集区',
    parseid: '4114',
    longitude: '115.82244680214',
    latitude: '34.39050097097'
  },
  411472:
  {
    name: '河南商丘经济开发区',
    parseid: '4114',
    longitude: '115.69828597896',
    latitude: '34.407737030214'
  },
  411481:
  {
    name: '永城市',
    parseid: '4114',
    longitude: '116.4555661476',
    latitude: '33.934801475851'
  },
  411502:
  {
    name: '浉河区',
    parseid: '4115',
    longitude: '114.06558130947',
    latitude: '32.122554156884'
  },
  411503:
  {
    name: '平桥区',
    parseid: '4115',
    longitude: '114.13240742415',
    latitude: '32.10732538611'
  },
  411521:
  {
    name: '罗山县',
    parseid: '4115',
    longitude: '114.51952993791',
    latitude: '32.209150451838'
  },
  411522:
  {
    name: '光山县',
    parseid: '4115',
    longitude: '114.92553303688',
    latitude: '32.015906879568'
  },
  411523:
  {
    name: '新县',
    parseid: '4115',
    longitude: '114.88552475523',
    latitude: '31.649738468475'
  },
  411524:
  {
    name: '商城县',
    parseid: '4115',
    longitude: '115.41351334076',
    latitude: '31.804345366903'
  },
  411525:
  {
    name: '固始县',
    parseid: '4115',
    longitude: '115.66048788818',
    latitude: '32.174174379622'
  },
  411526:
  {
    name: '潢川县',
    parseid: '4115',
    longitude: '115.05847075405',
    latitude: '32.137530716414'
  },
  411527:
  {
    name: '淮滨县',
    parseid: '4115',
    longitude: '115.42643896891',
    latitude: '32.479469756663'
  },
  411528:
  {
    name: '息县',
    parseid: '4115',
    longitude: '114.74745313225',
    latitude: '32.348955511715'
  },
  411571:
  {
    name: '信阳高新技术产业开发区',
    parseid: '4115',
    longitude: '114.20576592668',
    latitude: '32.139913710889'
  },
  411602:
  {
    name: '川汇区',
    parseid: '4116',
    longitude: '114.65760174056',
    latitude: '33.652997102814'
  },
  411603:
  {
    name: '淮阳区',
    parseid: '4116',
    longitude: '114.89258615519',
    latitude: '33.737347183458'
  },
  411621:
  {
    name: '扶沟县',
    parseid: '4116',
    longitude: '114.40150984137',
    latitude: '34.065906253969'
  },
  411622:
  {
    name: '西华县',
    parseid: '4116',
    longitude: '114.53559667094',
    latitude: '33.773215334922'
  },
  411623:
  {
    name: '商水县',
    parseid: '4116',
    longitude: '114.61841594744',
    latitude: '33.548877475353'
  },
  411624:
  {
    name: '沈丘县',
    parseid: '4116',
    longitude: '115.10545545595',
    latitude: '33.415691094059'
  },
  411625:
  {
    name: '郸城县',
    parseid: '4116',
    longitude: '115.18347760136',
    latitude: '33.650827955049'
  },
  411627:
  {
    name: '太康县',
    parseid: '4116',
    longitude: '114.84438389',
    latitude: '34.070038382248'
  },
  411628:
  {
    name: '鹿邑县',
    parseid: '4116',
    longitude: '115.4905852586',
    latitude: '33.867173290317'
  },
  411671:
  {
    name: '河南周口经济开发区',
    parseid: '4116',
    longitude: '114.68413166668',
    latitude: '33.592427240922'
  },
  411681:
  {
    name: '项城市',
    parseid: '4116',
    longitude: '114.88151400079',
    latitude: '33.47300744143'
  },
  411702:
  {
    name: '驿城区',
    parseid: '4117',
    longitude: '114.00038696674',
    latitude: '32.979519871982'
  },
  411721:
  {
    name: '西平县',
    parseid: '4117',
    longitude: '114.02747357279',
    latitude: '33.393860997525'
  },
  411722:
  {
    name: '上蔡县',
    parseid: '4117',
    longitude: '114.2704868624',
    latitude: '33.268511215884'
  },
  411723:
  {
    name: '平舆县',
    parseid: '4117',
    longitude: '114.62542865923',
    latitude: '32.967982400438'
  },
  411724:
  {
    name: '正阳县',
    parseid: '4117',
    longitude: '114.39949655906',
    latitude: '32.611641077273'
  },
  411725:
  {
    name: '确山县',
    parseid: '4117',
    longitude: '114.03249501076',
    latitude: '32.808175692984'
  },
  411726:
  {
    name: '泌阳县',
    parseid: '4117',
    longitude: '113.33355798837',
    latitude: '32.729730650435'
  },
  411727:
  {
    name: '汝南县',
    parseid: '4117',
    longitude: '114.36940889397',
    latitude: '33.013140881992'
  },
  411728:
  {
    name: '遂平县',
    parseid: '4117',
    longitude: '114.0194414639',
    latitude: '33.151971399579'
  },
  411729:
  {
    name: '新蔡县',
    parseid: '4117',
    longitude: '114.99246928382',
    latitude: '32.755268867306'
  },
  411771:
  {
    name: '河南驻马店经济开发区',
    parseid: '4117',
    longitude: '114.08186561209',
    latitude: '33.16814518381'
  },
  419001:
  {
    name: '济源市',
    parseid: '4190',
    longitude: '112.58830020169',
    latitude: '35.111359097364'
  },
  420102:
  {
    name: '江岸区',
    parseid: '4201',
    longitude: '114.31657918761',
    latitude: '30.605402797562'
  },
  420103:
  {
    name: '江汉区',
    parseid: '4201',
    longitude: '114.27750613182',
    latitude: '30.607282276827'
  },
  420104:
  {
    name: '硚口区',
    parseid: '4201',
    longitude: '114.22146031207',
    latitude: '30.587584340776'
  },
  420105:
  {
    name: '汉阳区',
    parseid: '4201',
    longitude: '114.22544555464',
    latitude: '30.560052027443'
  },
  420106:
  {
    name: '武昌区',
    parseid: '4201',
    longitude: '114.32254851755',
    latitude: '30.559566983522'
  },
  420107:
  {
    name: '青山区',
    parseid: '4201',
    longitude: '114.39149265697',
    latitude: '30.646593075543'
  },
  420111:
  {
    name: '洪山区',
    parseid: '4201',
    longitude: '114.35045554602',
    latitude: '30.506333956808'
  },
  420112:
  {
    name: '东西湖区',
    parseid: '4201',
    longitude: '114.14345873786',
    latitude: '30.625919818109'
  },
  420113:
  {
    name: '汉南区',
    parseid: '4201',
    longitude: '114.09151485056',
    latitude: '30.314809120145'
  },
  420114:
  {
    name: '蔡甸区',
    parseid: '4201',
    longitude: '114.03547963081',
    latitude: '30.588113621855'
  },
  420115:
  {
    name: '江夏区',
    parseid: '4201',
    longitude: '114.32855126446',
    latitude: '30.381564218182'
  },
  420116:
  {
    name: '黄陂区',
    parseid: '4201',
    longitude: '114.38245399676',
    latitude: '30.887533767835'
  },
  420117:
  {
    name: '新洲区',
    parseid: '4201',
    longitude: '114.8075433929',
    latitude: '30.847243870523'
  },
  420202:
  {
    name: '黄石港区',
    parseid: '4202',
    longitude: '115.07241748608',
    latitude: '30.229052639992'
  },
  420203:
  {
    name: '西塞山区',
    parseid: '4202',
    longitude: '115.11648143744',
    latitude: '30.210695184118'
  },
  420204:
  {
    name: '下陆区',
    parseid: '4202',
    longitude: '114.96741590247',
    latitude: '30.180046155273'
  },
  420205:
  {
    name: '铁山区',
    parseid: '4202',
    longitude: '114.90757141821',
    latitude: '30.212250832587'
  },
  420222:
  {
    name: '阳新县',
    parseid: '4202',
    longitude: '115.22142677197',
    latitude: '29.836541808086'
  },
  420281:
  {
    name: '大冶市',
    parseid: '4202',
    longitude: '114.98643626402',
    latitude: '30.101667800103'
  },
  420302:
  {
    name: '茅箭区',
    parseid: '4203',
    longitude: '110.81958031019',
    latitude: '32.597286519104'
  },
  420303:
  {
    name: '张湾区',
    parseid: '4203',
    longitude: '110.77542410285',
    latitude: '32.65839954548'
  },
  420304:
  {
    name: '郧阳区',
    parseid: '4203',
    longitude: '110.81857654362',
    latitude: '32.840592413038'
  },
  420322:
  {
    name: '郧西县',
    parseid: '4203',
    longitude: '110.43247261847',
    latitude: '32.999167007536'
  },
  420323:
  {
    name: '竹山县',
    parseid: '4203',
    longitude: '110.23558156764',
    latitude: '32.230304060376'
  },
  420324:
  {
    name: '竹溪县',
    parseid: '4203',
    longitude: '109.72154249889',
    latitude: '32.324120048853'
  },
  420325:
  {
    name: '房县',
    parseid: '4203',
    longitude: '110.74746155911',
    latitude: '32.061684964544'
  },
  420381:
  {
    name: '丹江口市',
    parseid: '4203',
    longitude: '111.51953205848',
    latitude: '32.546252688501'
  },
  420502:
  {
    name: '西陵区',
    parseid: '4205',
    longitude: '111.29255972053',
    latitude: '30.716749346598'
  },
  420503:
  {
    name: '伍家岗区',
    parseid: '4205',
    longitude: '111.36742225597',
    latitude: '30.65073733526'
  },
  420504:
  {
    name: '点军区',
    parseid: '4205',
    longitude: '111.27447135095',
    latitude: '30.69932951388'
  },
  420505:
  {
    name: '猇亭区',
    parseid: '4205',
    longitude: '111.44157378259',
    latitude: '30.536465982707'
  },
  420506:
  {
    name: '夷陵区',
    parseid: '4205',
    longitude: '111.33252973436',
    latitude: '30.774833327298'
  },
  420525:
  {
    name: '远安县',
    parseid: '4205',
    longitude: '111.64653035927',
    latitude: '31.066627841578'
  },
  420526:
  {
    name: '兴山县',
    parseid: '4205',
    longitude: '110.75344607041',
    latitude: '31.354463517716'
  },
  420527:
  {
    name: '秭归县',
    parseid: '4205',
    longitude: '110.98444937468',
    latitude: '30.831931643216'
  },
  420528:
  {
    name: '长阳土家族自治县',
    parseid: '4205',
    longitude: '111.21350712887',
    latitude: '30.478645783056'
  },
  420529:
  {
    name: '五峰土家族自治县',
    parseid: '4205',
    longitude: '111.05258063744',
    latitude: '30.171156151026'
  },
  420581:
  {
    name: '宜都市',
    parseid: '4205',
    longitude: '111.45651583712',
    latitude: '30.384404274314'
  },
  420582:
  {
    name: '当阳市',
    parseid: '4205',
    longitude: '111.79456850223',
    latitude: '30.826989050281'
  },
  420583:
  {
    name: '枝江市',
    parseid: '4205',
    longitude: '111.76653975337',
    latitude: '30.431730676998'
  },
  420602:
  {
    name: '襄城区',
    parseid: '4206',
    longitude: '112.14057206941',
    latitude: '32.016174618141'
  },
  420606:
  {
    name: '樊城区',
    parseid: '4206',
    longitude: '112.14259891613',
    latitude: '32.050572374692'
  },
  420607:
  {
    name: '襄州区',
    parseid: '4206',
    longitude: '112.21843413678',
    latitude: '32.093375783399'
  },
  420624:
  {
    name: '南漳县',
    parseid: '4206',
    longitude: '111.84538618392',
    latitude: '31.781129706779'
  },
  420625:
  {
    name: '谷城县',
    parseid: '4206',
    longitude: '111.65957564172',
    latitude: '32.268983068947'
  },
  420626:
  {
    name: '保康县',
    parseid: '4206',
    longitude: '111.26744121203',
    latitude: '31.883847150262'
  },
  420682:
  {
    name: '老河口市',
    parseid: '4206',
    longitude: '111.68155636908',
    latitude: '32.392459585271'
  },
  420683:
  {
    name: '枣阳市',
    parseid: '4206',
    longitude: '112.77847075951',
    latitude: '32.134729914319'
  },
  420684:
  {
    name: '宜城市',
    parseid: '4206',
    longitude: '112.26461144169',
    latitude: '31.725469730972'
  },
  420702:
  {
    name: '梁子湖区',
    parseid: '4207',
    longitude: '114.69150657526',
    latitude: '30.105906774051'
  },
  420703:
  {
    name: '华容区',
    parseid: '4207',
    longitude: '114.73642634228',
    latitude: '30.540599527838'
  },
  420704:
  {
    name: '鄂城区',
    parseid: '4207',
    longitude: '114.89859968176',
    latitude: '30.406389456292'
  },
  420802:
  {
    name: '东宝区',
    parseid: '4208',
    longitude: '112.2083882066',
    latitude: '31.058429271365'
  },
  420804:
  {
    name: '掇刀区',
    parseid: '4208',
    longitude: '112.2144276942',
    latitude: '30.979910859804'
  },
  420822:
  {
    name: '沙洋县',
    parseid: '4208',
    longitude: '112.59548493899',
    latitude: '30.715314748831'
  },
  420881:
  {
    name: '钟祥市',
    parseid: '4208',
    longitude: '112.59447102156',
    latitude: '31.174029854963'
  },
  420882:
  {
    name: '京山市',
    parseid: '4208',
    longitude: '113.12654806496',
    latitude: '31.024330601193'
  },
  420902:
  {
    name: '孝南区',
    parseid: '4209',
    longitude: '113.91748989699',
    latitude: '30.922977925049'
  },
  420921:
  {
    name: '孝昌县',
    parseid: '4209',
    longitude: '114.00440859068',
    latitude: '31.264540493062'
  },
  420922:
  {
    name: '大悟县',
    parseid: '4209',
    longitude: '114.13341253819',
    latitude: '31.567219806641'
  },
  420923:
  {
    name: '云梦县',
    parseid: '4209',
    longitude: '113.75941220183',
    latitude: '31.027218220752'
  },
  420981:
  {
    name: '应城市',
    parseid: '4209',
    longitude: '113.57956739635',
    latitude: '30.933976509913'
  },
  420982:
  {
    name: '安陆市',
    parseid: '4209',
    longitude: '113.69558292415',
    latitude: '31.261414994286'
  },
  420984:
  {
    name: '汉川市',
    parseid: '4209',
    longitude: '113.8455490104',
    latitude: '30.666913578821'
  },
  421002:
  {
    name: '沙市区',
    parseid: '4210',
    longitude: '112.26157741483',
    latitude: '30.316571904872'
  },
  421003:
  {
    name: '荆州区',
    parseid: '4210',
    longitude: '112.19641397381',
    latitude: '30.358989490775'
  },
  421022:
  {
    name: '公安县',
    parseid: '4210',
    longitude: '112.23650157584',
    latitude: '30.064400686806'
  },
  421023:
  {
    name: '监利县',
    parseid: '4210',
    longitude: '112.91142023009',
    latitude: '29.845735162836'
  },
  421024:
  {
    name: '江陵县',
    parseid: '4210',
    longitude: '112.43145201728',
    latitude: '30.048042984592'
  },
  421071:
  {
    name: '荆州经济技术开发区',
    parseid: '4210',
    longitude: '112.19641397381',
    latitude: '30.358989490775'
  },
  421081:
  {
    name: '石首市',
    parseid: '4210',
    longitude: '112.43141984371',
    latitude: '29.727033977407'
  },
  421083:
  {
    name: '洪湖市',
    parseid: '4210',
    longitude: '113.48255290196',
    latitude: '29.83277032976'
  },
  421087:
  {
    name: '松滋市',
    parseid: '4210',
    longitude: '111.77358031264',
    latitude: '30.175342235143'
  },
  421102:
  {
    name: '黄州区',
    parseid: '4211',
    longitude: '114.88653238452',
    latitude: '30.440224145146'
  },
  421121:
  {
    name: '团风县',
    parseid: '4211',
    longitude: '114.87852435023',
    latitude: '30.649367767215'
  },
  421122:
  {
    name: '红安县',
    parseid: '4211',
    longitude: '114.6244256113',
    latitude: '31.294296714037'
  },
  421123:
  {
    name: '罗田县',
    parseid: '4211',
    longitude: '115.4055471675',
    latitude: '30.788910495685'
  },
  421124:
  {
    name: '英山县',
    parseid: '4211',
    longitude: '115.68742160263',
    latitude: '30.741350084085'
  },
  421125:
  {
    name: '浠水县',
    parseid: '4211',
    longitude: '115.27156903289',
    latitude: '30.457460842265'
  },
  421126:
  {
    name: '蕲春县',
    parseid: '4211',
    longitude: '115.4423985341',
    latitude: '30.232535499734'
  },
  421127:
  {
    name: '黄梅县',
    parseid: '4211',
    longitude: '115.95046198477',
    latitude: '30.076605056821'
  },
  421171:
  {
    name: '龙感湖管理区',
    parseid: '4211',
    longitude: '116.00984310764',
    latitude: '29.880308219026'
  },
  421181:
  {
    name: '麻城市',
    parseid: '4211',
    longitude: '115.01656174777',
    latitude: '31.176995837411'
  },
  421182:
  {
    name: '武穴市',
    parseid: '4211',
    longitude: '115.56739216105',
    latitude: '29.850441430483'
  },
  421202:
  {
    name: '咸安区',
    parseid: '4212',
    longitude: '114.30456990606',
    latitude: '29.858153915154'
  },
  421221:
  {
    name: '嘉鱼县',
    parseid: '4212',
    longitude: '113.94557046336',
    latitude: '29.976353520898'
  },
  421222:
  {
    name: '通城县',
    parseid: '4212',
    longitude: '113.82356790903',
    latitude: '29.250857930222'
  },
  421223:
  {
    name: '崇阳县',
    parseid: '4212',
    longitude: '114.04656290943',
    latitude: '29.561333782271'
  },
  421224:
  {
    name: '通山县',
    parseid: '4212',
    longitude: '114.48939330027',
    latitude: '29.612634338058'
  },
  421281:
  {
    name: '赤壁市',
    parseid: '4212',
    longitude: '113.90643686179',
    latitude: '29.730665997526'
  },
  421303:
  {
    name: '曾都区',
    parseid: '4213',
    longitude: '113.3775133346',
    latitude: '31.722122861271'
  },
  421321:
  {
    name: '随县',
    parseid: '4213',
    longitude: '113.3064583569',
    latitude: '31.859971678258'
  },
  421381:
  {
    name: '广水市',
    parseid: '4213',
    longitude: '113.83259337884',
    latitude: '31.622476038007'
  },
  422801:
  {
    name: '恩施市',
    parseid: '4228',
    longitude: '109.48655026901',
    latitude: '30.301037143741'
  },
  422802:
  {
    name: '利川市',
    parseid: '4228',
    longitude: '108.94248057756',
    latitude: '30.29720344368'
  },
  422822:
  {
    name: '建始县',
    parseid: '4228',
    longitude: '109.72855610899',
    latitude: '30.607907026319'
  },
  422823:
  {
    name: '巴东县',
    parseid: '4228',
    longitude: '110.34757529184',
    latitude: '31.04806424896'
  },
  422825:
  {
    name: '宣恩县',
    parseid: '4228',
    longitude: '109.49756797283',
    latitude: '29.99260392208'
  },
  422826:
  {
    name: '咸丰县',
    parseid: '4228',
    longitude: '109.14660773562',
    latitude: '29.671077652358'
  },
  422827:
  {
    name: '来凤县',
    parseid: '4228',
    longitude: '109.41349484153',
    latitude: '29.499443572607'
  },
  422828:
  {
    name: '鹤峰县',
    parseid: '4228',
    longitude: '110.04042423301',
    latitude: '29.896116483403'
  },
  429004:
  {
    name: '仙桃市',
    parseid: '4290',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  429005:
  {
    name: '潜江市',
    parseid: '4290',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  429006:
  {
    name: '天门市',
    parseid: '4290',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  429021:
  {
    name: '神农架林区',
    parseid: '4290',
    longitude: '114.34844073659',
    latitude: '30.551600064658'
  },
  430102:
  {
    name: '芙蓉区',
    parseid: '4301',
    longitude: '113.03940774487',
    latitude: '28.191913247305'
  },
  430103:
  {
    name: '天心区',
    parseid: '4301',
    longitude: '112.99659225852',
    latitude: '28.118211217441'
  },
  430104:
  {
    name: '岳麓区',
    parseid: '4301',
    longitude: '112.9374476441',
    latitude: '28.241488836473'
  },
  430105:
  {
    name: '开福区',
    parseid: '4301',
    longitude: '112.99258491764',
    latitude: '28.261378687684'
  },
  430111:
  {
    name: '雨花区',
    parseid: '4301',
    longitude: '113.04242155986',
    latitude: '28.142232711654'
  },
  430112:
  {
    name: '望城区',
    parseid: '4301',
    longitude: '112.8244661432',
    latitude: '28.367403020376'
  },
  430121:
  {
    name: '长沙县',
    parseid: '4301',
    longitude: '113.08755916596',
    latitude: '28.251818487944'
  },
  430181:
  {
    name: '浏阳市',
    parseid: '4301',
    longitude: '113.64939823851',
    latitude: '28.169832216071'
  },
  430182:
  {
    name: '宁乡市',
    parseid: '4301',
    longitude: '112.55840691564',
    latitude: '28.284104536209'
  },
  430202:
  {
    name: '荷塘区',
    parseid: '4302',
    longitude: '113.18045222007',
    latitude: '27.862155809141'
  },
  430203:
  {
    name: '芦淞区',
    parseid: '4302',
    longitude: '113.15841867236',
    latitude: '27.791508825947'
  },
  430204:
  {
    name: '石峰区',
    parseid: '4302',
    longitude: '113.12456791567',
    latitude: '27.880705165595'
  },
  430211:
  {
    name: '天元区',
    parseid: '4302',
    longitude: '113.08954055842',
    latitude: '27.833083519485'
  },
  430212:
  {
    name: '渌口区',
    parseid: '4302',
    longitude: '113.15042671773',
    latitude: '27.704322804857'
  },
  430223:
  {
    name: '攸县',
    parseid: '4302',
    longitude: '113.35157834169',
    latitude: '27.005771565213'
  },
  430224:
  {
    name: '茶陵县',
    parseid: '4302',
    longitude: '113.54547165714',
    latitude: '26.78358911036'
  },
  430225:
  {
    name: '炎陵县',
    parseid: '4302',
    longitude: '113.77941879832',
    latitude: '26.496060691599'
  },
  430271:
  {
    name: '云龙示范区',
    parseid: '4302',
    longitude: '113.14834273878',
    latitude: '27.886292846193'
  },
  430281:
  {
    name: '醴陵市',
    parseid: '4302',
    longitude: '113.50348315084',
    latitude: '27.652325149951'
  },
  430302:
  {
    name: '雨湖区',
    parseid: '4303',
    longitude: '112.91344959207',
    latitude: '27.862466785111'
  },
  430304:
  {
    name: '岳塘区',
    parseid: '4303',
    longitude: '112.97558942655',
    latitude: '27.877720506364'
  },
  430321:
  {
    name: '湘潭县',
    parseid: '4303',
    longitude: '112.95750536884',
    latitude: '27.784982534656'
  },
  430371:
  {
    name: '湖南湘潭高新技术产业园区',
    parseid: '4303',
    longitude: '112.95046418076',
    latitude: '27.835702227136'
  },
  430372:
  {
    name: '湘潭昭山示范区',
    parseid: '4303',
    longitude: '112.95750536884',
    latitude: '27.784982534656'
  },
  430373:
  {
    name: '湘潭九华示范区',
    parseid: '4303',
    longitude: '112.95750536884',
    latitude: '27.784982534656'
  },
  430381:
  {
    name: '湘乡市',
    parseid: '4303',
    longitude: '112.54149155341',
    latitude: '27.740190553344'
  },
  430382:
  {
    name: '韶山市',
    parseid: '4303',
    longitude: '112.53349932929',
    latitude: '27.921043749631'
  },
  430405:
  {
    name: '珠晖区',
    parseid: '4304',
    longitude: '112.62659414282',
    latitude: '26.900265361946'
  },
  430406:
  {
    name: '雁峰区',
    parseid: '4304',
    longitude: '112.62041110599',
    latitude: '26.8465393997'
  },
  430407:
  {
    name: '石鼓区',
    parseid: '4304',
    longitude: '112.60452969339',
    latitude: '26.948961867165'
  },
  430408:
  {
    name: '蒸湘区',
    parseid: '4304',
    longitude: '112.57344401089',
    latitude: '26.917719877877'
  },
  430412:
  {
    name: '南岳区',
    parseid: '4304',
    longitude: '112.74557434825',
    latitude: '27.238360474562'
  },
  430421:
  {
    name: '衡阳县',
    parseid: '4304',
    longitude: '112.37755268433',
    latitude: '26.975294950861'
  },
  430422:
  {
    name: '衡南县',
    parseid: '4304',
    longitude: '112.68440252779',
    latitude: '26.744531956772'
  },
  430423:
  {
    name: '衡山县',
    parseid: '4304',
    longitude: '112.87556328771',
    latitude: '27.235996029656'
  },
  430424:
  {
    name: '衡东县',
    parseid: '4304',
    longitude: '112.95949529521',
    latitude: '27.087042820265'
  },
  430426:
  {
    name: '祁东县',
    parseid: '4304',
    longitude: '112.09644737847',
    latitude: '26.805995255191'
  },
  430471:
  {
    name: '衡阳综合保税区',
    parseid: '4304',
    longitude: '112.37755268433',
    latitude: '26.975294950861'
  },
  430472:
  {
    name: '湖南衡阳高新技术产业园区',
    parseid: '4304',
    longitude: '112.56031590468',
    latitude: '26.898382211994'
  },
  430473:
  {
    name: '湖南衡阳松木经济开发区',
    parseid: '4304',
    longitude: '112.57844721326',
    latitude: '26.899576139189'
  },
  430481:
  {
    name: '耒阳市',
    parseid: '4304',
    longitude: '112.86659721058',
    latitude: '26.428065593928'
  },
  430482:
  {
    name: '常宁市',
    parseid: '4304',
    longitude: '112.40556050266',
    latitude: '26.426720432257'
  },
  430502:
  {
    name: '双清区',
    parseid: '4305',
    longitude: '111.50344150643',
    latitude: '27.239108783297'
  },
  430503:
  {
    name: '大祥区',
    parseid: '4305',
    longitude: '111.44552828921',
    latitude: '27.227013968694'
  },
  430511:
  {
    name: '北塔区',
    parseid: '4305',
    longitude: '111.45849694619',
    latitude: '27.251536276174'
  },
  430522:
  {
    name: '新邵县',
    parseid: '4305',
    longitude: '111.46444938799',
    latitude: '27.32713173916'
  },
  430523:
  {
    name: '邵阳县',
    parseid: '4305',
    longitude: '111.28050768064',
    latitude: '26.996528332196'
  },
  430524:
  {
    name: '隆回县',
    parseid: '4305',
    longitude: '111.03950668528',
    latitude: '27.119946440019'
  },
  430525:
  {
    name: '洞口县',
    parseid: '4305',
    longitude: '110.58257909625',
    latitude: '27.065975437799'
  },
  430527:
  {
    name: '绥宁县',
    parseid: '4305',
    longitude: '110.16241987038',
    latitude: '26.588422719333'
  },
  430528:
  {
    name: '新宁县',
    parseid: '4305',
    longitude: '110.86349072744',
    latitude: '26.439723697954'
  },
  430529:
  {
    name: '城步苗族自治县',
    parseid: '4305',
    longitude: '110.32853713032',
    latitude: '26.396203220078'
  },
  430581:
  {
    name: '武冈市',
    parseid: '4305',
    longitude: '110.63840761588',
    latitude: '26.732898572992'
  },
  430582:
  {
    name: '邵东市',
    parseid: '4305',
    longitude: '111.75049070296',
    latitude: '27.264507471566'
  },
  430602:
  {
    name: '岳阳楼区',
    parseid: '4306',
    longitude: '113.13648070435',
    latitude: '29.377995036881'
  },
  430603:
  {
    name: '云溪区',
    parseid: '4306',
    longitude: '113.27840659691',
    latitude: '29.479907141133'
  },
  430611:
  {
    name: '君山区',
    parseid: '4306',
    longitude: '113.0125171491',
    latitude: '29.467129185832'
  },
  430621:
  {
    name: '岳阳县',
    parseid: '4306',
    longitude: '113.1225444825',
    latitude: '29.150269316045'
  },
  430623:
  {
    name: '华容县',
    parseid: '4306',
    longitude: '112.54746151216',
    latitude: '29.536286434382'
  },
  430624:
  {
    name: '湘阴县',
    parseid: '4306',
    longitude: '112.88952187736',
    latitude: '28.676676377581'
  },
  430626:
  {
    name: '平江县',
    parseid: '4306',
    longitude: '113.58760362284',
    latitude: '28.707564248115'
  },
  430671:
  {
    name: '岳阳市屈原管理区',
    parseid: '4306',
    longitude: '112.91418198055',
    latitude: '28.860717002083'
  },
  430681:
  {
    name: '汨罗市',
    parseid: '4306',
    longitude: '113.07349286947',
    latitude: '28.812454694812'
  },
  430682:
  {
    name: '临湘市',
    parseid: '4306',
    longitude: '113.45656151',
    latitude: '29.482801373395'
  },
  430702:
  {
    name: '武陵区',
    parseid: '4307',
    longitude: '111.68954489616',
    latitude: '29.060783476578'
  },
  430703:
  {
    name: '鼎城区',
    parseid: '4307',
    longitude: '111.68752209182',
    latitude: '29.024443397066'
  },
  430721:
  {
    name: '安乡县',
    parseid: '4307',
    longitude: '112.1775061558',
    latitude: '29.41732043222'
  },
  430722:
  {
    name: '汉寿县',
    parseid: '4307',
    longitude: '111.97641193356',
    latitude: '28.912287603085'
  },
  430723:
  {
    name: '澧县',
    parseid: '4307',
    longitude: '111.76553354736',
    latitude: '29.638946004609'
  },
  430724:
  {
    name: '临澧县',
    parseid: '4307',
    longitude: '111.65358500797',
    latitude: '29.446543990119'
  },
  430725:
  {
    name: '桃源县',
    parseid: '4307',
    longitude: '111.49540733145',
    latitude: '28.908694006999'
  },
  430726:
  {
    name: '石门县',
    parseid: '4307',
    longitude: '111.38645140702',
    latitude: '29.59036596665'
  },
  430771:
  {
    name: '常德市西洞庭管理区',
    parseid: '4307',
    longitude: '111.98817165098',
    latitude: '29.214091001391'
  },
  430781:
  {
    name: '津市市',
    parseid: '4307',
    longitude: '111.88451734602',
    latitude: '29.611258543007'
  },
  430802:
  {
    name: '永定区',
    parseid: '4308',
    longitude: '110.54443192397',
    latitude: '29.126190558381'
  },
  430811:
  {
    name: '武陵源区',
    parseid: '4308',
    longitude: '110.5574989454',
    latitude: '29.351681136671'
  },
  430821:
  {
    name: '慈利县',
    parseid: '4308',
    longitude: '111.14547125235',
    latitude: '29.435986725969'
  },
  430822:
  {
    name: '桑植县',
    parseid: '4308',
    longitude: '110.17041335213',
    latitude: '29.405923219415'
  },
  430902:
  {
    name: '资阳区',
    parseid: '4309',
    longitude: '112.33043548238',
    latitude: '28.597234549737'
  },
  430903:
  {
    name: '赫山区',
    parseid: '4309',
    longitude: '112.38059794001',
    latitude: '28.584983567573'
  },
  430921:
  {
    name: '南县',
    parseid: '4309',
    longitude: '112.40254156734',
    latitude: '29.367069853363'
  },
  430922:
  {
    name: '桃江县',
    parseid: '4309',
    longitude: '112.16254146398',
    latitude: '28.523870869898'
  },
  430923:
  {
    name: '安化县',
    parseid: '4309',
    longitude: '111.21949270432',
    latitude: '28.380053748765'
  },
  430971:
  {
    name: '益阳市大通湖管理区',
    parseid: '4309',
    longitude: '112.53998204083',
    latitude: '29.21794346192'
  },
  430972:
  {
    name: '湖南益阳高新技术产业园区',
    parseid: '4309',
    longitude: '112.3616991192',
    latitude: '28.818587615912'
  },
  430981:
  {
    name: '沅江市',
    parseid: '4309',
    longitude: '112.36053222035',
    latitude: '28.850233588583'
  },
  431002:
  {
    name: '北湖区',
    parseid: '4310',
    longitude: '113.01741012938',
    latitude: '25.790537261262'
  },
  431003:
  {
    name: '苏仙区',
    parseid: '4310',
    longitude: '113.04842340846',
    latitude: '25.806737374104'
  },
  431021:
  {
    name: '桂阳县',
    parseid: '4310',
    longitude: '112.74056036622',
    latitude: '25.759775327893'
  },
  431022:
  {
    name: '宜章县',
    parseid: '4310',
    longitude: '112.95547924076',
    latitude: '25.405713969356'
  },
  431023:
  {
    name: '永兴县',
    parseid: '4310',
    longitude: '113.12253316386',
    latitude: '26.132968478533'
  },
  431024:
  {
    name: '嘉禾县',
    parseid: '4310',
    longitude: '112.37558377831',
    latitude: '25.593421718268'
  },
  431025:
  {
    name: '临武县',
    parseid: '4310',
    longitude: '112.57041115183',
    latitude: '25.282527010969'
  },
  431026:
  {
    name: '汝城县',
    parseid: '4310',
    longitude: '113.69154466692',
    latitude: '25.556056733978'
  },
  431027:
  {
    name: '桂东县',
    parseid: '4310',
    longitude: '113.9515936018',
    latitude: '26.083173927327'
  },
  431028:
  {
    name: '安仁县',
    parseid: '4310',
    longitude: '113.27542359381',
    latitude: '26.715682788508'
  },
  431081:
  {
    name: '资兴市',
    parseid: '4310',
    longitude: '113.24255612233',
    latitude: '25.981873602722'
  },
  431102:
  {
    name: '零陵区',
    parseid: '4311',
    longitude: '111.63750237493',
    latitude: '26.227682089779'
  },
  431103:
  {
    name: '冷水滩区',
    parseid: '4311',
    longitude: '111.59842608526',
    latitude: '26.467705510832'
  },
  431121:
  {
    name: '祁阳县',
    parseid: '4311',
    longitude: '111.84742029288',
    latitude: '26.586434994948'
  },
  431122:
  {
    name: '东安县',
    parseid: '4311',
    longitude: '111.32354235354',
    latitude: '26.398288039365'
  },
  431123:
  {
    name: '双牌县',
    parseid: '4311',
    longitude: '111.6675938129',
    latitude: '25.967169239803'
  },
  431124:
  {
    name: '道县',
    parseid: '4311',
    longitude: '111.60740437934',
    latitude: '25.53252996283'
  },
  431125:
  {
    name: '江永县',
    parseid: '4311',
    longitude: '111.35043663236',
    latitude: '25.279720667918'
  },
  431126:
  {
    name: '宁远县',
    parseid: '4311',
    longitude: '111.95245340697',
    latitude: '25.57705193746'
  },
  431127:
  {
    name: '蓝山县',
    parseid: '4311',
    longitude: '112.20343493586',
    latitude: '25.37593472464'
  },
  431128:
  {
    name: '新田县',
    parseid: '4311',
    longitude: '112.21040920018',
    latitude: '25.909825802754'
  },
  431129:
  {
    name: '江华瑶族自治县',
    parseid: '4311',
    longitude: '111.58545203845',
    latitude: '25.191348924015'
  },
  431171:
  {
    name: '永州经济技术开发区',
    parseid: '4311',
    longitude: '111.61945505792',
    latitude: '26.4258641179'
  },
  431172:
  {
    name: '永州市金洞管理区',
    parseid: '4311',
    longitude: '112.09932114763',
    latitude: '26.29914955166'
  },
  431173:
  {
    name: '永州市回龙圩管理区',
    parseid: '4311',
    longitude: '111.3409273499',
    latitude: '25.14044222375'
  },
  431202:
  {
    name: '鹤城区',
    parseid: '4312',
    longitude: '110.04639994092',
    latitude: '27.585225763164'
  },
  431221:
  {
    name: '中方县',
    parseid: '4312',
    longitude: '109.95146189432',
    latitude: '27.44608117406'
  },
  431222:
  {
    name: '沅陵县',
    parseid: '4312',
    longitude: '110.40043076602',
    latitude: '28.459018102626'
  },
  431223:
  {
    name: '辰溪县',
    parseid: '4312',
    longitude: '110.19048661755',
    latitude: '28.012605313813'
  },
  431224:
  {
    name: '溆浦县',
    parseid: '4312',
    longitude: '110.60155112895',
    latitude: '27.913963373886'
  },
  431225:
  {
    name: '会同县',
    parseid: '4312',
    longitude: '109.74158556792',
    latitude: '26.893383817274'
  },
  431226:
  {
    name: '麻阳苗族自治县',
    parseid: '4312',
    longitude: '109.80943628984',
    latitude: '27.87193016295'
  },
  431227:
  {
    name: '新晃侗族自治县',
    parseid: '4312',
    longitude: '109.18147151144',
    latitude: '27.358782968573'
  },
  431228:
  {
    name: '芷江侗族自治县',
    parseid: '4312',
    longitude: '109.6914022696',
    latitude: '27.449513277765'
  },
  431229:
  {
    name: '靖州苗族侗族自治县',
    parseid: '4312',
    longitude: '109.70245160703',
    latitude: '26.581321351066'
  },
  431230:
  {
    name: '通道侗族自治县',
    parseid: '4312',
    longitude: '109.79044548256',
    latitude: '26.164219864712'
  },
  431271:
  {
    name: '怀化市洪江管理区',
    parseid: '4312',
    longitude: '109.8435098263',
    latitude: '27.215077093932'
  },
  431281:
  {
    name: '洪江市',
    parseid: '4312',
    longitude: '109.8435098263',
    latitude: '27.215077093932'
  },
  431302:
  {
    name: '娄星区',
    parseid: '4313',
    longitude: '112.00855842504',
    latitude: '27.735604842109'
  },
  431321:
  {
    name: '双峰县',
    parseid: '4313',
    longitude: '112.18146049666',
    latitude: '27.462982658573'
  },
  431322:
  {
    name: '新化县',
    parseid: '4313',
    longitude: '111.334515335',
    latitude: '27.732666751066'
  },
  431381:
  {
    name: '冷水江市',
    parseid: '4313',
    longitude: '111.44153972291',
    latitude: '27.692058848958'
  },
  431382:
  {
    name: '涟源市',
    parseid: '4313',
    longitude: '111.67056199396',
    latitude: '27.698167532255'
  },
  433101:
  {
    name: '吉首市',
    parseid: '4331',
    longitude: '109.70444880967',
    latitude: '28.267493127593'
  },
  433122:
  {
    name: '泸溪县',
    parseid: '4331',
    longitude: '110.22659921769',
    latitude: '28.221873097569'
  },
  433123:
  {
    name: '凤凰县',
    parseid: '4331',
    longitude: '109.6055266883',
    latitude: '27.953847809726'
  },
  433124:
  {
    name: '花垣县',
    parseid: '4331',
    longitude: '109.48856183128',
    latitude: '28.577909934397'
  },
  433125:
  {
    name: '保靖县',
    parseid: '4331',
    longitude: '109.66647357306',
    latitude: '28.705968872486'
  },
  433126:
  {
    name: '古丈县',
    parseid: '4331',
    longitude: '109.95750740057',
    latitude: '28.623083527843'
  },
  433127:
  {
    name: '永顺县',
    parseid: '4331',
    longitude: '109.86358578665',
    latitude: '28.985774485682'
  },
  433130:
  {
    name: '龙山县',
    parseid: '4331',
    longitude: '109.45041573696',
    latitude: '29.464121765857'
  },
  433173:
  {
    name: '湖南永顺经济开发区',
    parseid: '4331',
    longitude: '109.86358578665',
    latitude: '28.985774485682'
  },
  440103:
  {
    name: '荔湾区',
    parseid: '4401',
    longitude: '113.25050226337',
    latitude: '23.131791134975'
  },
  440104:
  {
    name: '越秀区',
    parseid: '4401',
    longitude: '113.273426481',
    latitude: '23.135260120148'
  },
  440105:
  {
    name: '海珠区',
    parseid: '4401',
    longitude: '113.32353998097',
    latitude: '23.088981296648'
  },
  440106:
  {
    name: '天河区',
    parseid: '4401',
    longitude: '113.36850942428',
    latitude: '23.130357835105'
  },
  440111:
  {
    name: '白云区',
    parseid: '4401',
    longitude: '113.27943309062',
    latitude: '23.164316834456'
  },
  440112:
  {
    name: '黄埔区',
    parseid: '4401',
    longitude: '113.48707083969',
    latitude: '23.187491541425'
  },
  440113:
  {
    name: '番禺区',
    parseid: '4401',
    longitude: '113.39046958043',
    latitude: '22.943830731518'
  },
  440114:
  {
    name: '花都区',
    parseid: '4401',
    longitude: '113.22657580629',
    latitude: '23.411161504876'
  },
  440115:
  {
    name: '南沙区',
    parseid: '4401',
    longitude: '113.53143554372',
    latitude: '22.807929296528'
  },
  440117:
  {
    name: '从化区',
    parseid: '4401',
    longitude: '113.59358543922',
    latitude: '23.553985922578'
  },
  440118:
  {
    name: '增城区',
    parseid: '4401',
    longitude: '113.8175456689',
    latitude: '23.266592400631'
  },
  440203:
  {
    name: '武江区',
    parseid: '4402',
    longitude: '113.59455578884',
    latitude: '24.798486030733'
  },
  440204:
  {
    name: '浈江区',
    parseid: '4402',
    longitude: '113.61747740137',
    latitude: '24.810413749784'
  },
  440205:
  {
    name: '曲江区',
    parseid: '4402',
    longitude: '113.61150106465',
    latitude: '24.68840784638'
  },
  440222:
  {
    name: '始兴县',
    parseid: '4402',
    longitude: '114.06856735205',
    latitude: '24.958558154346'
  },
  440224:
  {
    name: '仁化县',
    parseid: '4402',
    longitude: '113.75544293443',
    latitude: '25.092287524428'
  },
  440229:
  {
    name: '翁源县',
    parseid: '4402',
    longitude: '114.13642723669',
    latitude: '24.356594490867'
  },
  440232:
  {
    name: '乳源瑶族自治县',
    parseid: '4402',
    longitude: '113.28243136492',
    latitude: '24.782333322942'
  },
  440233:
  {
    name: '新丰县',
    parseid: '4402',
    longitude: '114.21351173078',
    latitude: '24.065546505164'
  },
  440281:
  {
    name: '乐昌市',
    parseid: '4402',
    longitude: '113.3545786821',
    latitude: '25.135591561195'
  },
  440282:
  {
    name: '南雄市',
    parseid: '4402',
    longitude: '114.31857889065',
    latitude: '25.123526537362'
  },
  440303:
  {
    name: '罗湖区',
    parseid: '4403',
    longitude: '114.13743190157',
    latitude: '22.554484875856'
  },
  440304:
  {
    name: '福田区',
    parseid: '4403',
    longitude: '114.06154700466',
    latitude: '22.528465912072'
  },
  440305:
  {
    name: '南山区',
    parseid: '4403',
    longitude: '113.93653916925',
    latitude: '22.538500195784'
  },
  440306:
  {
    name: '宝安区',
    parseid: '4403',
    longitude: '113.89042744066',
    latitude: '22.560032908925'
  },
  440307:
  {
    name: '龙岗区',
    parseid: '4403',
    longitude: '114.25445487896',
    latitude: '22.726016550781'
  },
  440308:
  {
    name: '盐田区',
    parseid: '4403',
    longitude: '114.2434301551',
    latitude: '22.563437914836'
  },
  440309:
  {
    name: '龙华区',
    parseid: '4403',
    longitude: '114.04852876121',
    latitude: '22.757596649222'
  },
  440310:
  {
    name: '坪山区',
    parseid: '4403',
    longitude: '114.35047403625',
    latitude: '22.716233464749'
  },
  440311:
  {
    name: '光明区',
    parseid: '4403',
    longitude: '113.94256006193',
    latitude: '22.754465883635'
  },
  440402:
  {
    name: '香洲区',
    parseid: '4404',
    longitude: '113.55047243408',
    latitude: '22.273003861799'
  },
  440403:
  {
    name: '斗门区',
    parseid: '4404',
    longitude: '113.30346725453',
    latitude: '22.215515662229'
  },
  440404:
  {
    name: '金湾区',
    parseid: '4404',
    longitude: '113.36951705357',
    latitude: '22.152576780675'
  },
  440507:
  {
    name: '龙湖区',
    parseid: '4405',
    longitude: '116.72352464693',
    latitude: '23.377775780628'
  },
  440511:
  {
    name: '金平区',
    parseid: '4405',
    longitude: '116.70955006744',
    latitude: '23.371750385773'
  },
  440512:
  {
    name: '濠江区',
    parseid: '4405',
    longitude: '116.73351658895',
    latitude: '23.291546359757'
  },
  440513:
  {
    name: '潮阳区',
    parseid: '4405',
    longitude: '116.6085145027',
    latitude: '23.270854956943'
  },
  440514:
  {
    name: '潮南区',
    parseid: '4405',
    longitude: '116.43949131427',
    latitude: '23.256341432673'
  },
  440515:
  {
    name: '澄海区',
    parseid: '4405',
    longitude: '116.76242504839',
    latitude: '23.472341401523'
  },
  440523:
  {
    name: '南澳县',
    parseid: '4405',
    longitude: '117.03049603113',
    latitude: '23.427812045946'
  },
  440604:
  {
    name: '禅城区',
    parseid: '4406',
    longitude: '113.12950518241',
    latitude: '23.015374368816'
  },
  440605:
  {
    name: '南海区',
    parseid: '4406',
    longitude: '113.14944567828',
    latitude: '23.035011446003'
  },
  440606:
  {
    name: '顺德区',
    parseid: '4406',
    longitude: '113.30045343954',
    latitude: '22.810453426795'
  },
  440607:
  {
    name: '三水区',
    parseid: '4406',
    longitude: '112.90347085515',
    latitude: '23.161920493984'
  },
  440608:
  {
    name: '高明区',
    parseid: '4406',
    longitude: '112.89947240749',
    latitude: '22.90634960163'
  },
  440703:
  {
    name: '蓬江区',
    parseid: '4407',
    longitude: '113.08454642894',
    latitude: '22.601065786023'
  },
  440704:
  {
    name: '江海区',
    parseid: '4407',
    longitude: '113.11755718015',
    latitude: '22.566115451824'
  },
  440705:
  {
    name: '新会区',
    parseid: '4407',
    longitude: '113.03845482239',
    latitude: '22.46511306052'
  },
  440781:
  {
    name: '台山市',
    parseid: '4407',
    longitude: '112.80044482505',
    latitude: '22.257923470251'
  },
  440783:
  {
    name: '开平市',
    parseid: '4407',
    longitude: '112.70446429491',
    latitude: '22.382499490201'
  },
  440784:
  {
    name: '鹤山市',
    parseid: '4407',
    longitude: '112.97052666653',
    latitude: '22.771169431377'
  },
  440785:
  {
    name: '恩平市',
    parseid: '4407',
    longitude: '112.31143757848',
    latitude: '22.189035201534'
  },
  440802:
  {
    name: '赤坎区',
    parseid: '4408',
    longitude: '110.37253254096',
    latitude: '21.272134812703'
  },
  440803:
  {
    name: '霞山区',
    parseid: '4408',
    longitude: '110.40442535096',
    latitude: '21.198227185303'
  },
  440804:
  {
    name: '坡头区',
    parseid: '4408',
    longitude: '110.46256709711',
    latitude: '21.250376738599'
  },
  440811:
  {
    name: '麻章区',
    parseid: '4408',
    longitude: '110.34057918516',
    latitude: '21.269188766567'
  },
  440823:
  {
    name: '遂溪县',
    parseid: '4408',
    longitude: '110.25651530642',
    latitude: '21.383102962029'
  },
  440825:
  {
    name: '徐闻县',
    parseid: '4408',
    longitude: '110.18247274427',
    latitude: '20.331723686702'
  },
  440881:
  {
    name: '廉江市',
    parseid: '4408',
    longitude: '110.29244770646',
    latitude: '21.615816495305'
  },
  440882:
  {
    name: '雷州市',
    parseid: '4408',
    longitude: '110.10258050648',
    latitude: '20.919880592716'
  },
  440883:
  {
    name: '吴川市',
    parseid: '4408',
    longitude: '110.78645034015',
    latitude: '21.447262768557'
  },
  440902:
  {
    name: '茂南区',
    parseid: '4409',
    longitude: '110.92554576188',
    latitude: '21.647152082304'
  },
  440904:
  {
    name: '电白区',
    parseid: '4409',
    longitude: '111.02047123221',
    latitude: '21.520351188198'
  },
  440981:
  {
    name: '高州市',
    parseid: '4409',
    longitude: '110.85947386452',
    latitude: '21.924048896771'
  },
  440982:
  {
    name: '化州市',
    parseid: '4409',
    longitude: '110.6464310112',
    latitude: '21.67023109387'
  },
  440983:
  {
    name: '信宜市',
    parseid: '4409',
    longitude: '110.95358169717',
    latitude: '22.36009314173'
  },
  441202:
  {
    name: '端州区',
    parseid: '4412',
    longitude: '112.49156022979',
    latitude: '23.057563726176'
  },
  441203:
  {
    name: '鼎湖区',
    parseid: '4412',
    longitude: '112.57443448255',
    latitude: '23.164308112716'
  },
  441204:
  {
    name: '高要区',
    parseid: '4412',
    longitude: '112.46444604577',
    latitude: '23.031895546866'
  },
  441223:
  {
    name: '广宁县',
    parseid: '4412',
    longitude: '112.44742387501',
    latitude: '23.641035726333'
  },
  441224:
  {
    name: '怀集县',
    parseid: '4412',
    longitude: '112.19146878783',
    latitude: '23.917842129185'
  },
  441225:
  {
    name: '封开县',
    parseid: '4412',
    longitude: '111.51852585255',
    latitude: '23.429768921261'
  },
  441226:
  {
    name: '德庆县',
    parseid: '4412',
    longitude: '111.79155377493',
    latitude: '23.15137330611'
  },
  441284:
  {
    name: '四会市',
    parseid: '4412',
    longitude: '112.7405791408',
    latitude: '23.332381005175'
  },
  441302:
  {
    name: '惠城区',
    parseid: '4413',
    longitude: '114.38949004962',
    latitude: '23.089725972544'
  },
  441303:
  {
    name: '惠阳区',
    parseid: '4413',
    longitude: '114.46346443037',
    latitude: '22.794720878571'
  },
  441322:
  {
    name: '博罗县',
    parseid: '4413',
    longitude: '114.29657265143',
    latitude: '23.178805592433'
  },
  441323:
  {
    name: '惠东县',
    parseid: '4413',
    longitude: '114.72642585138',
    latitude: '22.991443112002'
  },
  441324:
  {
    name: '龙门县',
    parseid: '4413',
    longitude: '114.26143022124',
    latitude: '23.733838340062'
  },
  441402:
  {
    name: '梅江区',
    parseid: '4414',
    longitude: '116.12353597667',
    latitude: '24.315878769038'
  },
  441403:
  {
    name: '梅县区',
    parseid: '4414',
    longitude: '116.08856170928',
    latitude: '24.270999314695'
  },
  441422:
  {
    name: '大埔县',
    parseid: '4414',
    longitude: '116.70155892129',
    latitude: '24.353459468582'
  },
  441423:
  {
    name: '丰顺县',
    parseid: '4414',
    longitude: '116.18845382094',
    latitude: '23.745738303255'
  },
  441424:
  {
    name: '五华县',
    parseid: '4414',
    longitude: '115.78248548653',
    latitude: '23.938408899571'
  },
  441426:
  {
    name: '平远县',
    parseid: '4414',
    longitude: '115.89747694601',
    latitude: '24.572414126137'
  },
  441427:
  {
    name: '蕉岭县',
    parseid: '4414',
    longitude: '116.17743924793',
    latitude: '24.664992548662'
  },
  441481:
  {
    name: '兴宁市',
    parseid: '4414',
    longitude: '115.73757946359',
    latitude: '24.142293779322'
  },
  441502:
  {
    name: '城区',
    parseid: '4415',
    longitude: '115.37153074806',
    latitude: '22.784551839489'
  },
  441521:
  {
    name: '海丰县',
    parseid: '4415',
    longitude: '115.32944477561',
    latitude: '22.972744260966'
  },
  441523:
  {
    name: '陆河县',
    parseid: '4415',
    longitude: '115.66648271471',
    latitude: '23.30767707649'
  },
  441581:
  {
    name: '陆丰市',
    parseid: '4415',
    longitude: '115.65849031092',
    latitude: '22.923635773561'
  },
  441602:
  {
    name: '源城区',
    parseid: '4416',
    longitude: '114.70843899033',
    latitude: '23.740298338347'
  },
  441621:
  {
    name: '紫金县',
    parseid: '4416',
    longitude: '115.19044771834',
    latitude: '23.641430253189'
  },
  441622:
  {
    name: '龙川县',
    parseid: '4416',
    longitude: '115.26655548485',
    latitude: '24.105850721955'
  },
  441623:
  {
    name: '连平县',
    parseid: '4416',
    longitude: '114.49544419635',
    latitude: '24.375808067414'
  },
  441624:
  {
    name: '和平县',
    parseid: '4416',
    longitude: '114.9454488143',
    latitude: '24.448252767689'
  },
  441625:
  {
    name: '东源县',
    parseid: '4416',
    longitude: '114.7535083252',
    latitude: '23.794257873114'
  },
  441702:
  {
    name: '江城区',
    parseid: '4417',
    longitude: '111.96145451801',
    latitude: '21.868127886755'
  },
  441704:
  {
    name: '阳东区',
    parseid: '4417',
    longitude: '112.01857947215',
    latitude: '21.873996844319'
  },
  441721:
  {
    name: '阳西县',
    parseid: '4417',
    longitude: '111.62448107725',
    latitude: '21.758700627505'
  },
  441781:
  {
    name: '阳春市',
    parseid: '4417',
    longitude: '111.7975361303',
    latitude: '22.17601480732'
  },
  441802:
  {
    name: '清城区',
    parseid: '4418',
    longitude: '113.06947663537',
    latitude: '23.704022037925'
  },
  441803:
  {
    name: '清新区',
    parseid: '4418',
    longitude: '112.99155779512',
    latitude: '23.754270337093'
  },
  441821:
  {
    name: '佛冈县',
    parseid: '4418',
    longitude: '113.53844124873',
    latitude: '23.885475421111'
  },
  441823:
  {
    name: '阳山县',
    parseid: '4418',
    longitude: '112.64751954085',
    latitude: '24.47094363588'
  },
  441825:
  {
    name: '连山壮族瑶族自治县',
    parseid: '4418',
    longitude: '112.10042570409',
    latitude: '24.576845604093'
  },
  441826:
  {
    name: '连南瑶族自治县',
    parseid: '4418',
    longitude: '112.29351728187',
    latitude: '24.73154858148'
  },
  441881:
  {
    name: '英德市',
    parseid: '4418',
    longitude: '113.42144297474',
    latitude: '24.191939355217'
  },
  441882:
  {
    name: '连州市',
    parseid: '4418',
    longitude: '112.38357258887',
    latitude: '24.786466855047'
  },
  445102:
  {
    name: '湘桥区',
    parseid: '4451',
    longitude: '116.63446160819',
    latitude: '23.680686981566'
  },
  445103:
  {
    name: '潮安区',
    parseid: '4451',
    longitude: '116.68452606069',
    latitude: '23.468357129831'
  },
  445122:
  {
    name: '饶平县',
    parseid: '4451',
    longitude: '117.01044917588',
    latitude: '23.670347111195'
  },
  445202:
  {
    name: '榕城区',
    parseid: '4452',
    longitude: '116.37351589492',
    latitude: '23.530746417966'
  },
  445203:
  {
    name: '揭东区',
    parseid: '4452',
    longitude: '116.41845578398',
    latitude: '23.572485187047'
  },
  445222:
  {
    name: '揭西县',
    parseid: '4452',
    longitude: '115.84856088728',
    latitude: '23.437299708209'
  },
  445224:
  {
    name: '惠来县',
    parseid: '4452',
    longitude: '116.30144448456',
    latitude: '23.039645374525'
  },
  445281:
  {
    name: '普宁市',
    parseid: '4452',
    longitude: '116.17244898117',
    latitude: '23.30363452186'
  },
  445302:
  {
    name: '云城区',
    parseid: '4453',
    longitude: '112.05052923472',
    latitude: '22.933897802971'
  },
  445303:
  {
    name: '云安区',
    parseid: '4453',
    longitude: '112.00956308992',
    latitude: '23.076892611911'
  },
  445321:
  {
    name: '新兴县',
    parseid: '4453',
    longitude: '112.23149683219',
    latitude: '22.701890082606'
  },
  445322:
  {
    name: '郁南县',
    parseid: '4453',
    longitude: '111.54155382446',
    latitude: '23.240174042653'
  },
  445381:
  {
    name: '罗定市',
    parseid: '4453',
    longitude: '111.57648048166',
    latitude: '22.774296060763'
  },
  450102:
  {
    name: '兴宁区',
    parseid: '4501',
    longitude: '108.37544497422',
    latitude: '22.860290951255'
  },
  450103:
  {
    name: '青秀区',
    parseid: '4501',
    longitude: '108.50143861009',
    latitude: '22.792227439631'
  },
  450105:
  {
    name: '江南区',
    parseid: '4501',
    longitude: '108.27949435764',
    latitude: '22.787045753588'
  },
  450107:
  {
    name: '西乡塘区',
    parseid: '4501',
    longitude: '108.31957243762',
    latitude: '22.839651509339'
  },
  450108:
  {
    name: '良庆区',
    parseid: '4501',
    longitude: '108.32751579392',
    latitude: '22.76284928359'
  },
  450109:
  {
    name: '邕宁区',
    parseid: '4501',
    longitude: '108.49342024528',
    latitude: '22.76460044955'
  },
  450110:
  {
    name: '武鸣区',
    parseid: '4501',
    longitude: '108.28151653318',
    latitude: '23.164515606911'
  },
  450123:
  {
    name: '隆安县',
    parseid: '4501',
    longitude: '107.70257390338',
    latitude: '23.171585249828'
  },
  450124:
  {
    name: '马山县',
    parseid: '4501',
    longitude: '108.18356215633',
    latitude: '23.71387772536'
  },
  450125:
  {
    name: '上林县',
    parseid: '4501',
    longitude: '108.61145148078',
    latitude: '23.438518877663'
  },
  450126:
  {
    name: '宾阳县',
    parseid: '4501',
    longitude: '108.81650237947',
    latitude: '23.223700543767'
  },
  450127:
  {
    name: '横县',
    parseid: '4501',
    longitude: '109.2675678064',
    latitude: '22.685572608838'
  },
  450202:
  {
    name: '城中区',
    parseid: '4502',
    longitude: '109.4174821502',
    latitude: '24.321314069891'
  },
  450203:
  {
    name: '鱼峰区',
    parseid: '4502',
    longitude: '109.44941628225',
    latitude: '24.318521699515'
  },
  450204:
  {
    name: '柳南区',
    parseid: '4502',
    longitude: '109.39155193285',
    latitude: '24.341578870912'
  },
  450205:
  {
    name: '柳北区',
    parseid: '4502',
    longitude: '109.40853179342',
    latitude: '24.367867017648'
  },
  450206:
  {
    name: '柳江区',
    parseid: '4502',
    longitude: '109.33244423878',
    latitude: '24.26081496535'
  },
  450222:
  {
    name: '柳城县',
    parseid: '4502',
    longitude: '109.25156152934',
    latitude: '24.656370391486'
  },
  450223:
  {
    name: '鹿寨县',
    parseid: '4502',
    longitude: '109.75755447547',
    latitude: '24.478622266898'
  },
  450224:
  {
    name: '融安县',
    parseid: '4502',
    longitude: '109.40456325934',
    latitude: '25.230511447128'
  },
  450225:
  {
    name: '融水苗族自治县',
    parseid: '4502',
    longitude: '109.26256083115',
    latitude: '25.072076504109'
  },
  450226:
  {
    name: '三江侗族自治县',
    parseid: '4502',
    longitude: '109.61454747223',
    latitude: '25.788830387788'
  },
  450302:
  {
    name: '秀峰区',
    parseid: '4503',
    longitude: '110.27043670622',
    latitude: '25.27961848567'
  },
  450303:
  {
    name: '叠彩区',
    parseid: '4503',
    longitude: '110.30846314624',
    latitude: '25.320233274843'
  },
  450304:
  {
    name: '象山区',
    parseid: '4503',
    longitude: '110.28742267527',
    latitude: '25.267930010211'
  },
  450305:
  {
    name: '七星区',
    parseid: '4503',
    longitude: '110.32453805385',
    latitude: '25.2585670875'
  },
  450311:
  {
    name: '雁山区',
    parseid: '4503',
    longitude: '110.3154792716',
    latitude: '25.066213543917'
  },
  450312:
  {
    name: '临桂区',
    parseid: '4503',
    longitude: '110.21858669186',
    latitude: '25.244301999271'
  },
  450321:
  {
    name: '阳朔县',
    parseid: '4503',
    longitude: '110.50347503171',
    latitude: '24.784519191433'
  },
  450323:
  {
    name: '灵川县',
    parseid: '4503',
    longitude: '110.33253719492',
    latitude: '25.41554953076'
  },
  450324:
  {
    name: '全州县',
    parseid: '4503',
    longitude: '111.07956895508',
    latitude: '25.934343027361'
  },
  450325:
  {
    name: '兴安县',
    parseid: '4503',
    longitude: '110.67851632807',
    latitude: '25.617567220037'
  },
  450326:
  {
    name: '永福县',
    parseid: '4503',
    longitude: '109.989590831',
    latitude: '24.985577973084'
  },
  450327:
  {
    name: '灌阳县',
    parseid: '4503',
    longitude: '111.16755205093',
    latitude: '25.495120752051'
  },
  450328:
  {
    name: '龙胜各族自治县',
    parseid: '4503',
    longitude: '110.01749399674',
    latitude: '25.804116784254'
  },
  450329:
  {
    name: '资源县',
    parseid: '4503',
    longitude: '110.6584391101',
    latitude: '26.048569077338'
  },
  450330:
  {
    name: '平乐县',
    parseid: '4503',
    longitude: '110.64944626347',
    latitude: '24.63963212806'
  },
  450332:
  {
    name: '恭城瑶族自治县',
    parseid: '4503',
    longitude: '110.8345596307',
    latitude: '24.837194365911'
  },
  450381:
  {
    name: '荔浦市',
    parseid: '4503',
    longitude: '110.40143677836',
    latitude: '24.494121641923'
  },
  450403:
  {
    name: '万秀区',
    parseid: '4504',
    longitude: '111.32751969101',
    latitude: '23.478845767296'
  },
  450405:
  {
    name: '长洲区',
    parseid: '4504',
    longitude: '111.28149914043',
    latitude: '23.491509584406'
  },
  450406:
  {
    name: '龙圩区',
    parseid: '4504',
    longitude: '111.25344829326',
    latitude: '23.421414485718'
  },
  450421:
  {
    name: '苍梧县',
    parseid: '4504',
    longitude: '111.55554663956',
    latitude: '23.845998205466'
  },
  450422:
  {
    name: '藤县',
    parseid: '4504',
    longitude: '110.92149925488',
    latitude: '23.38100991555'
  },
  450423:
  {
    name: '蒙山县',
    parseid: '4504',
    longitude: '110.53141700425',
    latitude: '24.200017445935'
  },
  450481:
  {
    name: '岑溪市',
    parseid: '4504',
    longitude: '111.00143182659',
    latitude: '22.92462127872'
  },
  450502:
  {
    name: '海城区',
    parseid: '4505',
    longitude: '109.12452136755',
    latitude: '21.481065838236'
  },
  450503:
  {
    name: '银海区',
    parseid: '4505',
    longitude: '109.14654476441',
    latitude: '21.454768668895'
  },
  450512:
  {
    name: '铁山港区',
    parseid: '4505',
    longitude: '109.42847264862',
    latitude: '21.53529504285'
  },
  450521:
  {
    name: '合浦县',
    parseid: '4505',
    longitude: '109.2134386113',
    latitude: '21.667005735642'
  },
  450602:
  {
    name: '港口区',
    parseid: '4506',
    longitude: '108.38648254385',
    latitude: '21.649565586624'
  },
  450603:
  {
    name: '防城区',
    parseid: '4506',
    longitude: '108.36044848238',
    latitude: '21.775411305197'
  },
  450621:
  {
    name: '上思县',
    parseid: '4506',
    longitude: '107.99044264125',
    latitude: '22.15991408311'
  },
  450681:
  {
    name: '东兴市',
    parseid: '4506',
    longitude: '107.97748898597',
    latitude: '21.55361543358'
  },
  450702:
  {
    name: '钦南区',
    parseid: '4507',
    longitude: '108.66454861267',
    latitude: '21.945972440989'
  },
  450703:
  {
    name: '钦北区',
    parseid: '4507',
    longitude: '108.63851257493',
    latitude: '22.020367050196'
  },
  450721:
  {
    name: '灵山县',
    parseid: '4507',
    longitude: '109.29747796631',
    latitude: '22.422413326701'
  },
  450722:
  {
    name: '浦北县',
    parseid: '4507',
    longitude: '109.5634229294',
    latitude: '22.277822326937'
  },
  450802:
  {
    name: '港北区',
    parseid: '4508',
    longitude: '109.57843298566',
    latitude: '23.117563632764'
  },
  450803:
  {
    name: '港南区',
    parseid: '4508',
    longitude: '109.6065534515',
    latitude: '23.08123957836'
  },
  450804:
  {
    name: '覃塘区',
    parseid: '4508',
    longitude: '109.45942672936',
    latitude: '23.133251089213'
  },
  450821:
  {
    name: '平南县',
    parseid: '4508',
    longitude: '110.39845197864',
    latitude: '23.545506098828'
  },
  450881:
  {
    name: '桂平市',
    parseid: '4508',
    longitude: '110.08552599672',
    latitude: '23.400048883699'
  },
  450902:
  {
    name: '玉州区',
    parseid: '4509',
    longitude: '110.15743140022',
    latitude: '22.634492736172'
  },
  450903:
  {
    name: '福绵区',
    parseid: '4509',
    longitude: '110.08853765577',
    latitude: '22.563705412249'
  },
  450921:
  {
    name: '容县',
    parseid: '4509',
    longitude: '110.56453016229',
    latitude: '22.863665599935'
  },
  450922:
  {
    name: '陆川县',
    parseid: '4509',
    longitude: '110.27045619945',
    latitude: '22.327221527769'
  },
  450923:
  {
    name: '博白县',
    parseid: '4509',
    longitude: '109.98255305648',
    latitude: '22.278674815493'
  },
  450924:
  {
    name: '兴业县',
    parseid: '4509',
    longitude: '109.88155180701',
    latitude: '22.742267653423'
  },
  450981:
  {
    name: '北流市',
    parseid: '4509',
    longitude: '110.36057016581',
    latitude: '22.713958021611'
  },
  451002:
  {
    name: '右江区',
    parseid: '4510',
    longitude: '106.62558913969',
    latitude: '23.907084503109'
  },
  451003:
  {
    name: '田阳区',
    parseid: '4510',
    longitude: '106.9214125525',
    latitude: '23.742005722478'
  },
  451022:
  {
    name: '田东县',
    parseid: '4510',
    longitude: '107.13249943541',
    latitude: '23.603129804015'
  },
  451023:
  {
    name: '平果县',
    parseid: '4510',
    longitude: '107.59657106849',
    latitude: '23.334922742592'
  },
  451024:
  {
    name: '德保县',
    parseid: '4510',
    longitude: '106.62158260728',
    latitude: '23.328994351286'
  },
  451026:
  {
    name: '那坡县',
    parseid: '4510',
    longitude: '105.83942261017',
    latitude: '23.393793831292'
  },
  451027:
  {
    name: '凌云县',
    parseid: '4510',
    longitude: '106.56841567705',
    latitude: '24.354015240604'
  },
  451028:
  {
    name: '乐业县',
    parseid: '4510',
    longitude: '106.56342972215',
    latitude: '24.783216467053'
  },
  451029:
  {
    name: '田林县',
    parseid: '4510',
    longitude: '106.23449791231',
    latitude: '24.300534611051'
  },
  451030:
  {
    name: '西林县',
    parseid: '4510',
    longitude: '105.10049410469',
    latitude: '24.495667790362'
  },
  451031:
  {
    name: '隆林各族自治县',
    parseid: '4510',
    longitude: '105.3504594704',
    latitude: '24.776813610296'
  },
  451081:
  {
    name: '靖西市',
    parseid: '4510',
    longitude: '106.42445269708',
    latitude: '23.140125669019'
  },
  451102:
  {
    name: '八步区',
    parseid: '4511',
    longitude: '111.55856737149',
    latitude: '24.417531040919'
  },
  451103:
  {
    name: '平桂区',
    parseid: '4511',
    longitude: '111.47841426578',
    latitude: '24.462001422773'
  },
  451121:
  {
    name: '昭平县',
    parseid: '4511',
    longitude: '110.81757491928',
    latitude: '24.175106050636'
  },
  451122:
  {
    name: '钟山县',
    parseid: '4511',
    longitude: '111.30958574015',
    latitude: '24.531673107939'
  },
  451123:
  {
    name: '富川瑶族自治县',
    parseid: '4511',
    longitude: '111.28451124863',
    latitude: '24.820159951323'
  },
  451202:
  {
    name: '金城江区',
    parseid: '4512',
    longitude: '108.04350707483',
    latitude: '24.695679382239'
  },
  451203:
  {
    name: '宜州区',
    parseid: '4512',
    longitude: '108.64353158748',
    latitude: '24.491084367739'
  },
  451221:
  {
    name: '南丹县',
    parseid: '4512',
    longitude: '107.54748028934',
    latitude: '24.981849775485'
  },
  451222:
  {
    name: '天峨县',
    parseid: '4512',
    longitude: '107.17845647579',
    latitude: '25.005664155232'
  },
  451223:
  {
    name: '凤山县',
    parseid: '4512',
    longitude: '107.04841983631',
    latitude: '24.553217796777'
  },
  451224:
  {
    name: '东兰县',
    parseid: '4512',
    longitude: '107.3805041595',
    latitude: '24.516871463381'
  },
  451225:
  {
    name: '罗城仫佬族自治县',
    parseid: '4512',
    longitude: '108.91157445325',
    latitude: '24.783084996429'
  },
  451226:
  {
    name: '环江毛南族自治县',
    parseid: '4512',
    longitude: '108.33833714141',
    latitude: '24.803718009116'
  },
  451227:
  {
    name: '巴马瑶族自治县',
    parseid: '4512',
    longitude: '107.26648125302',
    latitude: '24.14726480427'
  },
  451228:
  {
    name: '都安瑶族自治县',
    parseid: '4512',
    longitude: '108.11145804765',
    latitude: '23.937331261923'
  },
  451229:
  {
    name: '大化瑶族自治县',
    parseid: '4512',
    longitude: '108.00441075294',
    latitude: '23.742818222963'
  },
  451302:
  {
    name: '兴宾区',
    parseid: '4513',
    longitude: '109.24149907034',
    latitude: '23.733211038144'
  },
  451321:
  {
    name: '忻城县',
    parseid: '4513',
    longitude: '108.67256239612',
    latitude: '24.071888636576'
  },
  451322:
  {
    name: '象州县',
    parseid: '4513',
    longitude: '109.71146215028',
    latitude: '23.979680993271'
  },
  451323:
  {
    name: '武宣县',
    parseid: '4513',
    longitude: '109.66944220328',
    latitude: '23.600404197633'
  },
  451324:
  {
    name: '金秀瑶族自治县',
    parseid: '4513',
    longitude: '110.19550625891',
    latitude: '24.136319486486'
  },
  451381:
  {
    name: '合山市',
    parseid: '4513',
    longitude: '108.89256576969',
    latitude: '23.81226007105'
  },
  451402:
  {
    name: '江州区',
    parseid: '4514',
    longitude: '107.35953321738',
    latitude: '22.411245728018'
  },
  451421:
  {
    name: '扶绥县',
    parseid: '4514',
    longitude: '107.91046515426',
    latitude: '22.641097136345'
  },
  451422:
  {
    name: '宁明县',
    parseid: '4514',
    longitude: '107.08352381902',
    latitude: '22.145884844184'
  },
  451423:
  {
    name: '龙州县',
    parseid: '4514',
    longitude: '106.86058190847',
    latitude: '22.348298905766'
  },
  451424:
  {
    name: '大新县',
    parseid: '4514',
    longitude: '107.20755690312',
    latitude: '22.836229044406'
  },
  451425:
  {
    name: '天等县',
    parseid: '4514',
    longitude: '107.14947264852',
    latitude: '23.08750581209'
  },
  451481:
  {
    name: '凭祥市',
    parseid: '4514',
    longitude: '106.77352361814',
    latitude: '22.100152592954'
  },
  460105:
  {
    name: '秀英区',
    parseid: '4601',
    longitude: '110.30043588821',
    latitude: '20.013642385161'
  },
  460106:
  {
    name: '龙华区',
    parseid: '4601',
    longitude: '110.33554112854',
    latitude: '20.036320733521'
  },
  460107:
  {
    name: '琼山区',
    parseid: '4601',
    longitude: '110.36052605901',
    latitude: '20.009150644491'
  },
  460108:
  {
    name: '美兰区',
    parseid: '4601',
    longitude: '110.37349839904',
    latitude: '20.034646217625'
  },
  460202:
  {
    name: '海棠区',
    parseid: '4602',
    longitude: '109.71318002841',
    latitude: '18.348017835498'
  },
  460203:
  {
    name: '吉阳区',
    parseid: '4602',
    longitude: '109.60226380554',
    latitude: '18.298121377248'
  },
  460204:
  {
    name: '天涯区',
    parseid: '4602',
    longitude: '109.39862587224',
    latitude: '18.452443306203'
  },
  460205:
  {
    name: '崖州区',
    parseid: '4602',
    longitude: '109.15492207323',
    latitude: '18.394760392009'
  },
  460321:
  {
    name: '西沙群岛',
    parseid: '4603',
    longitude: '112.16056704237',
    latitude: '16.670664069294'
  },
  460322:
  {
    name: '南沙群岛',
    parseid: '4603',
    longitude: '114.39947592224',
    latitude: '8.7417645766477'
  },
  460323:
  {
    name: '中沙群岛的岛礁及其海域',
    parseid: '4603',
    longitude: '114.3604299104',
    latitude: '15.914359953954'
  },
  469001:
  {
    name: '五指山市',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469002:
  {
    name: '琼海市',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469005:
  {
    name: '文昌市',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469006:
  {
    name: '万宁市',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469007:
  {
    name: '东方市',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469021:
  {
    name: '定安县',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469022:
  {
    name: '屯昌县',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469023:
  {
    name: '澄迈县',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469024:
  {
    name: '临高县',
    parseid: '4690',
    longitude: '110.35553651088',
    latitude: '20.025801964463'
  },
  469025:
  {
    name: '白沙黎族自治县',
    parseid: '4690',
    longitude: '110.47147936573',
    latitude: '19.25423568946'
  },
  469026:
  {
    name: '昌江黎族自治县',
    parseid: '4690',
    longitude: '110.47147936573',
    latitude: '19.25423568946'
  },
  469027:
  {
    name: '乐东黎族自治县',
    parseid: '4690',
    longitude: '109.18118558079',
    latitude: '18.751742805146'
  },
  469028:
  {
    name: '陵水黎族自治县',
    parseid: '4690',
    longitude: '110.47147936573',
    latitude: '19.25423568946'
  },
  469029:
  {
    name: '保亭黎族苗族自治县',
    parseid: '4690',
    longitude: '110.47147936573',
    latitude: '19.25423568946'
  },
  469030:
  {
    name: '琼中黎族苗族自治县',
    parseid: '4690',
    longitude: '110.47147936573',
    latitude: '19.25423568946'
  },
  500101:
  {
    name: '万州区',
    parseid: '5001',
    longitude: '108.4155583705',
    latitude: '30.813621636708'
  },
  500102:
  {
    name: '涪陵区',
    parseid: '5001',
    longitude: '107.39641979754',
    latitude: '29.709278197979'
  },
  500103:
  {
    name: '渝中区',
    parseid: '5001',
    longitude: '106.57544006681',
    latitude: '29.559090182994'
  },
  500104:
  {
    name: '大渡口区',
    parseid: '5001',
    longitude: '106.48853359011',
    latitude: '29.490107128556'
  },
  500105:
  {
    name: '江北区',
    parseid: '5001',
    longitude: '106.58041506238',
    latitude: '29.61283231408'
  },
  500106:
  {
    name: '沙坪坝区',
    parseid: '5001',
    longitude: '106.46446511093',
    latitude: '29.547192516541'
  },
  500107:
  {
    name: '九龙坡区',
    parseid: '5001',
    longitude: '106.51755873943',
    latitude: '29.507927715553'
  },
  500108:
  {
    name: '南岸区',
    parseid: '5001',
    longitude: '106.6684297786',
    latitude: '29.502683098835'
  },
  500109:
  {
    name: '北碚区',
    parseid: '5001',
    longitude: '106.40228116965',
    latitude: '29.811156512939'
  },
  500110:
  {
    name: '綦江区',
    parseid: '5001',
    longitude: '106.37178962641',
    latitude: '29.226858419327'
  },
  500111:
  {
    name: '大足区',
    parseid: '5001',
    longitude: '106.29811321359',
    latitude: '29.222926941489'
  },
  500112:
  {
    name: '渝北区',
    parseid: '5001',
    longitude: '106.6375590606',
    latitude: '29.723927343007'
  },
  500113:
  {
    name: '巴南区',
    parseid: '5001',
    longitude: '106.54745425696',
    latitude: '29.40847473977'
  },
  500114:
  {
    name: '黔江区',
    parseid: '5001',
    longitude: '108.77759119835',
    latitude: '29.53881256766'
  },
  500115:
  {
    name: '长寿区',
    parseid: '5001',
    longitude: '107.08753107007',
    latitude: '29.863520067323'
  },
  500116:
  {
    name: '江津区',
    parseid: '5001',
    longitude: '106.26559760838',
    latitude: '29.295884374465'
  },
  500117:
  {
    name: '合川区',
    parseid: '5001',
    longitude: '106.28254108758',
    latitude: '29.978181239534'
  },
  500118:
  {
    name: '永川区',
    parseid: '5001',
    longitude: '106.55843415538',
    latitude: '29.568996245339'
  },
  500119:
  {
    name: '南川区',
    parseid: '5001',
    longitude: '107.10558512437',
    latitude: '29.163478599606'
  },
  500120:
  {
    name: '璧山区',
    parseid: '5001',
    longitude: '106.2421777956',
    latitude: '29.573041606733'
  },
  500151:
  {
    name: '铜梁区',
    parseid: '5001',
    longitude: '106.08307441526',
    latitude: '29.855981139651'
  },
  500152:
  {
    name: '潼南区',
    parseid: '5001',
    longitude: '105.84739903617',
    latitude: '30.197314239664'
  },
  500153:
  {
    name: '荣昌区',
    parseid: '5001',
    longitude: '105.60141979928',
    latitude: '29.41130739669'
  },
  500154:
  {
    name: '开州区',
    parseid: '5001',
    longitude: '108.4026808017',
    latitude: '31.172291036091'
  },
  500155:
  {
    name: '梁平区',
    parseid: '5001',
    longitude: '107.77609725763',
    latitude: '30.660553255023'
  },
  500156:
  {
    name: '武隆区',
    parseid: '5001',
    longitude: '107.76616602838',
    latitude: '29.330887084681'
  },
  500229:
  {
    name: '城口县',
    parseid: '5002',
    longitude: '108.67161164256',
    latitude: '31.953390746293'
  },
  500230:
  {
    name: '丰都县',
    parseid: '5002',
    longitude: '107.7374806182',
    latitude: '29.869412789214'
  },
  500231:
  {
    name: '垫江县',
    parseid: '5002',
    longitude: '107.33956587472',
    latitude: '30.3332939685'
  },
  500233:
  {
    name: '忠县',
    parseid: '5002',
    longitude: '108.04453753386',
    latitude: '30.305268389357'
  },
  500235:
  {
    name: '云阳县',
    parseid: '5002',
    longitude: '108.7034475',
    latitude: '30.936611271975'
  },
  500236:
  {
    name: '奉节县',
    parseid: '5002',
    longitude: '109.47047275631',
    latitude: '31.024601766549'
  },
  500237:
  {
    name: '巫山县',
    parseid: '5002',
    longitude: '109.88554550703',
    latitude: '31.080518811736'
  },
  500238:
  {
    name: '巫溪县',
    parseid: '5002',
    longitude: '109.576402559',
    latitude: '31.404880009858'
  },
  500240:
  {
    name: '石柱土家族自治县',
    parseid: '5002',
    longitude: '108.12041416638',
    latitude: '30.006108697869'
  },
  500241:
  {
    name: '秀山土家族苗族自治县',
    parseid: '5002',
    longitude: '108.76071221748',
    latitude: '29.651802622442'
  },
  500242:
  {
    name: '酉阳土家族苗族自治县',
    parseid: '5002',
    longitude: '108.76071221748',
    latitude: '29.651802622442'
  },
  500243:
  {
    name: '彭水苗族土家族自治县',
    parseid: '5002',
    longitude: '108.17257803588',
    latitude: '29.299462290443'
  },
  510104:
  {
    name: '锦江区',
    parseid: '5101',
    longitude: '104.0895617566',
    latitude: '30.661904490317'
  },
  510105:
  {
    name: '青羊区',
    parseid: '5101',
    longitude: '104.06744547494',
    latitude: '30.680037807007'
  },
  510106:
  {
    name: '金牛区',
    parseid: '5101',
    longitude: '104.05740358714',
    latitude: '30.697356042874'
  },
  510107:
  {
    name: '武侯区',
    parseid: '5101',
    longitude: '104.04942447828',
    latitude: '30.648712685321'
  },
  510108:
  {
    name: '成华区',
    parseid: '5101',
    longitude: '104.10859155035',
    latitude: '30.665589283983'
  },
  510112:
  {
    name: '龙泉驿区',
    parseid: '5101',
    longitude: '104.28139696436',
    latitude: '30.562697841'
  },
  510113:
  {
    name: '青白江区',
    parseid: '5101',
    longitude: '104.25751245813',
    latitude: '30.884421372736'
  },
  510114:
  {
    name: '新都区',
    parseid: '5101',
    longitude: '104.16539284504',
    latitude: '30.829407468191'
  },
  510115:
  {
    name: '温江区',
    parseid: '5101',
    longitude: '103.86357306318',
    latitude: '30.688486836627'
  },
  510116:
  {
    name: '双流区',
    parseid: '5101',
    longitude: '103.93039154227',
    latitude: '30.580399352821'
  },
  510117:
  {
    name: '郫都区',
    parseid: '5101',
    longitude: '103.90544568809',
    latitude: '30.799537653573'
  },
  510121:
  {
    name: '金堂县',
    parseid: '5101',
    longitude: '104.41844263262',
    latitude: '30.868358423946'
  },
  510129:
  {
    name: '大邑县',
    parseid: '5101',
    longitude: '103.52752981767',
    latitude: '30.593155402402'
  },
  510131:
  {
    name: '蒲江县',
    parseid: '5101',
    longitude: '103.51257132415',
    latitude: '30.202500428139'
  },
  510132:
  {
    name: '新津县',
    parseid: '5101',
    longitude: '103.81743303795',
    latitude: '30.416363953297'
  },
  510181:
  {
    name: '都江堰市',
    parseid: '5101',
    longitude: '103.65353360443',
    latitude: '30.994256893542'
  },
  510182:
  {
    name: '彭州市',
    parseid: '5101',
    longitude: '103.96556137078',
    latitude: '30.995564002629'
  },
  510183:
  {
    name: '邛崃市',
    parseid: '5101',
    longitude: '103.47048112964',
    latitude: '30.416398600854'
  },
  510184:
  {
    name: '崇州市',
    parseid: '5101',
    longitude: '103.67943336923',
    latitude: '30.636595891379'
  },
  510185:
  {
    name: '简阳市',
    parseid: '5101',
    longitude: '104.55349406265',
    latitude: '30.417451491353'
  },
  510302:
  {
    name: '自流井区',
    parseid: '5103',
    longitude: '104.7834473259',
    latitude: '29.343498562348'
  },
  510303:
  {
    name: '贡井区',
    parseid: '5103',
    longitude: '104.72155659154',
    latitude: '29.351476269522'
  },
  510304:
  {
    name: '大安区',
    parseid: '5103',
    longitude: '104.78041635328',
    latitude: '29.369928541322'
  },
  510311:
  {
    name: '沿滩区',
    parseid: '5103',
    longitude: '104.88040907516',
    latitude: '29.278797205251'
  },
  510321:
  {
    name: '荣县',
    parseid: '5103',
    longitude: '104.42387467446',
    latitude: '29.450986724012'
  },
  510322:
  {
    name: '富顺县',
    parseid: '5103',
    longitude: '104.98149440603',
    latitude: '29.186886257831'
  },
  510402:
  {
    name: '东区',
    parseid: '5104',
    longitude: '101.72554117091',
    latitude: '26.588033173333'
  },
  510403:
  {
    name: '西区',
    parseid: '5104',
    longitude: '101.72554117091',
    latitude: '26.588033173333'
  },
  510411:
  {
    name: '仁和区',
    parseid: '5104',
    longitude: '101.74444996291',
    latitude: '26.504019493295'
  },
  510421:
  {
    name: '米易县',
    parseid: '5104',
    longitude: '102.1164404304',
    latitude: '26.89696797612'
  },
  510422:
  {
    name: '盐边县',
    parseid: '5104',
    longitude: '101.86049854831',
    latitude: '26.688767481964'
  },
  510502:
  {
    name: '江阳区',
    parseid: '5105',
    longitude: '105.44157316095',
    latitude: '28.884498343782'
  },
  510503:
  {
    name: '纳溪区',
    parseid: '5105',
    longitude: '105.37800502071',
    latitude: '28.779001444761'
  },
  510504:
  {
    name: '龙马潭区',
    parseid: '5105',
    longitude: '105.44459416238',
    latitude: '28.919083963368'
  },
  510521:
  {
    name: '泸县',
    parseid: '5105',
    longitude: '105.38830966288',
    latitude: '29.157827612737'
  },
  510522:
  {
    name: '合江县',
    parseid: '5105',
    longitude: '105.8373682753',
    latitude: '28.81800642227'
  },
  510524:
  {
    name: '叙永县',
    parseid: '5105',
    longitude: '105.45117496889',
    latitude: '28.161785996116'
  },
  510525:
  {
    name: '古蔺县',
    parseid: '5105',
    longitude: '105.81914219549',
    latitude: '28.044757961923'
  },
  510603:
  {
    name: '旌阳区',
    parseid: '5106',
    longitude: '104.42343882821',
    latitude: '31.148596291553'
  },
  510604:
  {
    name: '罗江区',
    parseid: '5106',
    longitude: '104.51741416083',
    latitude: '31.324178639826'
  },
  510623:
  {
    name: '中江县',
    parseid: '5106',
    longitude: '104.68553015058',
    latitude: '31.038953695302'
  },
  510681:
  {
    name: '广汉市',
    parseid: '5106',
    longitude: '104.28842189311',
    latitude: '30.982415239743'
  },
  510682:
  {
    name: '什邡市',
    parseid: '5106',
    longitude: '104.17442710355',
    latitude: '31.132889048238'
  },
  510683:
  {
    name: '绵竹市',
    parseid: '5106',
    longitude: '104.227609305',
    latitude: '31.343592258211'
  },
  510703:
  {
    name: '涪城区',
    parseid: '5107',
    longitude: '104.76342033491',
    latitude: '31.46131438858'
  },
  510704:
  {
    name: '游仙区',
    parseid: '5107',
    longitude: '104.77242899171',
    latitude: '31.479904474058'
  },
  510705:
  {
    name: '安州区',
    parseid: '5107',
    longitude: '104.5735550213',
    latitude: '31.540750527876'
  },
  510722:
  {
    name: '三台县',
    parseid: '5107',
    longitude: '105.10148979833',
    latitude: '31.101585571238'
  },
  510723:
  {
    name: '盐亭县',
    parseid: '5107',
    longitude: '105.39550321547',
    latitude: '31.214318764837'
  },
  510725:
  {
    name: '梓潼县',
    parseid: '5107',
    longitude: '105.17756684281',
    latitude: '31.648313467681'
  },
  510726:
  {
    name: '北川羌族自治县',
    parseid: '5107',
    longitude: '104.36158555316',
    latitude: '31.963084103415'
  },
  510727:
  {
    name: '平武县',
    parseid: '5107',
    longitude: '104.53542150325',
    latitude: '32.414681977696'
  },
  510781:
  {
    name: '江油市',
    parseid: '5107',
    longitude: '104.75241160088',
    latitude: '31.784128193388'
  },
  510802:
  {
    name: '利州区',
    parseid: '5108',
    longitude: '105.85242622329',
    latitude: '32.440207812726'
  },
  510811:
  {
    name: '昭化区',
    parseid: '5108',
    longitude: '105.96941892782',
    latitude: '32.329618490159'
  },
  510812:
  {
    name: '朝天区',
    parseid: '5108',
    longitude: '105.8965888086',
    latitude: '32.649726240308'
  },
  510821:
  {
    name: '旺苍县',
    parseid: '5108',
    longitude: '106.29649124536',
    latitude: '32.235097383079'
  },
  510822:
  {
    name: '青川县',
    parseid: '5108',
    longitude: '105.24540705459',
    latitude: '32.5816168573'
  },
  510823:
  {
    name: '剑阁县',
    parseid: '5108',
    longitude: '105.53157601887',
    latitude: '32.293478516773'
  },
  510824:
  {
    name: '苍溪县',
    parseid: '5108',
    longitude: '105.9414826146',
    latitude: '31.738684400617'
  },
  510903:
  {
    name: '船山区',
    parseid: '5109',
    longitude: '105.5745228375',
    latitude: '30.531470607829'
  },
  510904:
  {
    name: '安居区',
    parseid: '5109',
    longitude: '105.46246730988',
    latitude: '30.361496469746'
  },
  510921:
  {
    name: '蓬溪县',
    parseid: '5109',
    longitude: '105.71344605411',
    latitude: '30.763751441791'
  },
  510923:
  {
    name: '大英县',
    parseid: '5109',
    longitude: '105.24340392313',
    latitude: '30.600810129921'
  },
  510981:
  {
    name: '射洪市',
    parseid: '5109',
    longitude: '105.39450950992',
    latitude: '30.877138522337'
  },
  511002:
  {
    name: '市中区',
    parseid: '5110',
    longitude: '105.07457421786',
    latitude: '29.592710148736'
  },
  511011:
  {
    name: '东兴区',
    parseid: '5110',
    longitude: '105.08254748773',
    latitude: '29.598485728583'
  },
  511024:
  {
    name: '威远县',
    parseid: '5110',
    longitude: '104.6744982286',
    latitude: '29.533634931412'
  },
  511025:
  {
    name: '资中县',
    parseid: '5110',
    longitude: '104.85849482242',
    latitude: '29.770234032565'
  },
  511071:
  {
    name: '内江经济开发区',
    parseid: '5110',
    longitude: '105.0163659971',
    latitude: '29.584305903645'
  },
  511083:
  {
    name: '隆昌市',
    parseid: '5110',
    longitude: '105.29429094213',
    latitude: '29.345238365347'
  },
  511102:
  {
    name: '市中区',
    parseid: '5111',
    longitude: '103.76755865552',
    latitude: '29.561363941633'
  },
  511111:
  {
    name: '沙湾区',
    parseid: '5111',
    longitude: '103.55643566073',
    latitude: '29.419272499245'
  },
  511112:
  {
    name: '五通桥区',
    parseid: '5111',
    longitude: '103.82445508074',
    latitude: '29.413185014439'
  },
  511113:
  {
    name: '金口河区',
    parseid: '5111',
    longitude: '103.08539389554',
    latitude: '29.250803570124'
  },
  511123:
  {
    name: '犍为县',
    parseid: '5111',
    longitude: '103.95550653595',
    latitude: '29.214219463759'
  },
  511124:
  {
    name: '井研县',
    parseid: '5111',
    longitude: '104.07651071353',
    latitude: '29.65730305908'
  },
  511126:
  {
    name: '夹江县',
    parseid: '5111',
    longitude: '103.57841009994',
    latitude: '29.743846302985'
  },
  511129:
  {
    name: '沐川县',
    parseid: '5111',
    longitude: '103.90846703743',
    latitude: '28.962888278216'
  },
  511132:
  {
    name: '峨边彝族自治县',
    parseid: '5111',
    longitude: '103.26857725338',
    latitude: '29.236089109563'
  },
  511133:
  {
    name: '马边彝族自治县',
    parseid: '5111',
    longitude: '103.55245419105',
    latitude: '28.841736014812'
  },
  511181:
  {
    name: '峨眉山市',
    parseid: '5111',
    longitude: '103.4915455741',
    latitude: '29.606975527462'
  },
  511302:
  {
    name: '顺庆区',
    parseid: '5113',
    longitude: '106.09841065838',
    latitude: '30.802753098595'
  },
  511303:
  {
    name: '高坪区',
    parseid: '5113',
    longitude: '106.12554047291',
    latitude: '30.787254931592'
  },
  511304:
  {
    name: '嘉陵区',
    parseid: '5113',
    longitude: '106.07843297265',
    latitude: '30.764895560139'
  },
  511321:
  {
    name: '南部县',
    parseid: '5113',
    longitude: '106.04357826971',
    latitude: '31.353705301526'
  },
  511322:
  {
    name: '营山县',
    parseid: '5113',
    longitude: '106.57240802852',
    latitude: '31.083002970199'
  },
  511323:
  {
    name: '蓬安县',
    parseid: '5113',
    longitude: '106.41848194209',
    latitude: '31.034630778271'
  },
  511324:
  {
    name: '仪陇县',
    parseid: '5113',
    longitude: '106.30943016844',
    latitude: '31.277597359981'
  },
  511325:
  {
    name: '西充县',
    parseid: '5113',
    longitude: '105.90761137653',
    latitude: '31.000688020792'
  },
  511381:
  {
    name: '阆中市',
    parseid: '5113',
    longitude: '106.01156526642',
    latitude: '31.56407455364'
  },
  511402:
  {
    name: '东坡区',
    parseid: '5114',
    longitude: '103.83852480217',
    latitude: '30.048272134435'
  },
  511403:
  {
    name: '彭山区',
    parseid: '5114',
    longitude: '103.87955823007',
    latitude: '30.19885441686'
  },
  511421:
  {
    name: '仁寿县',
    parseid: '5114',
    longitude: '104.14047690443',
    latitude: '30.001663984301'
  },
  511423:
  {
    name: '洪雅县',
    parseid: '5114',
    longitude: '103.37960224488',
    latitude: '29.910615837469'
  },
  511424:
  {
    name: '丹棱县',
    parseid: '5114',
    longitude: '103.51958331729',
    latitude: '30.020362794872'
  },
  511425:
  {
    name: '青神县',
    parseid: '5114',
    longitude: '103.85355883179',
    latitude: '29.837054743717'
  },
  511502:
  {
    name: '翠屏区',
    parseid: '5115',
    longitude: '104.62643798553',
    latitude: '28.772051773027'
  },
  511503:
  {
    name: '南溪区',
    parseid: '5115',
    longitude: '104.97651330198',
    latitude: '28.851503648027'
  },
  511504:
  {
    name: '叙州区',
    parseid: '5115',
    longitude: '104.53944275624',
    latitude: '28.696246394752'
  },
  511523:
  {
    name: '江安县',
    parseid: '5115',
    longitude: '105.07359488519',
    latitude: '28.729609721855'
  },
  511524:
  {
    name: '长宁县',
    parseid: '5115',
    longitude: '104.92756445509',
    latitude: '28.588133452699'
  },
  511525:
  {
    name: '高县',
    parseid: '5115',
    longitude: '104.52441132032',
    latitude: '28.442510804102'
  },
  511526:
  {
    name: '珙县',
    parseid: '5115',
    longitude: '104.71557459549',
    latitude: '28.444319765248'
  },
  511527:
  {
    name: '筠连县',
    parseid: '5115',
    longitude: '104.51740642378',
    latitude: '28.170174457648'
  },
  511528:
  {
    name: '兴文县',
    parseid: '5115',
    longitude: '105.24240230064',
    latitude: '28.309904884117'
  },
  511529:
  {
    name: '屏山县',
    parseid: '5115',
    longitude: '104.35267533908',
    latitude: '28.834274966477'
  },
  511602:
  {
    name: '广安区',
    parseid: '5116',
    longitude: '106.64853115608',
    latitude: '30.479768100142'
  },
  511603:
  {
    name: '前锋区',
    parseid: '5116',
    longitude: '106.90447959588',
    latitude: '30.506435157767'
  },
  511621:
  {
    name: '岳池县',
    parseid: '5116',
    longitude: '106.44641061972',
    latitude: '30.54411986458'
  },
  511622:
  {
    name: '武胜县',
    parseid: '5116',
    longitude: '106.3024617431',
    latitude: '30.355495660378'
  },
  511623:
  {
    name: '邻水县',
    parseid: '5116',
    longitude: '106.93640258896',
    latitude: '30.341072518332'
  },
  511681:
  {
    name: '华蓥市',
    parseid: '5116',
    longitude: '106.78946181601',
    latitude: '30.396307084289'
  },
  511702:
  {
    name: '通川区',
    parseid: '5117',
    longitude: '107.51144711201',
    latitude: '31.220931804105'
  },
  511703:
  {
    name: '达川区',
    parseid: '5117',
    longitude: '107.51841059667',
    latitude: '31.202393360554'
  },
  511722:
  {
    name: '宣汉县',
    parseid: '5117',
    longitude: '107.7335335663',
    latitude: '31.359754823662'
  },
  511723:
  {
    name: '开江县',
    parseid: '5117',
    longitude: '107.87542487414',
    latitude: '31.089372149066'
  },
  511724:
  {
    name: '大竹县',
    parseid: '5117',
    longitude: '107.21157970735',
    latitude: '30.74207661791'
  },
  511725:
  {
    name: '渠县',
    parseid: '5117',
    longitude: '106.97958296702',
    latitude: '30.842299283481'
  },
  511771:
  {
    name: '达州经济开发区',
    parseid: '5117',
    longitude: '107.50112333594',
    latitude: '31.142289539958'
  },
  511781:
  {
    name: '万源市',
    parseid: '5117',
    longitude: '108.04154069684',
    latitude: '32.087420847789'
  },
  511802:
  {
    name: '雨城区',
    parseid: '5118',
    longitude: '103.03957520533',
    latitude: '30.011061644393'
  },
  511803:
  {
    name: '名山区',
    parseid: '5118',
    longitude: '103.1154857938',
    latitude: '30.075913663382'
  },
  511822:
  {
    name: '荥经县',
    parseid: '5118',
    longitude: '102.85343551293',
    latitude: '29.799193512656'
  },
  511823:
  {
    name: '汉源县',
    parseid: '5118',
    longitude: '102.65857589024',
    latitude: '29.350217385987'
  },
  511824:
  {
    name: '石棉县',
    parseid: '5118',
    longitude: '102.36640453848',
    latitude: '29.23430487759'
  },
  511825:
  {
    name: '天全县',
    parseid: '5118',
    longitude: '102.76453022767',
    latitude: '30.072472953275'
  },
  511826:
  {
    name: '芦山县',
    parseid: '5118',
    longitude: '102.93452771831',
    latitude: '30.149873189563'
  },
  511827:
  {
    name: '宝兴县',
    parseid: '5118',
    longitude: '102.82148423429',
    latitude: '30.374082112445'
  },
  511902:
  {
    name: '巴州区',
    parseid: '5119',
    longitude: '106.77551310771',
    latitude: '31.857685602645'
  },
  511903:
  {
    name: '恩阳区',
    parseid: '5119',
    longitude: '106.63558190249',
    latitude: '31.802614044176'
  },
  511921:
  {
    name: '通江县',
    parseid: '5119',
    longitude: '107.25151684321',
    latitude: '31.917714346881'
  },
  511922:
  {
    name: '南江县',
    parseid: '5119',
    longitude: '106.83448345088',
    latitude: '32.352531654165'
  },
  511923:
  {
    name: '平昌县',
    parseid: '5119',
    longitude: '107.11059310023',
    latitude: '31.566185810095'
  },
  511971:
  {
    name: '巴中经济开发区',
    parseid: '5119',
    longitude: '106.85893254212',
    latitude: '31.854153481824'
  },
  512002:
  {
    name: '雁江区',
    parseid: '5120',
    longitude: '104.65842441063',
    latitude: '30.123753456785'
  },
  512021:
  {
    name: '安岳县',
    parseid: '5120',
    longitude: '105.34245423273',
    latitude: '30.103392734494'
  },
  512022:
  {
    name: '乐至县',
    parseid: '5120',
    longitude: '105.02747697007',
    latitude: '30.282348346'
  },
  513201:
  {
    name: '马尔康市',
    parseid: '5132',
    longitude: '102.21350208208',
    latitude: '31.911747955648'
  },
  513221:
  {
    name: '汶川县',
    parseid: '5132',
    longitude: '103.59651788422',
    latitude: '31.483005320468'
  },
  513222:
  {
    name: '理县',
    parseid: '5132',
    longitude: '103.17351138907',
    latitude: '31.442550437563'
  },
  513223:
  {
    name: '茂县',
    parseid: '5132',
    longitude: '103.85958979689',
    latitude: '31.686809397063'
  },
  513224:
  {
    name: '松潘县',
    parseid: '5132',
    longitude: '103.61057968918',
    latitude: '32.661796559853'
  },
  513225:
  {
    name: '九寨沟县',
    parseid: '5132',
    longitude: '104.24954673403',
    latitude: '33.257591509496'
  },
  513226:
  {
    name: '金川县',
    parseid: '5132',
    longitude: '102.07061042122',
    latitude: '31.482005950337'
  },
  513227:
  {
    name: '小金县',
    parseid: '5132',
    longitude: '102.36942635928',
    latitude: '31.002208697062'
  },
  513228:
  {
    name: '黑水县',
    parseid: '5132',
    longitude: '102.99651735613',
    latitude: '32.067805449368'
  },
  513230:
  {
    name: '壤塘县',
    parseid: '5132',
    longitude: '100.98558348726',
    latitude: '32.271093316269'
  },
  513231:
  {
    name: '阿坝县',
    parseid: '5132',
    longitude: '101.71360970816',
    latitude: '32.908220918625'
  },
  513232:
  {
    name: '若尔盖县',
    parseid: '5132',
    longitude: '102.97439065413',
    latitude: '33.584376654702'
  },
  513233:
  {
    name: '红原县',
    parseid: '5132',
    longitude: '102.55061520946',
    latitude: '32.796605278762'
  },
  513301:
  {
    name: '康定市',
    parseid: '5133',
    longitude: '101.96355522139',
    latitude: '30.004407384262'
  },
  513322:
  {
    name: '泸定县',
    parseid: '5133',
    longitude: '102.24143209631',
    latitude: '29.920401664951'
  },
  513323:
  {
    name: '丹巴县',
    parseid: '5133',
    longitude: '101.89643706759',
    latitude: '30.88476979933'
  },
  513324:
  {
    name: '九龙县',
    parseid: '5133',
    longitude: '101.51341566718',
    latitude: '29.006431902925'
  },
  513325:
  {
    name: '雅江县',
    parseid: '5133',
    longitude: '101.02050035294',
    latitude: '30.037568967864'
  },
  513326:
  {
    name: '道孚县',
    parseid: '5133',
    longitude: '101.13154034619',
    latitude: '30.985326277402'
  },
  513327:
  {
    name: '炉霍县',
    parseid: '5133',
    longitude: '100.68239693357',
    latitude: '31.397991882882'
  },
  513328:
  {
    name: '甘孜县',
    parseid: '5133',
    longitude: '99.999210350851',
    latitude: '31.628956694034'
  },
  513329:
  {
    name: '新龙县',
    parseid: '5133',
    longitude: '100.31839824093',
    latitude: '30.945469525266'
  },
  513330:
  {
    name: '德格县',
    parseid: '5133',
    longitude: '98.587401611354',
    latitude: '31.812106494713'
  },
  513331:
  {
    name: '白玉县',
    parseid: '5133',
    longitude: '98.83110021824',
    latitude: '31.215314448788'
  },
  513332:
  {
    name: '石渠县',
    parseid: '5133',
    longitude: '98.109480622408',
    latitude: '32.984003420478'
  },
  513333:
  {
    name: '色达县',
    parseid: '5133',
    longitude: '100.33941364918',
    latitude: '32.274330413227'
  },
  513334:
  {
    name: '理塘县',
    parseid: '5133',
    longitude: '100.27557457998',
    latitude: '30.000030621751'
  },
  513335:
  {
    name: '巴塘县',
    parseid: '5133',
    longitude: '99.11672669582',
    latitude: '30.011661707376'
  },
  513336:
  {
    name: '乡城县',
    parseid: '5133',
    longitude: '99.805059570922',
    latitude: '28.936733475224'
  },
  513337:
  {
    name: '稻城县',
    parseid: '5133',
    longitude: '100.3044615597',
    latitude: '29.043121558126'
  },
  513338:
  {
    name: '得荣县',
    parseid: '5133',
    longitude: '99.292984198181',
    latitude: '28.718780051461'
  },
  513401:
  {
    name: '西昌市',
    parseid: '5134',
    longitude: '102.27148382917',
    latitude: '27.900580896264'
  },
  513422:
  {
    name: '木里藏族自治县',
    parseid: '5134',
    longitude: '101.28639697674',
    latitude: '27.93459855924'
  },
  513423:
  {
    name: '盐源县',
    parseid: '5134',
    longitude: '101.51542912915',
    latitude: '27.428154867741'
  },
  513424:
  {
    name: '德昌县',
    parseid: '5134',
    longitude: '102.18259551085',
    latitude: '27.408504192994'
  },
  513425:
  {
    name: '会理县',
    parseid: '5134',
    longitude: '102.25143634511',
    latitude: '26.661199778427'
  },
  513426:
  {
    name: '会东县',
    parseid: '5134',
    longitude: '102.5844621823',
    latitude: '26.640823775829'
  },
  513427:
  {
    name: '宁南县',
    parseid: '5134',
    longitude: '102.76252636654',
    latitude: '27.064605070116'
  },
  513428:
  {
    name: '普格县',
    parseid: '5134',
    longitude: '102.54659671863',
    latitude: '27.381996213807'
  },
  513429:
  {
    name: '布拖县',
    parseid: '5134',
    longitude: '102.818478493',
    latitude: '27.7121287338'
  },
  513430:
  {
    name: '金阳县',
    parseid: '5134',
    longitude: '103.25454895521',
    latitude: '27.702144511749'
  },
  513431:
  {
    name: '昭觉县',
    parseid: '5134',
    longitude: '102.84942278222',
    latitude: '28.020506268006'
  },
  513432:
  {
    name: '喜德县',
    parseid: '5134',
    longitude: '102.41956715684',
    latitude: '28.312709832521'
  },
  513433:
  {
    name: '冕宁县',
    parseid: '5134',
    longitude: '102.18357457402',
    latitude: '28.55529444536'
  },
  513434:
  {
    name: '越西县',
    parseid: '5134',
    longitude: '102.5144744814',
    latitude: '28.645827564326'
  },
  513435:
  {
    name: '甘洛县',
    parseid: '5134',
    longitude: '102.77859651312',
    latitude: '28.9648231905'
  },
  513436:
  {
    name: '美姑县',
    parseid: '5134',
    longitude: '103.13858579866',
    latitude: '28.33401962389'
  },
  513437:
  {
    name: '雷波县',
    parseid: '5134',
    longitude: '103.57842869486',
    latitude: '28.268950617624'
  },
  520102:
  {
    name: '南明区',
    parseid: '5201',
    longitude: '106.72052763544',
    latitude: '26.574336181539'
  },
  520103:
  {
    name: '云岩区',
    parseid: '5201',
    longitude: '106.73053475882',
    latitude: '26.610381076426'
  },
  520111:
  {
    name: '花溪区',
    parseid: '5201',
    longitude: '106.6764407773',
    latitude: '26.41587945643'
  },
  520112:
  {
    name: '乌当区',
    parseid: '5201',
    longitude: '106.75755803432',
    latitude: '26.636529135598'
  },
  520113:
  {
    name: '白云区',
    parseid: '5201',
    longitude: '106.62959683989',
    latitude: '26.683588499124'
  },
  520115:
  {
    name: '观山湖区',
    parseid: '5201',
    longitude: '106.60953255751',
    latitude: '26.623894296899'
  },
  520121:
  {
    name: '开阳县',
    parseid: '5201',
    longitude: '106.97155955928',
    latitude: '27.063673573951'
  },
  520122:
  {
    name: '息烽县',
    parseid: '5201',
    longitude: '106.74756178044',
    latitude: '27.096475267062'
  },
  520123:
  {
    name: '修文县',
    parseid: '5201',
    longitude: '106.59849220314',
    latitude: '26.844862447594'
  },
  520181:
  {
    name: '清镇市',
    parseid: '5201',
    longitude: '106.47752261032',
    latitude: '26.561987898479'
  },
  520201:
  {
    name: '钟山区',
    parseid: '5202',
    longitude: '104.85052981696',
    latitude: '26.580704079622'
  },
  520203:
  {
    name: '六枝特区',
    parseid: '5202',
    longitude: '105.48342934686',
    latitude: '26.219214290638'
  },
  520221:
  {
    name: '水城县',
    parseid: '5202',
    longitude: '104.96456610819',
    latitude: '26.553719763692'
  },
  520281:
  {
    name: '盘州市',
    parseid: '5202',
    longitude: '104.47858183932',
    latitude: '25.715651258076'
  },
  520302:
  {
    name: '红花岗区',
    parseid: '5203',
    longitude: '106.90049658668',
    latitude: '27.650870260732'
  },
  520303:
  {
    name: '汇川区',
    parseid: '5203',
    longitude: '106.94045752761',
    latitude: '27.756343380087'
  },
  520304:
  {
    name: '播州区',
    parseid: '5203',
    longitude: '106.83650354793',
    latitude: '27.542500878'
  },
  520322:
  {
    name: '桐梓县',
    parseid: '5203',
    longitude: '106.83248902061',
    latitude: '28.139468384162'
  },
  520323:
  {
    name: '绥阳县',
    parseid: '5203',
    longitude: '107.19749228819',
    latitude: '27.953080005876'
  },
  520324:
  {
    name: '正安县',
    parseid: '5203',
    longitude: '107.4605748906',
    latitude: '28.55909172878'
  },
  520325:
  {
    name: '道真仡佬族苗族自治县',
    parseid: '5203',
    longitude: '107.61948378781',
    latitude: '28.86864981438'
  },
  520326:
  {
    name: '务川仡佬族苗族自治县',
    parseid: '5203',
    longitude: '107.90545629257',
    latitude: '28.569077110562'
  },
  520327:
  {
    name: '凤冈县',
    parseid: '5203',
    longitude: '107.72354763025',
    latitude: '27.960695338965'
  },
  520328:
  {
    name: '湄潭县',
    parseid: '5203',
    longitude: '107.47259853019',
    latitude: '27.75449836496'
  },
  520329:
  {
    name: '余庆县',
    parseid: '5203',
    longitude: '107.91146020728',
    latitude: '27.221379027997'
  },
  520330:
  {
    name: '习水县',
    parseid: '5203',
    longitude: '106.20342803999',
    latitude: '28.339117886481'
  },
  520381:
  {
    name: '赤水市',
    parseid: '5203',
    longitude: '105.70348859502',
    latitude: '28.596118908733'
  },
  520382:
  {
    name: '仁怀市',
    parseid: '5203',
    longitude: '106.40752655518',
    latitude: '27.797752158543'
  },
  520402:
  {
    name: '西秀区',
    parseid: '5204',
    longitude: '105.97240632053',
    latitude: '26.251497663244'
  },
  520403:
  {
    name: '平坝区',
    parseid: '5204',
    longitude: '106.26358378709',
    latitude: '26.411186471257'
  },
  520422:
  {
    name: '普定县',
    parseid: '5204',
    longitude: '105.74848570614',
    latitude: '26.308233451347'
  },
  520423:
  {
    name: '镇宁布依族苗族自治县',
    parseid: '5204',
    longitude: '105.77658344485',
    latitude: '26.063829083032'
  },
  520424:
  {
    name: '关岭布依族苗族自治县',
    parseid: '5204',
    longitude: '105.62547597168',
    latitude: '25.949877045969'
  },
  520425:
  {
    name: '紫云苗族布依族自治县',
    parseid: '5204',
    longitude: '106.09041375093',
    latitude: '25.757408728958'
  },
  520502:
  {
    name: '七星关区',
    parseid: '5205',
    longitude: '105.31158071811',
    latitude: '27.304095223427'
  },
  520521:
  {
    name: '大方县',
    parseid: '5205',
    longitude: '105.61845131242',
    latitude: '27.147060750626'
  },
  520522:
  {
    name: '黔西县',
    parseid: '5205',
    longitude: '106.03857397726',
    latitude: '27.014344747084'
  },
  520523:
  {
    name: '金沙县',
    parseid: '5205',
    longitude: '106.22644163901',
    latitude: '27.465354872614'
  },
  520524:
  {
    name: '织金县',
    parseid: '5205',
    longitude: '105.77758954702',
    latitude: '26.669221885659'
  },
  520525:
  {
    name: '纳雍县',
    parseid: '5205',
    longitude: '105.38948662276',
    latitude: '26.783717229132'
  },
  520526:
  {
    name: '威宁彝族回族苗族自治县',
    parseid: '5205',
    longitude: '104.25948063398',
    latitude: '26.879247190553'
  },
  520527:
  {
    name: '赫章县',
    parseid: '5205',
    longitude: '104.73351582262',
    latitude: '27.129051675142'
  },
  520602:
  {
    name: '碧江区',
    parseid: '5206',
    longitude: '109.18743536171',
    latitude: '27.696773471802'
  },
  520603:
  {
    name: '万山区',
    parseid: '5206',
    longitude: '109.22045617394',
    latitude: '27.524647851983'
  },
  520621:
  {
    name: '江口县',
    parseid: '5206',
    longitude: '108.84540005924',
    latitude: '27.705921695043'
  },
  520622:
  {
    name: '玉屏侗族自治县',
    parseid: '5206',
    longitude: '108.920563527',
    latitude: '27.248557881456'
  },
  520623:
  {
    name: '石阡县',
    parseid: '5206',
    longitude: '108.23046385479',
    latitude: '27.519722059758'
  },
  520624:
  {
    name: '思南县',
    parseid: '5206',
    longitude: '108.25941731933',
    latitude: '27.944547877977'
  },
  520625:
  {
    name: '印江土家族苗族自治县',
    parseid: '5206',
    longitude: '108.41659167843',
    latitude: '27.999823251993'
  },
  520626:
  {
    name: '德江县',
    parseid: '5206',
    longitude: '108.1264110615',
    latitude: '28.270423278494'
  },
  520627:
  {
    name: '沿河土家族自治县',
    parseid: '5206',
    longitude: '108.51047753979',
    latitude: '28.570101680095'
  },
  520628:
  {
    name: '松桃苗族自治县',
    parseid: '5206',
    longitude: '109.20940351278',
    latitude: '28.160420179011'
  },
  522301:
  {
    name: '兴义市',
    parseid: '5223',
    longitude: '104.9024609483',
    latitude: '25.098113310297'
  },
  522302:
  {
    name: '兴仁市',
    parseid: '5223',
    longitude: '105.19256772452',
    latitude: '25.440898753576'
  },
  522323:
  {
    name: '普安县',
    parseid: '5223',
    longitude: '104.95954583802',
    latitude: '25.789951769129'
  },
  522324:
  {
    name: '晴隆县',
    parseid: '5223',
    longitude: '105.22548361467',
    latitude: '25.841047900453'
  },
  522325:
  {
    name: '贞丰县',
    parseid: '5223',
    longitude: '105.65655958807',
    latitude: '25.392123965341'
  },
  522326:
  {
    name: '望谟县',
    parseid: '5223',
    longitude: '106.10644455174',
    latitude: '25.18435492392'
  },
  522327:
  {
    name: '册亨县',
    parseid: '5223',
    longitude: '105.81851050706',
    latitude: '24.989637494252'
  },
  522328:
  {
    name: '安龙县',
    parseid: '5223',
    longitude: '105.44954274777',
    latitude: '25.103990431232'
  },
  522601:
  {
    name: '凯里市',
    parseid: '5226',
    longitude: '107.98746889069',
    latitude: '26.573079425675'
  },
  522622:
  {
    name: '黄平县',
    parseid: '5226',
    longitude: '107.92354780622',
    latitude: '26.911288643101'
  },
  522623:
  {
    name: '施秉县',
    parseid: '5226',
    longitude: '108.13043978205',
    latitude: '27.039822051733'
  },
  522624:
  {
    name: '三穗县',
    parseid: '5226',
    longitude: '108.68154500207',
    latitude: '26.958666465246'
  },
  522625:
  {
    name: '镇远县',
    parseid: '5226',
    longitude: '108.43658077263',
    latitude: '27.054820913901'
  },
  522626:
  {
    name: '岑巩县',
    parseid: '5226',
    longitude: '108.82248096196',
    latitude: '27.179902417394'
  },
  522627:
  {
    name: '天柱县',
    parseid: '5226',
    longitude: '109.21444570161',
    latitude: '26.915804084012'
  },
  522628:
  {
    name: '锦屏县',
    parseid: '5226',
    longitude: '109.20743846948',
    latitude: '26.682631631865'
  },
  522629:
  {
    name: '剑河县',
    parseid: '5226',
    longitude: '108.44751710323',
    latitude: '26.734047558881'
  },
  522630:
  {
    name: '台江县',
    parseid: '5226',
    longitude: '108.32855163',
    latitude: '26.672372539643'
  },
  522631:
  {
    name: '黎平县',
    parseid: '5226',
    longitude: '109.14356697147',
    latitude: '26.236874050192'
  },
  522632:
  {
    name: '榕江县',
    parseid: '5226',
    longitude: '108.52755369872',
    latitude: '25.93772537325'
  },
  522633:
  {
    name: '从江县',
    parseid: '5226',
    longitude: '108.91156142782',
    latitude: '25.759881327892'
  },
  522634:
  {
    name: '雷山县',
    parseid: '5226',
    longitude: '108.08452891457',
    latitude: '26.384205121689'
  },
  522635:
  {
    name: '麻江县',
    parseid: '5226',
    longitude: '107.59555140191',
    latitude: '26.496807595584'
  },
  522636:
  {
    name: '丹寨县',
    parseid: '5226',
    longitude: '107.79551348972',
    latitude: '26.204421169869'
  },
  522701:
  {
    name: '都匀市',
    parseid: '5227',
    longitude: '107.52540443144',
    latitude: '26.266117957789'
  },
  522702:
  {
    name: '福泉市',
    parseid: '5227',
    longitude: '107.52643281158',
    latitude: '26.692525700784'
  },
  522722:
  {
    name: '荔波县',
    parseid: '5227',
    longitude: '107.89340938687',
    latitude: '25.417097566273'
  },
  522723:
  {
    name: '贵定县',
    parseid: '5227',
    longitude: '107.2405543594',
    latitude: '26.590659655039'
  },
  522725:
  {
    name: '瓮安县',
    parseid: '5227',
    longitude: '107.47755223592',
    latitude: '27.084125602602'
  },
  522726:
  {
    name: '独山县',
    parseid: '5227',
    longitude: '107.55149778107',
    latitude: '25.828287807074'
  },
  522727:
  {
    name: '平塘县',
    parseid: '5227',
    longitude: '107.32956664388',
    latitude: '25.828201706902'
  },
  522728:
  {
    name: '罗甸县',
    parseid: '5227',
    longitude: '106.75854805682',
    latitude: '25.430837682972'
  },
  522729:
  {
    name: '长顺县',
    parseid: '5227',
    longitude: '106.45842122163',
    latitude: '26.028454545714'
  },
  522730:
  {
    name: '龙里县',
    parseid: '5227',
    longitude: '106.98658596469',
    latitude: '26.459080630642'
  },
  522731:
  {
    name: '惠水县',
    parseid: '5227',
    longitude: '106.66345262709',
    latitude: '26.138209889396'
  },
  522732:
  {
    name: '三都水族自治县',
    parseid: '5227',
    longitude: '107.87642925681',
    latitude: '25.989479499373'
  },
  530102:
  {
    name: '五华区',
    parseid: '5301',
    longitude: '102.7134232806',
    latitude: '25.049834961981'
  },
  530103:
  {
    name: '盘龙区',
    parseid: '5301',
    longitude: '102.7585262121',
    latitude: '25.12237227983'
  },
  530111:
  {
    name: '官渡区',
    parseid: '5301',
    longitude: '102.7504817066',
    latitude: '25.021196423859'
  },
  530112:
  {
    name: '西山区',
    parseid: '5301',
    longitude: '102.6715571235',
    latitude: '25.043198760947'
  },
  530113:
  {
    name: '东川区',
    parseid: '5301',
    longitude: '103.19445186746',
    latitude: '26.089054237623'
  },
  530114:
  {
    name: '呈贡区',
    parseid: '5301',
    longitude: '102.82747259726',
    latitude: '24.891871210947'
  },
  530115:
  {
    name: '晋宁区',
    parseid: '5301',
    longitude: '102.60241805181',
    latitude: '24.676098812517'
  },
  530124:
  {
    name: '富民县',
    parseid: '5301',
    longitude: '102.50447319701',
    latitude: '25.228085092195'
  },
  530125:
  {
    name: '宜良县',
    parseid: '5301',
    longitude: '103.14755798426',
    latitude: '24.925286989652'
  },
  530126:
  {
    name: '石林彝族自治县',
    parseid: '5301',
    longitude: '103.29650817676',
    latitude: '24.77770196132'
  },
  530127:
  {
    name: '嵩明县',
    parseid: '5301',
    longitude: '103.04356394016',
    latitude: '25.344409459135'
  },
  530128:
  {
    name: '禄劝彝族苗族自治县',
    parseid: '5301',
    longitude: '102.47742324184',
    latitude: '25.55767180024'
  },
  530129:
  {
    name: '寻甸回族彝族自治县',
    parseid: '5301',
    longitude: '103.26357387135',
    latitude: '25.563893580433'
  },
  530181:
  {
    name: '安宁市',
    parseid: '5301',
    longitude: '102.48440918413',
    latitude: '24.925601726344'
  },
  530302:
  {
    name: '麒麟区',
    parseid: '5303',
    longitude: '103.81143036949',
    latitude: '25.502101828437'
  },
  530303:
  {
    name: '沾益区',
    parseid: '5303',
    longitude: '103.82848532841',
    latitude: '25.606630798868'
  },
  530304:
  {
    name: '马龙区',
    parseid: '5303',
    longitude: '103.58544688632',
    latitude: '25.433966374816'
  },
  530322:
  {
    name: '陆良县',
    parseid: '5303',
    longitude: '103.67343249743',
    latitude: '25.035639470439'
  },
  530323:
  {
    name: '师宗县',
    parseid: '5303',
    longitude: '103.99155634453',
    latitude: '24.827994969501'
  },
  530324:
  {
    name: '罗平县',
    parseid: '5303',
    longitude: '104.31551019438',
    latitude: '24.890519724895'
  },
  530325:
  {
    name: '富源县',
    parseid: '5303',
    longitude: '104.2614742434',
    latitude: '25.680279502133'
  },
  530326:
  {
    name: '会泽县',
    parseid: '5303',
    longitude: '103.30348729192',
    latitude: '26.424215045561'
  },
  530381:
  {
    name: '宣威市',
    parseid: '5303',
    longitude: '104.1115760691',
    latitude: '26.225598378324'
  },
  530402:
  {
    name: '红塔区',
    parseid: '5304',
    longitude: '102.55156461759',
    latitude: '24.359801443673'
  },
  530403:
  {
    name: '江川区',
    parseid: '5304',
    longitude: '102.76052700796',
    latitude: '24.293438700984'
  },
  530422:
  {
    name: '澄江县',
    parseid: '5304',
    longitude: '102.91455487235',
    latitude: '24.679414908816'
  },
  530423:
  {
    name: '通海县',
    parseid: '5304',
    longitude: '102.73242289128',
    latitude: '24.117891201574'
  },
  530424:
  {
    name: '华宁县',
    parseid: '5304',
    longitude: '102.93549185853',
    latitude: '24.198581027163'
  },
  530425:
  {
    name: '易门县',
    parseid: '5304',
    longitude: '102.1695354962',
    latitude: '24.677404477592'
  },
  530426:
  {
    name: '峨山彝族自治县',
    parseid: '5304',
    longitude: '102.41256450607',
    latitude: '24.174774239093'
  },
  530427:
  {
    name: '新平彝族傣族自治县',
    parseid: '5304',
    longitude: '101.99642771261',
    latitude: '24.076262705278'
  },
  530428:
  {
    name: '元江哈尼族彝族傣族自治县',
    parseid: '5304',
    longitude: '101.99936076993',
    latitude: '23.607853842954'
  },
  530502:
  {
    name: '隆阳区',
    parseid: '5305',
    longitude: '99.172070839289',
    latitude: '25.12688832219'
  },
  530521:
  {
    name: '施甸县',
    parseid: '5305',
    longitude: '99.195469362222',
    latitude: '24.728835000146'
  },
  530523:
  {
    name: '龙陵县',
    parseid: '5305',
    longitude: '98.695749912275',
    latitude: '24.592546947017'
  },
  530524:
  {
    name: '昌宁县',
    parseid: '5305',
    longitude: '99.611616576026',
    latitude: '24.833984919853'
  },
  530581:
  {
    name: '腾冲市',
    parseid: '5305',
    longitude: '98.497595035489',
    latitude: '25.026616860346'
  },
  530602:
  {
    name: '昭阳区',
    parseid: '5306',
    longitude: '103.71347042315',
    latitude: '27.326144206053'
  },
  530621:
  {
    name: '鲁甸县',
    parseid: '5306',
    longitude: '103.5644121645',
    latitude: '27.193107219133'
  },
  530622:
  {
    name: '巧家县',
    parseid: '5306',
    longitude: '102.93651934037',
    latitude: '26.914705038577'
  },
  530623:
  {
    name: '盐津县',
    parseid: '5306',
    longitude: '104.24157884246',
    latitude: '28.114384038516'
  },
  530624:
  {
    name: '大关县',
    parseid: '5306',
    longitude: '103.89751489665',
    latitude: '27.754021401911'
  },
  530625:
  {
    name: '永善县',
    parseid: '5306',
    longitude: '103.6445690431',
    latitude: '28.234722481383'
  },
  530626:
  {
    name: '绥江县',
    parseid: '5306',
    longitude: '103.9645523826',
    latitude: '28.604277931727'
  },
  530627:
  {
    name: '镇雄县',
    parseid: '5306',
    longitude: '104.88040422431',
    latitude: '27.447794634649'
  },
  530628:
  {
    name: '彝良县',
    parseid: '5306',
    longitude: '104.05444303021',
    latitude: '27.631690165547'
  },
  530629:
  {
    name: '威信县',
    parseid: '5306',
    longitude: '105.05557676311',
    latitude: '27.85253746404'
  },
  530681:
  {
    name: '水富市',
    parseid: '5306',
    longitude: '104.42243298394',
    latitude: '28.636106975262'
  },
  530702:
  {
    name: '古城区',
    parseid: '5307',
    longitude: '100.23248033921',
    latitude: '26.883161684001'
  },
  530721:
  {
    name: '玉龙纳西族自治县',
    parseid: '5307',
    longitude: '100.24352734105',
    latitude: '26.827391803625'
  },
  530722:
  {
    name: '永胜县',
    parseid: '5307',
    longitude: '100.75758141133',
    latitude: '26.689950245419'
  },
  530723:
  {
    name: '华坪县',
    parseid: '5307',
    longitude: '101.27243012268',
    latitude: '26.635223014622'
  },
  530724:
  {
    name: '宁蒗彝族自治县',
    parseid: '5307',
    longitude: '100.85859038623',
    latitude: '27.287727826052'
  },
  530802:
  {
    name: '思茅区',
    parseid: '5308',
    longitude: '100.98355510298',
    latitude: '22.79249798436'
  },
  530821:
  {
    name: '宁洱哈尼族彝族自治县',
    parseid: '5308',
    longitude: '101.05244246946',
    latitude: '23.054590179481'
  },
  530822:
  {
    name: '墨江哈尼族自治县',
    parseid: '5308',
    longitude: '101.69858356155',
    latitude: '23.437725772256'
  },
  530823:
  {
    name: '景东彝族自治县',
    parseid: '5308',
    longitude: '100.83848864452',
    latitude: '24.451863775495'
  },
  530824:
  {
    name: '景谷傣族彝族自治县',
    parseid: '5308',
    longitude: '100.7094565801',
    latitude: '23.503204071241'
  },
  530825:
  {
    name: '镇沅彝族哈尼族拉祜族自治县',
    parseid: '5308',
    longitude: '101.11556882305',
    latitude: '24.010330833613'
  },
  530826:
  {
    name: '江城哈尼族彝族自治县',
    parseid: '5308',
    longitude: '101.86847918429',
    latitude: '22.59168385943'
  },
  530827:
  {
    name: '孟连傣族拉祜族佤族自治县',
    parseid: '5308',
    longitude: '99.590962825578',
    latitude: '22.335307615556'
  },
  530828:
  {
    name: '澜沧拉祜族自治县',
    parseid: '5308',
    longitude: '99.938588283239',
    latitude: '22.561831918087'
  },
  530829:
  {
    name: '西盟佤族自治县',
    parseid: '5308',
    longitude: '99.596622150289',
    latitude: '22.650656010974'
  },
  530902:
  {
    name: '临翔区',
    parseid: '5309',
    longitude: '100.0884425304',
    latitude: '23.901401938645'
  },
  530921:
  {
    name: '凤庆县',
    parseid: '5309',
    longitude: '99.934989222215',
    latitude: '24.586472458274'
  },
  530922:
  {
    name: '云县',
    parseid: '5309',
    longitude: '100.12953102441',
    latitude: '24.442807275329'
  },
  530923:
  {
    name: '永德县',
    parseid: '5309',
    longitude: '99.265075642606',
    latitude: '24.024871282777'
  },
  530924:
  {
    name: '镇康县',
    parseid: '5309',
    longitude: '98.831871224123',
    latitude: '23.768315480096'
  },
  530925:
  {
    name: '双江拉祜族佤族布朗族傣族自治县',
    parseid: '5309',
    longitude: '99.834130982979',
    latitude: '23.479836504614'
  },
  530926:
  {
    name: '耿马傣族佤族自治县',
    parseid: '5309',
    longitude: '99.403942176092',
    latitude: '23.543490995101'
  },
  530927:
  {
    name: '沧源佤族自治县',
    parseid: '5309',
    longitude: '99.252721696084',
    latitude: '23.152878733913'
  },
  532301:
  {
    name: '楚雄市',
    parseid: '5323',
    longitude: '101.55247228396',
    latitude: '25.038860388323'
  },
  532322:
  {
    name: '双柏县',
    parseid: '5323',
    longitude: '101.64840700053',
    latitude: '24.694898530382'
  },
  532323:
  {
    name: '牟定县',
    parseid: '5323',
    longitude: '101.55348099122',
    latitude: '25.318845903714'
  },
  532324:
  {
    name: '南华县',
    parseid: '5323',
    longitude: '101.28042055018',
    latitude: '25.198587071156'
  },
  532325:
  {
    name: '姚安县',
    parseid: '5323',
    longitude: '101.2485272012',
    latitude: '25.509775443473'
  },
  532326:
  {
    name: '大姚县',
    parseid: '5323',
    longitude: '101.33056746713',
    latitude: '25.727600600572'
  },
  532327:
  {
    name: '永仁县',
    parseid: '5323',
    longitude: '101.67249299667',
    latitude: '26.055565754521'
  },
  532328:
  {
    name: '元谋县',
    parseid: '5323',
    longitude: '101.8804452425',
    latitude: '25.710895319939'
  },
  532329:
  {
    name: '武定县',
    parseid: '5323',
    longitude: '102.41053182037',
    latitude: '25.536089587807'
  },
  532331:
  {
    name: '禄丰县',
    parseid: '5323',
    longitude: '102.08553135476',
    latitude: '25.155830804806'
  },
  532501:
  {
    name: '个旧市',
    parseid: '5325',
    longitude: '103.16651860849',
    latitude: '23.364941534583'
  },
  532502:
  {
    name: '开远市',
    parseid: '5325',
    longitude: '103.27355323709',
    latitude: '23.719907796912'
  },
  532503:
  {
    name: '蒙自市',
    parseid: '5325',
    longitude: '103.37154588175',
    latitude: '23.402079885198'
  },
  532504:
  {
    name: '弥勒市',
    parseid: '5325',
    longitude: '103.421489063',
    latitude: '24.417982225357'
  },
  532523:
  {
    name: '屏边苗族自治县',
    parseid: '5325',
    longitude: '103.69343183232',
    latitude: '22.989989585513'
  },
  532524:
  {
    name: '建水县',
    parseid: '5325',
    longitude: '102.83343959161',
    latitude: '23.640938563461'
  },
  532525:
  {
    name: '石屏县',
    parseid: '5325',
    longitude: '102.50244661978',
    latitude: '23.712004452449'
  },
  532527:
  {
    name: '泸西县',
    parseid: '5325',
    longitude: '103.77252314092',
    latitude: '24.53803716745'
  },
  532528:
  {
    name: '元阳县',
    parseid: '5325',
    longitude: '102.84143280386',
    latitude: '23.226198051926'
  },
  532529:
  {
    name: '红河县',
    parseid: '5325',
    longitude: '102.42755057757',
    latitude: '23.374488738365'
  },
  532530:
  {
    name: '金平苗族瑶族傣族自治县',
    parseid: '5325',
    longitude: '103.23246860579',
    latitude: '22.785560606183'
  },
  532531:
  {
    name: '绿春县',
    parseid: '5325',
    longitude: '102.39849398755',
    latitude: '23.000164936586'
  },
  532532:
  {
    name: '河口瑶族自治县',
    parseid: '5325',
    longitude: '103.9454436278',
    latitude: '22.535465602947'
  },
  532601:
  {
    name: '文山市',
    parseid: '5326',
    longitude: '104.23854382746',
    latitude: '23.391944131908'
  },
  532622:
  {
    name: '砚山县',
    parseid: '5326',
    longitude: '104.3435508907',
    latitude: '23.6114865767'
  },
  532623:
  {
    name: '西畴县',
    parseid: '5326',
    longitude: '104.67852542203',
    latitude: '23.443271275283'
  },
  532624:
  {
    name: '麻栗坡县',
    parseid: '5326',
    longitude: '104.70954948078',
    latitude: '23.13158558356'
  },
  532625:
  {
    name: '马关县',
    parseid: '5326',
    longitude: '104.40041497692',
    latitude: '23.018993577166'
  },
  532626:
  {
    name: '丘北县',
    parseid: '5326',
    longitude: '104.17344174074',
    latitude: '24.056993896218'
  },
  532627:
  {
    name: '广南县',
    parseid: '5326',
    longitude: '105.06158238459',
    latitude: '24.052198510921'
  },
  532628:
  {
    name: '富宁县',
    parseid: '5326',
    longitude: '105.63749017905',
    latitude: '23.63138040952'
  },
  532801:
  {
    name: '景洪市',
    parseid: '5328',
    longitude: '100.80644312258',
    latitude: '22.017004423119'
  },
  532822:
  {
    name: '勐海县',
    parseid: '5328',
    longitude: '100.4594459398',
    latitude: '21.963433596681'
  },
  532823:
  {
    name: '勐腊县',
    parseid: '5328',
    longitude: '101.57152830823',
    latitude: '21.465280880862'
  },
  532901:
  {
    name: '大理市',
    parseid: '5329',
    longitude: '100.23651930044',
    latitude: '25.597604905452'
  },
  532922:
  {
    name: '漾濞彝族自治县',
    parseid: '5329',
    longitude: '99.964413758168',
    latitude: '25.676295762972'
  },
  532923:
  {
    name: '祥云县',
    parseid: '5329',
    longitude: '100.55744657937',
    latitude: '25.489872506242'
  },
  532924:
  {
    name: '宾川县',
    parseid: '5329',
    longitude: '100.57845668762',
    latitude: '25.835249028198'
  },
  532925:
  {
    name: '弥渡县',
    parseid: '5329',
    longitude: '100.49758601546',
    latitude: '25.349336028746'
  },
  532926:
  {
    name: '南涧彝族自治县',
    parseid: '5329',
    longitude: '100.51554862227',
    latitude: '25.049426762094'
  },
  532927:
  {
    name: '巍山彝族回族自治县',
    parseid: '5329',
    longitude: '100.31346033515',
    latitude: '25.233438729799'
  },
  532928:
  {
    name: '永平县',
    parseid: '5329',
    longitude: '99.547494899931',
    latitude: '25.4702064833'
  },
  532929:
  {
    name: '云龙县',
    parseid: '5329',
    longitude: '99.377416022867',
    latitude: '25.891945073902'
  },
  532930:
  {
    name: '洱源县',
    parseid: '5329',
    longitude: '99.969209721453',
    latitude: '26.120093341888'
  },
  532931:
  {
    name: '剑川县',
    parseid: '5329',
    longitude: '99.912091235112',
    latitude: '26.542516534181'
  },
  532932:
  {
    name: '鹤庆县',
    parseid: '5329',
    longitude: '100.18249206302',
    latitude: '26.566197313345'
  },
  533102:
  {
    name: '瑞丽市',
    parseid: '5331',
    longitude: '98.591359356114',
    latitude: '24.438010702758'
  },
  533103:
  {
    name: '芒市',
    parseid: '5331',
    longitude: '98.591359356114',
    latitude: '24.438010702758'
  },
  533122:
  {
    name: '梁河县',
    parseid: '5331',
    longitude: '98.303133631636',
    latitude: '24.810784458257'
  },
  533123:
  {
    name: '盈江县',
    parseid: '5331',
    longitude: '97.938426535386',
    latitude: '24.711534266143'
  },
  533124:
  {
    name: '陇川县',
    parseid: '5331',
    longitude: '97.798530364124',
    latitude: '24.189467890549'
  },
  533301:
  {
    name: '泸水市',
    parseid: '5333',
    longitude: '98.864586163328',
    latitude: '25.829026769972'
  },
  533323:
  {
    name: '福贡县',
    parseid: '5333',
    longitude: '98.875649424493',
    latitude: '26.908055208498'
  },
  533324:
  {
    name: '贡山独龙族怒族自治县',
    parseid: '5333',
    longitude: '98.735546103981',
    latitude: '27.822950369655'
  },
  533325:
  {
    name: '兰坪白族普米族自治县',
    parseid: '5333',
    longitude: '99.423284669988',
    latitude: '26.459207904688'
  },
  533401:
  {
    name: '香格里拉市',
    parseid: '5334',
    longitude: '99.707444573899',
    latitude: '27.835760125321'
  },
  533422:
  {
    name: '德钦县',
    parseid: '5334',
    longitude: '98.924452656054',
    latitude: '28.470086006822'
  },
  533423:
  {
    name: '维西傈僳族自治县',
    parseid: '5334',
    longitude: '99.293465689934',
    latitude: '27.183170204022'
  },
  540102:
  {
    name: '城关区',
    parseid: '5401',
    longitude: '91.145100352371',
    latitude: '29.658331252915'
  },
  540103:
  {
    name: '堆龙德庆区',
    parseid: '5401',
    longitude: '91.009963134209',
    latitude: '29.651625675009'
  },
  540104:
  {
    name: '达孜区',
    parseid: '5401',
    longitude: '91.356318118388',
    latitude: '29.675409063815'
  },
  540121:
  {
    name: '林周县',
    parseid: '5401',
    longitude: '91.26950057393',
    latitude: '29.898733205887'
  },
  540122:
  {
    name: '当雄县',
    parseid: '5401',
    longitude: '91.107451746831',
    latitude: '30.479221726942'
  },
  540123:
  {
    name: '尼木县',
    parseid: '5401',
    longitude: '90.171180066243',
    latitude: '29.437518981255'
  },
  540124:
  {
    name: '曲水县',
    parseid: '5401',
    longitude: '90.749958665453',
    latitude: '29.358987058337'
  },
  540127:
  {
    name: '墨竹工卡县',
    parseid: '5401',
    longitude: '91.737266398592',
    latitude: '29.839752605055'
  },
  540171:
  {
    name: '格尔木藏青工业园区',
    parseid: '5401',
    longitude: '94.933310210425',
    latitude: '36.412371046954'
  },
  540172:
  {
    name: '拉萨经济技术开发区',
    parseid: '5401',
    longitude: '91.027937868135',
    latitude: '29.644867303385'
  },
  540173:
  {
    name: '西藏文化旅游创意园区',
    parseid: '5401',
    longitude: '91.148141206352',
    latitude: '29.620917517004'
  },
  540174:
  {
    name: '达孜工业园区',
    parseid: '5401',
    longitude: '91.339583046065',
    latitude: '29.67361183062'
  },
  540202:
  {
    name: '桑珠孜区',
    parseid: '5402',
    longitude: '88.902951718862',
    latitude: '29.255582814198'
  },
  540221:
  {
    name: '南木林县',
    parseid: '5402',
    longitude: '89.105704213077',
    latitude: '29.687938036552'
  },
  540222:
  {
    name: '江孜县',
    parseid: '5402',
    longitude: '89.612012194954',
    latitude: '28.917634684239'
  },
  540223:
  {
    name: '定日县',
    parseid: '5402',
    longitude: '87.129597739314',
    latitude: '28.663951983289'
  },
  540224:
  {
    name: '萨迦县',
    parseid: '5402',
    longitude: '88.028269488152',
    latitude: '28.90493151262'
  },
  540225:
  {
    name: '拉孜县',
    parseid: '5402',
    longitude: '87.643647318074',
    latitude: '29.087509679995'
  },
  540226:
  {
    name: '昂仁县',
    parseid: '5402',
    longitude: '87.242427336755',
    latitude: '29.301060484014'
  },
  540227:
  {
    name: '谢通门县',
    parseid: '5402',
    longitude: '88.268206799957',
    latitude: '29.438142414132'
  },
  540228:
  {
    name: '白朗县',
    parseid: '5402',
    longitude: '89.268741991895',
    latitude: '29.111858951918'
  },
  540229:
  {
    name: '仁布县',
    parseid: '5402',
    longitude: '89.848624967899',
    latitude: '29.236788327037'
  },
  540230:
  {
    name: '康马县',
    parseid: '5402',
    longitude: '89.688244915761',
    latitude: '28.561443952501'
  },
  540231:
  {
    name: '定结县',
    parseid: '5402',
    longitude: '87.772376743375',
    latitude: '28.369910769393'
  },
  540232:
  {
    name: '仲巴县',
    parseid: '5402',
    longitude: '84.038116876917',
    latitude: '29.775982232026'
  },
  540233:
  {
    name: '亚东县',
    parseid: '5402',
    longitude: '88.913440783145',
    latitude: '27.491108780091'
  },
  540234:
  {
    name: '吉隆县',
    parseid: '5402',
    longitude: '85.304073768987',
    latitude: '28.858501664955'
  },
  540235:
  {
    name: '聂拉木县',
    parseid: '5402',
    longitude: '85.988770403046',
    latitude: '28.160839360543'
  },
  540236:
  {
    name: '萨嘎县',
    parseid: '5402',
    longitude: '85.239825701307',
    latitude: '29.334659688784'
  },
  540237:
  {
    name: '岗巴县',
    parseid: '5402',
    longitude: '88.526529281476',
    latitude: '28.28036304226'
  },
  540302:
  {
    name: '卡若区',
    parseid: '5403',
    longitude: '97.186654336416',
    latitude: '31.144248893947'
  },
  540321:
  {
    name: '江达县',
    parseid: '5403',
    longitude: '98.224594520968',
    latitude: '31.50520701798'
  },
  540322:
  {
    name: '贡觉县',
    parseid: '5403',
    longitude: '98.277334127289',
    latitude: '30.865966958412'
  },
  540323:
  {
    name: '类乌齐县',
    parseid: '5403',
    longitude: '96.606717192399',
    latitude: '31.217793112281'
  },
  540324:
  {
    name: '丁青县',
    parseid: '5403',
    longitude: '95.602643844218',
    latitude: '31.418402964614'
  },
  540325:
  {
    name: '察雅县',
    parseid: '5403',
    longitude: '97.575123679628',
    latitude: '30.659864699371'
  },
  540326:
  {
    name: '八宿县',
    parseid: '5403',
    longitude: '96.924360446152',
    latitude: '30.059028991399'
  },
  540327:
  {
    name: '左贡县',
    parseid: '5403',
    longitude: '97.847366832989',
    latitude: '29.676848537197'
  },
  540328:
  {
    name: '芒康县',
    parseid: '5403',
    longitude: '98.599685480392',
    latitude: '29.685776117713'
  },
  540329:
  {
    name: '洛隆县',
    parseid: '5403',
    longitude: '95.831306613477',
    latitude: '30.747126507478'
  },
  540330:
  {
    name: '边坝县',
    parseid: '5403',
    longitude: '94.714371149159',
    latitude: '30.939624927347'
  },
  540402:
  {
    name: '巴宜区',
    parseid: '5404',
    longitude: '94.36754427672',
    latitude: '29.641644546372'
  },
  540421:
  {
    name: '工布江达县',
    parseid: '5404',
    longitude: '93.252419796678',
    latitude: '29.891367616241'
  },
  540422:
  {
    name: '米林县',
    parseid: '5404',
    longitude: '94.219938578083',
    latitude: '29.220916541197'
  },
  540423:
  {
    name: '墨脱县',
    parseid: '5404',
    longitude: '95.33949529751',
    latitude: '29.330937701878'
  },
  540424:
  {
    name: '波密县',
    parseid: '5404',
    longitude: '95.773900121645',
    latitude: '29.865060090549'
  },
  540425:
  {
    name: '察隅县',
    parseid: '5404',
    longitude: '97.473269749246',
    latitude: '28.667444137201'
  },
  540426:
  {
    name: '朗县',
    parseid: '5404',
    longitude: '93.081368234407',
    latitude: '29.051902419086'
  },
  540502:
  {
    name: '乃东区',
    parseid: '5405',
    longitude: '91.778681965641',
    latitude: '29.234229154985'
  },
  540521:
  {
    name: '扎囊县',
    parseid: '5405',
    longitude: '91.343627127639',
    latitude: '29.251164315795'
  },
  540522:
  {
    name: '贡嘎县',
    parseid: '5405',
    longitude: '90.990582372498',
    latitude: '29.295585920341'
  },
  540523:
  {
    name: '桑日县',
    parseid: '5405',
    longitude: '92.022157253696',
    latitude: '29.265175836421'
  },
  540524:
  {
    name: '琼结县',
    parseid: '5405',
    longitude: '91.690100777976',
    latitude: '29.030865581933'
  },
  540525:
  {
    name: '曲松县',
    parseid: '5405',
    longitude: '92.210174662975',
    latitude: '29.068424815624'
  },
  540526:
  {
    name: '措美县',
    parseid: '5405',
    longitude: '91.439917573188',
    latitude: '28.444257990161'
  },
  540527:
  {
    name: '洛扎县',
    parseid: '5405',
    longitude: '90.866452001915',
    latitude: '28.391634617398'
  },
  540528:
  {
    name: '加查县',
    parseid: '5405',
    longitude: '92.600448881489',
    latitude: '29.146087474784'
  },
  540529:
  {
    name: '隆子县',
    parseid: '5405',
    longitude: '92.468965520987',
    latitude: '28.414018998419'
  },
  540530:
  {
    name: '错那县',
    parseid: '5405',
    longitude: '91.96375005827',
    latitude: '27.997004265923'
  },
  540531:
  {
    name: '浪卡子县',
    parseid: '5405',
    longitude: '90.404646883462',
    latitude: '28.973992017804'
  },
  540602:
  {
    name: '色尼区',
    parseid: '5406',
    longitude: '92.05984683665',
    latitude: '31.476117292678'
  },
  540621:
  {
    name: '嘉黎县',
    parseid: '5406',
    longitude: '93.23873151504',
    latitude: '30.647062455597'
  },
  540622:
  {
    name: '比如县',
    parseid: '5406',
    longitude: '93.685965938612',
    latitude: '31.48635726205'
  },
  540623:
  {
    name: '聂荣县',
    parseid: '5406',
    longitude: '92.308654466293',
    latitude: '32.113707483115'
  },
  540624:
  {
    name: '安多县',
    parseid: '5406',
    longitude: '91.688890677999',
    latitude: '32.271268023108'
  },
  540625:
  {
    name: '申扎县',
    parseid: '5406',
    longitude: '88.716481108234',
    latitude: '30.936393285832'
  },
  540626:
  {
    name: '索县',
    parseid: '5406',
    longitude: '93.792172958379',
    latitude: '31.892424309227'
  },
  540627:
  {
    name: '班戈县',
    parseid: '5406',
    longitude: '90.016707727114',
    latitude: '31.398727622963'
  },
  540628:
  {
    name: '巴青县',
    parseid: '5406',
    longitude: '94.059881564766',
    latitude: '31.924549424276'
  },
  540629:
  {
    name: '尼玛县',
    parseid: '5406',
    longitude: '87.243292410868',
    latitude: '31.790953326638'
  },
  540630:
  {
    name: '双湖县',
    parseid: '5406',
    longitude: '88.843427936123',
    latitude: '33.193503165809'
  },
  542521:
  {
    name: '普兰县',
    parseid: '5425',
    longitude: '81.183094731974',
    latitude: '30.300162591078'
  },
  542522:
  {
    name: '札达县',
    parseid: '5425',
    longitude: '79.809323212178',
    latitude: '31.485343070014'
  },
  542523:
  {
    name: '噶尔县',
    parseid: '5425',
    longitude: '80.102877146054',
    latitude: '32.497156823602'
  },
  542524:
  {
    name: '日土县',
    parseid: '5425',
    longitude: '79.739109138263',
    latitude: '33.387186043872'
  },
  542525:
  {
    name: '革吉县',
    parseid: '5425',
    longitude: '81.151664369638',
    latitude: '32.393356020044'
  },
  542526:
  {
    name: '改则县',
    parseid: '5425',
    longitude: '84.06911336254',
    latitude: '32.308356643244'
  },
  542527:
  {
    name: '措勤县',
    parseid: '5425',
    longitude: '85.165952205481',
    latitude: '31.022666379273'
  },
  610102:
  {
    name: '新城区',
    parseid: '6101',
    longitude: '108.9673910385',
    latitude: '34.272724469533'
  },
  610103:
  {
    name: '碑林区',
    parseid: '6101',
    longitude: '108.94049774781',
    latitude: '34.236473940412'
  },
  610104:
  {
    name: '莲湖区',
    parseid: '6101',
    longitude: '108.95042644912',
    latitude: '34.271017203053'
  },
  610111:
  {
    name: '灞桥区',
    parseid: '6101',
    longitude: '109.07141535554',
    latitude: '34.279127674951'
  },
  610112:
  {
    name: '未央区',
    parseid: '6101',
    longitude: '108.95340118781',
    latitude: '34.299148106589'
  },
  610113:
  {
    name: '雁塔区',
    parseid: '6101',
    longitude: '108.95144045638',
    latitude: '34.220635239986'
  },
  610114:
  {
    name: '阎良区',
    parseid: '6101',
    longitude: '109.23246311822',
    latitude: '34.668363274699'
  },
  610115:
  {
    name: '临潼区',
    parseid: '6101',
    longitude: '109.22043579558',
    latitude: '34.372747432848'
  },
  610116:
  {
    name: '长安区',
    parseid: '6101',
    longitude: '108.91358047235',
    latitude: '34.163290267305'
  },
  610117:
  {
    name: '高陵区',
    parseid: '6101',
    longitude: '109.09438691387',
    latitude: '34.541093106058'
  },
  610118:
  {
    name: '鄠邑区',
    parseid: '6101',
    longitude: '108.61142023271',
    latitude: '34.115020711599'
  },
  610122:
  {
    name: '蓝田县',
    parseid: '6101',
    longitude: '109.32938812681',
    latitude: '34.157620654732'
  },
  610124:
  {
    name: '周至县',
    parseid: '6101',
    longitude: '108.22842183954',
    latitude: '34.169385269616'
  },
  610202:
  {
    name: '王益区',
    parseid: '6102',
    longitude: '109.08141735858',
    latitude: '35.075322096471'
  },
  610203:
  {
    name: '印台区',
    parseid: '6102',
    longitude: '109.10643408907',
    latitude: '35.120859282945'
  },
  610204:
  {
    name: '耀州区',
    parseid: '6102',
    longitude: '108.98643790006',
    latitude: '34.91596030911'
  },
  610222:
  {
    name: '宜君县',
    parseid: '6102',
    longitude: '109.12353674801',
    latitude: '35.404582194219'
  },
  610302:
  {
    name: '渭滨区',
    parseid: '6103',
    longitude: '107.15641916768',
    latitude: '34.377481132682'
  },
  610303:
  {
    name: '金台区',
    parseid: '6103',
    longitude: '107.15342367813',
    latitude: '34.382351084696'
  },
  610304:
  {
    name: '陈仓区',
    parseid: '6103',
    longitude: '107.39343842395',
    latitude: '34.360756335457'
  },
  610322:
  {
    name: '凤翔县',
    parseid: '6103',
    longitude: '107.40737949665',
    latitude: '34.527616279899'
  },
  610323:
  {
    name: '岐山县',
    parseid: '6103',
    longitude: '107.62744727879',
    latitude: '34.449776962387'
  },
  610324:
  {
    name: '扶风县',
    parseid: '6103',
    longitude: '107.9064530651',
    latitude: '34.381463351226'
  },
  610326:
  {
    name: '眉县',
    parseid: '6103',
    longitude: '107.75639813644',
    latitude: '34.280375863086'
  },
  610327:
  {
    name: '陇县',
    parseid: '6103',
    longitude: '106.87058365441',
    latitude: '34.898780253107'
  },
  610328:
  {
    name: '千阳县',
    parseid: '6103',
    longitude: '107.13946616644',
    latitude: '34.648544600794'
  },
  610329:
  {
    name: '麟游县',
    parseid: '6103',
    longitude: '107.799514106',
    latitude: '34.683748667164'
  },
  610330:
  {
    name: '凤县',
    parseid: '6103',
    longitude: '106.52255782187',
    latitude: '33.916583016343'
  },
  610331:
  {
    name: '太白县',
    parseid: '6103',
    longitude: '107.32552913248',
    latitude: '34.064248441153'
  },
  610402:
  {
    name: '秦都区',
    parseid: '6104',
    longitude: '108.71243199239',
    latitude: '34.3351451161'
  },
  610403:
  {
    name: '杨陵区',
    parseid: '6104',
    longitude: '108.09151531881',
    latitude: '34.278012507654'
  },
  610404:
  {
    name: '渭城区',
    parseid: '6104',
    longitude: '108.74345057148',
    latitude: '34.368110229368'
  },
  610422:
  {
    name: '三原县',
    parseid: '6104',
    longitude: '108.94744650025',
    latitude: '34.623078955252'
  },
  610423:
  {
    name: '泾阳县',
    parseid: '6104',
    longitude: '108.84937884705',
    latitude: '34.533316532768'
  },
  610424:
  {
    name: '乾县',
    parseid: '6104',
    longitude: '108.24537762554',
    latitude: '34.534018266142'
  },
  610425:
  {
    name: '礼泉县',
    parseid: '6104',
    longitude: '108.43161549166',
    latitude: '34.487390768504'
  },
  610426:
  {
    name: '永寿县',
    parseid: '6104',
    longitude: '108.14846878644',
    latitude: '34.698035535617'
  },
  610428:
  {
    name: '长武县',
    parseid: '6104',
    longitude: '107.80556078005',
    latitude: '35.211657338715'
  },
  610429:
  {
    name: '旬邑县',
    parseid: '6104',
    longitude: '108.34046703665',
    latitude: '35.117963919719'
  },
  610430:
  {
    name: '淳化县',
    parseid: '6104',
    longitude: '108.58744176373',
    latitude: '34.804776911295'
  },
  610431:
  {
    name: '武功县',
    parseid: '6104',
    longitude: '108.20655106479',
    latitude: '34.266137667633'
  },
  610481:
  {
    name: '兴平市',
    parseid: '6104',
    longitude: '108.49639400877',
    latitude: '34.305476520292'
  },
  610482:
  {
    name: '彬州市',
    parseid: '6104',
    longitude: '108.08456557823',
    latitude: '35.049610571828'
  },
  610502:
  {
    name: '临渭区',
    parseid: '6105',
    longitude: '109.4985962764',
    latitude: '34.504000470428'
  },
  610503:
  {
    name: '华州区',
    parseid: '6105',
    longitude: '109.7784773716',
    latitude: '34.5187307401'
  },
  610522:
  {
    name: '潼关县',
    parseid: '6105',
    longitude: '110.25250761972',
    latitude: '34.550326848532'
  },
  610523:
  {
    name: '大荔县',
    parseid: '6105',
    longitude: '109.94845330291',
    latitude: '34.801832760484'
  },
  610524:
  {
    name: '合阳县',
    parseid: '6105',
    longitude: '110.15539621274',
    latitude: '35.243872196866'
  },
  610525:
  {
    name: '澄城县',
    parseid: '6105',
    longitude: '109.93843360325',
    latitude: '35.196572815551'
  },
  610526:
  {
    name: '蒲城县',
    parseid: '6105',
    longitude: '109.59249651068',
    latitude: '34.961274128783'
  },
  610527:
  {
    name: '白水县',
    parseid: '6105',
    longitude: '109.59752055374',
    latitude: '35.183287514613'
  },
  610528:
  {
    name: '富平县',
    parseid: '6105',
    longitude: '109.18643744728',
    latitude: '34.757260440256'
  },
  610581:
  {
    name: '韩城市',
    parseid: '6105',
    longitude: '110.44955264012',
    latitude: '35.482086787313'
  },
  610582:
  {
    name: '华阴市',
    parseid: '6105',
    longitude: '110.09860075704',
    latitude: '34.571800158753'
  },
  610602:
  {
    name: '宝塔区',
    parseid: '6106',
    longitude: '109.49959402433',
    latitude: '36.596890441313'
  },
  610603:
  {
    name: '安塞区',
    parseid: '6106',
    longitude: '109.33541943984',
    latitude: '36.870098259307'
  },
  610621:
  {
    name: '延长县',
    parseid: '6106',
    longitude: '110.01847172589',
    latitude: '36.585328801705'
  },
  610622:
  {
    name: '延川县',
    parseid: '6106',
    longitude: '110.20054028665',
    latitude: '36.884136960993'
  },
  610625:
  {
    name: '志丹县',
    parseid: '6106',
    longitude: '108.77557747991',
    latitude: '36.828021135864'
  },
  610626:
  {
    name: '吴起县',
    parseid: '6106',
    longitude: '108.18258966361',
    latitude: '36.932576099483'
  },
  610627:
  {
    name: '甘泉县',
    parseid: '6106',
    longitude: '109.35752350454',
    latitude: '36.282688619053'
  },
  610628:
  {
    name: '富县',
    parseid: '6106',
    longitude: '109.38659653355',
    latitude: '35.993367977969'
  },
  610629:
  {
    name: '洛川县',
    parseid: '6106',
    longitude: '109.43840396825',
    latitude: '35.768300429421'
  },
  610630:
  {
    name: '宜川县',
    parseid: '6106',
    longitude: '110.17541306458',
    latitude: '36.056397437854'
  },
  610631:
  {
    name: '黄龙县',
    parseid: '6106',
    longitude: '109.84654907671',
    latitude: '35.590233768069'
  },
  610632:
  {
    name: '黄陵县',
    parseid: '6106',
    longitude: '109.26960598495',
    latitude: '35.585076348969'
  },
  610681:
  {
    name: '子长市',
    parseid: '6106',
    longitude: '109.68138985954',
    latitude: '37.148816918367'
  },
  610702:
  {
    name: '汉台区',
    parseid: '6107',
    longitude: '107.03840167622',
    latitude: '33.074191093099'
  },
  610703:
  {
    name: '南郑区',
    parseid: '6107',
    longitude: '106.94243318334',
    latitude: '33.005614599734'
  },
  610722:
  {
    name: '城固县',
    parseid: '6107',
    longitude: '107.3406125803',
    latitude: '33.162399385178'
  },
  610723:
  {
    name: '洋县',
    parseid: '6107',
    longitude: '107.55246428058',
    latitude: '33.228862589315'
  },
  610724:
  {
    name: '西乡县',
    parseid: '6107',
    longitude: '107.77339281906',
    latitude: '32.989397441895'
  },
  610725:
  {
    name: '勉县',
    parseid: '6107',
    longitude: '106.67942594867',
    latitude: '33.159804746955'
  },
  610726:
  {
    name: '宁强县',
    parseid: '6107',
    longitude: '106.26458864382',
    latitude: '32.835380199209'
  },
  610727:
  {
    name: '略阳县',
    parseid: '6107',
    longitude: '106.16354400616',
    latitude: '33.333193777733'
  },
  610728:
  {
    name: '镇巴县',
    parseid: '6107',
    longitude: '107.9014456407',
    latitude: '32.54283336567'
  },
  610729:
  {
    name: '留坝县',
    parseid: '6107',
    longitude: '106.92741441352',
    latitude: '33.623825216737'
  },
  610730:
  {
    name: '佛坪县',
    parseid: '6107',
    longitude: '107.99742428443',
    latitude: '33.530693101588'
  },
  610802:
  {
    name: '榆阳区',
    parseid: '6108',
    longitude: '109.72755916953',
    latitude: '38.28241962673'
  },
  610803:
  {
    name: '横山区',
    parseid: '6108',
    longitude: '109.30049134534',
    latitude: '37.968573394166'
  },
  610822:
  {
    name: '府谷县',
    parseid: '6108',
    longitude: '111.0736281152',
    latitude: '39.03379562985'
  },
  610824:
  {
    name: '靖边县',
    parseid: '6108',
    longitude: '108.80060049853',
    latitude: '37.605063193955'
  },
  610825:
  {
    name: '定边县',
    parseid: '6108',
    longitude: '107.60756957446',
    latitude: '37.600459865341'
  },
  610826:
  {
    name: '绥德县',
    parseid: '6108',
    longitude: '110.26942648536',
    latitude: '37.508907288933'
  },
  610827:
  {
    name: '米脂县',
    parseid: '6108',
    longitude: '110.19045141747',
    latitude: '37.761397514329'
  },
  610828:
  {
    name: '佳县',
    parseid: '6108',
    longitude: '110.49747741874',
    latitude: '38.025611678572'
  },
  610829:
  {
    name: '吴堡县',
    parseid: '6108',
    longitude: '110.74645500778',
    latitude: '37.458269874078'
  },
  610830:
  {
    name: '清涧县',
    parseid: '6108',
    longitude: '110.12755916227',
    latitude: '37.094852887828'
  },
  610831:
  {
    name: '子洲县',
    parseid: '6108',
    longitude: '110.04239845247',
    latitude: '37.617025887547'
  },
  610881:
  {
    name: '神木市',
    parseid: '6108',
    longitude: '110.50542966826',
    latitude: '38.848544495221'
  },
  610902:
  {
    name: '汉滨区',
    parseid: '6109',
    longitude: '109.03359606476',
    latitude: '32.701196105738'
  },
  610921:
  {
    name: '汉阴县',
    parseid: '6109',
    longitude: '108.51550698561',
    latitude: '32.899120857292'
  },
  610922:
  {
    name: '石泉县',
    parseid: '6109',
    longitude: '108.25442679592',
    latitude: '33.044602110263'
  },
  610923:
  {
    name: '宁陕县',
    parseid: '6109',
    longitude: '108.32056400011',
    latitude: '33.316555486503'
  },
  610924:
  {
    name: '紫阳县',
    parseid: '6109',
    longitude: '108.54159431661',
    latitude: '32.525785619364'
  },
  610925:
  {
    name: '岚皋县',
    parseid: '6109',
    longitude: '108.90861535814',
    latitude: '32.312880776501'
  },
  610926:
  {
    name: '平利县',
    parseid: '6109',
    longitude: '109.36854670128',
    latitude: '32.394804123185'
  },
  610927:
  {
    name: '镇坪县',
    parseid: '6109',
    longitude: '109.53349679292',
    latitude: '31.889643295791'
  },
  610928:
  {
    name: '旬阳县',
    parseid: '6109',
    longitude: '109.37155674338',
    latitude: '32.839864221772'
  },
  610929:
  {
    name: '白河县',
    parseid: '6109',
    longitude: '110.11958688053',
    latitude: '32.814846485284'
  },
  611002:
  {
    name: '商州区',
    parseid: '6110',
    longitude: '109.94747163465',
    latitude: '33.86885529308'
  },
  611021:
  {
    name: '洛南县',
    parseid: '6110',
    longitude: '110.15442748007',
    latitude: '34.097070538846'
  },
  611022:
  {
    name: '丹凤县',
    parseid: '6110',
    longitude: '110.3335602886',
    latitude: '33.701537322921'
  },
  611023:
  {
    name: '商南县',
    parseid: '6110',
    longitude: '110.88840847837',
    latitude: '33.537533476707'
  },
  611024:
  {
    name: '山阳县',
    parseid: '6110',
    longitude: '109.88854863218',
    latitude: '33.537968382769'
  },
  611025:
  {
    name: '镇安县',
    parseid: '6110',
    longitude: '109.15957460914',
    latitude: '33.429044650147'
  },
  611026:
  {
    name: '柞水县',
    parseid: '6110',
    longitude: '109.120502272',
    latitude: '33.692026241945'
  },
  620102:
  {
    name: '城关区',
    parseid: '6201',
    longitude: '103.83147490053',
    latitude: '36.063181475369'
  },
  620103:
  {
    name: '七里河区',
    parseid: '6201',
    longitude: '103.79241388204',
    latitude: '36.07212925843'
  },
  620104:
  {
    name: '西固区',
    parseid: '6201',
    longitude: '103.63458007682',
    latitude: '36.094109365757'
  },
  620105:
  {
    name: '安宁区',
    parseid: '6201',
    longitude: '103.72553503682',
    latitude: '36.109753754973'
  },
  620111:
  {
    name: '红古区',
    parseid: '6201',
    longitude: '102.86542781272',
    latitude: '36.351863423179'
  },
  620121:
  {
    name: '永登县',
    parseid: '6201',
    longitude: '103.26662443823',
    latitude: '36.74209521344'
  },
  620122:
  {
    name: '皋兰县',
    parseid: '6201',
    longitude: '103.95346415997',
    latitude: '36.338142148673'
  },
  620123:
  {
    name: '榆中县',
    parseid: '6201',
    longitude: '104.11956587928',
    latitude: '35.848851048242'
  },
  620171:
  {
    name: '兰州新区',
    parseid: '6201',
    longitude: '103.65886828153',
    latitude: '36.665767925317'
  },
  620302:
  {
    name: '金川区',
    parseid: '6203',
    longitude: '102.20058588614',
    latitude: '38.525772245594'
  },
  620321:
  {
    name: '永昌县',
    parseid: '6203',
    longitude: '101.97946358316',
    latitude: '38.252940956889'
  },
  620402:
  {
    name: '白银区',
    parseid: '6204',
    longitude: '104.15541276065',
    latitude: '36.541463568069'
  },
  620403:
  {
    name: '平川区',
    parseid: '6204',
    longitude: '104.83161394007',
    latitude: '36.733498751869'
  },
  620421:
  {
    name: '靖远县',
    parseid: '6204',
    longitude: '104.68251507796',
    latitude: '36.577096288837'
  },
  620422:
  {
    name: '会宁县',
    parseid: '6204',
    longitude: '105.05960693274',
    latitude: '35.698508053094'
  },
  620423:
  {
    name: '景泰县',
    parseid: '6204',
    longitude: '104.06944438436',
    latitude: '37.187406260097'
  },
  620502:
  {
    name: '秦州区',
    parseid: '6205',
    longitude: '105.73041549435',
    latitude: '34.587315743121'
  },
  620503:
  {
    name: '麦积区',
    parseid: '6205',
    longitude: '105.89559698949',
    latitude: '34.576336861448'
  },
  620521:
  {
    name: '清水县',
    parseid: '6205',
    longitude: '106.14359506621',
    latitude: '34.753882906363'
  },
  620522:
  {
    name: '秦安县',
    parseid: '6205',
    longitude: '105.68157480343',
    latitude: '34.864876111568'
  },
  620523:
  {
    name: '甘谷县',
    parseid: '6205',
    longitude: '105.34247534291',
    latitude: '34.738300137398'
  },
  620524:
  {
    name: '武山县',
    parseid: '6205',
    longitude: '104.89742838309',
    latitude: '34.727669101635'
  },
  620525:
  {
    name: '张家川回族自治县',
    parseid: '6205',
    longitude: '106.21139036271',
    latitude: '34.99490501302'
  },
  620602:
  {
    name: '凉州区',
    parseid: '6206',
    longitude: '102.64857479651',
    latitude: '37.934121948376'
  },
  620621:
  {
    name: '民勤县',
    parseid: '6206',
    longitude: '103.10040027988',
    latitude: '38.630624826433'
  },
  620622:
  {
    name: '古浪县',
    parseid: '6206',
    longitude: '102.90362978165',
    latitude: '37.475801906601'
  },
  620623:
  {
    name: '天祝藏族自治县',
    parseid: '6206',
    longitude: '103.14862131966',
    latitude: '36.97759617654'
  },
  620702:
  {
    name: '甘州区',
    parseid: '6207',
    longitude: '100.48455772128',
    latitude: '38.934781471785'
  },
  620721:
  {
    name: '肃南裕固族自治县',
    parseid: '6207',
    longitude: '99.621905418008',
    latitude: '38.843100205023'
  },
  620722:
  {
    name: '民乐县',
    parseid: '6207',
    longitude: '100.81942903742',
    latitude: '38.436842233981'
  },
  620723:
  {
    name: '临泽县',
    parseid: '6207',
    longitude: '100.17055476077',
    latitude: '39.158514444726'
  },
  620724:
  {
    name: '高台县',
    parseid: '6207',
    longitude: '99.825759504337',
    latitude: '39.383646046807'
  },
  620725:
  {
    name: '山丹县',
    parseid: '6207',
    longitude: '101.09561558172',
    latitude: '38.790452663306'
  },
  620802:
  {
    name: '崆峒区',
    parseid: '6208',
    longitude: '106.68141452757',
    latitude: '35.548814892232'
  },
  620821:
  {
    name: '泾川县',
    parseid: '6208',
    longitude: '107.37451813364',
    latitude: '35.338668597821'
  },
  620822:
  {
    name: '灵台县',
    parseid: '6208',
    longitude: '107.62746120252',
    latitude: '35.07158181696'
  },
  620823:
  {
    name: '崇信县',
    parseid: '6208',
    longitude: '107.04141513189',
    latitude: '35.308615839828'
  },
  620825:
  {
    name: '庄浪县',
    parseid: '6208',
    longitude: '106.04258582178',
    latitude: '35.208192125804'
  },
  620826:
  {
    name: '静宁县',
    parseid: '6208',
    longitude: '105.73841580322',
    latitude: '35.528257189136'
  },
  620881:
  {
    name: '华亭市',
    parseid: '6208',
    longitude: '106.65948599177',
    latitude: '35.223550762897'
  },
  620902:
  {
    name: '肃州区',
    parseid: '6209',
    longitude: '98.514321853032',
    latitude: '39.751245509963'
  },
  620921:
  {
    name: '金塔县',
    parseid: '6209',
    longitude: '98.908368236172',
    latitude: '39.990029254093'
  },
  620922:
  {
    name: '瓜州县',
    parseid: '6209',
    longitude: '95.788736364512',
    latitude: '40.52610597895'
  },
  620923:
  {
    name: '肃北蒙古族自治县',
    parseid: '6209',
    longitude: '94.883692395412',
    latitude: '39.518329738436'
  },
  620924:
  {
    name: '阿克塞哈萨克族自治县',
    parseid: '6209',
    longitude: '94.346760190396',
    latitude: '39.640045316917'
  },
  620981:
  {
    name: '玉门市',
    parseid: '6209',
    longitude: '97.051711691182',
    latitude: '40.297620020884'
  },
  620982:
  {
    name: '敦煌市',
    parseid: '6209',
    longitude: '94.668527025762',
    latitude: '40.147867484244'
  },
  621002:
  {
    name: '西峰区',
    parseid: '6210',
    longitude: '107.65739112517',
    latitude: '35.736864475978'
  },
  621021:
  {
    name: '庆城县',
    parseid: '6210',
    longitude: '107.88840619724',
    latitude: '36.021726360644'
  },
  621022:
  {
    name: '环县',
    parseid: '6210',
    longitude: '107.31446964419',
    latitude: '36.574427108907'
  },
  621023:
  {
    name: '华池县',
    parseid: '6210',
    longitude: '107.99638952632',
    latitude: '36.467575129884'
  },
  621024:
  {
    name: '合水县',
    parseid: '6210',
    longitude: '108.026447188',
    latitude: '35.8252622164'
  },
  621025:
  {
    name: '正宁县',
    parseid: '6210',
    longitude: '108.36637461671',
    latitude: '35.498218780898'
  },
  621026:
  {
    name: '宁县',
    parseid: '6210',
    longitude: '107.93457092587',
    latitude: '35.507932974537'
  },
  621027:
  {
    name: '镇原县',
    parseid: '6210',
    longitude: '107.20757586986',
    latitude: '35.683230586316'
  },
  621102:
  {
    name: '安定区',
    parseid: '6211',
    longitude: '104.61650040265',
    latitude: '35.585600016725'
  },
  621121:
  {
    name: '通渭县',
    parseid: '6211',
    longitude: '105.24840362211',
    latitude: '35.217216821266'
  },
  621122:
  {
    name: '陇西县',
    parseid: '6211',
    longitude: '104.64138059069',
    latitude: '35.010197162318'
  },
  621123:
  {
    name: '渭源县',
    parseid: '6211',
    longitude: '104.22158401062',
    latitude: '35.142391958021'
  },
  621124:
  {
    name: '临洮县',
    parseid: '6211',
    longitude: '103.8656010777',
    latitude: '35.400587040258'
  },
  621125:
  {
    name: '漳县',
    parseid: '6211',
    longitude: '104.4785953255',
    latitude: '34.854249981778'
  },
  621126:
  {
    name: '岷县',
    parseid: '6211',
    longitude: '104.04339603983',
    latitude: '34.44440764065'
  },
  621202:
  {
    name: '武都区',
    parseid: '6212',
    longitude: '104.93259336075',
    latitude: '33.398072188089'
  },
  621221:
  {
    name: '成县',
    parseid: '6212',
    longitude: '105.7484779029',
    latitude: '33.756635187351'
  },
  621222:
  {
    name: '文县',
    parseid: '6212',
    longitude: '104.68955842198',
    latitude: '32.949601280768'
  },
  621223:
  {
    name: '宕昌县',
    parseid: '6212',
    longitude: '104.39938579987',
    latitude: '34.053486291359'
  },
  621224:
  {
    name: '康县',
    parseid: '6212',
    longitude: '105.61539187549',
    latitude: '33.335376401996'
  },
  621225:
  {
    name: '西和县',
    parseid: '6212',
    longitude: '105.30761048912',
    latitude: '34.016787358437'
  },
  621226:
  {
    name: '礼县',
    parseid: '6212',
    longitude: '105.1835909694',
    latitude: '34.194685061207'
  },
  621227:
  {
    name: '徽县',
    parseid: '6212',
    longitude: '106.09441787005',
    latitude: '33.77519418709'
  },
  621228:
  {
    name: '两当县',
    parseid: '6212',
    longitude: '106.31141946599',
    latitude: '33.915122835173'
  },
  622901:
  {
    name: '临夏市',
    parseid: '6229',
    longitude: '103.2495491776',
    latitude: '35.609898772689'
  },
  622921:
  {
    name: '临夏县',
    parseid: '6229',
    longitude: '103.2495491776',
    latitude: '35.609898772689'
  },
  622922:
  {
    name: '康乐县',
    parseid: '6229',
    longitude: '103.71547554223',
    latitude: '35.376109760702'
  },
  622923:
  {
    name: '永靖县',
    parseid: '6229',
    longitude: '103.29250749455',
    latitude: '35.963330304471'
  },
  622924:
  {
    name: '广河县',
    parseid: '6229',
    longitude: '103.58240999619',
    latitude: '35.494101361696'
  },
  622925:
  {
    name: '和政县',
    parseid: '6229',
    longitude: '103.35752370329',
    latitude: '35.430589904166'
  },
  622926:
  {
    name: '东乡族自治县',
    parseid: '6229',
    longitude: '116.60954171505',
    latitude: '28.253977397999'
  },
  622927:
  {
    name: '积石山保安族东乡族撒拉族自治县',
    parseid: '6229',
    longitude: '103.05835652778',
    latitude: '35.787165663563'
  },
  623001:
  {
    name: '合作市',
    parseid: '6230',
    longitude: '102.917571573',
    latitude: '35.005935428196'
  },
  623021:
  {
    name: '临潭县',
    parseid: '6230',
    longitude: '103.36053329624',
    latitude: '34.698639411522'
  },
  623022:
  {
    name: '卓尼县',
    parseid: '6230',
    longitude: '103.51361578396',
    latitude: '34.594916432804'
  },
  623023:
  {
    name: '舟曲县',
    parseid: '6230',
    longitude: '104.37748996239',
    latitude: '33.790814973644'
  },
  623024:
  {
    name: '迭部县',
    parseid: '6230',
    longitude: '103.22844034558',
    latitude: '34.062020054097'
  },
  623025:
  {
    name: '玛曲县',
    parseid: '6230',
    longitude: '102.07860004026',
    latitude: '34.003358168342'
  },
  623026:
  {
    name: '碌曲县',
    parseid: '6230',
    longitude: '102.49442413371',
    latitude: '34.597087271566'
  },
  623027:
  {
    name: '夏河县',
    parseid: '6230',
    longitude: '102.52857708038',
    latitude: '35.208324325541'
  },
  630102:
  {
    name: '城东区',
    parseid: '6301',
    longitude: '101.80956903833',
    latitude: '36.605707645661'
  },
  630103:
  {
    name: '城中区',
    parseid: '6301',
    longitude: '101.79048354964',
    latitude: '36.628800570589'
  },
  630104:
  {
    name: '城西区',
    parseid: '6301',
    longitude: '101.77241422413',
    latitude: '36.634496979524'
  },
  630105:
  {
    name: '城北区',
    parseid: '6301',
    longitude: '101.77240488176',
    latitude: '36.656293630837'
  },
  630121:
  {
    name: '大通回族土族自治县',
    parseid: '6301',
    longitude: '101.69256375752',
    latitude: '36.932666463407'
  },
  630122:
  {
    name: '湟中县',
    parseid: '6301',
    longitude: '101.57861675782',
    latitude: '36.506627546281'
  },
  630123:
  {
    name: '湟源县',
    parseid: '6301',
    longitude: '101.26244861154',
    latitude: '36.688587514903'
  },
  630202:
  {
    name: '乐都区',
    parseid: '6302',
    longitude: '102.40856633883',
    latitude: '36.487820051522'
  },
  630203:
  {
    name: '平安区',
    parseid: '6302',
    longitude: '102.11442787756',
    latitude: '36.506553573162'
  },
  630222:
  {
    name: '民和回族土族自治县',
    parseid: '6302',
    longitude: '102.83638963796',
    latitude: '36.325561401871'
  },
  630223:
  {
    name: '互助土族自治县',
    parseid: '6302',
    longitude: '101.96456904899',
    latitude: '36.850021613826'
  },
  630224:
  {
    name: '化隆回族自治县',
    parseid: '6302',
    longitude: '102.27044827345',
    latitude: '36.100988250893'
  },
  630225:
  {
    name: '循化撒拉族自治县',
    parseid: '6302',
    longitude: '102.4953853206',
    latitude: '35.856667223862'
  },
  632221:
  {
    name: '门源回族自治县',
    parseid: '6322',
    longitude: '101.62843803903',
    latitude: '37.382180626313'
  },
  632222:
  {
    name: '祁连县',
    parseid: '6322',
    longitude: '100.25962157243',
    latitude: '38.182924871569'
  },
  632223:
  {
    name: '海晏县',
    parseid: '6322',
    longitude: '101.0005855486',
    latitude: '36.902376022515'
  },
  632224:
  {
    name: '刚察县',
    parseid: '6322',
    longitude: '100.15360607139',
    latitude: '37.327320072254'
  },
  632321:
  {
    name: '同仁县',
    parseid: '6323',
    longitude: '102.0254377812',
    latitude: '35.521865150524'
  },
  632322:
  {
    name: '尖扎县',
    parseid: '6323',
    longitude: '102.0375073242',
    latitude: '35.944284459868'
  },
  632323:
  {
    name: '泽库县',
    parseid: '6323',
    longitude: '101.47359451319',
    latitude: '35.0420144951'
  },
  632324:
  {
    name: '河南蒙古族自治县',
    parseid: '6323',
    longitude: '101.62247338027',
    latitude: '34.740396071091'
  },
  632521:
  {
    name: '共和县',
    parseid: '6325',
    longitude: '100.62662348005',
    latitude: '36.288703317865'
  },
  632522:
  {
    name: '同德县',
    parseid: '6325',
    longitude: '100.58542386564',
    latitude: '35.259857775817'
  },
  632523:
  {
    name: '贵德县',
    parseid: '6325',
    longitude: '101.43953310384',
    latitude: '36.046158080751'
  },
  632524:
  {
    name: '兴海县',
    parseid: '6325',
    longitude: '99.994380072293',
    latitude: '35.594629879949'
  },
  632525:
  {
    name: '贵南县',
    parseid: '6325',
    longitude: '100.75359321473',
    latitude: '35.592415454611'
  },
  632621:
  {
    name: '玛沁县',
    parseid: '6326',
    longitude: '100.24556434882',
    latitude: '34.483569486002'
  },
  632622:
  {
    name: '班玛县',
    parseid: '6326',
    longitude: '100.74360459645',
    latitude: '32.93850392747'
  },
  632623:
  {
    name: '甘德县',
    parseid: '6326',
    longitude: '99.907510695578',
    latitude: '33.975003677602'
  },
  632624:
  {
    name: '达日县',
    parseid: '6326',
    longitude: '99.658010113065',
    latitude: '33.754937373991'
  },
  632625:
  {
    name: '久治县',
    parseid: '6326',
    longitude: '101.48853225585',
    latitude: '33.434773499408'
  },
  632626:
  {
    name: '玛多县',
    parseid: '6326',
    longitude: '98.215883832099',
    latitude: '34.920748646186'
  },
  632701:
  {
    name: '玉树市',
    parseid: '6327',
    longitude: '97.015376401101',
    latitude: '32.999555650886'
  },
  632722:
  {
    name: '杂多县',
    parseid: '6327',
    longitude: '95.306964878828',
    latitude: '32.89924067586'
  },
  632723:
  {
    name: '称多县',
    parseid: '6327',
    longitude: '97.115000009277',
    latitude: '33.374225698944'
  },
  632724:
  {
    name: '治多县',
    parseid: '6327',
    longitude: '95.61979357437',
    latitude: '33.857953267719'
  },
  632725:
  {
    name: '囊谦县',
    parseid: '6327',
    longitude: '96.486918271283',
    latitude: '32.209194368698'
  },
  632726:
  {
    name: '曲麻莱县',
    parseid: '6327',
    longitude: '95.803750013992',
    latitude: '34.132298666997'
  },
  632801:
  {
    name: '格尔木市',
    parseid: '6328',
    longitude: '94.933310210425',
    latitude: '36.412371046954'
  },
  632802:
  {
    name: '德令哈市',
    parseid: '6328',
    longitude: '97.367470299975',
    latitude: '37.375345907463'
  },
  632803:
  {
    name: '茫崖市',
    parseid: '6328',
    longitude: '90.87951750334',
    latitude: '38.261902814972'
  },
  632821:
  {
    name: '乌兰县',
    parseid: '6328',
    longitude: '98.486735699295',
    latitude: '36.935747859032'
  },
  632822:
  {
    name: '都兰县',
    parseid: '6328',
    longitude: '98.102704793777',
    latitude: '36.307611028682'
  },
  632823:
  {
    name: '天峻县',
    parseid: '6328',
    longitude: '99.029242967967',
    latitude: '37.306903395111'
  },
  632857:
  {
    name: '大柴旦行政委员会',
    parseid: '6328',
    longitude: '95.371983782488',
    latitude: '37.858584310296'
  },
  640104:
  {
    name: '兴庆区',
    parseid: '6401',
    longitude: '106.29549376692',
    latitude: '38.479578929456'
  },
  640105:
  {
    name: '西夏区',
    parseid: '6401',
    longitude: '106.15658124015',
    latitude: '38.496817469604'
  },
  640106:
  {
    name: '金凤区',
    parseid: '6401',
    longitude: '106.24956089094',
    latitude: '38.478695238722'
  },
  640121:
  {
    name: '永宁县',
    parseid: '6401',
    longitude: '106.25960457536',
    latitude: '38.283001541521'
  },
  640122:
  {
    name: '贺兰县',
    parseid: '6401',
    longitude: '106.3565182653',
    latitude: '38.560406689579'
  },
  640181:
  {
    name: '灵武市',
    parseid: '6401',
    longitude: '106.34644035545',
    latitude: '38.108658666793'
  },
  640202:
  {
    name: '大武口区',
    parseid: '6402',
    longitude: '106.3746104976',
    latitude: '39.024847756627'
  },
  640205:
  {
    name: '惠农区',
    parseid: '6402',
    longitude: '106.7884300223',
    latitude: '39.24538810836'
  },
  640221:
  {
    name: '平罗县',
    parseid: '6402',
    longitude: '106.53651847763',
    latitude: '38.91960682591'
  },
  640302:
  {
    name: '利通区',
    parseid: '6403',
    longitude: '106.21940702074',
    latitude: '37.990746080857'
  },
  640303:
  {
    name: '红寺堡区',
    parseid: '6403',
    longitude: '106.06842117808',
    latitude: '37.431882454446'
  },
  640323:
  {
    name: '盐池县',
    parseid: '6403',
    longitude: '107.41337954864',
    latitude: '37.789295649909'
  },
  640324:
  {
    name: '同心县',
    parseid: '6403',
    longitude: '105.9205990776',
    latitude: '36.986269629165'
  },
  640381:
  {
    name: '青铜峡市',
    parseid: '6403',
    longitude: '106.08537031661',
    latitude: '38.027412223967'
  },
  640402:
  {
    name: '原州区',
    parseid: '6404',
    longitude: '106.29451461392',
    latitude: '36.009367675763'
  },
  640422:
  {
    name: '西吉县',
    parseid: '6404',
    longitude: '105.73538590857',
    latitude: '35.97007642089'
  },
  640423:
  {
    name: '隆德县',
    parseid: '6404',
    longitude: '106.1184982967',
    latitude: '35.631762315094'
  },
  640424:
  {
    name: '泾源县',
    parseid: '6404',
    longitude: '106.33739343083',
    latitude: '35.504361637679'
  },
  640425:
  {
    name: '彭阳县',
    parseid: '6404',
    longitude: '106.64454429656',
    latitude: '35.85540546349'
  },
  640502:
  {
    name: '沙坡头区',
    parseid: '6405',
    longitude: '105.20357090089',
    latitude: '37.505701418703'
  },
  640521:
  {
    name: '中宁县',
    parseid: '6405',
    longitude: '105.6915371912',
    latitude: '37.497420805579'
  },
  640522:
  {
    name: '海原县',
    parseid: '6405',
    longitude: '105.65055514638',
    latitude: '36.570781489719'
  },
  650102:
  {
    name: '天山区',
    parseid: '6501',
    longitude: '87.638407777566',
    latitude: '43.800271358313'
  },
  650103:
  {
    name: '沙依巴克区',
    parseid: '6501',
    longitude: '87.604670027697',
    latitude: '43.807262352761'
  },
  650104:
  {
    name: '新市区',
    parseid: '6501',
    longitude: '87.575908441201',
    latitude: '43.861394002748'
  },
  650105:
  {
    name: '水磨沟区',
    parseid: '6501',
    longitude: '87.648896662192',
    latitude: '43.838251163831'
  },
  650106:
  {
    name: '头屯河区',
    parseid: '6501',
    longitude: '87.434506709858',
    latitude: '43.882653022602'
  },
  650107:
  {
    name: '达坂城区',
    parseid: '6501',
    longitude: '88.317397656607',
    latitude: '43.36994274634'
  },
  650109:
  {
    name: '米东区',
    parseid: '6501',
    longitude: '87.662134271848',
    latitude: '43.979247426398'
  },
  650121:
  {
    name: '乌鲁木齐县',
    parseid: '6501',
    longitude: '87.416028745179',
    latitude: '43.477086065793'
  },
  650202:
  {
    name: '独山子区',
    parseid: '6502',
    longitude: '84.893613283343',
    latitude: '44.334407392365'
  },
  650203:
  {
    name: '克拉玛依区',
    parseid: '6502',
    longitude: '84.866221962114',
    latitude: '45.596624206981'
  },
  650204:
  {
    name: '白碱滩区',
    parseid: '6502',
    longitude: '85.139510123686',
    latitude: '45.693951629764'
  },
  650205:
  {
    name: '乌尔禾区',
    parseid: '6502',
    longitude: '85.700304826442',
    latitude: '46.095295184689'
  },
  650402:
  {
    name: '高昌区',
    parseid: '6504',
    longitude: '89.192458882701',
    latitude: '42.948548691684'
  },
  650421:
  {
    name: '鄯善县',
    parseid: '6504',
    longitude: '90.220093886103',
    latitude: '42.874759228479'
  },
  650422:
  {
    name: '托克逊县',
    parseid: '6504',
    longitude: '88.660164359541',
    latitude: '42.798545831023'
  },
  650502:
  {
    name: '伊州区',
    parseid: '6505',
    longitude: '93.521320462369',
    latitude: '42.832824924721'
  },
  650521:
  {
    name: '巴里坤哈萨克自治县',
    parseid: '6505',
    longitude: '87.649943637264',
    latitude: '43.788228697652'
  },
  650522:
  {
    name: '伊吾县',
    parseid: '6505',
    longitude: '94.703825671285',
    latitude: '43.260676527466'
  },
  652301:
  {
    name: '昌吉市',
    parseid: '6523',
    longitude: '87.27386462195',
    latitude: '44.020126845939'
  },
  652302:
  {
    name: '阜康市',
    parseid: '6523',
    longitude: '87.993677905062',
    latitude: '44.163137321346'
  },
  652323:
  {
    name: '呼图壁县',
    parseid: '6523',
    longitude: '86.905143806731',
    latitude: '44.197654596132'
  },
  652324:
  {
    name: '玛纳斯县',
    parseid: '6523',
    longitude: '86.220643452199',
    latitude: '44.3100628588'
  },
  652325:
  {
    name: '奇台县',
    parseid: '6523',
    longitude: '89.601080811724',
    latitude: '44.026897819018'
  },
  652327:
  {
    name: '吉木萨尔县',
    parseid: '6523',
    longitude: '89.187122858141',
    latitude: '44.005717795203'
  },
  652328:
  {
    name: '木垒哈萨克自治县',
    parseid: '6523',
    longitude: '90.292514737334',
    latitude: '43.840308302807'
  },
  652701:
  {
    name: '博乐市',
    parseid: '6527',
    longitude: '82.057972254591',
    latitude: '44.860009784639'
  },
  652702:
  {
    name: '阿拉山口市',
    parseid: '6527',
    longitude: '83.007503636097',
    latitude: '45.011091867208'
  },
  652722:
  {
    name: '精河县',
    parseid: '6527',
    longitude: '82.900655316205',
    latitude: '44.606645943492'
  },
  652723:
  {
    name: '温泉县',
    parseid: '6527',
    longitude: '81.031145546486',
    latitude: '44.974856638705'
  },
  652801:
  {
    name: '库尔勒市',
    parseid: '6528',
    longitude: '86.181494309938',
    latitude: '41.732373221412'
  },
  652822:
  {
    name: '轮台县',
    parseid: '6528',
    longitude: '84.258212152054',
    latitude: '41.783813000515'
  },
  652823:
  {
    name: '尉犁县',
    parseid: '6528',
    longitude: '86.266036536399',
    latitude: '41.350122782054'
  },
  652824:
  {
    name: '若羌县',
    parseid: '6528',
    longitude: '88.175324441896',
    latitude: '39.028991037175'
  },
  652825:
  {
    name: '且末县',
    parseid: '6528',
    longitude: '85.535990385731',
    latitude: '38.15138769413'
  },
  652826:
  {
    name: '焉耆回族自治县',
    parseid: '6528',
    longitude: '86.581222026277',
    latitude: '42.064850858728'
  },
  652827:
  {
    name: '和静县',
    parseid: '6528',
    longitude: '86.390398220692',
    latitude: '42.329365035879'
  },
  652828:
  {
    name: '和硕县',
    parseid: '6528',
    longitude: '86.883689037252',
    latitude: '42.288065062428'
  },
  652829:
  {
    name: '博湖县',
    parseid: '6528',
    longitude: '86.638469149986',
    latitude: '41.986430356829'
  },
  652871:
  {
    name: '库尔勒经济技术开发区',
    parseid: '6528',
    longitude: '86.181494309938',
    latitude: '41.732373221412'
  },
  652901:
  {
    name: '阿克苏市',
    parseid: '6529',
    longitude: '80.269926757334',
    latitude: '41.173859926953'
  },
  652922:
  {
    name: '温宿县',
    parseid: '6529',
    longitude: '80.245564352581',
    latitude: '41.282567249887'
  },
  652923:
  {
    name: '库车县',
    parseid: '6529',
    longitude: '82.968458787284',
    latitude: '41.723447514833'
  },
  652924:
  {
    name: '沙雅县',
    parseid: '6529',
    longitude: '82.788823736148',
    latitude: '41.227749329027'
  },
  652925:
  {
    name: '新和县',
    parseid: '6529',
    longitude: '82.615823030526',
    latitude: '41.553999628477'
  },
  652926:
  {
    name: '拜城县',
    parseid: '6529',
    longitude: '81.858516272038',
    latitude: '41.800706601984'
  },
  652927:
  {
    name: '乌什县',
    parseid: '6529',
    longitude: '79.230868990897',
    latitude: '41.220871106999'
  },
  652928:
  {
    name: '阿瓦提县',
    parseid: '6529',
    longitude: '80.381849245908',
    latitude: '40.649358802911'
  },
  652929:
  {
    name: '柯坪县',
    parseid: '6529',
    longitude: '79.053213535614',
    latitude: '40.514055520966'
  },
  653001:
  {
    name: '阿图什市',
    parseid: '6530',
    longitude: '76.174906408698',
    latitude: '39.722079128589'
  },
  653022:
  {
    name: '阿克陶县',
    parseid: '6530',
    longitude: '75.953725266709',
    latitude: '39.153888517642'
  },
  653023:
  {
    name: '阿合奇县',
    parseid: '6530',
    longitude: '78.45253927839',
    latitude: '40.942958224222'
  },
  653024:
  {
    name: '乌恰县',
    parseid: '6530',
    longitude: '75.26533363237',
    latitude: '39.725123590953'
  },
  653101:
  {
    name: '喀什市',
    parseid: '6531',
    longitude: '76.000312737915',
    latitude: '39.473649532912'
  },
  653121:
  {
    name: '疏附县',
    parseid: '6531',
    longitude: '75.869168667361',
    latitude: '39.381291555212'
  },
  653122:
  {
    name: '疏勒县',
    parseid: '6531',
    longitude: '76.056614395075',
    latitude: '39.406709108732'
  },
  653123:
  {
    name: '英吉沙县',
    parseid: '6531',
    longitude: '76.182075425651',
    latitude: '38.935670863521'
  },
  653124:
  {
    name: '泽普县',
    parseid: '6531',
    longitude: '77.266559423761',
    latitude: '38.190725516333'
  },
  653125:
  {
    name: '莎车县',
    parseid: '6531',
    longitude: '77.252436713686',
    latitude: '38.420156752419'
  },
  653126:
  {
    name: '叶城县',
    parseid: '6531',
    longitude: '77.420097621865',
    latitude: '37.889166844427'
  },
  653127:
  {
    name: '麦盖提县',
    parseid: '6531',
    longitude: '77.658824287414',
    latitude: '38.911194315553'
  },
  653128:
  {
    name: '岳普湖县',
    parseid: '6531',
    longitude: '76.78414771574',
    latitude: '39.239387333945'
  },
  653129:
  {
    name: '伽师县',
    parseid: '6531',
    longitude: '76.730385568257',
    latitude: '39.493851605868'
  },
  653130:
  {
    name: '巴楚县',
    parseid: '6531',
    longitude: '78.5557014018',
    latitude: '39.79078837708'
  },
  653131:
  {
    name: '塔什库尔干塔吉克自治县',
    parseid: '6531',
    longitude: '75.230804744838',
    latitude: '37.779045640763'
  },
  653201:
  {
    name: '和田市',
    parseid: '6532',
    longitude: '79.920212469755',
    latitude: '37.118335544466'
  },
  653221:
  {
    name: '和田县',
    parseid: '6532',
    longitude: '79.920212469755',
    latitude: '37.118335544466'
  },
  653222:
  {
    name: '墨玉县',
    parseid: '6532',
    longitude: '79.735479265358',
    latitude: '37.282993446907'
  },
  653223:
  {
    name: '皮山县',
    parseid: '6532',
    longitude: '78.289871062405',
    latitude: '37.627248714375'
  },
  653224:
  {
    name: '洛浦县',
    parseid: '6532',
    longitude: '80.195387611879',
    latitude: '37.079611030988'
  },
  653225:
  {
    name: '策勒县',
    parseid: '6532',
    longitude: '80.813201268742',
    latitude: '37.004122359371'
  },
  653226:
  {
    name: '于田县',
    parseid: '6532',
    longitude: '81.683782914748',
    latitude: '36.86295413611'
  },
  653227:
  {
    name: '民丰县',
    parseid: '6532',
    longitude: '82.702713427589',
    latitude: '37.070256968231'
  },
  654002:
  {
    name: '伊宁市',
    parseid: '6540',
    longitude: '81.284242405278',
    latitude: '43.915299436243'
  },
  654003:
  {
    name: '奎屯市',
    parseid: '6540',
    longitude: '84.909449241687',
    latitude: '44.432057210004'
  },
  654004:
  {
    name: '霍尔果斯市',
    parseid: '6540',
    longitude: '80.427129772427',
    latitude: '44.235308556093'
  },
  654021:
  {
    name: '伊宁县',
    parseid: '6540',
    longitude: '81.284242405278',
    latitude: '43.915299436243'
  },
  654022:
  {
    name: '察布查尔锡伯自治县',
    parseid: '6540',
    longitude: '81.157924570907',
    latitude: '43.846690330452'
  },
  654023:
  {
    name: '霍城县',
    parseid: '6540',
    longitude: '80.885281123201',
    latitude: '44.062249507399'
  },
  654024:
  {
    name: '巩留县',
    parseid: '6540',
    longitude: '82.238225609409',
    latitude: '43.488485559536'
  },
  654025:
  {
    name: '新源县',
    parseid: '6540',
    longitude: '83.267022301497',
    latitude: '43.435927002185'
  },
  654026:
  {
    name: '昭苏县',
    parseid: '6540',
    longitude: '81.137377539147',
    latitude: '43.163496741509'
  },
  654027:
  {
    name: '特克斯县',
    parseid: '6540',
    longitude: '81.842587249244',
    latitude: '43.224248213467'
  },
  654028:
  {
    name: '尼勒克县',
    parseid: '6540',
    longitude: '82.51800753168',
    latitude: '43.804594836238'
  },
  654201:
  {
    name: '塔城市',
    parseid: '6542',
    longitude: '82.98553242099',
    latitude: '46.754346904188'
  },
  654202:
  {
    name: '乌苏市',
    parseid: '6542',
    longitude: '84.720088146964',
    latitude: '44.424048034452'
  },
  654221:
  {
    name: '额敏县',
    parseid: '6542',
    longitude: '83.633374454783',
    latitude: '46.531884861309'
  },
  654223:
  {
    name: '沙湾县',
    parseid: '6542',
    longitude: '85.626144686035',
    latitude: '44.331949461741'
  },
  654224:
  {
    name: '托里县',
    parseid: '6542',
    longitude: '83.612909438315',
    latitude: '45.94274280505'
  },
  654225:
  {
    name: '裕民县',
    parseid: '6542',
    longitude: '82.9894387025',
    latitude: '46.207453546928'
  },
  654226:
  {
    name: '和布克赛尔蒙古自治县',
    parseid: '6542',
    longitude: '85.735008883548',
    latitude: '46.798685112637'
  },
  654301:
  {
    name: '阿勒泰市',
    parseid: '6543',
    longitude: '88.139226564024',
    latitude: '47.832752648475'
  },
  654321:
  {
    name: '布尔津县',
    parseid: '6543',
    longitude: '86.881360170273',
    latitude: '47.707951723888'
  },
  654322:
  {
    name: '富蕴县',
    parseid: '6543',
    longitude: '89.531953408055',
    latitude: '46.999951053055'
  },
  654323:
  {
    name: '福海县',
    parseid: '6543',
    longitude: '87.493157246325',
    latitude: '47.118140737535'
  },
  654324:
  {
    name: '哈巴河县',
    parseid: '6543',
    longitude: '86.424817684664',
    latitude: '48.066148902458'
  },
  654325:
  {
    name: '青河县',
    parseid: '6543',
    longitude: '90.389444407193',
    latitude: '46.68019396705'
  },
  654326:
  {
    name: '吉木乃县',
    parseid: '6543',
    longitude: '85.880818240706',
    latitude: '47.449018413257'
  },
  659001:
  {
    name: '石河子市',
    parseid: '6590',
    longitude: '86.086885671933',
    latitude: '44.311976478063'
  },
  659002:
  {
    name: '阿拉尔市',
    parseid: '6590',
    longitude: '81.287354225395',
    latitude: '40.553263894706'
  },
  659003:
  {
    name: '图木舒克市',
    parseid: '6590',
    longitude: '79.075616286896',
    latitude: '39.871209077425'
  },
  659004:
  {
    name: '五家渠市',
    parseid: '6590',
    longitude: '87.549936632296',
    latitude: '44.172444518901'
  },
  659006:
  {
    name: '铁门关市',
    parseid: '6590',
    longitude: '106.58121087124',
    latitude: '29.556582391102'
  },
  441900003:
  {
    name: '东城街道',
    parseid: '4419',
    longitude: '113.80481477362',
    latitude: '23.022833305041'
  },
  441900004:
  {
    name: '南城街道',
    parseid: '4419',
    longitude: '113.74572814213',
    latitude: '22.982555228453'
  },
  441900005:
  {
    name: '万江街道',
    parseid: '4419',
    longitude: '113.7111790607',
    latitude: '23.049336149727'
  },
  441900006:
  {
    name: '莞城街道',
    parseid: '4419',
    longitude: '113.76556595539',
    latitude: '23.046434889292'
  },
  441900101:
  {
    name: '石碣镇',
    parseid: '4419',
    longitude: '113.80408440632',
    latitude: '23.10874912821'
  },
  441900102:
  {
    name: '石龙镇',
    parseid: '4419',
    longitude: '113.87279180539',
    latitude: '23.112431716324'
  },
  441900103:
  {
    name: '茶山镇',
    parseid: '4419',
    longitude: '113.8923872666',
    latitude: '23.067202434101'
  },
  441900104:
  {
    name: '石排镇',
    parseid: '4419',
    longitude: '113.95440458389',
    latitude: '23.093064230407'
  },
  441900105:
  {
    name: '企石镇',
    parseid: '4419',
    longitude: '114.05457195163',
    latitude: '23.070449404116'
  },
  441900106:
  {
    name: '横沥镇',
    parseid: '4419',
    longitude: '113.98568798972',
    latitude: '23.034887870789'
  },
  441900107:
  {
    name: '桥头镇',
    parseid: '4419',
    longitude: '114.09761952959',
    latitude: '23.023236543474'
  },
  441900108:
  {
    name: '谢岗镇',
    parseid: '4419',
    longitude: '114.18046228866',
    latitude: '22.953779112677'
  },
  441900109:
  {
    name: '东坑镇',
    parseid: '4419',
    longitude: '113.94447484414',
    latitude: '23.003200353385'
  },
  441900110:
  {
    name: '常平镇',
    parseid: '4419',
    longitude: '114.02920715831',
    latitude: '22.972466836751'
  },
  441900111:
  {
    name: '寮步镇',
    parseid: '4419',
    longitude: '113.87302146707',
    latitude: '23.001251028984'
  },
  441900112:
  {
    name: '樟木头镇',
    parseid: '4419',
    longitude: '114.11465002764',
    latitude: '22.917267758647'
  },
  441900113:
  {
    name: '大朗镇',
    parseid: '4419',
    longitude: '113.93187987327',
    latitude: '22.910666047644'
  },
  441900114:
  {
    name: '黄江镇',
    parseid: '4419',
    longitude: '114.00984368',
    latitude: '22.867225031632'
  },
  441900115:
  {
    name: '清溪镇',
    parseid: '4419',
    longitude: '114.17967006494',
    latitude: '22.849480919841'
  },
  441900116:
  {
    name: '塘厦镇',
    parseid: '4419',
    longitude: '114.08203275042',
    latitude: '22.806522591538'
  },
  441900117:
  {
    name: '凤岗镇',
    parseid: '4419',
    longitude: '114.17164255089',
    latitude: '22.733065315158'
  },
  441900118:
  {
    name: '大岭山镇',
    parseid: '4419',
    longitude: '113.83771195655',
    latitude: '22.905663086015'
  },
  441900119:
  {
    name: '长安镇',
    parseid: '4419',
    longitude: '113.78176751509',
    latitude: '22.796971654086'
  },
  441900121:
  {
    name: '虎门镇',
    parseid: '4419',
    longitude: '113.70816729744',
    latitude: '22.824018534621'
  },
  441900122:
  {
    name: '厚街镇',
    parseid: '4419',
    longitude: '113.70364193073',
    latitude: '22.920643184166'
  },
  441900123:
  {
    name: '沙田镇',
    parseid: '4419',
    longitude: '113.60719961855',
    latitude: '22.896678614848'
  },
  441900124:
  {
    name: '道滘镇',
    parseid: '4419',
    longitude: '113.66065444761',
    latitude: '22.994734005755'
  },
  441900125:
  {
    name: '洪梅镇',
    parseid: '4419',
    longitude: '113.6128350097',
    latitude: '22.983420718495'
  },
  441900126:
  {
    name: '麻涌镇',
    parseid: '4419',
    longitude: '113.57376368856',
    latitude: '23.039226355835'
  },
  441900127:
  {
    name: '望牛墩镇',
    parseid: '4419',
    longitude: '113.64297848561',
    latitude: '23.049228783407'
  },
  441900128:
  {
    name: '中堂镇',
    parseid: '4419',
    longitude: '113.6769841991',
    latitude: '23.103749303353'
  },
  441900129:
  {
    name: '高埗镇',
    parseid: '4419',
    longitude: '113.74588835312',
    latitude: '23.101725468803'
  },
  441900401:
  {
    name: '松山湖',
    parseid: '4419',
    longitude: '113.89386489652',
    latitude: '22.941245789836'
  },
  441900402:
  {
    name: '东莞港',
    parseid: '4419',
    longitude: '113.59028003427',
    latitude: '22.877904043647'
  },
  441900403:
  {
    name: '东莞生态园',
    parseid: '4419',
    longitude: '113.93317582359',
    latitude: '23.069244451922'
  },
  442000001:
  {
    name: '石岐街道',
    parseid: '4420',
    longitude: '113.38182181068',
    latitude: '22.527318731974'
  },
  442000002:
  {
    name: '东区街道',
    parseid: '4420',
    longitude: '113.43716804894',
    latitude: '22.508381642299'
  },
  442000003:
  {
    name: '中山港街道',
    parseid: '4420',
    longitude: '113.48111894226',
    latitude: '22.565773929989'
  },
  442000004:
  {
    name: '西区街道',
    parseid: '4420',
    longitude: '113.34603068893',
    latitude: '22.559437103414'
  },
  442000005:
  {
    name: '南区街道',
    parseid: '4420',
    longitude: '113.33788055618',
    latitude: '22.471511097107'
  },
  442000006:
  {
    name: '五桂山街道',
    parseid: '4420',
    longitude: '113.41819551678',
    latitude: '22.442028490765'
  },
  442000100:
  {
    name: '小榄镇',
    parseid: '4420',
    longitude: '113.24005933606',
    latitude: '22.646227724877'
  },
  442000101:
  {
    name: '黄圃镇',
    parseid: '4420',
    longitude: '113.3754355502',
    latitude: '22.731437028506'
  },
  442000102:
  {
    name: '民众镇',
    parseid: '4420',
    longitude: '113.49942512307',
    latitude: '22.637664266538'
  },
  442000103:
  {
    name: '东凤镇',
    parseid: '4420',
    longitude: '113.27371286349',
    latitude: '22.694311766896'
  },
  442000104:
  {
    name: '东升镇',
    parseid: '4420',
    longitude: '113.3077554659',
    latitude: '22.605084492233'
  },
  442000105:
  {
    name: '古镇镇',
    parseid: '4420',
    longitude: '113.19049824546',
    latitude: '22.631702653792'
  },
  442000106:
  {
    name: '沙溪镇',
    parseid: '4420',
    longitude: '113.31101285103',
    latitude: '22.52397101718'
  },
  442000107:
  {
    name: '坦洲镇',
    parseid: '4420',
    longitude: '113.4391896316',
    latitude: '22.276976050177'
  },
  442000108:
  {
    name: '港口镇',
    parseid: '4420',
    longitude: '113.39936034991',
    latitude: '22.611660089869'
  },
  442000109:
  {
    name: '三角镇',
    parseid: '4420',
    longitude: '113.43118973954',
    latitude: '22.691160020682'
  },
  442000110:
  {
    name: '横栏镇',
    parseid: '4420',
    longitude: '113.23188017995',
    latitude: '22.554402218127'
  },
  442000111:
  {
    name: '南头镇',
    parseid: '4420',
    longitude: '113.29496370773',
    latitude: '22.72358647661'
  },
  442000112:
  {
    name: '阜沙镇',
    parseid: '4420',
    longitude: '113.34517667168',
    latitude: '22.669686146608'
  },
  442000113:
  {
    name: '南朗镇',
    parseid: '4420',
    longitude: '113.5516317764',
    latitude: '22.504543215021'
  },
  442000114:
  {
    name: '三乡镇',
    parseid: '4420',
    longitude: '113.43753207378',
    latitude: '22.36829621507'
  },
  442000115:
  {
    name: '板芙镇',
    parseid: '4420',
    longitude: '113.31969393983',
    latitude: '22.404297027726'
  },
  442000116:
  {
    name: '大涌镇',
    parseid: '4420',
    longitude: '113.26932351729',
    latitude: '22.479721403989'
  },
  442000117:
  {
    name: '神湾镇',
    parseid: '4420',
    longitude: '113.35227454733',
    latitude: '22.325980312897'
  },
  460400100:
  {
    name: '那大镇',
    parseid: '4604',
    longitude: '109.56666499663',
    latitude: '19.557129752461'
  },
  460400101:
  {
    name: '和庆镇',
    parseid: '4604',
    longitude: '109.67972221121',
    latitude: '19.565540923606'
  },
  460400102:
  {
    name: '南丰镇',
    parseid: '4604',
    longitude: '109.60109502204',
    latitude: '19.351928106444'
  },
  460400103:
  {
    name: '大成镇',
    parseid: '4604',
    longitude: '109.41691802961',
    latitude: '19.554863023345'
  },
  460400104:
  {
    name: '雅星镇',
    parseid: '4604',
    longitude: '109.20682052692',
    latitude: '19.5206454296'
  },
  460400105:
  {
    name: '兰洋镇',
    parseid: '4604',
    longitude: '109.69098506778',
    latitude: '19.454872381689'
  },
  460400106:
  {
    name: '光村镇',
    parseid: '4604',
    longitude: '109.49919232119',
    latitude: '19.814386045823'
  },
  460400107:
  {
    name: '木棠镇',
    parseid: '4604',
    longitude: '109.37215902964',
    latitude: '19.828557468372'
  },
  460400108:
  {
    name: '海头镇',
    parseid: '4604',
    longitude: '109.02813792492',
    latitude: '19.517067603076'
  },
  460400109:
  {
    name: '峨蔓镇',
    parseid: '4604',
    longitude: '109.29572633075',
    latitude: '19.862720883205'
  },
  460400111:
  {
    name: '王五镇',
    parseid: '4604',
    longitude: '109.32983101865',
    latitude: '19.640974685168'
  },
  460400112:
  {
    name: '白马井镇',
    parseid: '4604',
    longitude: '109.25290908641',
    latitude: '19.665516440435'
  },
  460400113:
  {
    name: '中和镇',
    parseid: '4604',
    longitude: '109.38120242122',
    latitude: '19.757473195346'
  },
  460400114:
  {
    name: '排浦镇',
    parseid: '4604',
    longitude: '109.15850534744',
    latitude: '19.618971649133'
  },
  460400115:
  {
    name: '东成镇',
    parseid: '4604',
    longitude: '109.49004061193',
    latitude: '19.715584133525'
  },
  460400116:
  {
    name: '新州镇',
    parseid: '4604',
    longitude: '109.32436877139',
    latitude: '19.726548350304'
  },
  460400499:
  {
    name: '洋浦经济开发区',
    parseid: '4604',
    longitude: '109.58745583569',
    latitude: '19.527146110044'
  },
  460400500:
  {
    name: '华南热作学院',
    parseid: '4604',
    longitude: '109.49707866582',
    latitude: '19.512433868392'
  },
  620201100:
  {
    name: '新城镇',
    parseid: '6202',
    longitude: '98.420116329624',
    latitude: '39.877081756471'
  },
  620201101:
  {
    name: '峪泉镇',
    parseid: '6202',
    longitude: '98.152631383343',
    latitude: '39.837158582176'
  },
  620201102:
  {
    name: '文殊镇',
    parseid: '6202',
    longitude: '98.344407039734',
    latitude: '39.71927647164'
  },
  620201401:
  {
    name: '雄关区',
    parseid: '6202',
    longitude: '98.282689734909',
    latitude: '39.797321330847'
  },
  620201402:
  {
    name: '镜铁区',
    parseid: '6202',
    longitude: '98.296203843001',
    latitude: '39.777960147391'
  },
  620201403:
  {
    name: '长城区',
    parseid: '6202',
    longitude: '98.417887768399',
    latitude: '39.912013226609'
  }
}
